import { db, auth } from "./firebase";
import YouScreen from "./YouScreen";
import NutritionLog from "./NutritionLog";
import CommunityFeed from "./CommunityFeed.jsx";
import ChallengesScreen from "./ChallengesScreen.jsx";
import DirectMessages from "./DirectMessages.jsx";
import { subscribeToConversation, subscribeToAllConversations, getOrCreateConversation } from "./directMessages";
import { registerPushForUser } from "./pushNotifications";
import AdminBroadcasts from "./AdminBroadcasts.jsx";
import CallsScreen from "./CallsScreen.jsx";
import RecurringCallCard from "./RecurringCallCard.jsx";
import { subscribeToCall, subscribeToDirectCall, subscribeToAdminCall, createDailyRoom, deleteDailyRoom } from "./calls";
import {
  subscribeToRecurringConfig,
  setRecurringCallConfig,
  computeNextOccurrences,
  subscribeToCallPoll,
  getCallPollsForDateKeys,
  rescheduleOccurrence,
  cancelOccurrence,
  createRoomForOccurrence,
  removeRoomForOccurrence,
  dateKeyFromDate,
  getOccurrenceStatus,
  formatOccurrenceTime,
  computeEffectiveEndDate,
  DAYS_FULL,
} from "./recurringCalls";
import BroadcastCard from "./BroadcastCard.jsx";
import { getActiveBroadcastsForUser, getSubmittedResponsesWithFeedback, replyBackToCoach, dismissBroadcastForUser, getAllBroadcastResponsesForUser, dismissFeedbackForClient, reactToAdminReply, submitBroadcastResponse, awardBroadcastXP } from "./broadcasts";
import { recordAutoProgress, removeAutoProgress } from "./challenges";
import {
  doc,
  setDoc,
  getDoc,
  getDocFromServer,
  getDocs,
  addDoc,
  collection,
  query,
  where,
  orderBy,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  onSnapshot,
  increment,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
} from "firebase/auth";
import { useState, useEffect, useRef } from "react";
import AdminWeeklyPrompts from "./AdminWeeklyPrompts";
import WeeklyQuestCard from "./WeeklyQuestCard";
import AssignmentsScreen from "./AssignmentsScreen";
import { getActivePromptForUser, getUserResponseForPrompt, getAllPromptsForTag, coachSubmitWeeklyQuest } from "./weeklyQuests";
import { SideQuestScheduleModal, SideQuestMoveDayModal } from "./SideQuestScheduleModal";
import HandPortionLog from "./HandPortionLog";
import WaterTracker from "./WaterTracker";
import WeeklyRecap from "./WeeklyRecap";
import OnboardingWalkthrough from "./OnboardingWalkthrough";
import WorkoutsScreen from "./WorkoutsScreen";
import AvatarBuilder, { buildAvatarUrl, DEFAULT_OPTIONS } from "./AvatarBuilder";
import AvatarBuilderAdmin from "./AvatarBuilderAdmin";
import { getAvatarBuilderConfig, DEFAULT_AVATAR_CONFIG } from "./avatarBuilderConfig";
import { getAllWorkoutPrograms, createWorkoutProgram, updateWorkoutProgram, deleteWorkoutProgram, EQUIPMENT_LIST } from "./workoutPrograms";
import { allExerciseNames as wpExerciseNames, fuzzyMatchExercise } from "./exerciseLibrary";
// import RecipeGenerator from "./RecipeGenerator"; // TODO: re-enable when OpenAI integration is fixed
import SideQuestHeatmap from "./SideQuestHeatmap";
import MacroTracker from "./MacroTracker";
import CardioLog from "./CardioLog";
import { getBodyStats, saveBodyStats } from "./bodyMetrics";
import { writeActivityEvent, subscribeToAdminActivity, markAllActivityRead, markActivityRead, timeAgo, activityMeta } from "./adminActivity";
import { subscribeToUserNotifications, markAllUserNotificationsRead, notifTimeAgo, notifEmoji } from "./userNotifications";
import AdminPinnedNotes from "./AdminPinnedNotes";
import AdminHabitOverride from "./AdminHabitOverride";
import AdminBodyMetricsConfig from "./AdminBodyMetricsConfig";
import WeeklyHabitsWidget from "./WeeklyHabitsWidget";
import AdminGameContent from "./AdminGameContent";
import AdminChallenges from "./AdminChallenges";
import DashboardChallengeWidget from "./DashboardChallengeWidget";
import RichTextEditor, { RichTextDisplay } from "./RichTextEditor";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { getFunctions, httpsCallable } from "firebase/functions";
import { isNativeMobile, getHealthConnectAvailability } from "./healthConnectSteps";
import { getHealthSyncPrefs, runHealthSync } from "./healthSync";

function AdminBroadcastPreviewCard({ broadcast: b, clientId, onDismissed }) {
  const [confirming, setConfirming] = useState(false);
  const [dismissing, setDismissing] = useState(false);
  return (
    <div style={{ background: "#f0f9ff", borderRadius: "18px", padding: "16px 18px", marginBottom: "16px", border: "2px solid #38bdf8" }}>
      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "4px" }}>📢 {b.title}</div>
      {b.body && <RichTextDisplay html={b.body} style={{ color: "#4b6b8a", fontSize: "14px", lineHeight: 1.5 }} />}
      {b.xpReward > 0 && (
        <div style={{ marginTop: "8px", display: "inline-block", padding: "3px 10px", borderRadius: "999px", background: "#dcfce7", border: "1px solid #bbf7d0", color: "#166534", fontSize: "12px", fontWeight: "bold" }}>
          +{b.xpReward} XP for responding
        </div>
      )}
      <div style={{ marginTop: "12px", borderTop: "1px solid #bfdbfe", paddingTop: "12px" }}>
        {confirming ? (
          <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
            <span style={{ color: "#4b6b8a", fontSize: "13px", flex: 1 }}>Dismiss this broadcast for the client?</span>
            <button
              onClick={async () => {
                setDismissing(true);
                await dismissBroadcastForUser(b.id, clientId);
                onDismissed(b.id);
              }}
              disabled={dismissing}
              style={{ padding: "8px 16px", borderRadius: "10px", border: "none", background: "#dc2626", color: "#fff", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}
            >
              {dismissing ? "Dismissing..." : "Yes, dismiss"}
            </button>
            <button
              onClick={() => setConfirming(false)}
              style={{ padding: "8px 16px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}
            >
              Cancel
            </button>
          </div>
        ) : (
          <button
            onClick={() => setConfirming(true)}
            style={{ padding: "8px 16px", borderRadius: "10px", border: "2px solid #e2e8f0", background: "#fff", color: "#64748b", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}
          >
            Dismiss for client
          </button>
        )}
      </div>
    </div>
  );
}

const PROGRAM_FEATURE_GROUPS = [
  { group: "Access", features: [
    { key: "workouts", label: "Workouts Tab" },
    { key: "challenges", label: "Challenges" },
    { key: "communityFeed", label: "Community Feed" },
    { key: "leaderboard", label: "Leaderboard" },
  ]},
  { group: "Quests", features: [
    { key: "weeklyAssignments", label: "Weekly Quest Assignments" },
    { key: "sideQuests", label: "Side Quests" },
    { key: "weeklyGoals", label: "Weekly Goals" },
  ]},
  { group: "Nutrition", features: [
    { key: "nutritionTracking", label: "Nutrition Logging" },
    { key: "macroTracking", label: "Macro / Calorie Tracking" },
    { key: "mealPhotos", label: "Meal Photos" },
    { key: "handPortions", label: "Hand Portion Tracking" },
    { key: "waterTracking", label: "Water Tracking" },
  ]},
  { group: "Body & Progress", features: [
    { key: "bodyMetrics", label: "Body Metrics (weight, measurements, steps)" },
    { key: "progressPhotos", label: "Progress Photos" },
  ]},
];

const PROGRAM_FEATURE_TEMPLATES = {
  "quit-the-quit": {
    workouts: false, challenges: false, communityFeed: true, leaderboard: false,
    weeklyAssignments: true, sideQuests: true, weeklyGoals: false,
    nutritionTracking: true, macroTracking: false, mealPhotos: false, handPortions: false, waterTracking: true,
    bodyMetrics: true, progressPhotos: false,
  },
  "momentum": {
    workouts: true, challenges: true, communityFeed: true, leaderboard: true,
    weeklyAssignments: true, sideQuests: true, weeklyGoals: true,
    nutritionTracking: true, macroTracking: true, mealPhotos: true, handPortions: true, waterTracking: true,
    bodyMetrics: true, progressPhotos: true,
  },
};

function getDefaultFeatures(programTag) {
  if (programTag === "momentum") return { ...PROGRAM_FEATURE_TEMPLATES["momentum"] };
  return { ...PROGRAM_FEATURE_TEMPLATES["quit-the-quit"] };
}

function ProgramsEditor({ db, programs, setPrograms, programSettings, setProgramSettings }) {
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState({ tag: "", label: "", code: "", template: "quit-the-quit" });
  const [saving, setSaving] = useState(false);
  const [expandedFeatures, setExpandedFeatures] = useState(null);
  const [featureSaving, setFeatureSaving] = useState(false);

  function slugify(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  }

  function getFeatures(programTag) {
    const saved = programSettings[programTag]?.features;
    if (saved) return saved;
    return getDefaultFeatures(programTag);
  }

  async function toggleFeature(programTag, key) {
    setFeatureSaving(true);
    const current = getFeatures(programTag);
    const updated = { ...current, [key]: !current[key] };
    const next = { ...programSettings, [programTag]: { ...(programSettings[programTag] || {}), features: updated } };
    try {
      await setDoc(doc(db, "appConfig", "programSettings"), next, { merge: false });
      setProgramSettings(next);
    } catch (err) {
      console.error("Failed to save feature:", err);
    } finally {
      setFeatureSaving(false);
    }
  }

  async function applyTemplate(programTag, templateKey) {
    setFeatureSaving(true);
    const features = { ...PROGRAM_FEATURE_TEMPLATES[templateKey] };
    const next = { ...programSettings, [programTag]: { ...(programSettings[programTag] || {}), features } };
    try {
      await setDoc(doc(db, "appConfig", "programSettings"), next, { merge: false });
      setProgramSettings(next);
    } catch (err) {
      console.error("Failed to apply template:", err);
    } finally {
      setFeatureSaving(false);
    }
  }

  async function saveProgram() {
    if (!draft.label.trim() || !draft.code.trim()) return;
    setSaving(true);
    const tag = draft.tag || slugify(draft.label);
    const entry = { tag, label: draft.label.trim(), code: draft.code.trim().toUpperCase() };
    const updated = editing === "new" ? [...programs, entry] : programs.map((p, i) => i === editing ? entry : p);
    const codesMap = Object.fromEntries(updated.filter(p => p.code).map(p => [p.code, p.tag]));
    // If new program, seed features from chosen template
    const nextProgramSettings = editing === "new"
      ? { ...programSettings, [tag]: { ...(programSettings[tag] || {}), features: { ...PROGRAM_FEATURE_TEMPLATES[draft.template || "quit-the-quit"] } } }
      : programSettings;
    try {
      await Promise.all([
        setDoc(doc(db, "appConfig", "programs"), { list: updated }),
        setDoc(doc(db, "appConfig", "signupCodes"), codesMap),
        ...(editing === "new" ? [setDoc(doc(db, "appConfig", "programSettings"), nextProgramSettings, { merge: false })] : []),
      ]);
      setPrograms(updated);
      if (editing === "new") setProgramSettings(nextProgramSettings);
      setEditing(null);
    } catch (err) {
      console.error("Failed to save program:", err);
      alert("Save failed — check your connection and try again.");
    } finally {
      setSaving(false);
    }
  }

  async function deleteProgram(idx) {
    setSaving(true);
    const updated = programs.filter((_, i) => i !== idx);
    const codesMap = Object.fromEntries(updated.filter(p => p.code).map(p => [p.code, p.tag]));
    try {
      await Promise.all([
        setDoc(doc(db, "appConfig", "programs"), { list: updated }),
        setDoc(doc(db, "appConfig", "signupCodes"), codesMap),
      ]);
      setPrograms(updated);
    } catch (err) {
      console.error("Failed to delete program:", err);
    } finally {
      setSaving(false);
    }
  }

  const inputStyle = { padding: "8px 12px", borderRadius: "8px", border: "1.5px solid #bfdbfe", fontSize: "13px", color: "#1e3a5f", background: "#fff", width: "100%", boxSizing: "border-box" };

  return (
    <div style={{ display: "grid", gap: "14px" }}>
      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>📋 Programs</div>
      <div style={{ fontSize: "13px", color: "#6b7280" }}>Each program has a name, tag, and signup code. Toggle features on/off per program below.</div>

      {programs.map((p, idx) => (
        <div key={p.tag} style={{ background: "#f8fbff", borderRadius: "14px", border: "2px solid #bfdbfe", overflow: "hidden" }}>
          {/* Header row */}
          {editing === idx ? (
            <div style={{ padding: "14px 16px", display: "grid", gap: "8px" }}>
              <input value={draft.label} onChange={(e) => setDraft(d => ({ ...d, label: e.target.value }))} placeholder="Program name" style={{ ...inputStyle, fontSize: "14px" }} />
              <input value={draft.tag} onChange={(e) => setDraft(d => ({ ...d, tag: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "") }))} placeholder="Tag (e.g. momentum)" style={{ ...inputStyle, fontFamily: "monospace" }} />
              <input value={draft.code} onChange={(e) => setDraft(d => ({ ...d, code: e.target.value.toUpperCase() }))} placeholder="Signup code (e.g. QTQBETA)" style={{ ...inputStyle, fontFamily: "monospace" }} />
              <div style={{ display: "flex", gap: "8px" }}>
                <button type="button" onClick={saveProgram} disabled={saving || !draft.label.trim() || !draft.code.trim()} style={{ flex: 1, padding: "8px", borderRadius: "8px", border: "none", background: draft.label.trim() && draft.code.trim() ? "#2563eb" : "#bfdbfe", color: "#fff", fontWeight: "bold", fontSize: "13px", cursor: draft.label.trim() && draft.code.trim() ? "pointer" : "not-allowed" }}>{saving ? "…" : "Save"}</button>
                <button type="button" onClick={() => setEditing(null)} style={{ padding: "8px 14px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>Cancel</button>
              </div>
              <button type="button" onClick={() => { if (window.confirm(`Delete "${p.label}"? This cannot be undone.`)) deleteProgram(idx); }} disabled={saving} style={{ padding: "7px", borderRadius: "8px", border: "none", background: "#fee2e2", color: "#dc2626", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>🗑 Delete this program</button>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "14px 16px" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>{p.label}</div>
                <div style={{ color: "#6b8cb0", fontSize: "11px", marginTop: "2px" }}>
                  <span style={{ fontFamily: "monospace" }}>{p.tag}</span>
                  {p.code && <span> · code: <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>{p.code}</span></span>}
                  {!p.code && <span style={{ color: "#f59e0b" }}> · no code set</span>}
                </div>
              </div>
              <button type="button" onClick={() => { setDraft({ ...p }); setEditing(idx); }} style={{ padding: "5px 10px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontSize: "12px", cursor: "pointer" }}>✏️ Edit</button>
              <button type="button" onClick={() => setExpandedFeatures(expandedFeatures === p.tag ? null : p.tag)} style={{ padding: "5px 10px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: expandedFeatures === p.tag ? "#e0f2fe" : "#f5faff", color: "#1e3a5f", fontSize: "12px", cursor: "pointer" }}>⚙️ Features</button>
            </div>
          )}

          {/* Feature toggles */}
          {expandedFeatures === p.tag && editing !== idx && (
            <div style={{ borderTop: "1px solid #dbeafe", padding: "14px 16px", display: "grid", gap: "14px" }}>
              {/* Template quick-apply buttons */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <span style={{ fontSize: "12px", color: "#6b8cb0", fontWeight: "bold" }}>Apply template:</span>
                {Object.keys(PROGRAM_FEATURE_TEMPLATES).map((tmpl) => (
                  <button key={tmpl} type="button" disabled={featureSaving} onClick={() => applyTemplate(p.tag, tmpl)} style={{ padding: "4px 10px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#f0f9ff", color: "#1e3a5f", fontSize: "12px", fontWeight: "bold", cursor: "pointer" }}>
                    {tmpl === "momentum" ? "Momentum" : "Quit the Quit"}
                  </button>
                ))}
              </div>
              {PROGRAM_FEATURE_GROUPS.map(({ group, features }) => (
                <div key={group}>
                  <div style={{ fontSize: "11px", fontWeight: "bold", color: "#6b8cb0", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>{group}</div>
                  <div style={{ display: "grid", gap: "6px" }}>
                    {features.map(({ key, label }) => {
                      const on = getFeatures(p.tag)[key] ?? getDefaultFeatures(p.tag)[key] ?? true;
                      return (
                        <div key={key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 10px", borderRadius: "8px", background: on ? "#f0fdf4" : "#f8fafc", border: `1px solid ${on ? "#86efac" : "#e2e8f0"}` }}>
                          <span style={{ fontSize: "13px", color: "#1e3a5f", fontWeight: on ? "600" : "400" }}>{label}</span>
                          <button type="button" disabled={featureSaving} onClick={() => toggleFeature(p.tag, key)} style={{ width: "44px", height: "24px", borderRadius: "999px", border: "none", background: on ? "#16a34a" : "#cbd5e1", cursor: "pointer", position: "relative", flexShrink: 0 }}>
                            <div style={{ position: "absolute", top: "2px", left: on ? "22px" : "2px", width: "20px", height: "20px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* Add new program */}
      {editing === "new" ? (
        <div style={{ background: "#f0fdf4", borderRadius: "12px", padding: "14px 16px", border: "1.5px dashed #86efac" }}>
          <div style={{ display: "grid", gap: "8px" }}>
            <input value={draft.label} onChange={(e) => setDraft(d => ({ ...d, label: e.target.value, tag: slugify(e.target.value) }))} placeholder="Program name" style={{ ...inputStyle, fontSize: "14px" }} autoFocus />
            <input value={draft.tag} onChange={(e) => setDraft(d => ({ ...d, tag: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "") }))} placeholder="Tag (auto-generated)" style={{ ...inputStyle, fontFamily: "monospace" }} />
            <input value={draft.code} onChange={(e) => setDraft(d => ({ ...d, code: e.target.value.toUpperCase() }))} placeholder="Signup code" style={{ ...inputStyle, fontFamily: "monospace" }} />
            <div>
              <div style={{ fontSize: "12px", color: "#6b8cb0", fontWeight: "bold", marginBottom: "6px" }}>START FROM TEMPLATE</div>
              <div style={{ display: "flex", gap: "8px" }}>
                {Object.keys(PROGRAM_FEATURE_TEMPLATES).map((tmpl) => (
                  <button key={tmpl} type="button" onClick={() => setDraft(d => ({ ...d, template: tmpl }))} style={{ flex: 1, padding: "8px", borderRadius: "8px", border: draft.template === tmpl ? "2px solid #2563eb" : "1.5px solid #bfdbfe", background: draft.template === tmpl ? "#e0f2fe" : "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
                    {tmpl === "momentum" ? "Momentum" : "Quit the Quit"}
                  </button>
                ))}
              </div>
              <div style={{ fontSize: "11px", color: "#6b8cb0", marginTop: "4px" }}>
                {draft.template === "momentum" ? "Includes workouts, challenges, macro tracking, progress photos, leaderboard." : "Core habits, weekly assignments, side quests, nutrition & water logging, body metrics."}
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button type="button" onClick={saveProgram} disabled={saving || !draft.label.trim() || !draft.code.trim()} style={{ flex: 1, padding: "8px", borderRadius: "8px", border: "none", background: draft.label.trim() && draft.code.trim() ? "#2563eb" : "#bfdbfe", color: "#fff", fontWeight: "bold", fontSize: "13px", cursor: draft.label.trim() && draft.code.trim() ? "pointer" : "not-allowed" }}>{saving ? "…" : "Add Program"}</button>
              <button type="button" onClick={() => setEditing(null)} style={{ padding: "8px 14px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => { setDraft({ tag: "", label: "", code: "", template: "quit-the-quit" }); setEditing("new"); }} style={{ padding: "10px", borderRadius: "10px", border: "2px dashed #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>+ Add Program</button>
      )}
    </div>
  );
}

function SignupCodesEditor({ db }) {
  const [codes, setCodes] = useState(null);
  const [newCode, setNewCode] = useState("");
  const [newProgram, setNewProgram] = useState("momentum");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    getDoc(doc(db, "appConfig", "signupCodes")).then((snap) => {
      setCodes(snap.exists() ? snap.data() : {});
    }).catch(() => setCodes({}));
  }, []);

  async function save(updated) {
    setSaving(true);
    await setDoc(doc(db, "appConfig", "signupCodes"), updated);
    setCodes(updated);
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  if (codes === null) return <div style={{ color: "#6b7280", fontSize: "13px" }}>Loading…</div>;

  return (
    <div style={{ display: "grid", gap: "16px" }}>
      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>🔑 Signup Codes</div>
      <div style={{ fontSize: "13px", color: "#6b7280" }}>Each code maps to a program. Users enter a code on signup and are automatically assigned to that program.</div>
      <div style={{ display: "grid", gap: "8px" }}>
        {Object.entries(codes).length === 0 && (
          <div style={{ color: "#9ca3af", fontSize: "13px", fontStyle: "italic" }}>No codes yet. Add one below.</div>
        )}
        {Object.entries(codes).map(([code, program]) => (
          <div key={code} style={{ display: "flex", alignItems: "center", gap: "10px", background: "#f0f9ff", borderRadius: "10px", padding: "10px 14px", border: "1px solid #bfdbfe" }}>
            <div style={{ flex: 1, fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", fontFamily: "monospace" }}>{code}</div>
            <div style={{ color: "#4b6b8a", fontSize: "13px", background: "#dbeafe", borderRadius: "6px", padding: "2px 8px" }}>{program}</div>
            <button type="button" onClick={() => { const u = { ...codes }; delete u[code]; save(u); }} style={{ padding: "4px 10px", borderRadius: "8px", border: "none", background: "#fca5a5", color: "#fff", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>✕</button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <input
          type="text"
          value={newCode}
          onChange={(e) => setNewCode(e.target.value.toUpperCase())}
          placeholder="CODE"
          style={{ flex: 1, padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "14px", color: "#1e3a5f", fontFamily: "monospace", textTransform: "uppercase" }}
        />
        <select value={newProgram} onChange={(e) => setNewProgram(e.target.value)} style={{ padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "13px", color: "#1e3a5f", background: "#fff" }}>
          <option value="momentum">momentum</option>
          <option value="basic">basic</option>
        </select>
        <button
          type="button"
          onClick={() => {
            if (!newCode.trim()) return;
            const updated = { ...codes, [newCode.trim()]: newProgram };
            save(updated);
            setNewCode("");
          }}
          disabled={saving || !newCode.trim()}
          style={{ padding: "10px 16px", borderRadius: "10px", border: "none", background: newCode.trim() ? "#2563eb" : "#bfdbfe", color: "#fff", fontWeight: "bold", fontSize: "13px", cursor: newCode.trim() ? "pointer" : "default" }}
        >
          {saving ? "…" : saved ? "✓" : "Add"}
        </button>
      </div>
    </div>
  );
}

function InfoTextsEditor({ infoTexts, setInfoTexts, db }) {
  const fields = [
    { key: "weekly", label: "📅 Weekly Challenge popup", rows: 4 },
    { key: "habitsIntro", label: "💡 Habits — intro line", rows: 2 },
    { key: "habitsKeepStreak", label: "💡 Habits — Keep the Streak description", rows: 2 },
    { key: "habitsMainQuest", label: "💡 Habits — Main Quest description", rows: 2 },
    { key: "habitsExtraCredit", label: "💡 Habits — Extra Credit description", rows: 2 },
    { key: "habitsWarning", label: "💡 Habits — core categories warning", rows: 3 },
    { key: "habitsExtra", label: "✨ Bonus Category popup", rows: 4 },
    { key: "questAssignments", label: "📋 Quests — Weekly Quest Assignments popup", rows: 3 },
    { key: "sideQuests", label: "✨ Quests — Side Quests popup", rows: 3 },
  ];
  const [draft, setDraft] = useState({ ...infoTexts });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  return (
    <div style={{ display: "grid", gap: "16px" }}>
      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>📝 Edit Info Popup Text</div>
      <div style={{ fontSize: "13px", color: "#6b7280" }}>These are the explanations shown when users tap the ℹ️ icons on their dashboard.</div>
      {fields.map(({ key, label, rows }) => (
        <div key={key}>
          <div style={{ fontSize: "12px", fontWeight: "bold", color: "#4b6b8a", marginBottom: "4px" }}>{label}</div>
          <textarea
            value={draft[key] || ""}
            onChange={(e) => setDraft((d) => ({ ...d, [key]: e.target.value }))}
            rows={rows}
            style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "13px", color: "#1e3a5f", resize: "vertical", fontFamily: "inherit", lineHeight: 1.5 }}
          />
        </div>
      ))}
      <button
        onClick={async () => {
          setSaving(true);
          await setDoc(doc(db, "appConfig", "infoTexts"), draft, { merge: false });
          setInfoTexts(draft);
          setSaving(false);
          setSaved(true);
          setTimeout(() => setSaved(false), 2000);
        }}
        disabled={saving}
        style={{ padding: "12px", borderRadius: "12px", border: "none", background: saving ? "#bfdbfe" : saved ? "#16a34a" : "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: saving ? "default" : "pointer" }}>
        {saving ? "Saving…" : saved ? "✓ Saved!" : "Save Changes"}
      </button>
    </div>
  );
}

function BroadcastConvoReply({ responseId, onSent }) {
  const [replyText, setReplyText] = useState("");
  const [replying, setReplying] = useState(false);
  return (
    <div style={{ display: "grid", gap: "8px" }}>
      <textarea
        value={replyText}
        onChange={(e) => setReplyText(e.target.value)}
        placeholder="Reply to coach..."
        rows={2}
        style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: "12px", border: "1px solid #bfdbfe", background: "#fff", color: "#1e3a5f", fontSize: "14px", resize: "vertical", fontFamily: "inherit" }}
      />
      <button
        onClick={async () => {
          if (!replyText.trim()) return;
          setReplying(true);
          await replyBackToCoach(responseId, replyText.trim());
          onSent(replyText.trim());
          setReplying(false);
        }}
        disabled={replying || !replyText.trim()}
        style={{ padding: "8px 16px", borderRadius: "10px", border: "none", background: replyText.trim() ? "#2563eb" : "#bfdbfe", color: "#fff", fontWeight: "bold", cursor: replyText.trim() && !replying ? "pointer" : "default", fontSize: "13px", alignSelf: "flex-start" }}
      >
        {replying ? "Sending..." : "Send reply"}
      </button>
    </div>
  );
}

function VacationTab({ vacations, onAdd, onRemove, vacationModeActive, onToggleVacationMode }) {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [saving, setSaving] = useState(false);
  const [toggling, setToggling] = useState(false);
  const [error, setError] = useState("");
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  async function handleAdd() {
    setError("");
    if (!start || !end) { setError("Please enter both a start and end date."); return; }
    if (start > end) { setError("Start date must be before end date."); return; }
    setSaving(true);
    await onAdd(start, end);
    setStart("");
    setEnd("");
    setSaving(false);
  }

  async function handleToggle() {
    setToggling(true);
    await onToggleVacationMode();
    setToggling(false);
  }

  return (
    <div>
      {/* ── Flexible (indefinite) vacation mode toggle ── */}
      <div style={{ background: vacationModeActive ? "#f0fdf4" : "#f8fbff", borderRadius: "18px", padding: "18px", border: `2px solid ${vacationModeActive ? "#86efac" : "#bfdbfe"}`, marginBottom: "16px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px" }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ marginTop: 0, marginBottom: "6px", color: "#1e3a5f", fontSize: "18px" }}>
              🏄 Flexible Mode {vacationModeActive && <span style={{ fontSize: "13px", fontWeight: "normal", color: "#16a34a", marginLeft: "6px" }}>● Active</span>}
            </h3>
            <p style={{ marginTop: 0, marginBottom: 0, color: "#4b6b8a", fontSize: "13px", lineHeight: 1.5 }}>
              {vacationModeActive
                ? "You're in flexible mode — earn points for what you do, no penalties or revives for days you skip. Turn off anytime to return to normal tracking."
                : "Just want to show up when you can, without pressure? Toggle this on to earn points for habits you complete without ever needing a revive for days you miss."}
            </p>
          </div>
          <button
            type="button"
            disabled={toggling}
            onClick={handleToggle}
            style={{
              flexShrink: 0,
              padding: "10px 20px",
              borderRadius: "20px",
              border: "none",
              background: vacationModeActive ? "#22c55e" : "#e5e7eb",
              color: vacationModeActive ? "#fff" : "#6b7280",
              fontWeight: "bold",
              fontSize: "14px",
              cursor: toggling ? "default" : "pointer",
              opacity: toggling ? 0.7 : 1,
              transition: "background 0.2s",
              whiteSpace: "nowrap",
            }}>
            {toggling ? "Saving..." : vacationModeActive ? "On" : "Off"}
          </button>
        </div>
      </div>

      {/* ── Scheduled date-range vacations ── */}
      <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
        <h3 style={{ marginTop: 0, marginBottom: "6px", color: "#1e3a5f", fontSize: "20px" }}>🏖️ Scheduled Vacation</h3>
        <p style={{ marginTop: 0, marginBottom: "16px", color: "#4b6b8a", fontSize: "13px", lineHeight: 1.5 }}>
          Set specific vacation dates to freeze your streak. Days in your window won't require revives or break your progress — your streak picks up right where it left off when you return.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: "120px" }}>
              <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Start Date</div>
              <input type="date" value={start} onChange={(e) => setStart(e.target.value)}
                style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f8fbff", color: "#1e3a5f", fontSize: "14px" }} />
            </div>
            <div style={{ flex: 1, minWidth: "120px" }}>
              <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>End Date</div>
              <input type="date" value={end} onChange={(e) => setEnd(e.target.value)}
                style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f8fbff", color: "#1e3a5f", fontSize: "14px" }} />
            </div>
          </div>
          {error && <div style={{ color: "#ef4444", fontSize: "12px" }}>{error}</div>}
          <button type="button" onClick={handleAdd} disabled={saving}
            style={{ padding: "12px", borderRadius: "14px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: "pointer", opacity: saving ? 0.6 : 1 }}>
            {saving ? "Saving..." : "Add Vacation"}
          </button>
        </div>
      </div>

      {vacations.length > 0 && (
        <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe" }}>
          <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a5f", fontSize: "16px" }}>Scheduled Vacations</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {[...vacations].sort((a, b) => b.start.localeCompare(a.start)).map((v) => {
              const startFmt = new Date(`${v.start}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
              const endFmt = new Date(`${v.end}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
              const today = new Date().toISOString().slice(0, 10);
              const status = v.end < today ? "past" : v.start <= today ? "active" : "upcoming";
              return (
                <div key={v.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", borderRadius: "12px", border: `1.5px solid ${status === "active" ? "#93c5fd" : "#dbeafe"}`, background: status === "active" ? "#eff6ff" : "#f8fbff" }}>
                  <div>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>
                      {startFmt} → {endFmt}
                      {status === "active" && <span style={{ marginLeft: "8px", fontSize: "11px", color: "#2563eb", fontWeight: "bold" }}>ACTIVE</span>}
                      {status === "upcoming" && <span style={{ marginLeft: "8px", fontSize: "11px", color: "#7c3aed", fontWeight: "bold" }}>UPCOMING</span>}
                    </div>
                  </div>
                  {confirmDeleteId === v.id ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ fontSize: "12px", color: "#ef4444", fontWeight: "bold" }}>Delete?</span>
                      <button type="button" onClick={() => { onRemove(v.id); setConfirmDeleteId(null); }}
                        style={{ background: "#ef4444", border: "none", color: "#fff", cursor: "pointer", fontSize: "12px", fontWeight: "bold", borderRadius: "8px", padding: "4px 10px" }}>Yes</button>
                      <button type="button" onClick={() => setConfirmDeleteId(null)}
                        style={{ background: "none", border: "1.5px solid #bfdbfe", color: "#4b6b8a", cursor: "pointer", fontSize: "12px", borderRadius: "8px", padding: "4px 10px" }}>No</button>
                    </div>
                  ) : (
                    <button type="button" onClick={() => setConfirmDeleteId(v.id)}
                      style={{ background: "none", border: "none", color: "#93c5fd", cursor: "pointer", fontSize: "16px", padding: "0 4px" }}>✕</button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

function BroadcastFeedbackCard({ response: r, onDismiss, onClientReply, onReactionUpdate, coachName = "Coach" }) {
  const [replyOpen, setReplyOpen] = useState(false);
  const [replyText, setReplyText] = useState(r.clientReply || "");
  const [saving, setSaving] = useState(false);
  const [reactionPickerOpen, setReactionPickerOpen] = useState(false);
  const [clientReplyReaction, setClientReplyReaction] = useState(r.clientReplyReaction || "");
  const REACTION_EMOJIS = ["❤️", "🔥", "😮", "🙌", "😭", "🎉"];

  async function handleReaction(emoji) {
    const next = clientReplyReaction === emoji ? "" : emoji;
    setClientReplyReaction(next);
    setReactionPickerOpen(false);
    await reactToAdminReply(r.id, next);
    if (onReactionUpdate) onReactionUpdate(r.id, next);
  }

  async function handleSend() {
    if (!replyText.trim()) return;
    setSaving(true);
    try {
      await replyBackToCoach(r.id, replyText);
      onClientReply(replyText.trim());
      setReplyOpen(false);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ background: "#f0f9ff", borderRadius: "18px", border: "2px solid #bfdbfe", padding: "16px", display: "grid", gap: "8px" }}>
      <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
        Re: {r.broadcastTitle || "Broadcast"}
      </div>
      {r.comment && (
        <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe" }}>
          <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px", fontSize: "13px" }}>You said:</span>
          <RichTextDisplay html={r.comment} style={{ color: "#243b53", fontSize: "14px" }} />
        </div>
      )}
      {r.selections?.length > 0 && (
        <div style={{ color: "#243b53", fontSize: "14px", background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe" }}>
          <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>You picked:</span>{r.selections.join(", ")}
        </div>
      )}
      {r.adminReaction && (
        <div style={{ fontSize: "22px" }}>{r.adminReaction}</div>
      )}
      {r.adminReply && (
        <div>
          <div style={{ background: "#e0f2fe", borderRadius: "12px", padding: "10px 14px", border: "2px solid #93c5fd", fontSize: "14px", color: "#1e3a5f" }}>
            <span style={{ fontWeight: "bold", color: "#2563eb", marginRight: "6px" }}>{coachName}:</span>
            <RichTextDisplay html={r.adminReply} style={{ color: "#1e3a5f", fontSize: "14px" }} />
          </div>
          <div style={{ marginTop: "6px", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
            {clientReplyReaction && (
              <button onClick={() => handleReaction(clientReplyReaction)} style={{ padding: "3px 10px", borderRadius: "999px", border: "2px solid #2563eb", background: "#e0f2fe", color: "#1e3a5f", cursor: "pointer", fontSize: "14px" }}>
                {clientReplyReaction}
              </button>
            )}
            <button onClick={() => setReactionPickerOpen((p) => !p)} style={{ padding: "3px 10px", borderRadius: "999px", border: "2px solid #bfdbfe", background: "#f8fbff", color: "#6b8cb0", cursor: "pointer", fontSize: "13px" }}>
              {clientReplyReaction ? "Change" : "+ React"}
            </button>
            {reactionPickerOpen && (
              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                {REACTION_EMOJIS.map((e) => (
                  <button key={e} onClick={() => handleReaction(e)} style={{ padding: "3px 8px", borderRadius: "999px", border: "2px solid #bfdbfe", background: clientReplyReaction === e ? "#e0f2fe" : "#f5faff", cursor: "pointer", fontSize: "16px" }}>
                    {e}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      {r.clientReply && !replyOpen && (
        <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe", fontSize: "14px", color: "#243b53" }}>
          <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>You replied:</span>
          <RichTextDisplay html={r.clientReply} style={{ color: "#243b53", fontSize: "14px" }} />
        </div>
      )}
      {replyOpen ? (
        <div style={{ display: "grid", gap: "8px" }}>
          <RichTextEditor
            value={replyText}
            onChange={setReplyText}
            placeholder="Write a reply to your coach..."
            rows={3}
          />
          <div style={{ display: "flex", gap: "8px" }}>
            <button onClick={handleSend} disabled={saving || !replyText.trim()} style={{ padding: "10px 18px", borderRadius: "14px", border: "none", background: replyText.trim() ? "#2563eb" : "#bfdbfe", color: "#fff", fontWeight: "bold", cursor: replyText.trim() && !saving ? "pointer" : "default", fontSize: "14px" }}>
              {saving ? "Sending..." : "Send"}
            </button>
            <button onClick={() => setReplyOpen(false)} style={{ padding: "8px 14px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f8fbff", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button
            onClick={() => { setReplyText(r.clientReply || ""); setReplyOpen(true); }}
            style={{ background: "none", border: "none", color: "#2563eb", cursor: "pointer", fontSize: "13px", fontWeight: "bold", padding: 0 }}
          >
            {r.clientReply ? "✏️ Edit reply" : "↩ Reply to coach"}
          </button>
          <button onClick={onDismiss} style={{ background: "none", border: "none", color: "#93c5fd", cursor: "pointer", fontSize: "12px", fontWeight: "bold" }}>
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
}

export default function App() {
  const defaultNotificationSettings = {
    dailyHabitReminder: { enabled: true, time: "10:00" },
    streakRiskReminder: { enabled: true, time: "20:00" },
    dueReminder: { enabled: true, time: "09:00" },
  };

  const defaultHabits = {
    nutrition: {
      low: {
        label: "Keep the Streak",
        habitName: "Protein with every meal",
        xp: 10,
      },
      main: {
        label: "Main Quest",
        habitName: "Balanced plate at every meal",
        xp: 20,
      },
      high: {
        label: "Extra Credit",
        habitName: "Balanced meals + paired snacks",
        xp: 30,
      },
    },
    movement: {
      low: {
        label: "Keep the Streak",
        habitName: "within 2000 of step goal",
        xp: 10,
      },
      main: {
        label: "Main Quest",
        habitName: "Step Goal",
        xp: 20,
      },
      high: {
        label: "Extra Credit",
        habitName: "2000+ over step goal",
        xp: 30,
      },
    },
    mindset: {
      low: {
        label: "Keep the Streak",
        habitName: "Name 1 win",
        xp: 10,
      },
      main: {
        label: "Main Quest",
        habitName: "Journal",
        xp: 20,
      },
      high: {
        label: "Extra Credit",
        habitName: "No phone 30 min before bed",
        xp: 30,
      },
    },
  };

 const [currentDate, setCurrentDate] = useState(new Date());
const [dailySelections, setDailySelections] = useState({});
const [revivedDays, setRevivedDays] = useState({});
const [spentXP, setSpentXP] = useState(0);
const [challengeCosts, setChallengeCosts] = useState({});
const [activeChallenges, setActiveChallenges] = useState({});
const [resolvedDebtLog, setResolvedDebtLog] = useState({});
const [sideQuestCompletions, setSideQuestCompletions] = useState({});
const [sideQuestSchedules, setSideQuestSchedules] = useState({});
const [weeklyHabits, setWeeklyHabits] = useState([]);
const [weeklyHabitCompletions, setWeeklyHabitCompletions] = useState({});
const [scheduleEditQuest, setScheduleEditQuest] = useState(null); // title of quest being edited
const [scheduleMoveQuest, setScheduleMoveQuest] = useState(null); // { title, fromDateKey }
const [showScheduleManager, setShowScheduleManager] = useState(false);
const [customHabits, setCustomHabits] = useState(defaultHabits);
const [categoryLabels, setCategoryLabels] = useState({ nutrition: "Nutrition", movement: "Movement", mindset: "Mindset" });
const [categoryEmojis, setCategoryEmojis] = useState({ nutrition: "🍓", movement: "🚶‍♀️", mindset: "🌙" });
const [extraCategories, setExtraCategories] = useState([]);
const [adminExtraCatOpen, setAdminExtraCatOpen] = useState(false);
const [adminExtraCatLabel, setAdminExtraCatLabel] = useState("");
const [adminExtraCatEmoji, setAdminExtraCatEmoji] = useState("");
const [adminExtraCatDeleteConfirm, setAdminExtraCatDeleteConfirm] = useState(null); // key to confirm delete
const [workoutAutoSideQuest, setWorkoutAutoSideQuest] = useState("Go to the gym");
const [addCategoryOpen, setAddCategoryOpen] = useState(false);
const [newCatLabel, setNewCatLabel] = useState("");
const [newCatEmoji, setNewCatEmoji] = useState("");
const [newCatHabits, setNewCatHabits] = useState({ low: "", main: "", high: "" });
const [deleteExtraCatConfirm, setDeleteExtraCatConfirm] = useState(null);
const [editingCategory, setEditingCategory] = useState(null);
const [infoPopup, setInfoPopup] = useState(null); // "weekly" | "habits" | "habits_extra"
const [dashboardScheduledWorkouts, setDashboardScheduledWorkouts] = useState([]);
const [scheduleStartWorkout, setScheduleStartWorkout] = useState(null);
const [dashboardDeleteConfirm, setDashboardDeleteConfirm] = useState(null);
const [dashboardMoveItem, setDashboardMoveItem] = useState(null);
const [dashboardMoveDate, setDashboardMoveDate] = useState("");
const [dailyCheckIns, setDailyCheckIns] = useState({});

// ── Confirmation / info popup states ─────────────────────────────────────
const [pastQuestUncheckConfirm, setPastQuestUncheckConfirm] = useState(null); // {dateKey, title}

// ── Onboarding ────────────────────────────────────────────────────────────
const [showOnboarding, setShowOnboarding] = useState(false);
const [expandedProgramHabit, setExpandedProgramHabit] = useState(null);

// ── How This Works (admin-editable) ───────────────────────────────────────
const defaultHowItWorksItems = [
  {
    emoji: "🏠",
    title: "Dashboard",
    body: "Your daily home base. Each day log which habit level you hit for Nutrition, Movement, and Mindset — Keep the Streak (low), Main Quest (medium), or Extra Credit (high). Tap the one you completed to earn XP. Use the arrows to view past days.",
  },
  {
    emoji: "⭐",
    title: "Weekly Challenge",
    body: "A rotating challenge at the top of your dashboard. Tap it to mark it done and earn bonus XP. Resets each week.",
  },
  {
    emoji: "💎",
    title: "XP & Levels",
    body: "Every habit you log earns XP. XP fills your level bar — 500 XP per level. Your total XP and level are shown in the header card at the top of every screen.",
  },
  {
    emoji: "🔒",
    title: "Missed Days",
    body: "If you miss a day, a Resolve Missed Days banner appears. Use saved XP to revive a full missed day (25 XP) or spend a token on a single missed category (10 XP). No XP? Accept the challenge — complete today's habits and the cost is covered.",
  },
  {
    emoji: "🛡️",
    title: "Streak Shield",
    body: "Complete every habit for 14 days in a row and you'll automatically earn a Streak Shield. The shield sits in your pocket until you have a fully-missed day — then it fires automatically, protecting your streak. You can only hold one shield at a time.",
  },
  {
    emoji: "✨",
    title: "Quests",
    body: "Side Quests are bonus tasks you can complete once per day for extra XP. Tap 📅 on any Side Quest to schedule it — set it to appear on your dashboard on specific days of the week or as a one-time event. Tap ↔ to move a scheduled quest to a different day. Bonus XP opportunities and Weekly Quest Assignments (reflection prompts from your coach) are also found here.",
  },
  {
    emoji: "📅",
    title: "Scheduled Quests",
    body: "Side Quests you've scheduled appear in a 'Today's Scheduled Quests' section at the top of your dashboard each day they're due. Tap to complete them, or tap ↔ to move them to another day.",
  },
  {
    emoji: "📊",
    title: "You",
    body: "Your personal stats hub. View your streaks, earned badges, body metrics, progress photos, and the group leaderboard (when visible). Log body metrics and photos from here.",
  },
  {
    emoji: "📈",
    title: "Weekly Recap",
    body: "A weekly summary card appears on your dashboard showing how many habits you completed each day of the current week. Tap any day dot to jump to that day. Your coach can also view your weekly history from the admin panel.",
  },
  {
    emoji: "💬",
    title: "Feed & Messages",
    body: "Feed is the community board — share wins, ask questions, or check in. Messages is your private chat with your coach.",
  },
  {
    emoji: "⚙️",
    title: "Customize",
    body: "Edit the habit names shown on your dashboard to match your personal goals. Toggle meal photo logging, hand portion tracking, water tracking, and set notification reminders here.",
  },
  {
    emoji: "🥗",
    title: "Nutrition Log",
    body: "When enabled in Customize, a meal photo log appears on your dashboard. Tap to add a photo and notes for each meal. Your coach can view your nutrition log from the admin panel.",
  },
  {
    emoji: "🤚",
    title: "Hand Portion Tracker",
    body: "When enabled in Customize, a hand portion tracker appears on your dashboard. Based on the Precision Nutrition system — tap Edit Targets to set your daily goals, then log each food group throughout the day.",
  },
  {
    emoji: "💧",
    title: "Water Tracker",
    body: "When enabled in Customize, a water tracker appears on your dashboard. Set your daily glass goal and tap each glass to log your intake.",
  },
];
const [howItWorksItems, setHowItWorksItems] = useState(defaultHowItWorksItems);
const [howItWorksEditMode, setHowItWorksEditMode] = useState(false);
const [howItWorksEditDraft, setHowItWorksEditDraft] = useState([]);

// ── Streak Shield ──────────────────────────────────────────────────────────
// "ready"  = user holds a shield (auto-activates on next fully-missed day)
// "none"   = no shield held
const [streakShield, setStreakShield] = useState("none");
// dateKey from which the current 14-day earn window is counted
const [shieldEarnProgressStart, setShieldEarnProgressStart] = useState(null);
// days the shield fired — treated as full-quest days for streak purposes
const [shieldActivatedDays, setShieldActivatedDays] = useState({});
// banner shown once after shield fires
const [shieldJustActivated, setShieldJustActivated] = useState(null); // dateKey or null
// vacations: [{ id, start: "YYYY-MM-DD", end: "YYYY-MM-DD", createdAt }]
const [vacations, setVacations] = useState([]);
const [vacationModeActive, setVacationModeActive] = useState(false);
const [vacationModeStart, setVacationModeStart] = useState(null);
const [weeklyGoalFreqs, setWeeklyGoalFreqs] = useState({ nutrition: null, movement: null, mindset: null });
const [weeklyGoalFreqsLog, setWeeklyGoalFreqsLog] = useState([]); // [{ date, freqs }] sorted ascending
const [weeklyTokensApplied, setWeeklyTokensApplied] = useState({});
const [weekStartDay, setWeekStartDay] = useState("monday");
const [expandedWeeklyDebt, setExpandedWeeklyDebt] = useState(new Set());

  const [isLoaded, setIsLoaded] = useState(false);
  const [saveStatus, setSaveStatus] = useState("Saved");
  const saveTimeoutRef = useRef(null);

  const [user, setUser] = useState(null);
  const [authMode, setAuthMode] = useState("login");
  const [videoGender, setVideoGender] = useState("women");
  const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [signupCode, setSignupCode] = useState("");
const [showPassword, setShowPassword] = useState(false);
const [authError, setAuthError] = useState("");
const [authLoading, setAuthLoading] = useState(true);

  const [profileName, setProfileName] = useState("");
const [profileFirstName, setProfileFirstName] = useState("");
const [profileLastName, setProfileLastName] = useState("");
const [showLastNameInitial, setShowLastNameInitial] = useState(false);
const [showNameEditModal, setShowNameEditModal] = useState(false);
const [showReviveActivationModal, setShowReviveActivationModal] = useState(false);
const [showDebtDetails, setShowDebtDetails] = useState(false);
const [selectedAvatar, setSelectedAvatar] = useState("");
const [profileComplete, setProfileComplete] = useState(false);
const [isEditingAvatar, setIsEditingAvatar] = useState(false);
const [avatarBuilderConfig, setAvatarBuilderConfig] = useState(DEFAULT_AVATAR_CONFIG);

const [sparkles, setSparkles] = useState([]);
const [activeScreen, setActiveScreen] = useState("dashboard");
const [communitySubTab, setCommunitySubTab] = useState("feed");
const [activeWeeklyPrompt, setActiveWeeklyPrompt] = useState(null);
const [weeklyPromptLoading, setWeeklyPromptLoading] = useState(true);
const [weeklyPromptRefreshKey, setWeeklyPromptRefreshKey] = useState(0);
const [pendingBroadcasts, setPendingBroadcasts] = useState([]);
const [groupCall, setGroupCall] = useState(null);
const [callPollBroadcast, setCallPollBroadcast] = useState(null);
const [recurringCallConfig, setRecurringCallConfig_] = useState(null);
const [nextCallOccurrences, setNextCallOccurrences] = useState([]);
const [nextCallPolls, setNextCallPolls] = useState({});
const [rcAdminSaving, setRcAdminSaving] = useState(false);
const [rcAdminError, setRcAdminError] = useState("");
const [rcRescheduleFor, setRcRescheduleFor] = useState(null);
const [rcRescheduleDate, setRcRescheduleDate] = useState("");
const [rcRescheduleTime, setRcRescheduleTime] = useState("");
const [rcRescheduleNote, setRcRescheduleNote] = useState("");
const [rcRescheduleScope, setRcRescheduleScope] = useState("one");
const [rcRescheduleSaving, setRcRescheduleSaving] = useState(false);
const [rcFormEndType, setRcFormEndType] = useState("indefinite");
const [rcFormTargetType, setRcFormTargetType] = useState("program");
const [rcFormTargetUserIds, setRcFormTargetUserIds] = useState([]);
const [rcFormStartDate, setRcFormStartDate] = useState("");
const [rcFormEndDate, setRcFormEndDate] = useState("");
const [rcFormTotalCalls, setRcFormTotalCalls] = useState("");
const [broadcastFeedback, setBroadcastFeedback] = useState([]);
const [dismissedBroadcasts, setDismissedBroadcasts] = useState([]);
const [messagesTab, setMessagesTab] = useState("direct");
const [broadcastConvos, setBroadcastConvos] = useState([]);
const [broadcastConvosLoading, setBroadcastConvosLoading] = useState(false);

const [programs, setPrograms] = useState([
  { tag: "quit-the-quit-beta", label: "Quit the Quit Beta", code: "" },
  { tag: "quit-the-quit", label: "Quit the Quit", code: "" },
  { tag: "momentum", label: "Momentum", code: "" },
]);
const AVAILABLE_PROGRAMS = [
  { value: "", label: "None" },
  ...programs.map((p) => ({ value: p.tag, label: p.label })),
];


const AVAILABLE_CATEGORY_TAGS = [
  { value: "beginner", label: "Beginner" },
  { value: "morning-group", label: "Morning Group" },
  { value: "high-support", label: "High Support" },
  { value: "nutrition-focus", label: "Nutrition Focus" },
];

const [gameContent, setGameContent] = useState({
  sideQuests: [],
  weeklyChallenges: [],
  bonusXPOpportunities: [],
  badges: [],
});

const [isAdmin, setIsAdmin] = useState(false);
const [userStatus, setUserStatus] = useState("active");
const [userStartDate, setUserStartDate] = useState(null);
const [userEndDate, setUserEndDate] = useState(null);
const [reviveStartDate, setReviveStartDate] = useState(null);
const [startingXP, setStartingXP] = useState(0);
const [userprogramTag, setUserprogramTag] = useState("");
const [nutritionTrackingEnabled, setNutritionTrackingEnabled] = useState(false);
const [portionTrackingEnabled, setPortionTrackingEnabled] = useState(false);
const [waterTrackingEnabled, setWaterTrackingEnabled] = useState(false);
const [macroTrackingEnabled, setMacroTrackingEnabled] = useState(false);
const [macroOpenTrigger, setMacroOpenTrigger] = useState(0);
const [nutritionOpenTrigger, setNutritionOpenTrigger] = useState(0);
const [showCardioPanel, setShowCardioPanel] = useState(false);
const [healthSyncPrefs, setHealthSyncPrefs] = useState({ workouts: false, autoSideQuests: false });
const [healthTodayWorkouts, setHealthTodayWorkouts] = useState([]);
const [weeklyGoalsEnabled, setWeeklyGoalsEnabled] = useState(true);
const [communityNotifPrefs, setCommunityNotifPrefs] = useState({ win: true, question: true, checkin: true, general: true });
const [notificationsEnabled, setNotificationsEnabled] = useState(true);
const [notificationSettings, setNotificationSettings] = useState(defaultNotificationSettings);
const [userTimezone, setUserTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York");
const [allUsers, setAllUsers] = useState([]);
const [programSettings, setProgramSettings] = useState({});

const [selectedAdminUser, setSelectedAdminUser] = useState(null);
const [adminTab, setAdminTab] = useState("users");
const [adminUserSearch, setAdminUserSearch] = useState("");
const [wpList, setWpList] = useState([]);
const [wpEditing, setWpEditing] = useState(null);
const [wpWorkoutIdx, setWpWorkoutIdx] = useState(null);
const [wpExEditIdx, setWpExEditIdx] = useState(null);
const [wpSaving, setWpSaving] = useState(false);
const [wpReviewExercises, setWpReviewExercises] = useState(null);
const [wpSubTab, setWpSubTab] = useState("programs");
const [wpSelectedWorkouts, setWpSelectedWorkouts] = useState([]);
const [wpBatchPending, setWpBatchPending] = useState(null);
const [wpUpdateModal, setWpUpdateModal] = useState(null);
const [wpExpandedPrograms, setWpExpandedPrograms] = useState({});
const [adminOnboardingSubTab, setAdminOnboardingSubTab] = useState("programHabits");
const [adminGameSubTab, setAdminGameSubTab] = useState("gameContent");
const [leaderboardVisibilityOpen, setLeaderboardVisibilityOpen] = useState(false);
const [adminDashboardFeedback, setAdminDashboardFeedback] = useState([]);
const [adminDashboardWeeklyPrompt, setAdminDashboardWeeklyPrompt] = useState(null);
const [adminDashboardPendingBroadcasts, setAdminDashboardPendingBroadcasts] = useState([]);
const [adminDashboardViewDate, setAdminDashboardViewDate] = useState(new Date());
const [coachSubmitText, setCoachSubmitText] = useState("");
const [coachSubmitting, setCoachSubmitting] = useState(false);
const [adminUserStatus, setAdminUserStatus] = useState("active");
const [adminUserStartDate, setAdminUserStartDate] = useState("");
const [adminUserEndDate, setAdminUserEndDate] = useState("");
const [adminReviveStartDate, setAdminReviveStartDate] = useState("");
const [adminUserStartingXP, setAdminUserStartingXP] = useState(0);
const [adminUserprogramTag, setAdminUserprogramTag] = useState("");
const [adminUserCategoryTags, setAdminUserCategoryTags] = useState([]);
const [adminUserWeeklyGoalFreqs, setAdminUserWeeklyGoalFreqs] = useState({ nutrition: null, movement: null, mindset: null });
const [adminUserWeekStartDay, setAdminUserWeekStartDay] = useState("monday");
const [adminLeaderboardProgramFilter, setAdminLeaderboardProgramFilter] = useState("all");
const [activityProgramFilter, setActivityProgramFilter] = useState("all");
const [adminNutritionDate, setAdminNutritionDate] = useState(new Date().toISOString().slice(0, 10));
const [dmUnread, setDmUnread] = useState(0);
const [adminUserAssignments, setAdminUserAssignments] = useState([]);
const [adminAssignmentsLoading, setAdminAssignmentsLoading] = useState(false);
const [programLeaderboardUsers, setProgramLeaderboardUsers] = useState([]);
const [adminSettingsEditMode, setAdminSettingsEditMode] = useState(false);
const [adminXPAdjustAmount, setAdminXPAdjustAmount] = useState(0);
const [adminXPAdjustNote, setAdminXPAdjustNote] = useState("");
const [adminXPAdjustLog, setAdminXPAdjustLog] = useState([]);
const [adminXPAdjustLogLoading, setAdminXPAdjustLogLoading] = useState(false);
const [customizeTab, setCustomizeTab] = useState("tracking");
const [adminActivityEvents, setAdminActivityEvents] = useState([]);
const [adminActivityUnread, setAdminActivityUnread] = useState(0);
const [userNotifications, setUserNotifications] = useState([]);
const [showNotifInbox, setShowNotifInbox] = useState(false);
const [showFABMenu, setShowFABMenu] = useState(false);
const [fabTab, setFabTab] = useState(0); // 0=My Log, 1=Clients
const fabSwipeStartX = useRef(null);
const [fabInitBroadcastType, setFabInitBroadcastType] = useState(null);
const [fabInitBroadcastKey, setFabInitBroadcastKey] = useState(0);
const [inActiveCall, setInActiveCall] = useState(false);
const [sideQuestLogDate, setSideQuestLogDate] = useState(() => formatDateKey(new Date()));
const sideQuestDateScrollRef = useRef(null);
const [youInitAction, setYouInitAction] = useState(null);
const [highlightPostId, setHighlightPostId] = useState(null);
const [coachInfo, setCoachInfo] = useState(null);
const [coachId, setCoachId] = useState("");
const [adminUserCoachId, setAdminUserCoachId] = useState("");
const [resetConfirmStep, setResetConfirmStep] = useState(0); // 0=idle 1=first 2=second
const [resetConfirmInput, setResetConfirmInput] = useState("");
const [resetInProgress, setResetInProgress] = useState(false);
const [deleteAccountStep, setDeleteAccountStep] = useState(0); // 0=idle 1=confirm 2=deleting
const [deleteAccountError, setDeleteAccountError] = useState("");
const [deleteAccountConfirmText, setDeleteAccountConfirmText] = useState("");

// Level-up celebration
const [levelUpBanner, setLevelUpBanner] = useState(null); // { level, xp }
const prevLevelRef = useRef(null);
const xpBaseRef = useRef(null); // tracks startingXP + xpAdjustmentTotal from last snapshot
const challengeDeclinedRef = useRef(false); // set true when user cancels challenge; prevents auto-re-accept

// Pinned notes for dashboard
const [pinnedNotes, setPinnedNotes] = useState([]);

const defaultInfoTexts = {
  weekly: "Each week your coach sets a bonus challenge. Complete it once during the week to earn extra XP — it doesn't affect your streak either way. Think of it as a little push beyond your daily habits.",
  habitsIntro: "Each category has 3 capacity levels — do whichever fits your day:",
  habitsKeepStreak: "The minimum — enough to keep your streak going on a tough day.",
  questAssignments: "Weekly Quest Assignments are reflection prompts from your coach. Submit your response each week for bonus XP. Your coach reviews and responds to every submission.",
  sideQuests: "Side Quests are one-off bonus tasks for extra XP. Tap a quest to complete it today. Tap the 📅 icon to schedule it to appear on your dashboard automatically on specific days.",
  habitsMainQuest: "The standard goal for a solid day.",
  habitsExtraCredit: "For when you're crushing it — earns the most XP.",
  habitsWarning: "⚠️ The 3 core categories (Nutrition, Movement, Mindset) must each be completed at some level every day. Miss one and your streak breaks — you'll need a Revive to restore it.",
  habitsExtra: "This is an optional habit category you added for extra XP. Completing it earns points, but it doesn't affect your streak — missing it won't require a Revive. Use it to level up beyond the core three.",
};
const [infoTexts, setInfoTexts] = useState(defaultInfoTexts);

  const FULL_REVIVE_COST = 25;
const CATEGORY_TOKEN_COST = 10;
const BULK_CHALLENGE_KEY = "all-debt";
const REQUIRED_SIGNUP_CODE = "QTQBETA";
const DEFAULT_COACH_ID = "A7p7VRScy3UIYwGhrX9zsz7PWTb2";
const [pendingProgramTag, setPendingProgramTag] = useState("momentum");

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes sparkle-burst {
        0% {
          transform: translate(0px, 0px) scale(0.6) rotate(0deg);
          opacity: 0;
        }
        10% {
          opacity: 1;
        }
        100% {
          transform: translate(var(--dx), var(--dy)) scale(1.5) rotate(var(--rot));
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  function createSparkleBurst(event) {
    const emojis = ["✨", "💎", "⭐", "🌟"];
    const rect = event?.currentTarget?.getBoundingClientRect();

    const originX = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
    const originY = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;

    const newSparkles = Array.from({ length: 18 }, (_, index) => {
      const angle = (Math.PI * 2 * index) / 18;
      const distance = 60 + Math.random() * 140;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance - Math.random() * 40;

      return {
        id: `${Date.now()}-${index}-${Math.random()}`,
        emoji: emojis[Math.floor(Math.random() * emojis.length)],
        x: originX,
        y: originY,
        dx: `${dx}px`,
        dy: `${dy}px`,
        rot: `${Math.floor(Math.random() * 220 - 110)}deg`,
        size: 18 + Math.random() * 18,
        duration: 700 + Math.random() * 500,
      };
    });

    setSparkles((prev) => [...prev, ...newSparkles]);

    setTimeout(() => {
      setSparkles((prev) =>
        prev.filter(
          (sparkle) =>
            !newSparkles.some((newSparkle) => newSparkle.id === sparkle.id)
        )
      );
    }, 1400);
  }

  function formatDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function formatDisplayDate(date) {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  function changeDay(days) {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + days);
    setCurrentDate(newDate);
  }

  function getDateKeyFromDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function getStartOfWeek(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    d.setHours(12, 0, 0, 0);
    return d;
  }

  function getWeekKey(date) {
    return getDateKeyFromDate(getStartOfWeek(date));
  }

  function getCurrentWeeklyChallenge(date, programTagOverride = userprogramTag) {
  const allChallenges = gameContent.weeklyChallenges || [];
  const dateKey = getDateKeyFromDate(date);
  const activeProgramTag = (programTagOverride || "").toLowerCase();

  const matchesProgram = (c) => {
    if (!c.targetProgram || c.targetProgram === "all") return true;
    const target = String(c.targetProgram || "").toLowerCase();
    if (target === activeProgramTag) return true;
    // "quit-the-quit" family: challenges targeted at "quit-the-quit" also match any "quit-the-quit-*" variant
    if (target === "quit-the-quit" && activeProgramTag && activeProgramTag.startsWith("quit-the-quit")) return true;
    return false;
  };

  // First: try to find a challenge whose startDate/endDate covers this date
  const dated = allChallenges.find(
    (c) => c.active && matchesProgram(c) && c.startDate && c.endDate && dateKey >= c.startDate && dateKey <= c.endDate
  );
  if (dated) return { ...dated, xp: dated.xp || 10 };

  // Fallback: rotate through active challenges without dates
  const undated = allChallenges.filter((c) => c.active && matchesProgram(c) && (!c.startDate || !c.endDate));
  if (undated.length === 0) {
    return {
      id: "fallback",
      emoji: "⭐",
      text: "No weekly challenge set yet",
      xp: 0,
      active: true,
    };
  }

  const weekStart = getStartOfWeek(date);
  const seed = Math.floor(weekStart.getTime() / (1000 * 60 * 60 * 24 * 7));
  const challenge = undated[Math.abs(seed) % undated.length];
  return { ...challenge, xp: challenge.xp || 10 };
}

  function getReviveData(dateKey) {
    return revivedDays[dateKey] || {
      nutrition: false,
      movement: false,
      mindset: false,
    };
  }

  function categoryResolved(daySelections, dateKey, category) {
    const reviveData = getReviveData(dateKey);
    return Boolean(daySelections?.[category] || reviveData?.[category]);
  }

  function fullQuestResolved(daySelections, dateKey) {
    return (
      categoryResolved(daySelections, dateKey, "nutrition") &&
      categoryResolved(daySelections, dateKey, "movement") &&
      categoryResolved(daySelections, dateKey, "mindset")
    );
  }

 const currentDateKey = formatDateKey(currentDate);
const currentWeekKey = getWeekKey(currentDate);
const currentWeeklyChallenge = getCurrentWeeklyChallenge(currentDate);

const realToday = new Date();
realToday.setHours(12, 0, 0, 0);

const viewedDate = new Date(currentDate);
viewedDate.setHours(12, 0, 0, 0);

const isMobile = window.innerWidth <= 640;

function isBeforeStartDate() {
  if (!userStartDate) return false;
  return currentDateKey < userStartDate;
}

function isAfterEndDate() {
  if (!userEndDate) return false;
  return currentDateKey > userEndDate;
}

function isBeforeReviveStartDate(dateKey) {
  if (!reviveStartDate) return true;
  return dateKey < reviveStartDate;
}

function hasProgramAccess() {
  if (userStatus === "ended") return false;
  if (isAfterEndDate()) return false;
  return true;
}

function canUseProgramToday() {
  if (!hasProgramAccess()) return false;
  if (isBeforeStartDate()) return false;
  return true;
}

function getDefaultDaySelections() {
  return {
    nutrition: null,
    movement: null,
    mindset: null,
    weekly: false,
  };
}

function getEmptyReviveState() {
  return {
    nutrition: false,
    movement: false,
    mindset: false,
  };
}

function getTrackingStartDate() {
  const allTrackedKeys = [
    ...Object.keys(dailySelections),
    ...Object.keys(revivedDays),
    ...Object.keys(dailyCheckIns),
  ].sort();

  if (allTrackedKeys.length === 0) return null;

  return new Date(`${allTrackedKeys[0]}T12:00:00`);
}

function getOriginalMissedCategories(dateKey) {
  const daySelections = dailySelections[dateKey] || getDefaultDaySelections();

  return {
    nutrition: !Boolean(daySelections.nutrition),
    movement: !Boolean(daySelections.movement),
    mindset: !Boolean(daySelections.mindset),
  };
}

function getResolvedStateForDate(dateKey) {
  return revivedDays[dateKey] || getEmptyReviveState();
}
function getDebtItemKey(item) {
  return item.type === "revive"
    ? `revive-${item.dateKey}`
    : `${item.category}-${item.dateKey}`;
}
function markDebtResolvedToday(item) {
  const itemKey = getDebtItemKey(item);
  const todayKey = formatDateKey(realToday);

  setResolvedDebtLog((prev) => ({
    ...prev,
    [itemKey]: todayKey,
  }));
}

function clearResolvedDebtLog(itemKey) {
  setResolvedDebtLog((prev) => {
    const updated = { ...prev };
    delete updated[itemKey];
    return updated;
  });
}
function getTodaySelections() {
  return dailySelections[formatDateKey(realToday)] || {
    nutrition: null,
    movement: null,
    mindset: null,
    weekly: false,
  };
}
function isSideQuestCompleted(dateKey, title) {
  return Boolean(sideQuestCompletions[dateKey]?.[title]);
}

function isSideQuestCompletedToday(title) {
  return isSideQuestCompleted(formatDateKey(realToday), title);
}
function isChallengeAccepted(item) {
  return Boolean(activeChallenges[getDebtItemKey(item)]);
}

function isChallengeComplete(item) {
  const todaySelections = getTodaySelections();

  if (item.type === "revive") {
    return (
      Boolean(todaySelections.nutrition) &&
      Boolean(todaySelections.movement) &&
      Boolean(todaySelections.mindset)
    );
  }

  return Boolean(todaySelections[item.category]);
}
// Expand vacations array into a flat lookup: { "YYYY-MM-DD": true }
const vacationDays = vacations.reduce((acc, v) => {
  if (!v.start || !v.end) return acc;
  const start = new Date(`${v.start}T12:00:00`);
  const end = new Date(`${v.end}T12:00:00`);
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    acc[getDateKeyFromDate(new Date(d))] = true;
  }
  return acc;
}, {});
// Flexible vacation mode: freeze all days from activation through today
if (vacationModeActive && vacationModeStart) {
  const modeStart = new Date(`${vacationModeStart}T12:00:00`);
  for (let d = new Date(modeStart); d <= realToday; d.setDate(d.getDate() + 1)) {
    vacationDays[getDateKeyFromDate(new Date(d))] = true;
  }
}

// Returns the weekly goal settings that were in effect on a specific date.
// The log is sorted ascending by date; we take the last entry on-or-before dateKey.
function getEffectiveFreqs(dateKey) {
  const defaultFreqs = { nutrition: null, movement: null, mindset: null };
  if (!weeklyGoalFreqsLog || weeklyGoalFreqsLog.length === 0) return defaultFreqs;
  let effective = defaultFreqs;
  for (const entry of weeklyGoalFreqsLog) {
    if (entry.date <= dateKey) effective = entry.freqs;
    else break;
  }
  return effective;
}

function getWeekMonday(dateKey) {
  const d = new Date(`${dateKey}T12:00:00`);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d.toISOString().slice(0, 10);
}

function getWeekStart(dateKey) {
  const d = new Date(`${dateKey}T12:00:00`);
  const day = d.getDay(); // 0=Sun
  if (weekStartDay === "sunday") {
    d.setDate(d.getDate() - day);
  } else {
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
  }
  return d.toISOString().slice(0, 10);
}

function getWeekDays(startKey) {
  const days = [];
  const d = new Date(`${startKey}T12:00:00`);
  for (let i = 0; i < 7; i++) {
    days.push(d.toISOString().slice(0, 10));
    d.setDate(d.getDate() + 1);
  }
  return days;
}

function formatWeekLabel(startKey) {
  const d = new Date(`${startKey}T12:00:00`);
  const end = new Date(d);
  end.setDate(end.getDate() + 6);
  const fmt = (date) => date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `${fmt(d)} – ${fmt(end)}`;
}

function getWeeklyGoalDebtItems() {
  const categories = ["nutrition", "movement", "mindset"];
  const items = [];
  const today = formatDateKey(realToday);
  const earliest = reviveStartDate || today;
  // Also don't go back further than the earliest log entry
  const firstLogDate = weeklyGoalFreqsLog.length > 0 ? weeklyGoalFreqsLog[0].date : today;
  let weekStart = getWeekStart(today);
  for (let w = 0; w < 8; w++) {
    const days = getWeekDays(weekStart);
    const weekEnd = days[6];
    // Stop if this week ended before reviveStartDate or before any goals were ever set
    if (weekEnd < earliest || weekEnd < firstLogDate) break;
    const pastDays = days.filter(d => d <= today);
    for (const cat of categories) {
      const tokenKey = `${weekStart}_${cat}`;
      if (weeklyTokensApplied[tokenKey]) continue;
      // Find days in this week where the weekly goal was active for this category
      const activeDays = days.filter(d => {
        const freqs = getEffectiveFreqs(d);
        return freqs[cat] !== null && freqs[cat] !== undefined;
      });
      if (activeDays.length === 0) continue;
      // Goal = the value in effect on the last active day of the week (or today if current week)
      const lastActiveDay = activeDays[activeDays.length - 1];
      const requestedGoal = getEffectiveFreqs(lastActiveDay)[cat];
      if (!requestedGoal) continue;
      // Effective goal is capped at number of active days (can't require more than available)
      const effectiveGoal = Math.min(requestedGoal, activeDays.length);
      const dayCompletions = {};
      days.forEach(d => {
        dayCompletions[d] = !vacationDays[d] && Boolean(dailySelections[d]?.[cat]);
      });
      const activePastDays = activeDays.filter(d => d <= today);
      const doneCount = activePastDays.filter(d => !vacationDays[d] && dayCompletions[d]).length;
      const remaining = activeDays.filter(d => d >= today && !vacationDays[d]).length;
      const needed = effectiveGoal - doneCount;
      if (needed <= 0) continue;
      if (remaining < needed) {
        items.push({
          type: "weeklyToken",
          weekMonday: weekStart,
          weekLabel: formatWeekLabel(weekStart),
          category: cat,
          doneCount,
          goal: effectiveGoal,
          cost: CATEGORY_TOKEN_COST,
          days,
          dayCompletions,
          activeDays,
        });
      }
    }
    const prev = new Date(`${weekStart}T12:00:00`);
    prev.setDate(prev.getDate() - 7);
    weekStart = prev.toISOString().slice(0, 10);
  }
  return items;
}

function getMissedDebtItems() {
  if (!reviveStartDate) return [];

  const startDate = new Date(`${reviveStartDate}T12:00:00`);
  const dayBeforeToday = new Date(realToday);
  dayBeforeToday.setDate(realToday.getDate() - 1);

  if (dayBeforeToday < startDate) return [];

  const debts = [];

  for (
    let checkDate = new Date(dayBeforeToday);
    checkDate >= startDate;
    checkDate.setDate(checkDate.getDate() - 1)
  ) {
    const dateKey = getDateKeyFromDate(checkDate);
    if (vacationDays[dateKey]) continue; // vacation days are frozen — no debt
    const originalMissed = getOriginalMissedCategories(dateKey);
    const reviveState = getResolvedStateForDate(dateKey);

    // Only consider categories not covered by a weekly frequency goal ON THIS SPECIFIC DAY
    const effectiveFreqs = getEffectiveFreqs(dateKey);
    const dailyCats = ["nutrition", "movement", "mindset"].filter(cat => !effectiveFreqs[cat]);
    const catsWithDebt = dailyCats.filter(cat => originalMissed[cat]);

    if (catsWithDebt.length === 0) continue;

    if (catsWithDebt.length === 3) {
      debts.push({
        type: "revive",
        dateKey,
        label: formatDisplayDate(new Date(`${dateKey}T12:00:00`)),
        cost: FULL_REVIVE_COST,
        isApplied:
          reviveState.nutrition &&
          reviveState.movement &&
          reviveState.mindset,
      });
    } else {
      const emojiMap = { nutrition: "🥕", movement: "👟", mindset: "🌙" };
      for (const cat of catsWithDebt) {
        debts.push({
          type: "token",
          category: cat,
          emoji: emojiMap[cat],
          dateKey,
          label: formatDisplayDate(new Date(`${dateKey}T12:00:00`)),
          cost: CATEGORY_TOKEN_COST,
          isApplied: reviveState[cat],
        });
      }
    }
  }

  return debts;
}

const missedDebtItems = getMissedDebtItems();
const unresolvedDebtItems = missedDebtItems.filter((item) => !item.isApplied);
const weeklyGoalDebtItems = getWeeklyGoalDebtItems();

const resolvedItemsForViewedDay = missedDebtItems.filter((item) => {
  const itemKey = getDebtItemKey(item);
  return item.isApplied && resolvedDebtLog[itemKey] === currentDateKey;
});

const shouldShowDebtSection =
  unresolvedDebtItems.length > 0 || weeklyGoalDebtItems.length > 0 || resolvedItemsForViewedDay.length > 0;

// Only unresolved items go in the main list; resolved-today items render separately below the challenge card
const displayedDebtItems = [...unresolvedDebtItems, ...weeklyGoalDebtItems];

const isLocked = displayedDebtItems.length > 0;
const hasAcceptedChallenge = Object.values(activeChallenges).some(Boolean);
const isViewingTodayOrFuture = viewedDate >= realToday;
// Unlock today when a challenge is accepted — the user must check off habits to complete it
const shouldDisableCurrentView = isLocked && isViewingTodayOrFuture && !hasAcceptedChallenge;

const totalDebtCost = displayedDebtItems.reduce(
  (sum, item) => sum + item.cost,
  0
);

const selectedHabits = dailySelections[currentDateKey] || {
  nutrition: null,
  movement: null,
  mindset: null,
  weekly: false,
};
const activeSideQuests = gameContent.sideQuests.filter(
  (quest) => quest.active
);
const activeBonusXPOpportunities = gameContent.bonusXPOpportunities.filter(
  (item) => item.active
);
const activeBadges = gameContent.badges.filter((badge) => badge.active);

  function getDayXP(daySelections, dateKey = null) {
  if (!daySelections) return 0;

  const challengeDate = dateKey
    ? new Date(`${dateKey}T12:00:00`)
    : realToday;

  const weeklyChallengeForDay = getCurrentWeeklyChallenge(challengeDate);
  const weeklyXP = weeklyChallengeForDay?.xp || 0;

  return (
    (daySelections.nutrition
      ? customHabits.nutrition[daySelections.nutrition].xp
      : 0) +
    (daySelections.movement
      ? customHabits.movement[daySelections.movement].xp
      : 0) +
    (daySelections.mindset
      ? customHabits.mindset[daySelections.mindset].xp
      : 0) +
    (daySelections.weekly ? weeklyXP : 0) +
    extraCategories.reduce((sum, cat) =>
      sum + (daySelections[cat.key] ? (customHabits[cat.key]?.[daySelections[cat.key]]?.xp || 0) : 0), 0)
  );
}

  const earnedXPFromHabits = Object.entries(dailySelections).reduce(
  (total, [dateKey, daySelections]) => total + getDayXP(daySelections, dateKey),
  0
);

const sideQuestXPByTitle = Object.fromEntries(
  activeSideQuests.map((quest) => [quest.title, quest.xp])
);

const earnedXPFromSideQuests = Object.entries(sideQuestCompletions).reduce(
  (total, [, completedQuests]) =>
    total +
    Object.entries(completedQuests).reduce(
      (dayTotal, [title, completed]) =>
        dayTotal + (completed ? sideQuestXPByTitle[title] || 0 : 0),
      0
    ),
  0
);

const earnedXPBeforeSpending =
  earnedXPFromHabits + earnedXPFromSideQuests;

// challengeCosts is kept only as an undo marker (challenge-claimed vs. XP-paid).
// It no longer deducts from XP — challenges are free when the user has no XP.
const totalChallengeCost = 0;

const [xpAdjustmentTotal, setXpAdjustmentTotal] = useState(0);
const [bodyMetricsConfig, setBodyMetricsConfig] = useState({});
const [bodyMetricsXpLog, setBodyMetricsXpLog] = useState({});

const totalXP = Math.max(
  0,
  startingXP + xpAdjustmentTotal + earnedXPBeforeSpending - spentXP
);

// Items client can't afford with current XP — covered by the single bulk challenge
const unaffordableUnresolvedItems =
  totalDebtCost > totalXP ? unresolvedDebtItems : [];
// Any accepted challenge (old per-item keys or new bulk key) counts
const isChallengeAllAccepted = Object.values(activeChallenges).some(Boolean);
const isChallengeAllComplete = (() => {
  const s = getTodaySelections();
  return Boolean(s.nutrition) && Boolean(s.movement) && Boolean(s.mindset);
})();

const isChallengeInProgress = isChallengeAllAccepted && !isChallengeAllComplete && unaffordableUnresolvedItems.length > 0;

const xpPerLevel = 500;
const level = Math.floor(totalXP / xpPerLevel) + 1;
const xpIntoLevel = totalXP % xpPerLevel;
const progressPercent = (xpIntoLevel / xpPerLevel) * 100;

  function dayCountsForCategory(daySelections, category) {
  return Boolean(daySelections?.[category]);
}

  function dayCountsForFullQuest(daySelections) {
  return (
    Boolean(daySelections?.nutrition) &&
    Boolean(daySelections?.movement) &&
    Boolean(daySelections?.mindset)
  );
}

  function calculateCategoryCurrentStreak(selections, category) {
    let streak = 0;
    const today = new Date();

    for (let i = 0; i < 3650; i++) {
      const checkDate = new Date(today);
      checkDate.setDate(today.getDate() - i);
      const dateKey = getDateKeyFromDate(checkDate);

      if (vacationDays[dateKey]) continue; // skip — doesn't break or add to streak
      if (dayCountsForCategory(selections[dateKey], category)) {
        streak++;
      } else {
        break;
      }
    }

    return streak;
  }

  function gapBridgedByVacation(dateKeyA, dateKeyB) {
    // Returns true if every day strictly between dateKeyA and dateKeyB is a vacation day
    const a = new Date(`${dateKeyA}T12:00:00`);
    const b = new Date(`${dateKeyB}T12:00:00`);
    const diff = Math.round((b - a) / (1000 * 60 * 60 * 24));
    if (diff <= 1) return true;
    for (let d = 1; d < diff; d++) {
      const mid = new Date(a);
      mid.setDate(a.getDate() + d);
      if (!vacationDays[getDateKeyFromDate(mid)]) return false;
    }
    return true;
  }

  function calculateCategoryLongestStreak(selections, category) {
    const completedDays = Object.keys(selections)
  .filter((dateKey) =>
    dayCountsForCategory(selections[dateKey], category)
  )
  .sort();

if (completedDays.length === 0) return 0;

let longest = 1;
let current = 1;

for (let i = 1; i < completedDays.length; i++) {
      if (gapBridgedByVacation(completedDays[i - 1], completedDays[i])) {
        current++;
        if (current > longest) longest = current;
      } else {
        current = 1;
      }
    }

    return longest;
  }

  // ── Shield-aware full-quest check ─────────────────────────────────────────
  // A day counts as a full quest day if the user logged all 3 habits OR
  // the shield auto-activated for that day.
  function dayCountsForFullQuestWithShield(dateKey, selections) {
    if (dayCountsForFullQuest(selections[dateKey])) return true;
    if (shieldActivatedDays[dateKey]) return true;
    return false;
  }

  function calculateFullQuestCurrentStreak(selections) {
    let streak = 0;
    const today = new Date();

    for (let i = 0; i < 3650; i++) {
      const checkDate = new Date(today);
      checkDate.setDate(today.getDate() - i);
      const dateKey = getDateKeyFromDate(checkDate);

      if (vacationDays[dateKey]) continue; // skip — doesn't break or add to streak
      if (dayCountsForFullQuestWithShield(dateKey, selections)) {
        streak++;
      } else {
        break;
      }
    }

    return streak;
  }

  function calculateFullQuestLongestStreak(selections) {
    // Merge actual completions + shield-activated days
    const allDays = new Set([
      ...Object.keys(selections).filter((dk) => dayCountsForFullQuest(selections[dk])),
      ...Object.keys(shieldActivatedDays),
    ]);
    const completedDays = [...allDays].sort();

if (completedDays.length === 0) return 0;

    let longest = 1;
    let current = 1;

    for (let i = 1; i < completedDays.length; i++) {
      if (gapBridgedByVacation(completedDays[i - 1], completedDays[i])) {
        current++;
        if (current > longest) longest = current;
      } else {
        current = 1;
      }
    }

    return longest;
  }

  function calculateWeeklyChallengeCurrentStreak(selections) {
    let streak = 0;
    const today = new Date();

    for (let i = 0; i < 3650; i++) {
      const checkDate = new Date(today);
      checkDate.setDate(today.getDate() - i);
      const dateKey = getDateKeyFromDate(checkDate);

      if (selections[dateKey]?.weekly) {
        streak++;
      } else {
        break;
      }
    }

    return streak;
  }

  function calculateWeeklyChallengeLongestStreak(selections) {
    const completedDays = Object.keys(selections)
      .filter((dateKey) => Boolean(selections[dateKey]?.weekly))
      .sort();

    if (completedDays.length === 0) return 0;

    let longest = 1;
    let current = 1;

    for (let i = 1; i < completedDays.length; i++) {
      const previousDate = new Date(`${completedDays[i - 1]}T12:00:00`);
      const currentDate = new Date(`${completedDays[i]}T12:00:00`);

      const diffInDays = Math.round(
        (currentDate - previousDate) / (1000 * 60 * 60 * 24)
      );

      if (diffInDays === 1) {
        current++;
        if (current > longest) longest = current;
      } else {
        current = 1;
      }
    }

    return longest;
  }

  function calculateLoginCurrentStreak(checkIns) {
    let streak = 0;
    const today = new Date();

    for (let i = 0; i < 3650; i++) {
      const checkDate = new Date(today);
      checkDate.setDate(today.getDate() - i);
      const dateKey = getDateKeyFromDate(checkDate);

      if (checkIns[dateKey]) {
        streak++;
      } else {
        break;
      }
    }

    return streak;
  }

  function calculateLoginLongestStreak(checkIns) {
    const activeDays = Object.keys(checkIns)
      .filter((dateKey) => Boolean(checkIns[dateKey]))
      .sort();

    if (activeDays.length === 0) return 0;

    let longest = 1;
    let current = 1;

    for (let i = 1; i < activeDays.length; i++) {
      const previousDate = new Date(`${activeDays[i - 1]}T12:00:00`);
      const currentDate = new Date(`${activeDays[i]}T12:00:00`);

      const diffInDays = Math.round(
        (currentDate - previousDate) / (1000 * 60 * 60 * 24)
      );

      if (diffInDays === 1) {
        current++;
        if (current > longest) longest = current;
      } else {
        current = 1;
      }
    }

    return longest;
  }

  const nutritionCurrentStreak = calculateCategoryCurrentStreak(
    dailySelections,
    "nutrition"
  );
  const nutritionLongestStreak = calculateCategoryLongestStreak(
    dailySelections,
    "nutrition"
  );

  const movementCurrentStreak = calculateCategoryCurrentStreak(
    dailySelections,
    "movement"
  );
  const movementLongestStreak = calculateCategoryLongestStreak(
    dailySelections,
    "movement"
  );

  const mindsetCurrentStreak = calculateCategoryCurrentStreak(
    dailySelections,
    "mindset"
  );
  const mindsetLongestStreak = calculateCategoryLongestStreak(
    dailySelections,
    "mindset"
  );

  const fullQuestCurrentStreak =
    calculateFullQuestCurrentStreak(dailySelections);
  const fullQuestLongestStreak =
    calculateFullQuestLongestStreak(dailySelections);

  const challengeCurrentStreak =
    calculateWeeklyChallengeCurrentStreak(dailySelections);
  const challengeLongestStreak =
    calculateWeeklyChallengeLongestStreak(dailySelections);

  const loginCurrentStreak = calculateLoginCurrentStreak(dailyCheckIns);
  const loginLongestStreak = calculateLoginLongestStreak(dailyCheckIns);

  const badges = activeBadges.map((badge) => {
  let earned = false;

  if (badge.type === "xp") {
    earned = totalXP >= badge.threshold;
  } else if (badge.type === "level") {
    earned = level >= badge.threshold;
  } else if (badge.type === "nutritionStreak") {
    earned =
      nutritionCurrentStreak >= badge.threshold ||
      nutritionLongestStreak >= badge.threshold;
  } else if (badge.type === "movementStreak") {
    earned =
      movementCurrentStreak >= badge.threshold ||
      movementLongestStreak >= badge.threshold;
  } else if (badge.type === "mindsetStreak") {
    earned =
      mindsetCurrentStreak >= badge.threshold ||
      mindsetLongestStreak >= badge.threshold;
  } else if (badge.type === "fullQuestStreak") {
    earned =
      fullQuestCurrentStreak >= badge.threshold ||
      fullQuestLongestStreak >= badge.threshold;
  } else if (badge.type === "weeklyChallengeStreak") {
    earned =
      challengeCurrentStreak >= badge.threshold ||
      challengeLongestStreak >= badge.threshold;
  } else if (badge.type === "loginStreak") {
    earned =
      loginCurrentStreak >= badge.threshold ||
      loginLongestStreak >= badge.threshold;
  } else if (badge.type === "loginAfterMissedDay") {
    // earned if user ever logged in the day after a fully-missed habit day
    const checkInDates = Object.keys(dailyCheckIns).sort();
    earned = checkInDates.some((dateKey) => {
      const prev = new Date(`${dateKey}T12:00:00`);
      prev.setDate(prev.getDate() - 1);
      const prevKey = formatDateKey(prev);
      const prevSel = dailySelections[prevKey];
      const missedPrev = !prevSel || (!prevSel.nutrition && !prevSel.movement && !prevSel.mindset);
      return missedPrev && dailyCheckIns[dateKey];
    });
  } else if (badge.type === "reviveUsed") {
    earned = Object.keys(revivedDays).length >= badge.threshold;
  } else if (badge.type === "habitsAfterRevive") {
    // earned if, after any revived day, the user completed at least one habit the next day
    earned = Object.keys(revivedDays).some((dateKey) => {
      const next = new Date(`${dateKey}T12:00:00`);
      next.setDate(next.getDate() + 1);
      const nextKey = formatDateKey(next);
      const nextSel = dailySelections[nextKey];
      return nextSel && (nextSel.nutrition || nextSel.movement || nextSel.mindset);
    });
  } else if (badge.type === "shieldEarned") {
    earned =
      shieldStatus === "ready" ||
      Object.keys(shieldActivatedDays).length >= badge.threshold;
  } else if (badge.type === "sideQuestCount") {
    const totalCompleted = Object.values(sideQuestCompletions).reduce(
      (sum, dayQuests) =>
        sum + Object.values(dayQuests || {}).filter(Boolean).length,
      0
    );
    earned = totalCompleted >= badge.threshold;
  }

  return {
    ...badge,
    earned,
  };
});

  const earnedBadges = badges.filter((badge) => badge.earned);

  function markTodayCheckIn() {
    const todayKey = formatDateKey(new Date());
    setDailyCheckIns((prev) => ({
      ...prev,
      [todayKey]: true,
    }));
  }

 function handleHabitClick(category, levelType, event) {
  if (shouldDisableCurrentView || !canUseProgramToday()) return;
  const CORE_CATEGORIES = ["nutrition", "movement", "mindset"];
  if (isChallengeInProgress && !CORE_CATEGORIES.includes(category)) return;

  markTodayCheckIn();

  const currentLevel = selectedHabits[category] ?? null;
  const isUnclicking = currentLevel === levelType;

  if (!isUnclicking) {
    createSparkleBurst(event);
  }

  const habitLabel = customHabits[category]?.[levelType]?.habitName || levelType;
  const habitXP = customHabits[category]?.[levelType]?.xp || 0;
  const categoryLabel = getCatLabel(category);
  const prevLabel = currentLevel ? (customHabits[category]?.[currentLevel]?.habitName || currentLevel) : null;
  const prevXP = currentLevel ? (customHabits[category]?.[currentLevel]?.xp || 0) : null;
  const messageBase = `${categoryLabel} · ${habitLabel} (+${habitXP} XP)`;
  const message = isUnclicking
    ? `Unchecked ${messageBase}`
    : prevLabel && prevLabel !== habitLabel
    ? `Switched to ${messageBase} (was ${prevLabel} +${prevXP} XP)`
    : `Completed ${messageBase}`;

  writeActivityEvent({
    type: "habit_completed",
    userId: user?.uid,
    userName: profileName,
    userAvatar: selectedAvatar,
    message,
    meta: { category, levelType, dateKey: currentDateKey },
  });

  if (user?.uid && userprogramTag === "momentum") {
    if (!isUnclicking) {
      recordAutoProgress(user.uid, "habit", currentDateKey, { habitCategory: category });
    } else {
      removeAutoProgress(user.uid, "habit", currentDateKey, { habitCategory: category });
    }
  }

  const daySelections = dailySelections[currentDateKey] || { nutrition: null, movement: null, mindset: null, weekly: false };
  const newDailySelections = {
    ...dailySelections,
    [currentDateKey]: { ...daySelections, [category]: isUnclicking ? null : levelType },
  };
  setDailySelections(newDailySelections);
  if (user?.uid) {
    updateDoc(doc(db, "users", user.uid), { dailySelections: newDailySelections }).catch(console.error);
  }
}

  function handleWeeklyChallengeClick(event) {
  if (shouldDisableCurrentView || !canUseProgramToday()) return;
  if (isChallengeInProgress) return;
  markTodayCheckIn();

    const currentWeekly = (dailySelections[currentDateKey] || {}).weekly;
    if (!currentWeekly) {
      createSparkleBurst(event);
      const challengeXP = currentWeeklyChallenge?.xp || 10;
      writeActivityEvent({
        type: "weekly_challenge",
        userId: user?.uid,
        userName: profileName,
        userAvatar: selectedAvatar,
        message: `Completed Weekly Challenge · ${currentWeeklyChallenge.text || ""} (+${challengeXP} XP)`,
        meta: { dateKey: currentDateKey, xp: challengeXP },
      });

      // Auto-complete any linked side quests for this challenge
      const todayKey = formatDateKey(realToday);
      (currentWeeklyChallenge?.linkedSideQuests || []).forEach((questTitle) => {
        const alreadyDone = isSideQuestCompleted(todayKey, questTitle);
        if (!alreadyDone) handleSideQuestClick(questTitle, event);
      });
    } else {
      // Auto-unlog linked side quests when unchecking
      const todayKey = formatDateKey(realToday);
      (currentWeeklyChallenge?.linkedSideQuests || []).forEach((questTitle) => {
        const alreadyDone = isSideQuestCompleted(todayKey, questTitle);
        if (alreadyDone) handleSideQuestClick(questTitle, event);
      });
    }

    setDailySelections((prev) => {
      const daySelections = prev[currentDateKey] || {
        nutrition: null,
        movement: null,
        mindset: null,
        weekly: false,
      };

      return {
        ...prev,
        [currentDateKey]: {
          ...daySelections,
          weekly: !daySelections.weekly,
        },
      };
    });
  }

  function handleFullRevive(dateKey) {
  const reviveState = revivedDays[dateKey] || {
    nutrition: false,
    movement: false,
    mindset: false,
  };

  const isApplied =
    reviveState.nutrition &&
    reviveState.movement &&
    reviveState.mindset;

  const challengeKey = `revive-${dateKey}`;
  const wasChallengeApplied = challengeKey in challengeCosts;

  if (!isApplied && totalXP < FULL_REVIVE_COST) return;

  markTodayCheckIn();

  if (isApplied) {
    setRevivedDays((prev) => {
      const updated = { ...prev };
      delete updated[dateKey];
      return updated;
    });

    if (wasChallengeApplied) {
      setChallengeCosts((prev) => {
        const updated = { ...prev };
        delete updated[challengeKey];
        return updated;
      });
    }
    setSpentXP((prev) => Math.max(0, prev - FULL_REVIVE_COST));
    // Clear any pending challenge acceptance so auto-claim doesn't re-apply
    // this revive on the next page load.
    setActiveChallenges({});
    clearResolvedDebtLog(challengeKey);
  } else {
    setRevivedDays((prev) => ({
  ...prev,
  [dateKey]: {
    nutrition: true,
    movement: true,
    mindset: true,
  },
}));

setSpentXP((prev) => prev + FULL_REVIVE_COST);

writeActivityEvent({
  type: "revive_used",
  userId: user?.uid,
  userName: profileName,
  userAvatar: selectedAvatar,
  message: `Used Full Revive for ${dateKey} (-${FULL_REVIVE_COST} XP)`,
  meta: { dateKey, cost: FULL_REVIVE_COST },
});

addDoc(collection(db, "users", user.uid, "xpAdjustments"), {
  amount: FULL_REVIVE_COST,
  type: "spend",
  source: "revive",
  note: `Full Revive used for ${dateKey}`,
  createdAt: serverTimestamp(),
});

markDebtResolvedToday({
  type: "revive",
  dateKey,
});
  }

  setSaveStatus("Saving...");
}

  function handleCategoryToken(dateKey, category) {
  const existing = revivedDays[dateKey] || {
    nutrition: false,
    movement: false,
    mindset: false,
  };

  const isApplied = existing[category];
  const challengeKey = `${category}-${dateKey}`;
  const wasChallengeApplied = challengeKey in challengeCosts;

  if (!isApplied && totalXP < CATEGORY_TOKEN_COST) return;

  markTodayCheckIn();

  setRevivedDays((prev) => {
    const current = prev[dateKey] || {
      nutrition: false,
      movement: false,
      mindset: false,
    };

    const updatedDay = {
      ...current,
      [category]: !current[category],
    };

    const hasAny =
      updatedDay.nutrition || updatedDay.movement || updatedDay.mindset;

    if (!hasAny) {
      const updated = { ...prev };
      delete updated[dateKey];
      return updated;
    }

    return {
      ...prev,
      [dateKey]: updatedDay,
    };
  });

  if (isApplied) {
  if (wasChallengeApplied) {
    setChallengeCosts((prev) => {
      const updated = { ...prev };
      delete updated[challengeKey];
      return updated;
    });
  }
  setSpentXP((prev) => Math.max(0, prev - CATEGORY_TOKEN_COST));
  // Clear any pending challenge acceptance so auto-claim doesn't re-apply on reload.
  setActiveChallenges({});
  clearResolvedDebtLog(challengeKey);
} else {
  setSpentXP((prev) => prev + CATEGORY_TOKEN_COST);

  const catLabel = category.charAt(0).toUpperCase() + category.slice(1);
  writeActivityEvent({
    type: "token_used",
    userId: user?.uid,
    userName: profileName,
    userAvatar: selectedAvatar,
    message: `Used ${catLabel} Token for ${dateKey} (-${CATEGORY_TOKEN_COST} XP)`,
    meta: { category, dateKey, cost: CATEGORY_TOKEN_COST },
  });

  addDoc(collection(db, "users", user.uid, "xpAdjustments"), {
    amount: CATEGORY_TOKEN_COST,
    type: "spend",
    source: "token",
    note: `${catLabel} Token used for ${dateKey}`,
    createdAt: serverTimestamp(),
  });

  markDebtResolvedToday({
    type: "token",
    category,
    dateKey,
  });
}
  setSaveStatus("Saving...");
}
function handleWeeklyToken(weekMonday, category) {
  if (!user?.uid) return;
  if (totalXP < CATEGORY_TOKEN_COST) return;
  markTodayCheckIn();
  const tokenKey = `${weekMonday}_${category}`;
  const newApplied = { ...weeklyTokensApplied, [tokenKey]: true };
  setWeeklyTokensApplied(newApplied);
  setSpentXP((prev) => prev + CATEGORY_TOKEN_COST);
  const catLabel = category.charAt(0).toUpperCase() + category.slice(1);
  writeActivityEvent({
    type: "token_used",
    userId: user?.uid,
    userName: profileName,
    userAvatar: selectedAvatar,
    message: `Used ${catLabel} weekly goal token for week of ${weekMonday} (-${CATEGORY_TOKEN_COST} XP)`,
    meta: { category, weekMonday, cost: CATEGORY_TOKEN_COST },
  });
  addDoc(collection(db, "users", user.uid, "xpAdjustments"), {
    amount: CATEGORY_TOKEN_COST,
    type: "spend",
    source: "weeklyToken",
    note: `${catLabel} weekly goal token for week of ${weekMonday}`,
    createdAt: serverTimestamp(),
  });
  updateDoc(doc(db, "users", user.uid), { weeklyTokensApplied: newApplied }).catch(console.error);
  setSaveStatus("Saving...");
}

function handleDebtChallenge(item) {
  markTodayCheckIn();

  const itemKey = getDebtItemKey(item);

  setActiveChallenges((prev) => ({
    ...prev,
    [itemKey]: true,
  }));

  setSaveStatus("Saving...");
}
function handleClaimChallenge(item) {
  markTodayCheckIn();

  const itemKey = getDebtItemKey(item);

  if (item.type === "revive") {
    setRevivedDays((prev) => ({
      ...prev,
      [item.dateKey]: {
        nutrition: true,
        movement: true,
        mindset: true,
      },
    }));
  } else {
    setRevivedDays((prev) => {
      const current = prev[item.dateKey] || {
        nutrition: false,
        movement: false,
        mindset: false,
      };

      return {
        ...prev,
        [item.dateKey]: {
          ...current,
          [item.category]: true,
        },
      };
    });
  }

  // Deduct the full revive cost from spentXP. totalXP = Math.max(0, earned - spentXP),
  // so if the user's earned XP (including today's habits) covers the shortfall it comes
  // out naturally; if not, XP simply floors at zero — no ongoing debt.
  const claimCost = item.type === "revive" ? FULL_REVIVE_COST : CATEGORY_TOKEN_COST;
  setSpentXP((prev) => prev + claimCost);

  // Store the cost as a marker so the undo path knows this was challenge-claimed
  // and can refund spentXP correctly.
  setChallengeCosts((prev) => ({
    ...prev,
    [itemKey]: claimCost,
  }));

setActiveChallenges((prev) => {
  const updated = { ...prev };
  delete updated[itemKey];
  return updated;
});

markDebtResolvedToday(item);

  if (user?.uid) {
    const claimNote = item.type === "revive"
      ? `Challenge complete — full streak revived for ${item.dateKey}`
      : `Challenge complete — ${item.category} revived for ${item.dateKey}`;
    addDoc(collection(db, "users", user.uid, "xpAdjustments"), {
      amount: claimCost,
      type: "spend",
      source: "challenge",
      note: claimNote,
      createdAt: serverTimestamp(),
    }).catch(console.error);
  }

  setSaveStatus("Saving...");
}
function handleDebtChallengeAll() {
  markTodayCheckIn();
  setActiveChallenges((prev) => ({ ...prev, [BULK_CHALLENGE_KEY]: true }));
  setSaveStatus("Saving...");
}

function handlePayAll() {
  if (displayedDebtItems.length === 0) return;
  if (totalDebtCost <= totalXP) {
    for (const item of displayedDebtItems) {
      if (item.type === "weeklyToken") {
        handleWeeklyToken(item.weekMonday, item.category);
      } else if (item.type === "revive") {
        handleFullRevive(item.dateKey);
      } else {
        handleCategoryToken(item.dateKey, item.category);
      }
    }
  } else {
    handleDebtChallengeAll();
  }
}

function handleActivateRevive() {
  markTodayCheckIn();
  const items = unresolvedDebtItems;

  // Mark past days as revived
  const revivedUpdate = {};
  for (const item of items) {
    const existing = revivedUpdate[item.dateKey]
      || revivedDays[item.dateKey]
      || { nutrition: false, movement: false, mindset: false };
    if (item.type === "revive") {
      revivedUpdate[item.dateKey] = { nutrition: true, movement: true, mindset: true };
    } else {
      revivedUpdate[item.dateKey] = { ...existing, [item.category]: true };
    }
    markDebtResolvedToday(item);
  }
  const newRevivedDays = Object.keys(revivedUpdate).length > 0
    ? { ...revivedDays, ...revivedUpdate }
    : revivedDays;
  if (Object.keys(revivedUpdate).length > 0) {
    setRevivedDays(newRevivedDays);
  }

  // Reset XP to 0 — set spentXP = current earned total so totalXP lands at exactly 0
  const newSpentXP = startingXP + xpAdjustmentTotal + earnedXPBeforeSpending;
  setSpentXP(newSpentXP);
  setActiveChallenges({});
  setShowReviveActivationModal(false);

  // Immediately persist so a page refresh doesn't re-trigger the challenge
  if (user?.uid) {
    updateDoc(doc(db, "users", user.uid), {
      spentXP: newSpentXP,
      activeChallenges: {},
      revivedDays: newRevivedDays,
    }).catch(console.error);

    const itemCount = items.length;
    addDoc(collection(db, "users", user.uid, "xpAdjustments"), {
      amount: items.reduce((sum, item) => sum + (item.type === "revive" ? FULL_REVIVE_COST : CATEGORY_TOKEN_COST), 0),
      type: "spend",
      source: "challenge",
      note: `Challenge complete — ${itemCount} debt item${itemCount !== 1 ? "s" : ""} resolved`,
      createdAt: serverTimestamp(),
    }).catch(console.error);
  }

  setSaveStatus("Saving...");
}

// ── Side Quest Schedule helpers ──────────────────────────────────────────────

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function isQuestScheduledForDate(title, dateKey) {
  const sched = sideQuestSchedules[title];
  if (!sched) return false;
  const date = new Date(`${dateKey}T12:00:00`);
  const dow = date.getDay(); // 0=Sun … 6=Sat

  if (sched.type === "once") {
    // Check if the original date OR a moved date matches
    const movedTo = sched.movedDates?.[sched.oneTimeDate];
    const effectiveDate = movedTo || sched.oneTimeDate;
    return effectiveDate === dateKey;
  }

  if (sched.type === "recurring") {
    const days = sched.days || [];
    // Check if this dateKey is a moved-away date (skip it)
    const movedAway = Object.keys(sched.movedDates || {}).includes(dateKey);
    if (movedAway) return false;
    // Check if this dateKey is a moved-to date
    const movedTo = Object.values(sched.movedDates || {}).includes(dateKey);
    if (movedTo) return true;
    // Normal recurring check
    return days.includes(dow);
  }

  return false;
}

function getScheduledQuestsForDate(dateKey) {
  return activeSideQuests.filter((q) => isQuestScheduledForDate(q.title, dateKey));
}

async function saveSchedules(updated) {
  setSideQuestSchedules(updated);
  if (!auth.currentUser) return;
  try {
    await setDoc(doc(db, "users", auth.currentUser.uid), { sideQuestSchedules: updated }, { merge: true });
  } catch (err) {
    console.error("Error saving schedules:", err);
  }
}

function handleSaveSchedule(title, schedData) {
  const updated = { ...sideQuestSchedules };
  if (!schedData) {
    delete updated[title];
  } else {
    updated[title] = schedData;
  }
  saveSchedules(updated);
  setScheduleEditQuest(null);
}

function handleMoveScheduledQuest(title, fromDateKey, toDateKey) {
  const sched = sideQuestSchedules[title];
  if (!sched) return;
  const updated = {
    ...sideQuestSchedules,
    [title]: {
      ...sched,
      movedDates: {
        ...(sched.movedDates || {}),
        [fromDateKey]: toDateKey,
      },
    },
  };
  saveSchedules(updated);
  setScheduleMoveQuest(null);
}

async function triggerHealthSync(uid, prefs) {
  if (!uid || !isNativeMobile()) return;
  try {
    const availability = await getHealthConnectAvailability();
    if (!availability.available) return;
    const result = await runHealthSync(uid, prefs, activeSideQuests);
    if (result.workoutsAdded.length > 0) {
      setHealthTodayWorkouts((prev) => {
        const existingIds = new Set(prev.map((w) => w.platformId).filter(Boolean));
        const newOnes = result.workoutsAdded.filter((w) => !w.platformId || !existingIds.has(w.platformId));
        return [...prev, ...newOnes];
      });
    }
    if (result.questsToComplete.length > 0) {
      const todayKey = formatDateKey(realToday);
      result.questsToComplete.forEach((questTitle) => {
        if (!isSideQuestCompleted(todayKey, questTitle)) {
          handleSideQuestClick(questTitle, null, todayKey);
        }
      });
    }
  } catch (err) {
    console.warn("[App] health sync failed:", err?.message);
  }
}

function handleSideQuestClick(title, event, targetDateKey = formatDateKey(realToday)) {
  const alreadyCompleted = isSideQuestCompleted(targetDateKey, title);
  const isToday = targetDateKey === formatDateKey(realToday);

  if (isToday) {
    if (!canUseProgramToday()) return;
    if (isChallengeInProgress) return;
    markTodayCheckIn();
  }

  if (!alreadyCompleted) {
    createSparkleBurst(event);
    const quest = activeSideQuests.find((q) => q.title === title);
    const questXP = quest?.xp || 0;
    writeActivityEvent({
      type: "side_quest",
      userId: user?.uid,
      userName: profileName,
      userAvatar: selectedAvatar,
      message: `Completed Side Quest · ${title} (+${questXP} XP)`,
      meta: { title, dateKey: targetDateKey, xp: questXP },
    });
    if (user?.uid && userprogramTag === "momentum") {
      recordAutoProgress(user.uid, "side_quest", targetDateKey, { questTitle: title });
    }
    weeklyHabits.forEach((habit) => {
      if ((habit.linkedSideQuests || []).includes(title)) {
        handleWeeklyHabitAdd(habit.id, `sidequest:${title}:${targetDateKey}`);
      }
    });
  } else {
    if (user?.uid && userprogramTag === "momentum") {
      removeAutoProgress(user.uid, "side_quest", targetDateKey, { questTitle: title });
    }
    weeklyHabits.forEach((habit) => {
      if ((habit.linkedSideQuests || []).includes(title)) {
        handleWeeklyHabitRemove(habit.id);
      }
    });
  }

  const currentDay = sideQuestCompletions[targetDateKey] || {};
  const updatedDay = { ...currentDay, [title]: !alreadyCompleted };
  if (!updatedDay[title]) delete updatedDay[title];
  const updatedCompletions = { ...sideQuestCompletions, [targetDateKey]: updatedDay };
  if (Object.keys(updatedDay).length === 0) delete updatedCompletions[targetDateKey];
  setSideQuestCompletions(updatedCompletions);
  if (user?.uid) {
    updateDoc(doc(db, "users", user.uid), { sideQuestCompletions: updatedCompletions }).catch(console.error);
  }

  setSaveStatus("Saving...");
}

function handleWeeklyHabitAdd(habitId, source = "manual") {
  if (!user?.uid || !canUseProgramToday()) return;
  const habit = weeklyHabits.find((h) => h.id === habitId);
  if (!habit) return;
  const sourceDateKey = source.startsWith("manual:") ? source.replace("manual:", "") : null;
  const sourceDate = sourceDateKey ? new Date(`${sourceDateKey}T12:00:00`) : realToday;
  const thisWeekKey = getWeekKey(sourceDate);

  // When manually logging, auto-complete linked side quests that aren't done on that date
  if (source.startsWith("manual:")) {
    const manualDateKey = source.replace("manual:", "");
    (habit.linkedSideQuests || []).forEach((questTitle) => {
      if (!isSideQuestCompleted(manualDateKey, questTitle)) {
        handleSideQuestClick(questTitle, null);
      }
    });
  }
  const currentData = weeklyHabitCompletions[habitId]?.[thisWeekKey] || { count: 0, xpAwarded: false, sources: [] };
  const existingSources = currentData.sources || [];
  // Guard against duplicate manual logs for the same date.
  if (sourceDateKey && existingSources.includes(`manual:${sourceDateKey}`)) return;
  if (currentData.count >= habit.targetCount) return;
  const newCount = currentData.count + 1;
  const nowCompleted = newCount >= habit.targetCount;
  const newXpAwarded = currentData.xpAwarded || (nowCompleted && !currentData.xpAwarded);
  const updatedWeekData = { count: newCount, xpAwarded: newXpAwarded, sources: [...existingSources, source] };
  const updatedCompletions = {
    ...weeklyHabitCompletions,
    [habitId]: { ...(weeklyHabitCompletions[habitId] || {}), [thisWeekKey]: updatedWeekData },
  };
  setWeeklyHabitCompletions(updatedCompletions);
  const payload = { weeklyHabitCompletions: updatedCompletions };
  if (nowCompleted && !currentData.xpAwarded) {
    payload.xpAdjustmentTotal = increment(habit.xpReward);
    setXpAdjustmentTotal((prev) => prev + habit.xpReward);
    addDoc(collection(db, "users", user.uid, "xpAdjustments"), {
      amount: habit.xpReward,
      type: "earn",
      source: "weekly_habit",
      note: `Weekly Goal: ${habit.title}`,
      createdAt: serverTimestamp(),
    }).catch(console.error);
    writeActivityEvent({
      type: "weekly_habit",
      userId: user.uid,
      userName: profileName,
      userAvatar: selectedAvatar,
      message: `Completed Weekly Goal: ${habit.title} (+${habit.xpReward} XP)`,
      meta: { habitId, weekKey: thisWeekKey, xp: habit.xpReward },
    });
  }
  updateDoc(doc(db, "users", user.uid), payload).catch(console.error);
  setSaveStatus("Saving...");
}

function handleWeeklyHabitRemoveSource(habitId, sourceString) {
  if (!user?.uid || !sourceString) return;
  const habit = weeklyHabits.find((h) => h.id === habitId);
  if (!habit) return;
  let dateKey = null;
  if (sourceString.startsWith("manual:")) {
    dateKey = sourceString.replace("manual:", "");
  } else if (sourceString.startsWith("sidequest:")) {
    const parts = sourceString.replace("sidequest:", "").split(":");
    dateKey = parts[1] || null;
  }
  const thisWeekKey = dateKey ? getWeekKey(new Date(`${dateKey}T12:00:00`)) : getWeekKey(realToday);
  const currentData = weeklyHabitCompletions[habitId]?.[thisWeekKey] || { count: 0, xpAwarded: false, sources: [] };
  const existingSources = currentData.sources || [];
  const idx = existingSources.findIndex((s) => s === sourceString);
  if (idx === -1) return;
  const newSources = [...existingSources.slice(0, idx), ...existingSources.slice(idx + 1)];
  const newCount = currentData.count - 1;
  const nowCompleted = newCount >= habit.targetCount;
  const revokeXP = currentData.xpAwarded && !nowCompleted;
  const updatedWeekData = { count: newCount, xpAwarded: nowCompleted ? currentData.xpAwarded : false, sources: newSources };
  const updatedCompletions = {
    ...weeklyHabitCompletions,
    [habitId]: { ...(weeklyHabitCompletions[habitId] || {}), [thisWeekKey]: updatedWeekData },
  };
  setWeeklyHabitCompletions(updatedCompletions);
  const payload = { weeklyHabitCompletions: updatedCompletions };
  if (revokeXP) {
    payload.xpAdjustmentTotal = increment(-habit.xpReward);
    setXpAdjustmentTotal((prev) => prev - habit.xpReward);
  }
  if (sourceString.startsWith("sidequest:") && dateKey) {
    const parts = sourceString.replace("sidequest:", "").split(":");
    const questTitle = parts[0];
    if (isSideQuestCompleted(dateKey, questTitle)) handleSideQuestClick(questTitle, null);
  }
  if (sourceString.startsWith("manual:") && dateKey) {
    (habit.linkedSideQuests || []).forEach((questTitle) => {
      if (isSideQuestCompleted(dateKey, questTitle)) handleSideQuestClick(questTitle, null);
    });
  }
  updateDoc(doc(db, "users", user.uid), payload).catch(console.error);
  setSaveStatus("Saving...");
}

function handleWeeklyHabitManualUndo(habitId, dateKey) {
  if (!user?.uid) return;
  const habit = weeklyHabits.find((h) => h.id === habitId);
  if (!habit) return;
  const thisWeekKey = getWeekKey(new Date(`${dateKey}T12:00:00`));
  const currentData = weeklyHabitCompletions[habitId]?.[thisWeekKey] || { count: 0, xpAwarded: false, sources: [] };
  const existingSources = currentData.sources || [];
  // Remove the first matching manual entry for this date
  const idx = existingSources.findIndex((s) => s === `manual:${dateKey}`);
  if (idx === -1) return;
  const newSources = [...existingSources.slice(0, idx), ...existingSources.slice(idx + 1)];
  const newCount = currentData.count - 1;
  const nowCompleted = newCount >= habit.targetCount;
  const revokeXP = currentData.xpAwarded && !nowCompleted;
  const updatedWeekData = { count: newCount, xpAwarded: nowCompleted ? currentData.xpAwarded : false, sources: newSources };
  const updatedCompletions = {
    ...weeklyHabitCompletions,
    [habitId]: { ...(weeklyHabitCompletions[habitId] || {}), [thisWeekKey]: updatedWeekData },
  };
  setWeeklyHabitCompletions(updatedCompletions);
  const payload = { weeklyHabitCompletions: updatedCompletions };
  if (revokeXP) {
    payload.xpAdjustmentTotal = increment(-habit.xpReward);
    setXpAdjustmentTotal((prev) => prev - habit.xpReward);
  }
  // Auto-unlink side quests that were completed via this manual log
  (habit.linkedSideQuests || []).forEach((questTitle) => {
    if (isSideQuestCompleted(dateKey, questTitle)) {
      handleSideQuestClick(questTitle, null);
    }
  });
  updateDoc(doc(db, "users", user.uid), payload).catch(console.error);
  setSaveStatus("Saving...");
}

function handleWeeklyHabitRemove(habitId) {
  if (!user?.uid) return;
  const habit = weeklyHabits.find((h) => h.id === habitId);
  if (!habit) return;
  const thisWeekKey = getWeekKey(realToday);
  const currentData = weeklyHabitCompletions[habitId]?.[thisWeekKey] || { count: 0, xpAwarded: false, sources: [] };
  if (currentData.count <= 0) return;
  const newCount = currentData.count - 1;
  const nowCompleted = newCount >= habit.targetCount;
  const revokeXP = currentData.xpAwarded && !nowCompleted;
  const existingSources = currentData.sources || [];
  const updatedWeekData = { count: newCount, xpAwarded: nowCompleted ? currentData.xpAwarded : false, sources: existingSources.slice(0, -1) };
  const updatedCompletions = {
    ...weeklyHabitCompletions,
    [habitId]: { ...(weeklyHabitCompletions[habitId] || {}), [thisWeekKey]: updatedWeekData },
  };
  setWeeklyHabitCompletions(updatedCompletions);
  const payload = { weeklyHabitCompletions: updatedCompletions };
  if (revokeXP) {
    payload.xpAdjustmentTotal = increment(-habit.xpReward);
    setXpAdjustmentTotal((prev) => prev - habit.xpReward);
  }
  updateDoc(doc(db, "users", user.uid), payload).catch(console.error);
  setSaveStatus("Saving...");
}

function handleUpdateWeeklyHabit(habitId, updates) {
  if (!user?.uid) return;
  const updated = weeklyHabits.map((h) => h.id === habitId ? { ...h, ...updates } : h);
  setWeeklyHabits(updated);
  updateDoc(doc(db, "users", user.uid), { weeklyHabits: updated }).catch(console.error);
  setSaveStatus("Saving...");
}

function handleAddWeeklyHabit(habitData) {
  if (!user?.uid) return;
  const newHabit = { ...habitData, id: Date.now().toString() };
  const updated = [...weeklyHabits, newHabit];
  setWeeklyHabits(updated);
  updateDoc(doc(db, "users", user.uid), { weeklyHabits: updated }).catch(console.error);
  setSaveStatus("Saving...");
}

function handleDeleteWeeklyHabit(habitId) {
  if (!user?.uid) return;
  const updated = weeklyHabits.filter((h) => h.id !== habitId);
  setWeeklyHabits(updated);
  updateDoc(doc(db, "users", user.uid), { weeklyHabits: updated }).catch(console.error);
  setSaveStatus("Saving...");
}

function handlePastSideQuestUncheck(dateKey, title) {
  if (!user?.uid) return;
  setSideQuestCompletions((prev) => {
    const dayData = { ...(prev[dateKey] || {}) };
    delete dayData[title];
    const updated = { ...prev, [dateKey]: dayData };
    updateDoc(doc(db, "users", user.uid), { sideQuestCompletions: updated }).catch(console.error);
    return updated;
  });
  // Also decrement linked weekly habits for the week that day belongs to
  weeklyHabits.forEach((habit) => {
    if ((habit.linkedSideQuests || []).includes(title)) {
      handleWeeklyHabitRemove(habit.id);
    }
  });
  setPastQuestUncheckConfirm(null);
  setSaveStatus("Saving...");
}

// Called after a workout log is deleted — unchecks the linked side quest for that date
function handleWorkoutDeleted(dateKey) {
  if (!workoutAutoSideQuest || userprogramTag !== "momentum" || !user?.uid) return;
  if (!isSideQuestCompleted(dateKey, workoutAutoSideQuest)) return;
  setSideQuestCompletions((prev) => {
    const dayData = { ...(prev[dateKey] || {}) };
    delete dayData[workoutAutoSideQuest];
    const updated = { ...prev, [dateKey]: dayData };
    updateDoc(doc(db, "users", user.uid), { sideQuestCompletions: updated }).catch(console.error);
    return updated;
  });
  removeAutoProgress(user.uid, "side_quest", dateKey, { questTitle: workoutAutoSideQuest });
}

// Called after a workout is saved — auto-completes the linked side quest
function handleWorkoutAutoSideQuest() {
  if (!workoutAutoSideQuest || userprogramTag !== "momentum" || !user?.uid) return;
  const todayKey = formatDateKey(new Date());
  const alreadyCompleted = isSideQuestCompleted(todayKey, workoutAutoSideQuest);
  if (alreadyCompleted) return;
  setSideQuestCompletions((prev) => {
    const currentDay = prev[todayKey] || {};
    return { ...prev, [todayKey]: { ...currentDay, [workoutAutoSideQuest]: true } };
  });
  const quest = activeSideQuests.find((q) => q.title === workoutAutoSideQuest);
  const questXP = quest?.xp || 0;
  writeActivityEvent({
    type: "side_quest",
    userId: user.uid,
    userName: profileName,
    userAvatar: selectedAvatar,
    message: `Completed Side Quest · ${workoutAutoSideQuest} (+${questXP} XP)`,
    meta: { title: workoutAutoSideQuest, dateKey: todayKey, xp: questXP },
  });
  recordAutoProgress(user.uid, "side_quest", todayKey, { questTitle: workoutAutoSideQuest });
}

function localDateKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

async function loadDashboardSchedule(uid) {
  try {
    const now = new Date();
    const today = localDateKey(now);
    const todayDow = now.getDay();
    const sSnap = await getDocs(collection(db, "users", uid, "workoutSchedule"));
    const allDocs = sSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
    const oneOffs = allDocs.filter((d) => !d.recurring && d.dateKey === today);
    const rules = allDocs.filter((d) => d.recurring);
    const expanded = [];
    rules.forEach((rule) => {
      if (!rule.days || rule.days.length === 0) return;
      if (rule.startDate && today < rule.startDate) return;
      if (rule.endDate && today > rule.endDate) return;
      if (rule.days.includes(todayDow)) expanded.push({ ...rule, dateKey: today, isRuleOccurrence: true });
    });
    setDashboardScheduledWorkouts([...oneOffs, ...expanded]);
  } catch (_) {}
}

async function loadActiveWeeklyPrompt() {
  if (!user || !profileComplete) {
    setActiveWeeklyPrompt(null);
    setWeeklyPromptLoading(false);
    return;
  }

  try {
    setWeeklyPromptLoading(true);

    const userDoc = await getDoc(doc(db, "users", user.uid));
    const userData = userDoc.exists() ? userDoc.data() : {};
    const programTag = userData.programTag || "";

    if (!programTag) {
      setActiveWeeklyPrompt(null);
      setWeeklyPromptLoading(false);
      return;
    }

    const prompt = await getActivePromptForUser(programTag);

    if (!prompt) {
      setActiveWeeklyPrompt(null);
      setWeeklyPromptLoading(false);
      return;
    }

    const existingResponse = await getUserResponseForPrompt(prompt.id, user.uid);

    if (existingResponse?.status === "submitted") {
      setActiveWeeklyPrompt(null);
      setWeeklyPromptLoading(false);
      return;
    }

    setActiveWeeklyPrompt(prompt);
  } catch (error) {
    console.error("Error loading weekly quest prompt:", error);
    setActiveWeeklyPrompt(null);
  } finally {
    setWeeklyPromptLoading(false);
  }
}

async function loadAllUsers() {
  try {
    const snapshot = await getDocs(collection(db, "users"));
    const users = snapshot.docs.map((docSnap) => {
      const data = docSnap.data();

      return {
        id: docSnap.id,
        ...data,
        programTag: data.programTag || "",
        categoryTags: Array.isArray(data.categoryTags) ? data.categoryTags : [],
      };
    });

    setAllUsers(users);
  } catch (error) {
    console.error("Error loading users:", error);
  }
}

async function saveUserAccess(userId, updates) {
  try {
    await updateDoc(doc(db, "users", userId), updates);
    await loadAllUsers();

    if (auth.currentUser && auth.currentUser.uid === userId) {
      await loadProgress(userId);
    }
  } catch (error) {
    console.error("Error updating user:", error);
  }
}

async function refreshAdminDashboard(client) {
  const prog = client.programTag;
  const uid = client.id;

  // Re-fetch client's Firestore user doc (gets latest dailySelections, revivedDays, etc.)
  let freshClient = client;
  try {
    // Use getDocFromServer to bypass local IndexedDB cache — ensures dismissed
    // broadcasts written by updateDoc are always visible after a page reload.
    const snap = await getDocFromServer(doc(db, "users", uid));
    if (snap.exists()) {
      freshClient = { ...client, ...snap.data(), id: uid };
      setSelectedAdminUser((prev) => prev ? freshClient : prev);
    }
  } catch (err) {
    console.error("Error refreshing client data:", err);
  }

  // Re-fetch pinned notes
  try {
    const snap = await getDoc(doc(db, "appConfig", "pinnedNotes"));
    if (snap.exists() && Array.isArray(snap.data().notes)) {
      setPinnedNotes(snap.data().notes);
    }
  } catch (err) {
    console.error("Error refreshing pinned notes:", err);
  }

  // Re-fetch dynamic dashboard data, passing current dismissedBroadcasts
  const dismissed = freshClient.dismissedBroadcasts || [];
  getSubmittedResponsesWithFeedback(uid).then(setAdminDashboardFeedback).catch(console.error);
  if (prog) {
    getActiveBroadcastsForUser(prog, uid, dismissed).then(setAdminDashboardPendingBroadcasts).catch(console.error);
    getActivePromptForUser(prog).then(async (prompt) => {
      if (!prompt) { setAdminDashboardWeeklyPrompt(null); return; }
      const existing = await getUserResponseForPrompt(prompt.id, uid);
      setAdminDashboardWeeklyPrompt({ ...prompt, alreadySubmitted: existing?.status === "submitted" });
    }).catch(console.error);
  }
}

async function handleAdminRevive(client, dateKey) {
  const COST = 25;
  const currentRevived = client.revivedDays || {};
  const currentSpent = client.spentXP || 0;
  const existing = currentRevived[dateKey] || { nutrition: false, movement: false, mindset: false };
  const isApplied = existing.nutrition && existing.movement && existing.mindset;

  let newRevived, newSpent;
  if (isApplied) {
    newRevived = { ...currentRevived };
    delete newRevived[dateKey];
    newSpent = Math.max(0, currentSpent - COST);
  } else {
    newRevived = { ...currentRevived, [dateKey]: { nutrition: true, movement: true, mindset: true } };
    newSpent = currentSpent + COST;
    await addDoc(collection(db, "users", client.id, "xpAdjustments"), {
      amount: COST,
      type: "spend",
      source: "revive",
      note: `Full Revive applied for ${dateKey} (by coach)`,
      createdAt: serverTimestamp(),
    });
  }
  await setDoc(doc(db, "users", client.id), { revivedDays: newRevived, spentXP: newSpent }, { merge: true });
  await refreshAdminDashboard({ ...client, revivedDays: newRevived, spentXP: newSpent });
}

async function handleAdminToken(client, dateKey, category) {
  const COST = 10;
  const currentRevived = client.revivedDays || {};
  const currentSpent = client.spentXP || 0;
  const existing = currentRevived[dateKey] || { nutrition: false, movement: false, mindset: false };
  const isApplied = existing[category];

  const updatedDay = { ...existing, [category]: !isApplied };
  const newRevived = { ...currentRevived, [dateKey]: updatedDay };
  const newSpent = isApplied ? Math.max(0, currentSpent - COST) : currentSpent + COST;

  if (!isApplied) {
    const catLabel = category.charAt(0).toUpperCase() + category.slice(1);
    await addDoc(collection(db, "users", client.id, "xpAdjustments"), {
      amount: COST,
      type: "spend",
      source: "token",
      note: `${catLabel} Token applied for ${dateKey} (by coach)`,
      createdAt: serverTimestamp(),
    });
  }
  await setDoc(doc(db, "users", client.id), { revivedDays: newRevived, spentXP: newSpent }, { merge: true });
  await refreshAdminDashboard({ ...client, revivedDays: newRevived, spentXP: newSpent });
}

async function loadAdminUserAssignments(user) {
  setAdminAssignmentsLoading(true);
  setAdminUserAssignments([]);
  try {
    const prompts = await getAllPromptsForTag(user.programTag || "");
    const results = [];
    for (const prompt of prompts) {
      const response = await getUserResponseForPrompt(prompt.id, user.id);
      if (response?.status === "submitted") {
        results.push({ prompt, response });
      }
    }
    results.sort((a, b) => {
      const aTime = a.response.submittedAt?.toDate?.()?.getTime?.() || 0;
      const bTime = b.response.submittedAt?.toDate?.()?.getTime?.() || 0;
      return bTime - aTime;
    });
    setAdminUserAssignments(results);
  } catch (err) {
    console.error(err);
  } finally {
    setAdminAssignmentsLoading(false);
  }
}

async function loadAdminXPAdjustLog(userId) {
  setAdminXPAdjustLogLoading(true);
  setAdminXPAdjustLog([]);
  try {
    const q = query(
      collection(db, "users", userId, "xpAdjustments"),
      orderBy("createdAt", "desc")
    );
    const snap = await getDocs(q);
    setAdminXPAdjustLog(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  } catch (err) {
    console.error("Error loading XP log:", err);
  } finally {
    setAdminXPAdjustLogLoading(false);
  }
}

function openAdminUser(client) {
  setSelectedAdminUser(client);
  refreshAdminDashboard(client); // always load fresh Firestore data so XP matches user's view
  setAdminTab("profile");
  setResetConfirmStep(0);
  setResetConfirmInput("");
  setDeleteAccountStep(0);
  setDeleteAccountError("");
  setDeleteAccountConfirmText("");
  setAdminUserStatus(client.status || "active");
  setAdminUserStartDate(client.startDate || "");
  setAdminUserEndDate(client.endDate || "");
  setAdminReviveStartDate(client.reviveStartDate || "");
  setAdminUserStartingXP(client.startingXP || 0);
  setAdminUserprogramTag(client.programTag || "");
  setAdminUserCategoryTags(
    Array.isArray(client.categoryTags) ? client.categoryTags : []
  );
  setAdminUserCoachId(client.coachId || "");
  setAdminUserWeeklyGoalFreqs(client.weeklyGoalFreqs || { nutrition: null, movement: null, mindset: null });
  setAdminUserWeekStartDay(client.weekStartDay || "monday");
  // weeklyGoalFreqsLog loaded from client object directly (read via selectedAdminUser.weeklyGoalFreqsLog)
}

async function handleToggleVacationMode() {
  if (!auth.currentUser) return;
  const today = new Date().toISOString().slice(0, 10);
  const newActive = !vacationModeActive;
  const newStart = vacationModeStart || today;
  setVacationModeActive(newActive);
  if (newActive && !vacationModeStart) setVacationModeStart(today);
  await updateDoc(doc(db, "users", auth.currentUser.uid), {
    vacationModeActive: newActive,
    vacationModeStart: newStart,
  });
}

async function handleSetWeeklyGoalFreq(category, value) {
  if (!auth.currentUser) return;
  const newGoals = { ...weeklyGoalFreqs, [category]: value };
  setWeeklyGoalFreqs(newGoals);
  // Record effective date in log so historical debt uses the settings that were active then
  const today = new Date().toISOString().slice(0, 10);
  const existingIdx = weeklyGoalFreqsLog.findIndex(e => e.date === today);
  let newLog;
  if (existingIdx >= 0) {
    newLog = weeklyGoalFreqsLog.map((e, i) => i === existingIdx ? { ...e, freqs: newGoals } : e);
  } else {
    newLog = [...weeklyGoalFreqsLog, { date: today, freqs: newGoals }];
  }
  setWeeklyGoalFreqsLog(newLog);
  await updateDoc(doc(db, "users", auth.currentUser.uid), { weeklyGoalFreqs: newGoals, weeklyGoalFreqsLog: newLog });
}

async function handleSetWeekStartDay(day) {
  if (!auth.currentUser) return;
  setWeekStartDay(day);
  await updateDoc(doc(db, "users", auth.currentUser.uid), { weekStartDay: day });
}

async function handleAddVacation(start, end) {
  if (!auth.currentUser || !start || !end || start > end) return;
  const newVacation = { id: `${Date.now()}`, start, end, createdAt: new Date().toISOString() };
  const updated = [...vacations, newVacation];
  setVacations(updated);
  await updateDoc(doc(db, "users", auth.currentUser.uid), { vacations: updated });
}

async function handleRemoveVacation(id) {
  if (!auth.currentUser) return;
  const updated = vacations.filter((v) => v.id !== id);
  setVacations(updated);
  await updateDoc(doc(db, "users", auth.currentUser.uid), { vacations: updated });
}

async function handleSaveAdminUserSettings() {
  if (!selectedAdminUser) return;

  await saveUserAccess(selectedAdminUser.id, {
    status: adminUserStatus,
    startDate: adminUserStartDate || null,
    endDate: adminUserEndDate || null,
    reviveStartDate: adminReviveStartDate || null,
    startingXP: Number(adminUserStartingXP) || 0,
    programTag: adminUserprogramTag || "",
    categoryTags: Array.isArray(adminUserCategoryTags)
      ? adminUserCategoryTags
      : [],
      coachId: adminUserCoachId,
  });

  const updatedClient = {
    ...selectedAdminUser,
    status: adminUserStatus,
    startDate: adminUserStartDate || null,
    endDate: adminUserEndDate || null,
    reviveStartDate: adminReviveStartDate || null,
    startingXP: Number(adminUserStartingXP) || 0,
    programTag: adminUserprogramTag || "",
    categoryTags: Array.isArray(adminUserCategoryTags) ? adminUserCategoryTags : [],
  };
  setSelectedAdminUser(updatedClient);
  refreshAdminDashboard(updatedClient);
}
async function handleResetUserData() {
  if (!selectedAdminUser) return;
  setResetInProgress(true);
  try {
    const uid = selectedAdminUser.id;

    // Delete all xpAdjustments subcollection docs
    const xpSnap = await getDocs(collection(db, "users", uid, "xpAdjustments"));
    await Promise.all(xpSnap.docs.map((d) => deleteDoc(d.ref)));

    await setDoc(doc(db, "users", uid), {
      dailySelections: {},
      revivedDays: {},
      spentXP: 0,
      challengeCosts: {},
      activeChallenges: {},
      resolvedDebtLog: {},
      sideQuestCompletions: {},
      sideQuestSchedules: {},
      dailyCheckIns: {},
      streakShield: "none",
      shieldEarnProgressStart: null,
      shieldActivatedDays: {},
      vacations: [],
      reviveStartDate: null,
      startingXP: 0,
      xpAdjustmentTotal: 0,
      bodyMetricsXpLog: {},
      extraCategories: [],
    }, { merge: true });
    await saveBodyStats(uid, { pinnedBadges: [] });
    const fresh = {
      ...selectedAdminUser,
      dailySelections: {},
      revivedDays: {},
      spentXP: 0,
      challengeCosts: {},
      activeChallenges: {},
      resolvedDebtLog: {},
      sideQuestCompletions: {},
      sideQuestSchedules: {},
      dailyCheckIns: {},
      streakShield: "none",
      shieldEarnProgressStart: null,
      shieldActivatedDays: {},
      vacations: [],
      reviveStartDate: null,
      startingXP: 0,
      xpAdjustmentTotal: 0,
      bodyMetricsXpLog: {},
    };
    setSelectedAdminUser(fresh);
    setResetConfirmStep(0);
    setResetConfirmInput("");
  } catch (e) {
    console.error("Reset failed:", e);
  }
  setResetInProgress(false);
}

async function loadGameContent() {
  try {
    const docRef = doc(db, "appConfig", "gameContent");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();

      setGameContent({
        sideQuests: data.sideQuests || [],
        weeklyChallenges: data.weeklyChallenges || [],
        bonusXPOpportunities: data.bonusXPOpportunities || [],
        badges: data.badges || [],
      });
    } else {
      setGameContent({
        sideQuests: [],
        weeklyChallenges: [],
        bonusXPOpportunities: [],
        badges: [],
      });
    }
  } catch (error) {
    console.error("Error loading game content:", error);
    setGameContent({
      sideQuests: [],
      weeklyChallenges: [],
      bonusXPOpportunities: [],
      badges: [],
    });
  }
}

async function loadProgramSettings() {
  try {
    const snap = await getDoc(doc(db, "appConfig", "programSettings"));
    if (snap.exists()) {
      setProgramSettings(snap.data() || {});
    } else {
      setProgramSettings({});
    }
  } catch (err) {
    console.error("Error loading program settings:", err);
    setProgramSettings({});
  }
}

async function loadHowItWorks() {
  try {
    const snap = await getDoc(doc(db, "appConfig", "howItWorks"));
    if (snap.exists() && Array.isArray(snap.data().items) && snap.data().items.length > 0) {
      setHowItWorksItems(snap.data().items);
    } else {
      setHowItWorksItems(defaultHowItWorksItems);
    }
  } catch (err) {
    console.error("Error loading how-it-works:", err);
  }
}

async function saveHowItWorks(items) {
  try {
    await setDoc(doc(db, "appConfig", "howItWorks"), { items }, { merge: false });
    setHowItWorksItems(items);
  } catch (err) {
    console.error("Error saving how-it-works:", err);
  }
}

async function handleToggleProgramCategory(programTag, category) {
  if (!programTag) return;
  const current = programSettings[programTag] || {};
  const currentEnabled = current[category] !== false; // default true
  const next = {
    ...programSettings,
    [programTag]: {
      ...current,
      [category]: !currentEnabled,
    },
  };
  setProgramSettings(next);
  try {
    await setDoc(doc(db, "appConfig", "programSettings"), next, { merge: false });
  } catch (err) {
    console.error("Error saving program settings:", err);
    setProgramSettings(programSettings);
  }
}

async function handleToggleProgramLeaderboard(programTag) {
  if (!programTag) return;
  const current = programSettings[programTag] || {};
  const next = {
    ...programSettings,
    [programTag]: { ...current, leaderboardVisible: !current.leaderboardVisible },
  };
  setProgramSettings(next);
  try {
    await setDoc(doc(db, "appConfig", "programSettings"), next, { merge: false });
  } catch (err) {
    console.error(err);
    setProgramSettings(programSettings);
  }
}

function isCategoryEnabledForProgram(programTag, category) {
  if (!programTag) return true;
  const settings = programSettings[programTag] || {};
  return settings[category] !== false;
}

function hasFeature(key) {
  if (!userprogramTag) return true;
  const features = programSettings[userprogramTag]?.features;
  if (features && key in features) return features[key];
  return getDefaultFeatures(userprogramTag)[key] ?? true;
}

function isLeaderboardVisibleForProgram(programTag) {
  if (!programTag) return false;
  return programSettings[programTag]?.leaderboardVisible === true;
}

  function handleHabitEdit(category, levelType, value) {
    markTodayCheckIn();

    setCustomHabits((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [levelType]: {
          ...prev[category][levelType],
          habitName: value,
        },
      },
    }));
    setSaveStatus("Saving...");
  }

  // ── Shield: auto-activate on missed full days ──────────────────────────────
  useEffect(() => {
    if (!isLoaded || !user) return;

    const trackingStart = getTrackingStartDate();
    if (!trackingStart) return;

    const todayKey = formatDateKey(realToday);
    const yesterday = new Date(realToday);
    yesterday.setDate(realToday.getDate() - 1);

    // Walk back from yesterday looking for a fully-missed day that hasn't been
    // revived and hasn't already had the shield applied
    for (let i = 1; i <= 60; i++) {
      const checkDate = new Date(realToday);
      checkDate.setDate(realToday.getDate() - i);
      const dk = formatDateKey(checkDate);

      if (dk < formatDateKey(trackingStart)) break;

      const sel = dailySelections[dk] || {};
      const rev = revivedDays[dk] || {};
      const fullyMissed =
        !sel.nutrition && !sel.movement && !sel.mindset &&
        !rev.nutrition && !rev.movement && !rev.mindset;

      if (!fullyMissed) continue;
      if (shieldActivatedDays[dk]) continue; // already handled

      // Found a fully-missed day — auto-activate shield if held
      if (streakShield === "ready") {
        const newActivated = { ...shieldActivatedDays, [dk]: true };
        setShieldActivatedDays(newActivated);
        setStreakShield("none");
        setShieldEarnProgressStart(dk); // day 1 of earning next shield
        setShieldJustActivated(dk);

        // Persist
        if (auth.currentUser) {
          setDoc(doc(db, "users", auth.currentUser.uid), {
            streakShield: "none",
            shieldEarnProgressStart: dk,
            shieldActivatedDays: newActivated,
          }, { merge: true }).catch(console.error);
        }
      }
      break; // only handle the most recent missed day
    }
  }, [isLoaded, user, dailySelections, revivedDays, streakShield]);

  // ── Shield: auto-award at 14-day full quest streak ─────────────────────────
  useEffect(() => {
    if (!isLoaded || !user) return;
    if (streakShield === "ready") return; // already have one

    const startKey = shieldEarnProgressStart;
    if (!startKey) return;

    // Count consecutive full-quest days from shieldEarnProgressStart
    let count = 0;
    const startDate = new Date(`${startKey}T12:00:00`);
    for (let i = 0; i < 60; i++) {
      const d = new Date(startDate);
      d.setDate(startDate.getDate() + i);
      const dk = formatDateKey(d);
      if (dk > formatDateKey(realToday)) break;
      if (dayCountsForFullQuestWithShield(dk, dailySelections)) {
        count++;
      } else {
        count = 0; // reset on any gap
      }
    }

    if (count >= 14) {
      setStreakShield("ready");
      if (auth.currentUser) {
        setDoc(doc(db, "users", auth.currentUser.uid), {
          streakShield: "ready",
        }, { merge: true }).catch(console.error);
      }
    }
  }, [isLoaded, user, dailySelections, shieldEarnProgressStart, streakShield]);

  // Auto-engage challenge the moment user has debt they can't afford.
  // This ensures completing habits always triggers the popup even if earning XP
  // from habits makes the debt "affordable" before they click Accept.
  useEffect(() => {
    if (!isLoaded || !user) return;
    if (unaffordableUnresolvedItems.length > 0 && !isChallengeAllAccepted && !challengeDeclinedRef.current) {
      setActiveChallenges(prev => ({ ...prev, [BULK_CHALLENGE_KEY]: true }));
    }
    // Reset the declined flag when unaffordable debt clears (new debt cycle)
    if (unaffordableUnresolvedItems.length === 0) {
      challengeDeclinedRef.current = false;
    }
  }, [isLoaded, user, unaffordableUnresolvedItems.length, isChallengeAllAccepted]);

  // Clear challenge state when all debt is resolved via tokens (not revive)
  useEffect(() => {
    if (!isLoaded || !user) return;
    if (isChallengeAllAccepted && unresolvedDebtItems.length === 0) {
      setActiveChallenges({});
      challengeDeclinedRef.current = false;
    }
  }, [isLoaded, user, isChallengeAllAccepted, unresolvedDebtItems.length]);

  // Show revive activation popup when all 3 habits are done with an active challenge
  useEffect(() => {
    if (!isLoaded || !user) return;
    if (isChallengeAllAccepted && isChallengeAllComplete && unresolvedDebtItems.length > 0) {
      setShowReviveActivationModal(true);
    }
  }, [isLoaded, user, isChallengeAllAccepted, isChallengeAllComplete, unresolvedDebtItems.length]);

  // Scroll side quest date picker to today (rightmost) whenever the quests tab is opened
  useEffect(() => {
    if (activeScreen === "quests" && sideQuestDateScrollRef.current) {
      sideQuestDateScrollRef.current.scrollLeft = sideQuestDateScrollRef.current.scrollWidth;
    }
  }, [activeScreen]);

  async function saveProgress(
  updatedSelections,
  updatedRevivedDays,
  updatedSpentXP,
  updatedChallengeCosts,
  updatedActiveChallenges,
  updatedResolvedDebtLog,
  updatedSideQuestCompletions,
  updatedCustomHabits,
  updatedCheckIns,
  updatedCategoryLabels
) {
    if (!auth.currentUser) return;

    try {
      await setDoc(
        doc(db, "users", auth.currentUser.uid),
        {
          email: auth.currentUser.email,
          name: [profileFirstName,profileLastName].filter(Boolean).join(" ")||profileName,
          firstName: profileFirstName,
          lastName: profileLastName,
          profileComplete: profileComplete,
          dailySelections: updatedSelections,
revivedDays: updatedRevivedDays,
spentXP: updatedSpentXP,
challengeCosts: updatedChallengeCosts,
activeChallenges: updatedActiveChallenges,
resolvedDebtLog: updatedResolvedDebtLog,
sideQuestCompletions: updatedSideQuestCompletions,
customHabits: updatedCustomHabits,
dailyCheckIns: updatedCheckIns,
categoryLabels: updatedCategoryLabels,
        },
        { merge: true }
      );
      setSaveStatus("Saved");
    } catch (error) {
      console.error(error);
      setSaveStatus("Error saving");
    }
  }

  async function loadProgress(uid) {
    // Safety net: if loadProgress hangs (Firestore connection never resolves),
    // force isLoaded=true after 8 seconds so the app doesn't stay on loading screen.
    const loadTimeoutId = setTimeout(() => {
      console.warn("[loadProgress] timed out — forcing isLoaded=true");
      setIsLoaded(true);
    }, 8000);

    try {
      const docRef = doc(db, "users", uid);
      // Use getDoc (cache-first with offline persistence) so that writes that
      // haven't synced to the server yet (e.g., a revive uncheck right before
      // a page refresh) are still visible on reload via the local IndexedDB cache.
      const docSnap = await Promise.race([
        getDoc(docRef),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Firestore getDoc timeout")), 6000)
        ),
      ]);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setDailySelections(data.dailySelections || {});
setRevivedDays(data.revivedDays || {});
// If no revive system is active, spentXP is stale (leftover from testing) — reset it
const _hasReviveActive = Boolean(data.reviveStartDate) || Object.values(data.activeChallenges || {}).some(Boolean);
const _rawSpentXP = _hasReviveActive ? (data.spentXP || 0) : 0;
// One-time migration: old per-item challenge system incorrectly added challenge costs to
// spentXP, inflating it above earned XP. Subtract those costs and clear the marker.
const _loadedChallengeCosts = data.challengeCosts || {};
const _challengeCostTotal = Object.values(_loadedChallengeCosts).reduce((s, c) => s + c, 0);
const _correctedSpentXP = _challengeCostTotal > 0
  ? Math.max(0, _rawSpentXP - _challengeCostTotal)
  : _rawSpentXP;
setSpentXP(_correctedSpentXP);
if (!_hasReviveActive && (data.spentXP || 0) > 0) {
  updateDoc(doc(db, "users", uid), { spentXP: 0 }).catch(console.error);
} else if (_challengeCostTotal > 0) {
  updateDoc(doc(db, "users", uid), { spentXP: _correctedSpentXP, challengeCosts: {} }).catch(console.error);
}
setChallengeCosts(_challengeCostTotal > 0 ? {} : _loadedChallengeCosts);
setActiveChallenges(data.activeChallenges || {});
setResolvedDebtLog(data.resolvedDebtLog || {});
setSideQuestCompletions(data.sideQuestCompletions || {});
setSideQuestSchedules(data.sideQuestSchedules || {});
setWeeklyHabits(data.weeklyHabits || []);
setWeeklyHabitCompletions(data.weeklyHabitCompletions || {});
setCustomHabits(data.customHabits || defaultHabits);
setExtraCategories(data.extraCategories || []);
setCategoryLabels({ nutrition: "Nutrition", movement: "Movement", mindset: "Mindset", ...(data.categoryLabels || {}) });
setCategoryEmojis({ nutrition: "🍓", movement: "🚶‍♀️", mindset: "🌙", ...(data.categoryEmojis || {}) });
setDailyCheckIns(data.dailyCheckIns || {});
setStreakShield(data.streakShield || "none");
setShieldEarnProgressStart(data.shieldEarnProgressStart || null);
setShieldActivatedDays(data.shieldActivatedDays || {});
setVacations(data.vacations || []);
setVacationModeActive(data.vacationModeActive || false);
setVacationModeStart(data.vacationModeStart || null);
setWeeklyGoalFreqs(data.weeklyGoalFreqs || { nutrition: null, movement: null, mindset: null });
setWeeklyGoalFreqsLog(data.weeklyGoalFreqsLog || []);
setWeeklyTokensApplied(data.weeklyTokensApplied || {});
setWeekStartDay(data.weekStartDay || "monday");
const _fn = data.firstName || (data.name||"").trim().split(/\s+/)[0]||""; const _ln = data.lastName || (data.name||"").trim().split(/\s+/).slice(1).join(" ")||""; const _ui = data.showLastNameInitial||false; setProfileFirstName(_fn); setProfileLastName(_ln); setShowLastNameInitial(_ui); setProfileName(_ui&&_ln?_fn+" "+_ln[0]+".":([_fn,_ln].filter(Boolean).join(" ")||data.name||""));
{
  // Auto-migrate users still on old JPEG/PNG avatars to DiceBear on load
  let avatarUrl = data.avatar || "";
  if (avatarUrl && !avatarUrl.startsWith("https://api.dicebear.com")) {
    const seed = data.firstName || (data.name || "").trim().split(/\s+/)[0] || uid;
    avatarUrl = buildAvatarUrl({ ...DEFAULT_OPTIONS, seed });
    setDoc(doc(db, "users", uid), { avatar: avatarUrl }, { merge: true }).catch(console.error);
  }
  setSelectedAvatar(avatarUrl);
}
// Backward-compatible profile completion check:
// older user docs may have name/avatar but no explicit profileComplete flag yet.
setProfileComplete(
  data.profileComplete === true ||
    (String(data.name || "").trim().length > 0 &&
      String(data.avatar || "").trim().length > 0)
);
setIsAdmin(Boolean(data.isAdmin));
setUserStatus(data.status || "active");
setUserStartDate(data.startDate || null);
setUserEndDate(data.endDate || null);
setReviveStartDate(data.reviveStartDate || null);
setStartingXP(data.startingXP || 0);
setXpAdjustmentTotal(data.xpAdjustmentTotal || 0);
xpBaseRef.current = (data.startingXP || 0) + (data.xpAdjustmentTotal || 0);
setBodyMetricsConfig(data.bodyMetricsConfig || {});
setBodyMetricsXpLog(data.bodyMetricsXpLog || {});
setUserprogramTag(data.programTag || "");
setDismissedBroadcasts(Array.isArray(data.dismissedBroadcasts) ? data.dismissedBroadcasts : []);
setNutritionTrackingEnabled(Boolean(data.nutritionTrackingEnabled));
setPortionTrackingEnabled(Boolean(data.portionTrackingEnabled));
setWaterTrackingEnabled(Boolean(data.waterTrackingEnabled));
setMacroTrackingEnabled(Boolean(data.macroTrackingEnabled));
setWeeklyGoalsEnabled(data.weeklyGoalsEnabled !== false);
setCommunityNotifPrefs(data.communityNotifPrefs || { win: true, question: true, checkin: true, general: true });
setWorkoutAutoSideQuest(data.workoutAutoSideQuest !== undefined ? data.workoutAutoSideQuest : "Go to the gym");
setNotificationsEnabled(data.notificationsEnabled !== false);
setNotificationSettings({
  ...defaultNotificationSettings,
  ...(data.notificationSettings || {}),
  dailyHabitReminder: {
    ...defaultNotificationSettings.dailyHabitReminder,
    ...(data.notificationSettings?.dailyHabitReminder || {}),
  },
  streakRiskReminder: {
    ...defaultNotificationSettings.streakRiskReminder,
    ...(data.notificationSettings?.streakRiskReminder || {}),
  },
  dueReminder: {
    ...defaultNotificationSettings.dueReminder,
    ...(data.notificationSettings?.dueReminder || {}),
  },
});
setUserTimezone(data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York");
if (data.healthSync) setHealthSyncPrefs(data.healthSync);
// Load video gender preference from bodyMetrics
try {
  const bodyStats = await getBodyStats(uid);
  if (bodyStats.videoGender) setVideoGender(bodyStats.videoGender);
} catch (_) {}
await loadGameContent();
await loadProgramSettings();
await loadHowItWorks();
// Load programs list
try {
  const progSnap = await getDoc(doc(db, "appConfig", "programs"));
  if (progSnap.exists() && Array.isArray(progSnap.data().list)) {
    setPrograms(progSnap.data().list);
  }
} catch (_) {}
// Load pinned notes for dashboard
try {
  const snap = await getDoc(doc(db, "appConfig", "pinnedNotes"));
  if (snap.exists() && Array.isArray(snap.data().notes)) {
    setPinnedNotes(snap.data().notes);
  }
} catch (_) {}
try {
  const itSnap = await getDoc(doc(db, "appConfig", "infoTexts"));
  if (itSnap.exists()) setInfoTexts({ ...defaultInfoTexts, ...itSnap.data() });
} catch (_) {}
// Load today's scheduled workouts for dashboard widget
loadDashboardSchedule(uid);
// Run health sync in background on login
setTimeout(() => triggerHealthSync(uid, data.healthSync || {}), 2000);
      } else {
       setDailySelections({});
setRevivedDays({});
setSpentXP(0);
setChallengeCosts({});
setActiveChallenges({});
setResolvedDebtLog({});
setSideQuestCompletions({});
setCustomHabits(defaultHabits);
setExtraCategories([]);
setCategoryLabels({ nutrition: "Nutrition", movement: "Movement", mindset: "Mindset" });
setDailyCheckIns({});
setProfileName("");
setSelectedAvatar("");
setProfileComplete(false);
setIsAdmin(false);
setUserStatus("active");
setUserStartDate(null);
setUserEndDate(null);
setReviveStartDate(null);
setStartingXP(0);
setAllUsers([]);
setUserprogramTag("");
await loadGameContent();
      }

      clearTimeout(loadTimeoutId);
      setIsLoaded(true);
    } catch (error) {
      clearTimeout(loadTimeoutId);
      console.error("[loadProgress ERROR]", error?.code, error?.message, String(error));

      // If offline, don't wipe profile — just mark loaded so the app doesn't
      // get stuck on the loading screen. The user will see the dashboard with
      // empty data until connectivity is restored, at which point a page reload
      // will re-run loadProgress successfully.
      if (error?.code === "unavailable" || error?.message?.includes("offline") || error?.message?.includes("network")) {
        setIsLoaded(true);
        setSaveStatus("Offline — reconnecting...");
        // Retry after 5 seconds
        setTimeout(() => loadProgress(uid), 5000);
        return;
      }

      setDailySelections({});
setRevivedDays({});
setSpentXP(0);
setChallengeCosts({});
setActiveChallenges({});
setResolvedDebtLog({});
setSideQuestCompletions({});
setCustomHabits(defaultHabits);
setExtraCategories([]);
setCategoryLabels({ nutrition: "Nutrition", movement: "Movement", mindset: "Mindset" });
setDailyCheckIns({});
setProfileName("");
setSelectedAvatar("");
setProfileComplete(false);
setIsAdmin(false);
setUserStatus("active");
setUserStartDate(null);
setUserEndDate(null);
setStartingXP(0);
setAllUsers([]);
setUserprogramTag("");
setGameContent({
  sideQuests: [],
  weeklyChallenges: [],
  bonusXPOpportunities: [],
  badges: [],
});
setIsLoaded(true);
setSaveStatus("Error loading");
    }
  }

  useEffect(() => {
    // Fallback: if onAuthStateChanged never fires (iOS WKWebView IndexedDB issue),
    // clear the loading screen after 4 seconds so the user sees the login form.
    const authTimeout = setTimeout(() => {
      setAuthLoading(false);
    }, 4000);

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      clearTimeout(authTimeout);
      setUser(firebaseUser);
      setAuthLoading(false);
      setAuthError("");
      setSaveStatus("Saved");

      if (firebaseUser) {
        setIsLoaded(false);
        await loadProgress(firebaseUser.uid);
      } else {
      setDailySelections({});
setRevivedDays({});
setSpentXP(0);
setChallengeCosts({});
setActiveChallenges({});
setResolvedDebtLog({});
setSideQuestCompletions({});
setCustomHabits(defaultHabits);
setExtraCategories([]);
setCategoryLabels({ nutrition: "Nutrition", movement: "Movement", mindset: "Mindset" });
setDailyCheckIns({});
setProfileName("");
setSelectedAvatar("");
setProfileComplete(false);
setIsAdmin(false);
setUserStatus("active");
setUserStartDate(null);
setUserEndDate(null);
setStartingXP(0);
setAllUsers([]);
setGameContent({
  sideQuests: [],
  weeklyChallenges: [],
  bonusXPOpportunities: [],
  badges: [],
});
setIsLoaded(false);
      }
    });

    return () => unsubscribe();
  }, []);
useEffect(() => {
  if (isAdmin) {
    loadAllUsers();
  }
}, [isAdmin]);

// Keep admin-configurable client fields in sync in real-time so the client
// always sees changes the coach makes without needing to reload the app.
useEffect(() => {
  if (!user?.uid) return;
  const unsub = onSnapshot(doc(db, "users", user.uid), (snap) => {
    if (!snap.exists()) return;
    const data = snap.data();
    setBodyMetricsConfig(data.bodyMetricsConfig || {});
    setBodyMetricsXpLog(data.bodyMetricsXpLog || {});
    setCustomHabits(data.customHabits || defaultHabits);
    setCategoryLabels({ nutrition: "Nutrition", movement: "Movement", mindset: "Mindset", ...(data.categoryLabels || {}) });
    setCategoryEmojis({ nutrition: "🍓", movement: "🚶‍♀️", mindset: "🌙", ...(data.categoryEmojis || {}) });
    setExtraCategories(data.extraCategories || []);
    setUserprogramTag(data.programTag || "");
    setReviveStartDate(data.reviveStartDate || null);
    // If the admin reduces startingXP or xpAdjustmentTotal, reduce spentXP by the same
    // delta so totalXP stays stable and users are never stuck earning toward a deficit.
    const newXPBase = (data.startingXP || 0) + (data.xpAdjustmentTotal || 0);
    if (xpBaseRef.current !== null) {
      const delta = newXPBase - xpBaseRef.current;
      if (delta < 0) {
        setSpentXP(prev => {
          const corrected = Math.max(0, prev + delta);
          // Write immediately so admin's next refresh sees the same value
          if (corrected !== prev && user?.uid) {
            updateDoc(doc(db, "users", user.uid), { spentXP: corrected }).catch(console.error);
          }
          return corrected;
        });
      }
    }
    xpBaseRef.current = newXPBase;
    setStartingXP(data.startingXP || 0);
    setXpAdjustmentTotal(data.xpAdjustmentTotal || 0);
    setUserStartDate(data.startDate || null);
    setUserEndDate(data.endDate || null);
    setUserStatus(data.status || "active");
  });
  return unsub;
}, [user?.uid]);

useEffect(() => {
  async function loadProgramLeaderboardUsers() {
   if (!user || !profileComplete || !userprogramTag || !isLeaderboardVisibleForProgram(userprogramTag) || !isAdmin) {
      setProgramLeaderboardUsers([]);
      return;
    }

    try {
      const qRef = query(collection(db, "users"), where("programTag", "==", userprogramTag));
      const snapshot = await getDocs(qRef);
      const users = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
      setProgramLeaderboardUsers(users);
    } catch (error) {
      console.error("Error loading leaderboard users:", error);
      setProgramLeaderboardUsers([]);
    }
  }

  loadProgramLeaderboardUsers();
}, [user, profileComplete, userprogramTag, programSettings, isAdmin]);
useEffect(() => {
  loadActiveWeeklyPrompt();
}, [user, profileComplete, weeklyPromptRefreshKey]);

async function refreshDashboard(uid) {
  if (!uid) return;
  try {
    const docSnap = await getDocFromServer(doc(db, "users", uid));
    if (!docSnap.exists()) return;
    const data = docSnap.data();
    // Only refresh admin-controlled fields not covered by the onSnapshot listener.
    // Client-owned fields (dailySelections, sideQuestCompletions, spentXP, etc.)
    // are authoritative in React state — overwriting them from server can undo
    // changes the user just made if the write hasn't reached Firestore yet.
    // xpAdjustmentTotal is now handled by the onSnapshot listener — skip here.
    setSideQuestSchedules(data.sideQuestSchedules || {});
    setWeeklyHabits(data.weeklyHabits || []);
    const tag = data.programTag || userprogramTag || "";
    const dismissed = dismissedBroadcasts;
    if (tag) {
      getActiveBroadcastsForUser(tag, uid, dismissed).then(setPendingBroadcasts).catch(console.error);
    }
    getSubmittedResponsesWithFeedback(uid).then(setBroadcastFeedback).catch(console.error);
  } catch (err) {
    console.warn("[refreshDashboard] failed:", err?.message);
  }
}

useEffect(() => {
  if (!user || !profileComplete || activeScreen !== "dashboard") return;
  refreshDashboard(user.uid);
  loadDashboardSchedule(user.uid);
}, [user, profileComplete, activeScreen]);

// Load programs list before login so signup code branding works
useEffect(() => {
  getDoc(doc(db, "appConfig", "programs")).then((snap) => {
    if (snap.exists() && Array.isArray(snap.data().list)) setPrograms(snap.data().list);
  }).catch(() => {});
}, []);

useEffect(() => {
  if (!user || !profileComplete) return;
  const tag = userprogramTag;
  if (!tag) return;
  getActiveBroadcastsForUser(tag, user.uid, dismissedBroadcasts).then(setPendingBroadcasts).catch(console.error);
}, [user, profileComplete, userprogramTag, dismissedBroadcasts]);

useEffect(() => {
  if (!user || !profileComplete) return;

  let programCallRef = null;
  let directCallRef = null;
  let adminCallRef = null;

  async function applyCall(call) {
    setGroupCall(call);
    if (call?.pollBroadcastId) {
      try {
        const [broadcastSnap, responsesSnap] = await Promise.all([
          getDoc(doc(db, "broadcasts", call.pollBroadcastId)),
          getDocs(query(collection(db, "broadcastResponses"), where("broadcastId", "==", call.pollBroadcastId))),
        ]);
        if (broadcastSnap.exists()) {
          setCallPollBroadcast({
            id: broadcastSnap.id,
            ...broadcastSnap.data(),
            responses: responsesSnap.docs.map((d) => ({ id: d.id, ...d.data() })),
          });
        }
      } catch (_) {}
    } else {
      setCallPollBroadcast(null);
    }
  }

  function pickBest() {
    const candidates = [programCallRef, directCallRef, adminCallRef].filter(Boolean);
    if (candidates.length === 0) { applyCall(null); return; }
    candidates.sort((a, b) => (b.createdAt?.toDate?.()?.getTime?.() || 0) - (a.createdAt?.toDate?.()?.getTime?.() || 0));
    applyCall(candidates[0]);
  }

  const unsubs = [];
  if (userprogramTag) {
    unsubs.push(subscribeToCall(userprogramTag, user.uid, (call) => { programCallRef = call; pickBest(); }));
    unsubs.push(subscribeToDirectCall(user.uid, (call) => { directCallRef = call; pickBest(); }));
  }
  if (isAdmin) {
    unsubs.push(subscribeToAdminCall(user.uid, (call) => { adminCallRef = call; pickBest(); }));
  }
  return () => unsubs.forEach((u) => u());
}, [user, profileComplete, userprogramTag, isAdmin]);

// Sync recurring call form state when config loads
useEffect(() => {
  if (!recurringCallConfig) return;
  setRcFormTargetType(recurringCallConfig.targetType || "program");
  setRcFormTargetUserIds(recurringCallConfig.targetUserIds || []);
  setRcFormStartDate(recurringCallConfig.startDate || "");
  if (recurringCallConfig.totalCalls) {
    setRcFormEndType("count");
    setRcFormTotalCalls(String(recurringCallConfig.totalCalls));
    setRcFormEndDate("");
  } else if (recurringCallConfig.endDate) {
    setRcFormEndType("date");
    setRcFormEndDate(recurringCallConfig.endDate);
    setRcFormTotalCalls("");
  } else {
    setRcFormEndType("indefinite");
    setRcFormEndDate("");
    setRcFormTotalCalls("");
  }
}, [recurringCallConfig]);

// Subscribe to recurring call config + live poll data for next occurrences
useEffect(() => {
  const unsub = subscribeToRecurringConfig(async (config) => {
    setRecurringCallConfig_(config);
    if (!config?.active) { setNextCallOccurrences([]); setNextCallPolls({}); return; }
    const occurrences = computeNextOccurrences(config, new Date(), 5);
    setNextCallOccurrences(occurrences);
    const dateKeys = occurrences.map(dateKeyFromDate);
    const polls = await getCallPollsForDateKeys(dateKeys);
    setNextCallPolls(polls);
  });
  return unsub;
}, []);

useEffect(() => {
  if (!user || !profileComplete) return;
  const q = query(collection(db, "broadcastResponses"), where("userId", "==", user.uid));
  const unsub = onSnapshot(q, (snap) => {
    const withFeedback = snap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .filter((r) => (r.adminReaction || r.adminReply) && !r.clientDismissed);
    setBroadcastFeedback(withFeedback);
  }, (err) => console.error("broadcastResponses listener:", err));
  return () => unsub();
}, [user, profileComplete]);

useEffect(() => {
  if (!user?.uid || !profileComplete) return;
  registerPushForUser(user.uid).catch((err) => {
    console.error("Push registration failed:", err);
  });
}, [user?.uid, profileComplete]);


// Level-up detection
useEffect(() => {
  if (!isLoaded || !user) return;
  if (prevLevelRef.current === null) {
    prevLevelRef.current = level;
    return;
  }
  if (level > prevLevelRef.current) {
    setLevelUpBanner({ level, xp: totalXP });
    setTimeout(() => setLevelUpBanner(null), 5000);
  }
  prevLevelRef.current = level;
}, [level, isLoaded, user]);

// Load assigned coach info for non-admin users
useEffect(() => {
  if (!user?.uid || !profileComplete || isAdmin) return;

  async function fetchCoachInfo() {
    try {
      const userSnap = await getDoc(doc(db, "users", user.uid));

      let assignedCoachId = DEFAULT_COACH_ID;

      if (userSnap.exists()) {
        const userData = userSnap.data();
        assignedCoachId = userData.coachId || DEFAULT_COACH_ID;
      }

      setCoachId(assignedCoachId);

      const coachSnap = await getDoc(doc(db, "coachProfiles", assignedCoachId));

      if (!coachSnap.exists()) {
        setCoachInfo(null);
        return;
      }

      const data = coachSnap.data();
      let coachAvatar = data.avatar || data.selectedAvatar || data.photoURL || "";
      // Always prefer the coach's user-profile avatar since it's always current
      try {
        const coachUserSnap = await getDoc(doc(db, "users", assignedCoachId));
        if (coachUserSnap.exists()) {
          const userAvatar = coachUserSnap.data().avatar || "";
          if (userAvatar) coachAvatar = userAvatar;
        }
      } catch { /* permission denied — use coachProfiles avatar */ }
      setCoachInfo({
        id: coachSnap.id,
        name: data.name || "",
        avatar: coachAvatar,
      });
    } catch (err) {
      console.warn("Could not load coach info:", err?.message);
      setCoachInfo(null);
    }
  }

  fetchCoachInfo();
}, [user?.uid, profileComplete, isAdmin]);

// Subscribe to admin activity feed (admin only)
useEffect(() => {
  if (!isAdmin || !user) return;
  const unsub = subscribeToAdminActivity((events) => {
    setAdminActivityEvents(events);
    setAdminActivityUnread(events.filter((e) => !e.readByAdmin).length);
  });
  return unsub;
}, [isAdmin, user]);

// Subscribe to user notification inbox (all users, including admin)
useEffect(() => {
  if (!user?.uid || !profileComplete) return;
  const unsub = subscribeToUserNotifications(user.uid, (notifs) => {
    setUserNotifications(notifs);
  });
  return unsub;
}, [user?.uid, profileComplete]);

// Mark all activity read when admin LEAVES the Activity tab (any way — tab switch or screen switch)
const prevAdminTabRef = useRef(null);
const prevActiveScreenRef = useRef(null);
useEffect(() => {
  if (!isAdmin) return;
  const wasOnActivity = prevAdminTabRef.current === "activity";
  const leftAdminTab = wasOnActivity && adminTab !== "activity";
  const leftAdminScreen = wasOnActivity && prevActiveScreenRef.current === "admin" && activeScreen !== "admin";
  if (leftAdminTab || leftAdminScreen) {
    markAllActivityRead();
  }
  prevAdminTabRef.current = adminTab;
  prevActiveScreenRef.current = activeScreen;
}, [isAdmin, adminTab, activeScreen]);

// Load workout programs when admin opens the tab
useEffect(() => {
  if (!isAdmin || adminTab !== "workoutPrograms") return;
  getAllWorkoutPrograms().then(setWpList).catch(console.error);
}, [isAdmin, adminTab]);

// Load avatar builder config once on mount
useEffect(() => {
  getAvatarBuilderConfig().then(setAvatarBuilderConfig).catch(console.error);
}, []);

// Subscribe to unread message count
useEffect(() => {
  if (!user || !profileComplete) return;
  if (isAdmin) {
    // Coach: watch all conversations, sum coachUnread
    const unsub = subscribeToAllConversations((convs) => {
      setDmUnread(convs.reduce((sum, c) => sum + (c.coachUnread || 0), 0));
    });
    return unsub;
  } else {
    // Client: watch their own conversation
    getOrCreateConversation(user.uid, profileName, selectedAvatar).then(() => {
      const unsub = subscribeToConversation(user.uid, (conv) => {
        setDmUnread(conv?.clientUnread || 0);
      });
      return unsub;
    }).catch((err) => console.error("getOrCreateConversation:", err));
  }
}, [user, profileComplete, isAdmin]);
  useEffect(() => {
    if (!isLoaded || !user || !profileComplete) return;

    setSaveStatus("Saving...");

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(() => {
   saveProgress(
  dailySelections,
  revivedDays,
  spentXP,
  challengeCosts,
  activeChallenges,
  resolvedDebtLog,
  sideQuestCompletions,
  customHabits,
  dailyCheckIns,
  categoryLabels
);
    }, 100);

    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, [
  dailySelections,
  revivedDays,
  spentXP,
  challengeCosts,
  activeChallenges,
  resolvedDebtLog,
  sideQuestCompletions,
  customHabits,
  dailyCheckIns,
  categoryLabels,
  isLoaded,
  user,
  profileComplete,
]);

// Flush any pending save immediately when the page is about to unload
useEffect(() => {
  function handleBeforeUnload() {
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
      saveTimeoutRef.current = null;
    }
    if (!isLoaded || !user || !profileComplete) return;
    saveProgress(
      dailySelections,
      revivedDays,
      spentXP,
      challengeCosts,
      activeChallenges,
      resolvedDebtLog,
      sideQuestCompletions,
      customHabits,
      dailyCheckIns,
      categoryLabels
    );
  }
  window.addEventListener("beforeunload", handleBeforeUnload);
  return () => window.removeEventListener("beforeunload", handleBeforeUnload);
}, [dailySelections, revivedDays, spentXP, challengeCosts, activeChallenges, resolvedDebtLog, sideQuestCompletions, customHabits, dailyCheckIns, categoryLabels, isLoaded, user, profileComplete]);

  async function handleSignup(e) {
  e.preventDefault();
  setAuthError("");

  if (password !== confirmPassword) {
    setAuthError("Passwords do not match.");
    return;
  }

  // Validate signup code — check programs list first (already loaded in state)
  let resolvedProgramTag = null;
  const enteredCode = signupCode.trim().toUpperCase();
  const matchedProgram = programs.find((p) => p.code && p.code.toUpperCase() === enteredCode);
  if (matchedProgram) {
    resolvedProgramTag = matchedProgram.tag;
  } else {
    // Fall back to signupCodes doc in Firestore
    try {
      const codesSnap = await getDoc(doc(db, "appConfig", "signupCodes"));
      if (codesSnap.exists()) {
        const codesMap = codesSnap.data();
        if (codesMap[enteredCode]) {
          resolvedProgramTag = codesMap[enteredCode];
        }
      }
    } catch (_) {}
    // Final fallback to hardcoded code
    if (!resolvedProgramTag) {
      if (enteredCode === REQUIRED_SIGNUP_CODE) {
        resolvedProgramTag = "quit-the-quit-beta";
      } else {
        setAuthError("That sign up code is not correct.");
        return;
      }
    }
  }
  setPendingProgramTag(resolvedProgramTag);

  try {
    await createUserWithEmailAndPassword(auth, email, password);
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setSignupCode("");
    setShowPassword(false);
  } catch (error) {
    console.error(error);
    setAuthError(error.message);
  }
}
async function handleForgotPassword() {
  setAuthError("");

  if (!email.trim()) {
    setAuthError("Enter your email first, then tap Forgot password.");
    return;
  }

  try {
    await sendPasswordResetEmail(auth, email.trim());
    setAuthError("Password reset email sent. Check your inbox.");
  } catch (error) {
    console.error(error);
    setAuthError("Couldn't send reset email. Double-check the email address.");
  }
}
  async function handleLogin(e) {
    e.preventDefault();
    setAuthError("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setEmail("");
setPassword("");
setConfirmPassword("");
setSignupCode("");
setShowPassword(false);
    } catch (error) {
      console.error(error);
      setAuthError(error.message);
    }
  }

  async function handleUpdateCommunityNotifPrefs(typeKey, value) {
    const next = { ...communityNotifPrefs, [typeKey]: value };
    setCommunityNotifPrefs(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        communityNotifPrefs: next,
      });
    }
  }

  async function handleToggleNutritionTracking() {
    const next = !nutritionTrackingEnabled;
    setNutritionTrackingEnabled(next);
    if (next) { setPortionTrackingEnabled(false); setMacroTrackingEnabled(false); }
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        nutritionTrackingEnabled: next,
        ...(next && { portionTrackingEnabled: false, macroTrackingEnabled: false }),
      });
    }
  }

  async function handleTogglePortionTracking() {
    const next = !portionTrackingEnabled;
    setPortionTrackingEnabled(next);
    if (next) { setNutritionTrackingEnabled(false); setMacroTrackingEnabled(false); }
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        portionTrackingEnabled: next,
        ...(next && { nutritionTrackingEnabled: false, macroTrackingEnabled: false }),
      });
    }
  }

  async function handleToggleWeeklyGoals() {
    const next = !weeklyGoalsEnabled;
    setWeeklyGoalsEnabled(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), { weeklyGoalsEnabled: next });
    }
  }

  async function handleToggleWaterTracking() {
    const next = !waterTrackingEnabled;
    setWaterTrackingEnabled(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        waterTrackingEnabled: next,
      });
    }
  }

  async function handleToggleMacroTracking() {
    const next = !macroTrackingEnabled;
    setMacroTrackingEnabled(next);
    if (next) { setNutritionTrackingEnabled(false); setPortionTrackingEnabled(false); }
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        macroTrackingEnabled: next,
        ...(next && { nutritionTrackingEnabled: false, portionTrackingEnabled: false }),
      });
    }
  }

  async function handleTogglePushNotifications() {
    const next = !notificationsEnabled;
    setNotificationsEnabled(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        notificationsEnabled: next,
      });
    }

    if (next && user?.uid) {
      registerPushForUser(user.uid).catch((err) => {
        console.error("Push registration failed:", err);
      });
    }
  }

  async function handleReminderToggle(path, value) {
    const next = {
      ...notificationSettings,
      [path]: {
        ...(notificationSettings[path] || {}),
        enabled: value,
      },
    };
    setNotificationSettings(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        notificationSettings: next,
      });
    }
  }

  async function handleReminderTime(path, value) {
    const next = {
      ...notificationSettings,
      [path]: {
        ...(notificationSettings[path] || {}),
        time: value,
      },
    };
    setNotificationSettings(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        notificationSettings: next,
      });
    }
  }

  async function handleDueReminderToggle(value) {
    const next = {
      ...notificationSettings,
      dueReminder: {
        ...(notificationSettings.dueReminder || {}),
        enabled: value,
      },
    };
    setNotificationSettings(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        notificationSettings: next,
      });
    }
  }

  async function handleDueReminderTime(value) {
    const next = {
      ...notificationSettings,
      dueReminder: {
        ...(notificationSettings.dueReminder || {}),
        time: value,
      },
    };
    setNotificationSettings(next);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        notificationSettings: next,
      });
    }
  }

  async function handleTimezoneChange(value) {
    setUserTimezone(value);
    if (auth.currentUser) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        timezone: value,
      });
    }
  }

  async function handleLogout() {
    try {
      await signOut(auth);
      setEmail("");
setPassword("");
setConfirmPassword("");
setSignupCode("");
setShowPassword(false);
      setAuthError("");
      setIsEditingAvatar(false);
      setActiveScreen("dashboard");
    } catch (error) {
      console.error(error);
    }
  }

  async function handleProfileSetup(e) {
    e.preventDefault();

    if (!profileFirstName.trim() || !selectedAvatar) return;

    try {
      // Apply program-specific default habit names if configured
      const progTag = pendingProgramTag || "momentum";
      const progDefaultHabits = programSettings[progTag]?.defaultHabits || {};
      const mergedHabits = JSON.parse(JSON.stringify(defaultHabits));
      ["nutrition", "movement", "mindset"].forEach((cat) => {
        if (progDefaultHabits[cat]) {
          ["low", "main", "high"].forEach((level) => {
            if (progDefaultHabits[cat][level]) {
              mergedHabits[cat][level].habitName = progDefaultHabits[cat][level];
            }
          });
        }
      });
      setCustomHabits(mergedHabits);

            await setDoc(
        doc(db, "users", auth.currentUser.uid),
        {
          email: auth.currentUser.email,
          name: [profileFirstName.trim(),profileLastName.trim()].filter(Boolean).join(" "),
          firstName: profileFirstName.trim(),
          lastName: profileLastName.trim(),
          showLastNameInitial: false,
          avatar: selectedAvatar,
          profileComplete: true,
          dailySelections: dailySelections,
          revivedDays: revivedDays,
          spentXP: spentXP,
          challengeCosts: challengeCosts,
          activeChallenges: activeChallenges,
          resolvedDebtLog: resolvedDebtLog,
          sideQuestCompletions: sideQuestCompletions,
          customHabits: mergedHabits,
          dailyCheckIns: dailyCheckIns,
          isAdmin: false,
          status: "active",
          startDate: null,
          endDate: null,
          reviveStartDate: null,
          startingXP: 0,
          coachId: DEFAULT_COACH_ID,
          programTag: pendingProgramTag || "momentum",
          categoryTags: [],
          notificationsEnabled: true,
          notificationSettings: defaultNotificationSettings,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York",
        },
        { merge: true }
      );

      setProfileName([profileFirstName.trim(),profileLastName.trim()].filter(Boolean).join(" "));
      setProfileComplete(true);
      setShowOnboarding(true); // show walkthrough for new users
      setSaveStatus("Saved");
    } catch (error) {
      console.error(error);
      setSaveStatus("Error saving");
    }
  }

  async function handleSaveName() {
    if (!auth.currentUser) return;
    const fn = profileFirstName.trim();
    const ln = profileLastName.trim();
    const fullName = [fn, ln].filter(Boolean).join(" ");
    const displayName = showLastNameInitial && ln ? fn + " " + ln[0] + "." : fullName;
    setProfileName(displayName);
    setSaveStatus("Saving...");
    try {
      await setDoc(doc(db, "users", auth.currentUser.uid), {
        name: fullName,
        firstName: fn,
        lastName: ln,
        showLastNameInitial,
      }, { merge: true });
      setSaveStatus("Saved");
      setShowNameEditModal(false);
    } catch (e) {
      setSaveStatus("Error saving");
    }
  }

  async function handleAvatarChange(avatar) {
    setSelectedAvatar(avatar);
    setSaveStatus("Saving...");
    markTodayCheckIn();

    try {
      await setDoc(
        doc(db, "users", auth.currentUser.uid),
        {
          avatar: avatar,
        },
        { merge: true }
      );
      setSaveStatus("Saved");
      setIsEditingAvatar(false);
    } catch (error) {
      console.error(error);
      setSaveStatus("Error saving");
    }
  }

  function getButtonStyle(category, levelType) {
    const isSelected = selectedHabits[category] === levelType;
    const CORE_CATEGORIES = ["nutrition", "movement", "mindset"];
    const isLockedByChallenge = isChallengeInProgress && !CORE_CATEGORIES.includes(category);
    const isEffectivelyDisabled = shouldDisableCurrentView || isLockedByChallenge;

    return {
      display: "block",
      width: "100%",
      marginTop: "10px",
      padding: "14px 16px",
      borderRadius: "16px",
      border: isSelected ? "2px solid #5f7fe0" : "2px solid #bfdbfe",
      cursor: isEffectivelyDisabled ? "not-allowed" : "pointer",
      background: isSelected ? "#7c9bff" : "#f5faff",
      color: isSelected ? "#fff" : "#4b3f57",
      textAlign: "left",
      boxShadow: isSelected
        ? "0 8px 18px rgba(159, 122, 234, 0.28)"
        : "0 4px 10px rgba(30, 58, 138, 0.10)",
      transition: "all 0.2s ease",
      position: "relative",
      overflow: "visible",
      opacity: isEffectivelyDisabled ? 0.5 : 1,
    };
  }

  function getArrowButtonStyle() {
    return {
      width: "30px",
      height: "30px",
      borderRadius: "999px",
      border: "2px solid #bfdbfe",
      background: "#f5faff",
      cursor: "pointer",
      fontSize: "14px",
      color: "#4b6b8a",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      boxShadow: "0 4px 10px rgba(30, 58, 138, 0.10)",
    };
  }

  function getCategoryCardStyle() {
    return {
      marginTop: "14px",
      background: "#f8fbff",
      padding: "14px",
      borderRadius: "22px",
      border: "2px solid #dbeafe",
      boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
    };
  }

function getAuthInputStyle() {
  return {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "14px",
    border: "2px solid #bfdbfe",
    background: "#f5faff",
    color: "#1e3a5f",
    WebkitTextFillColor: "#1e3a5f",
    fontSize: "15px",
    boxSizing: "border-box",
    marginTop: "10px",
    outline: "none",
  };
}
  function getPrimaryButtonStyle() {
    return {
      width: "100%",
      padding: "14px",
      marginTop: "14px",
      borderRadius: "16px",
      border: "none",
      background: "#38bdf8",
      color: "white",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 6px 16px rgba(159, 122, 234, 0.4)",
    };
  }

  const tokenStyle = {
    display: "block",
    width: "100%",
    marginTop: "10px",
    padding: "12px 14px",
    borderRadius: "16px",
    border: "2px solid #bfdbfe",
    background: "#f8fbff",
    cursor: "pointer",
    fontWeight: "bold",
    color: "#1e3a5f",
    fontSize: "15px",
  };

  const CATEGORY_EMOJIS = categoryEmojis;
  function getCatLabel(key) { return categoryLabels[key] || key.charAt(0).toUpperCase() + key.slice(1); }

  function renderCategory(categoryName, title, emoji, isExtra = false) {
    const categoryHabits = customHabits[categoryName];
    const isEditing = editingCategory === categoryName;

    return (
      <div key={categoryName} style={getCategoryCardStyle()}>
        {/* Header row */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
          <h3 style={{ margin: 0, color: "#1e3a5f", fontSize: "20px" }}>{emoji} {title}</h3>
          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <button
              onClick={() => setInfoPopup(isExtra ? "habits_extra" : "habits")}
              style={{ background: "transparent", border: "1px solid #bfdbfe", borderRadius: "8px", padding: "5px 7px", cursor: "pointer", color: "#6b7280", display: "flex", alignItems: "center" }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
            </button>
            <button
              onClick={() => setEditingCategory(isEditing ? null : categoryName)}
              style={{ background: isEditing ? "#e0f2fe" : "transparent", border: `1px solid ${isEditing ? "#2563eb" : "#bfdbfe"}`, borderRadius: "8px", padding: "5px 7px", cursor: "pointer", color: isEditing ? "#2563eb" : "#6b7280", display: "flex", alignItems: "center" }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.57 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>
            </button>
          </div>
        </div>

        {/* Edit mode */}
        {isEditing ? (
          <div>
            {/* Category name and emoji */}
            <div style={{ display: "grid", gridTemplateColumns: "56px 1fr", gap: "8px", marginBottom: "12px" }}>
              <div>
                <div style={{ color: "#4b6b8a", fontSize: "11px", fontWeight: "bold", marginBottom: "4px" }}>Emoji</div>
                <input type="text" value={emoji}
                  onChange={async (e) => {
                    const val = e.target.value;
                    if (isExtra) {
                      const updated = extraCategories.map((c) => c.key === categoryName ? { ...c, emoji: val } : c);
                      setExtraCategories(updated);
                      await updateDoc(doc(db, "users", auth.currentUser.uid), { extraCategories: updated });
                    } else {
                      const updated = { ...categoryEmojis, [categoryName]: val };
                      setCategoryEmojis(updated);
                      await updateDoc(doc(db, "users", auth.currentUser.uid), { categoryEmojis: updated });
                    }
                  }}
                  style={{ width: "100%", padding: "8px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "20px", textAlign: "center", boxSizing: "border-box" }} />
              </div>
              <div>
                <div style={{ color: "#4b6b8a", fontSize: "11px", fontWeight: "bold", marginBottom: "4px" }}>Category Name</div>
                <input type="text" value={title}
                  onChange={async (e) => {
                    const val = e.target.value;
                    if (isExtra) {
                      const updated = extraCategories.map((c) => c.key === categoryName ? { ...c, label: val } : c);
                      setExtraCategories(updated);
                      await updateDoc(doc(db, "users", auth.currentUser.uid), { extraCategories: updated });
                    } else {
                      const updated = { ...categoryLabels, [categoryName]: val };
                      setCategoryLabels(updated);
                      await updateDoc(doc(db, "users", auth.currentUser.uid), { categoryLabels: updated });
                    }
                  }}
                  style={{ width: "100%", padding: "8px 12px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "14px", fontWeight: "bold", color: "#1e3a5f", boxSizing: "border-box" }} />
              </div>
            </div>

            {/* Habit names */}
            {["low", "main", "high"].map((levelType) => {
              const habit = categoryHabits?.[levelType];
              if (!habit) return null;
              return (
                <div key={levelType} style={{ marginBottom: "10px" }}>
                  <div style={{ color: "#4b6b8a", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "4px" }}>{habit.label}</div>
                  <input type="text" value={habit.habitName}
                    onChange={(e) => handleHabitEdit(categoryName, levelType, e.target.value)}
                    style={{ width: "100%", padding: "9px 12px", borderRadius: "10px", border: "1.5px solid #bfdbfe", background: "#f5faff", fontSize: "14px", color: "#1e3a5f", boxSizing: "border-box", outline: "none" }} />
                </div>
              );
            })}

            {/* Remove button for extra categories */}
            {isExtra && (
              <div style={{ marginTop: "4px" }}>
                {deleteExtraCatConfirm === categoryName ? (
                  <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "12px", color: "#991b1b" }}>Remove this category?</span>
                    <button onClick={async () => {
                      const updated = extraCategories.filter((c) => c.key !== categoryName);
                      setExtraCategories(updated);
                      setDeleteExtraCatConfirm(null);
                      setEditingCategory(null);
                      await updateDoc(doc(db, "users", auth.currentUser.uid), { extraCategories: updated });
                    }} style={{ padding: "4px 12px", borderRadius: "8px", border: "1px solid #fecaca", background: "#fee2e2", color: "#991b1b", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Yes</button>
                    <button onClick={() => setDeleteExtraCatConfirm(null)} style={{ padding: "4px 12px", borderRadius: "8px", border: "1px solid #d1d5db", background: "#f9fafb", color: "#374151", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>No</button>
                  </span>
                ) : (
                  <button onClick={() => setDeleteExtraCatConfirm(categoryName)} style={{ padding: "5px 12px", borderRadius: "8px", border: "1px solid #fecaca", background: "#fff5f5", color: "#991b1b", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Remove category</button>
                )}
              </div>
            )}
          </div>
        ) : (
          /* Normal habit buttons */
          ["low", "main", "high"].map((levelType) => {
            const habit = categoryHabits[levelType];
            return (
              <button key={levelType} onClick={(event) => handleHabitClick(categoryName, levelType, event)} style={getButtonStyle(categoryName, levelType)}>
                <div style={{ fontSize: "12px", opacity: 0.85, letterSpacing: "0.3px" }}>{habit.label} (+{habit.xp})</div>
                <div style={{ fontWeight: "bold", marginTop: "4px", fontSize: "15px" }}>{habit.habitName}</div>
              </button>
            );
          })
        )}
      </div>
    );
  }

  function renderWeeklyChallengeCard() {
    const isSelected = Boolean(selectedHabits.weekly);
    const isDisabled = shouldDisableCurrentView || isChallengeInProgress;

    return (
      <div style={getCategoryCardStyle()}>
        <h3
          onClick={() => setInfoPopup("weekly")}
          style={{
            marginTop: 0,
            marginBottom: "10px",
            color: "#1e3a5f",
            fontSize: "20px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          {currentWeeklyChallenge.emoji} Weekly Challenge <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ color: "#9ca3af", flexShrink: 0 }}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
        </h3>

        <button
          onClick={isDisabled ? undefined : handleWeeklyChallengeClick}
          style={{
            display: "block",
            width: "100%",
            marginTop: "10px",
            padding: "14px 16px",
            borderRadius: "16px",
            border: isSelected ? "2px solid #5f7fe0" : "2px solid #bfdbfe",
            cursor: isDisabled ? "not-allowed" : "pointer",
            background: isSelected ? "#7c9bff" : "#f5faff",
            color: isSelected ? "#fff" : "#4b3f57",
            textAlign: "center",
            boxShadow: isSelected
              ? "0 8px 18px rgba(159, 122, 234, 0.28)"
              : "0 4px 10px rgba(30, 58, 138, 0.10)",
            transition: "all 0.2s ease",
            opacity: isDisabled ? 0.5 : 1,
          }}
        >
          <div style={{ fontSize: "12px", opacity: 0.85, letterSpacing: "0.3px" }}>
            Challenge Accepted (+{currentWeeklyChallenge.xp || 0})
          </div>
          <div style={{ fontWeight: "bold", marginTop: "6px", fontSize: "15px" }}>
            {currentWeeklyChallenge.text}
          </div>
        </button>

        {isChallengeInProgress && (
          <div style={{ marginTop: "10px", color: "#b45309", fontSize: "12px", textAlign: "center", background: "#fef3c7", borderRadius: "8px", padding: "6px 10px" }}>
            🔒 Complete all 3 habits today to unlock
          </div>
        )}
      </div>
    );
  }

  function renderQuestCard(item, type = "default") {
    return (
      <div
        key={item.title}
        style={{
          background: "#f8fbff",
          borderRadius: "18px",
          padding: "16px",
          border: "2px solid #bfdbfe",
        }}
      >
        <div style={{ fontSize: "28px", marginBottom: "8px" }}>
          {item.emoji}
        </div>

        <div
          style={{
            color: "#1e3a5f",
            fontWeight: "bold",
            marginBottom: "6px",
            fontSize: "16px",
          }}
        >
          {item.title}
        </div>

        {"description" in item && item.description && (
          <div
            style={{
              color: "#4b6b8a",
              fontSize: "14px",
              marginBottom: "10px",
              lineHeight: 1.4,
              whiteSpace: "pre-wrap",
            }}
          >
            {item.description}
          </div>
        )}

        <div
          style={{
            display: "inline-block",
            padding: "6px 10px",
            borderRadius: "999px",
            background: type === "bonus" ? "#e0f2fe" : "#f5faff",
            border: "2px solid #bfdbfe",
            color: "#1e3a5f",
            fontSize: "13px",
            fontWeight: "bold",
          }}
        >
          +{item.xp} XP
        </div>
      </div>
    );
  }

  function renderHeaderLevelCard() {
    return (
  <div
    style={{
      width: "100%",
      background: "#f8fbff",
      borderRadius: "18px",
      padding: "12px 14px",
      border: "2px solid #bfdbfe",
      boxSizing: "border-box",
    }}
  >
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: "8px", marginBottom: "6px" }}>
          <span style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "13px" }}>Level {level}</span>
          <span style={{ color: "#bfdbfe", fontSize: "11px" }}>·</span>
          <span style={{ color: "#4b6b8a", fontSize: "12px" }}>{totalXP} XP</span>
        </div>

        <div
          style={{
            width: "100%",
            height: "9px",
            background: "#dbeafe",
            borderRadius: "999px",
            overflow: "hidden",
            border: "1px solid #bfdbfe",
          }}
        >
          <div
            style={{
              width: `${progressPercent}%`,
              height: "100%",
              background:
                "linear-gradient(90deg, #38bdf8 0%, #3b82f6 50%, #1e3a8a 100%)",
              transition: "width 0.3s ease",
              borderRadius: "999px",
            }}
          />
        </div>

        <div
          style={{
            color: "#4b6b8a",
            fontSize: "10px",
            marginTop: "4px",
            textAlign: "center",
          }}
        >
          {xpIntoLevel}/{xpPerLevel}
        </div>
      </div>
    );
  }
  function getAdminUserXP(client) {
  const clientSelections = client.dailySelections || {};
  const clientRevivedDays = client.revivedDays || {};
  const clientSideQuestCompletions = client.sideQuestCompletions || {};
  const clientSpentXP = client.spentXP || 0;
  const clientStartingXP = client.startingXP || 0;
  const clientXPAdjustmentTotal = parseInt(client.xpAdjustmentTotal, 10) || 0;
  const clientCustomHabits = client.customHabits || defaultHabits;

  function getClientDayXP(daySelections, dateKey = null) {
    if (!daySelections) return 0;

    const challengeDate = dateKey
      ? new Date(`${dateKey}T12:00:00`)
      : new Date();

    const weeklyChallengeForDay = getCurrentWeeklyChallenge(challengeDate, client.programTag || "");
    const weeklyXP = weeklyChallengeForDay?.xp || 0;

    return (
      (daySelections.nutrition
        ? clientCustomHabits.nutrition?.[daySelections.nutrition]?.xp || 0
        : 0) +
      (daySelections.movement
        ? clientCustomHabits.movement?.[daySelections.movement]?.xp || 0
        : 0) +
      (daySelections.mindset
        ? clientCustomHabits.mindset?.[daySelections.mindset]?.xp || 0
        : 0) +
      (daySelections.weekly ? weeklyXP : 0) +
      (client.extraCategories || []).reduce((sum, cat) =>
        sum + (daySelections[cat.key] ? (clientCustomHabits[cat.key]?.[daySelections[cat.key]]?.xp || 0) : 0), 0)
    );
  }

  const earnedXPFromHabits = Object.entries(clientSelections).reduce(
    (total, [dateKey, daySelections]) => total + getClientDayXP(daySelections, dateKey),
    0
  );

  const activeSideQuestsForAdmin = (gameContent.sideQuests || []).filter(
    (quest) => quest.active
  );

  const sideQuestXPByTitle = Object.fromEntries(
    activeSideQuestsForAdmin.map((quest) => [quest.title, quest.xp])
  );

  const earnedXPFromSideQuests = Object.entries(clientSideQuestCompletions).reduce(
    (total, [, completedQuests]) =>
      total +
      Object.entries(completedQuests || {}).reduce(
        (dayTotal, [title, completed]) =>
          dayTotal + (completed ? sideQuestXPByTitle[title] || 0 : 0),
        0
      ),
    0
  );

  const totalXP = Math.max(
    0,
    clientStartingXP + clientXPAdjustmentTotal + earnedXPFromHabits + earnedXPFromSideQuests - clientSpentXP
  );

  const level = Math.floor(totalXP / 500) + 1;

  return { totalXP, level };
}
const rankedUsers = [...allUsers]
  .filter((client) => {
    if (adminLeaderboardProgramFilter === "all") return true;
    return (client.programTag || "") === adminLeaderboardProgramFilter;
  })
  .sort((a, b) => {
    const aXP = getAdminUserXP(a).totalXP;
    const bXP = getAdminUserXP(b).totalXP;
    return bXP - aXP;
  });
function getAdminUserBadges(client) {
  const clientSelections = client.dailySelections || {};
  const clientCheckIns = client.dailyCheckIns || {};
  const clientRevivedDays = client.revivedDays || {};
  const clientShieldActivatedDays = client.shieldActivatedDays || {};
  const clientShieldStatus = client.shieldStatus || "none";
  const clientSideQuestCompletions = client.sideQuestCompletions || {};

  const nutritionCurrent = calculateCategoryCurrentStreak(clientSelections, "nutrition");
  const nutritionLongest = calculateCategoryLongestStreak(clientSelections, "nutrition");

  const movementCurrent = calculateCategoryCurrentStreak(clientSelections, "movement");
  const movementLongest = calculateCategoryLongestStreak(clientSelections, "movement");

  const mindsetCurrent = calculateCategoryCurrentStreak(clientSelections, "mindset");
  const mindsetLongest = calculateCategoryLongestStreak(clientSelections, "mindset");

  const fullCurrent = calculateFullQuestCurrentStreak(clientSelections);
  const fullLongest = calculateFullQuestLongestStreak(clientSelections);

  const weeklyCurrent = calculateWeeklyChallengeCurrentStreak(clientSelections);
  const weeklyLongest = calculateWeeklyChallengeLongestStreak(clientSelections);

  const loginCurrent = calculateLoginCurrentStreak(clientCheckIns);
  const loginLongest = calculateLoginLongestStreak(clientCheckIns);

  const { totalXP, level } = getAdminUserXP(client);

  return (gameContent.badges || [])
    .filter((badge) => badge.active)
    .map((badge) => {
      let earned = false;

      if (badge.type === "xp") {
        earned = totalXP >= badge.threshold;
      } else if (badge.type === "level") {
        earned = level >= badge.threshold;
      } else if (badge.type === "nutritionStreak") {
        earned = nutritionCurrent >= badge.threshold || nutritionLongest >= badge.threshold;
      } else if (badge.type === "movementStreak") {
        earned = movementCurrent >= badge.threshold || movementLongest >= badge.threshold;
      } else if (badge.type === "mindsetStreak") {
        earned = mindsetCurrent >= badge.threshold || mindsetLongest >= badge.threshold;
      } else if (badge.type === "fullQuestStreak") {
        earned = fullCurrent >= badge.threshold || fullLongest >= badge.threshold;
      } else if (badge.type === "weeklyChallengeStreak") {
        earned = weeklyCurrent >= badge.threshold || weeklyLongest >= badge.threshold;
      } else if (badge.type === "loginStreak") {
        earned = loginCurrent >= badge.threshold || loginLongest >= badge.threshold;
      } else if (badge.type === "loginAfterMissedDay") {
        const checkInDates = Object.keys(clientCheckIns).sort();
        earned = checkInDates.some((dateKey) => {
          const prev = new Date(`${dateKey}T12:00:00`);
          prev.setDate(prev.getDate() - 1);
          const prevKey = formatDateKey(prev);
          const prevSel = clientSelections[prevKey];
          const missedPrev = !prevSel || (!prevSel.nutrition && !prevSel.movement && !prevSel.mindset);
          return missedPrev && clientCheckIns[dateKey];
        });
      } else if (badge.type === "reviveUsed") {
        earned = Object.keys(clientRevivedDays).length >= badge.threshold;
      } else if (badge.type === "habitsAfterRevive") {
        earned = Object.keys(clientRevivedDays).some((dateKey) => {
          const next = new Date(`${dateKey}T12:00:00`);
          next.setDate(next.getDate() + 1);
          const nextKey = formatDateKey(next);
          const nextSel = clientSelections[nextKey];
          return nextSel && (nextSel.nutrition || nextSel.movement || nextSel.mindset);
        });
      } else if (badge.type === "shieldEarned") {
        earned =
          clientShieldStatus === "ready" ||
          Object.keys(clientShieldActivatedDays).length >= badge.threshold;
      } else if (badge.type === "sideQuestCount") {
        const totalCompleted = Object.values(clientSideQuestCompletions).reduce(
          (sum, dayQuests) =>
            sum + Object.values(dayQuests || {}).filter(Boolean).length,
          0
        );
        earned = totalCompleted >= badge.threshold;
      }

      return { ...badge, earned };
    })
    .filter((badge) => badge.earned);
}

function getLeaderboardEntriesForProgram() {
  if (!Array.isArray(programLeaderboardUsers) || programLeaderboardUsers.length === 0) {
    return [];
  }

  return [...programLeaderboardUsers]
    .map((client) => {
      const xpData = getAdminUserXP(client);
      return {
        id: client.id,
        name: client.name || "No name",
        avatar: client.avatar || "",
        totalXP: xpData.totalXP,
        level: xpData.level,
        isMe: client.id === user?.uid,
      };
    })
    .sort((a, b) => b.totalXP - a.totalXP)
    .slice(0, 20)
    .map((entry, idx) => ({ ...entry, rank: idx + 1 }));
}

function getAdminLogDays(client) {
  const dateKeys = Array.from(
    new Set([
      ...Object.keys(client.dailySelections || {}),
      ...Object.keys(client.sideQuestCompletions || {}),
      ...Object.keys(client.revivedDays || {}),
      ...Object.keys(client.resolvedDebtLog || {}),
      ...Object.keys(client.dailyCheckIns || {}),
    ])
  ).sort((a, b) => new Date(b) - new Date(a));

  return dateKeys.map((dateKey) => {
    const selections = client.dailySelections?.[dateKey] || {};
    const sideQuests = client.sideQuestCompletions?.[dateKey] || {};
    const reviveState = client.revivedDays?.[dateKey] || {};
    const resolvedDebtLog = client.resolvedDebtLog || {};

    const habits = [];

    if (selections.nutrition) {
      habits.push(
        `🥕 ${client.customHabits?.nutrition?.[selections.nutrition]?.label || selections.nutrition}: ${client.customHabits?.nutrition?.[selections.nutrition]?.habitName || ""}`
      );
    }

    if (selections.movement) {
      habits.push(
        `👟 ${client.customHabits?.movement?.[selections.movement]?.label || selections.movement}: ${client.customHabits?.movement?.[selections.movement]?.habitName || ""}`
      );
    }

    if (selections.mindset) {
      habits.push(
        `🌙 ${client.customHabits?.mindset?.[selections.mindset]?.label || selections.mindset}: ${client.customHabits?.mindset?.[selections.mindset]?.habitName || ""}`
      );
    }

    const quests = [];
    if (selections.weekly) {
      quests.push(`⭐ Weekly Challenge completed`);
    }

    const challenges = Object.keys(sideQuests)
      .filter((title) => sideQuests[title])
      .map((title) => `✨ ${title}`);

    const revives = [];
    const tokens = [];

    Object.entries(client.resolvedDebtLog || {}).forEach(([itemKey, resolvedOnDate]) => {
      if (resolvedOnDate !== dateKey) return;

      if (itemKey.startsWith("revive-")) {
        const originalDate = itemKey.replace("revive-", "");
        revives.push(`💖 Full revive used for ${originalDate}`);
      } else {
        const firstDash = itemKey.indexOf("-");
        const category = itemKey.slice(0, firstDash);
        const originalDate = itemKey.slice(firstDash + 1);
        tokens.push(`💎 ${category} token used for ${originalDate}`);
      }
    });

    return {
      dateKey,
      habits,
      quests,
      challenges,
      revives,
      tokens,
    };
  });
}

  if (authLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#eaf4ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            "'Trebuchet MS', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          color: "#1e3a5f",
          fontWeight: "bold",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#eaf4ff",
          padding: "20px",
          fontFamily:
            "'Trebuchet MS', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "420px",
            background: "#f5faff",
            borderRadius: "26px",
            padding: "24px",
            border: "2px solid #dbeafe",
            boxShadow: "0 10px 28px rgba(30, 58, 138, 0.12)",
          }}
        >
          {authMode === "signup" && (() => {
            const matchedProg = programs.find((p) => p.code && p.code.toUpperCase() === signupCode.trim().toUpperCase());
            const isMomentumType = matchedProg && (matchedProg.tag === "momentum" || matchedProg.tag.startsWith("momentum-"));
            if (isMomentumType) {
              return (
                <>
                  <div style={{ textAlign: "center", marginBottom: "8px" }}>
                    <div style={{ fontSize: "36px", fontWeight: "900", color: "#1e3a5f", letterSpacing: "-1px", lineHeight: 1.1 }}>{matchedProg.label}</div>
                    <div style={{ fontSize: "13px", color: "#4b6b8a", marginTop: "4px", fontStyle: "italic" }}>A Quit the Quit Program</div>
                    <div style={{ fontSize: "22px", marginTop: "6px", letterSpacing: "4px" }}>💎💎💎</div>
                  </div>
                  <p style={{ marginTop: 0, color: "#4b6b8a", textAlign: "center" }}>Create your account to start your quest.</p>
                </>
              );
            }
            return (
              <>
                <h1 style={{ marginTop: 0, marginBottom: "8px", color: "#1e3a5f" }}>Quit the Quit ✨</h1>
                <p style={{ marginTop: 0, color: "#4b6b8a" }}>Create your account to start your quest.</p>
              </>
            );
          })()}
          {authMode === "login" && (
            <>
              <h1 style={{ marginTop: 0, marginBottom: "8px", color: "#1e3a5f" }}>Quit the Quit ✨</h1>
              <p style={{ marginTop: 0, color: "#4b6b8a" }}>Log in to keep building consistency.</p>
            </>
          )}

          <form onSubmit={authMode === "login" ? handleLogin : handleSignup}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={getAuthInputStyle()}
              required
            />

            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={getAuthInputStyle()}
              required
            />

            {authMode === "signup" && (
  <>
    <input
      type={showPassword ? "text" : "password"}
      placeholder="Confirm password"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      style={getAuthInputStyle()}
      required
    />

    <input
      type="text"
      placeholder="Sign up code"
      value={signupCode}
      onChange={(e) => setSignupCode(e.target.value)}
      style={getAuthInputStyle()}
      required
    />
  </>
)}

            <div
  style={{
    marginTop: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  }}
>
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    style={{
      background: "transparent",
      border: "none",
      color: "#4b6b8a",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "13px",
      padding: 0,
    }}
  >
    {showPassword ? "Hide password" : "Show password"}
  </button>

  {authMode === "login" && (
    <button
      type="button"
      onClick={handleForgotPassword}
      style={{
        background: "transparent",
        border: "none",
        color: "#4b6b8a",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: "13px",
        padding: 0,
      }}
    >
      Forgot password?
    </button>
  )}
</div>

            {authError && (
              <p
                style={{
                  color: "#b91c1c",
                  fontSize: "14px",
                  marginTop: "12px",
                  marginBottom: 0,
                }}
              >
                {authError}
              </p>
            )}

            <button type="submit" style={getPrimaryButtonStyle()}>
              {authMode === "login" ? "Log In" : "Create Account"}
            </button>
          </form>

          <button
            onClick={() =>
              setAuthMode(authMode === "login" ? "signup" : "login")
            }
            style={{
              marginTop: "12px",
              background: "transparent",
              border: "none",
              color: "#4b6b8a",
              cursor: "pointer",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            {authMode === "login"
              ? "Need an account? Sign up"
              : "Already have an account? Log in"}
          </button>
        </div>
      </div>
    );
  }

  if (user && !isLoaded) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#eaf4ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            "'Trebuchet MS', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          color: "#1e3a5f",
          fontWeight: "bold",
        }}
      >
        Loading...
      </div>
    );
  }

  if (user && isLoaded && !profileComplete) {
    return (
      <>
      <div
        style={{
          minHeight: "100vh",
          background: "#eaf4ff",
          padding: "20px",
          fontFamily:
            "'Trebuchet MS', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "520px",
            background: "#f5faff",
            borderRadius: "26px",
            padding: "24px",
            border: "2px solid #dbeafe",
            boxShadow: "0 10px 28px rgba(30, 58, 138, 0.12)",
          }}
        >
          <h1 style={{ marginTop: 0, marginBottom: "8px", color: "#1e3a5f" }}>
            Set Up Your Profile
          </h1>
          <p style={{ marginTop: 0, color: "#4b6b8a" }}>
            Enter your first and last name, then pick an avatar before you start your quest.
          </p>

          <form onSubmit={handleProfileSetup}>
            <input type="text" placeholder="First name" value={profileFirstName} onChange={(e) => setProfileFirstName(e.target.value)} style={getAuthInputStyle()} required />
            <input type="text" placeholder="Last name" value={profileLastName} onChange={(e) => setProfileLastName(e.target.value)} style={{ ...getAuthInputStyle(), marginTop: "10px" }} />

            <div style={{ marginTop: "18px" }}>
              <div style={{ color: "#1e3a5f", fontWeight: "bold", marginBottom: "10px" }}>
                Choose your avatar
              </div>
              {selectedAvatar ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                  <img src={selectedAvatar} alt="Your avatar" style={{ width: 100, height: 100, borderRadius: "999px", border: "3px solid #2563eb" }} />
                  <button type="button" onClick={() => setIsEditingAvatar(true)}
                    style={{ fontSize: "13px", color: "#2563eb", background: "none", border: "none", cursor: "pointer", fontWeight: "bold" }}>
                    Customize ✏️
                  </button>
                </div>
              ) : (
                <button type="button" onClick={() => {
                  setSelectedAvatar(buildAvatarUrl({ ...DEFAULT_OPTIONS, seed: profileFirstName.trim() || "newuser" }));
                  setIsEditingAvatar(true);
                }} style={{ width: "100%", padding: "14px", borderRadius: "16px", border: "2px dashed #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}>
                  Pick your avatar
                </button>
              )}
            </div>

            <button
              type="submit"
              style={getPrimaryButtonStyle()}
              disabled={!profileFirstName.trim() || !selectedAvatar}
            >
              Start My Quest
            </button>
          </form>
        </div>
      </div>
      {isEditingAvatar && (
        <AvatarBuilder
          initialUrl={selectedAvatar}
          seedHint={profileFirstName.trim() || "newuser"}
          onSave={(url) => { setSelectedAvatar(url); setIsEditingAvatar(false); }}
          onCancel={() => setIsEditingAvatar(false)}
          config={avatarBuilderConfig}
        />
      )}
      </>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#eaf4ff",
        padding: "14px",
        paddingBottom: "90px",
        fontFamily:
          "'Trebuchet MS', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        position: "relative",
        overflowX: "hidden",
        boxSizing: "border-box",
        colorScheme: "light",
      }}
    >
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          style={{
            position: "fixed",
            left: sparkle.x,
            top: sparkle.y,
            fontSize: `${sparkle.size}px`,
            pointerEvents: "none",
            zIndex: 9999,
            animation: `sparkle-burst ${sparkle.duration}ms ease-out forwards`,
            "--dx": sparkle.dx,
            "--dy": sparkle.dy,
            "--rot": sparkle.rot,
          }}
        >
          {sparkle.emoji}
        </div>
      ))}
{!shouldShowDebtSection && isBeforeStartDate() && (
  <div
    style={{
      maxWidth: "700px",
      margin: "0 auto 20px auto",
      background: "#f5faff",
      borderRadius: "24px",
      padding: "22px",
      border: "2px solid #dbeafe",
      boxShadow: "0 10px 28px rgba(30, 58, 138, 0.14)",
    }}
  >
    <h2 style={{ color: "#1e3a5f", marginTop: 0 }}>
      ⏳ Your program has not started yet
    </h2>
    <p style={{ color: "#4b6b8a", marginBottom: 0 }}>
      {userStartDate
        ? `Your start date is ${userStartDate}.`
        : "Your coach has not set your start date yet."}
    </p>
  </div>
)}

{!shouldShowDebtSection && !hasProgramAccess() && !isBeforeStartDate() && (
  <div
    style={{
      maxWidth: "700px",
      margin: "0 auto 20px auto",
      background: "#f5faff",
      borderRadius: "24px",
      padding: "22px",
      border: "2px solid #dbeafe",
      boxShadow: "0 10px 28px rgba(30, 58, 138, 0.14)",
    }}
  >
    <h2 style={{ color: "#1e3a5f", marginTop: 0 }}>
      🔒 Your program has ended
    </h2>
    <p style={{ color: "#4b6b8a", marginBottom: 0 }}>
      Reach out to Ashley if you need access restored.
    </p>
  </div>
)}
      {displayedDebtItems.length > 0 && (
  <div
    style={{
      maxWidth: "700px",
      margin: "0 auto 20px auto",
      background: "#f5faff",
      borderRadius: "24px",
      padding: "18px 22px",
      border: "2px solid #dbeafe",
      boxShadow: "0 10px 28px rgba(30, 58, 138, 0.14)",
    }}
  >
    {/* Compact summary row */}
    {displayedDebtItems.length > 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>
            🔒 Resolve Missed Days
          </div>
          <div style={{ fontSize: "12px", color: "#4b6b8a", marginTop: "2px" }}>
            {[
              unresolvedDebtItems.length > 0 && `${new Set(unresolvedDebtItems.map((i) => i.dateKey)).size} ${new Set(unresolvedDebtItems.map((i) => i.dateKey)).size === 1 ? "day" : "days"}`,
              weeklyGoalDebtItems.length > 0 && `${weeklyGoalDebtItems.length} weekly goal${weeklyGoalDebtItems.length !== 1 ? "s" : ""}`,
            ].filter(Boolean).join(" · ")} · {totalDebtCost} XP outstanding
          </div>
        </div>

        {/* Pay All / Revive action button */}
        {isChallengeAllAccepted && isChallengeAllComplete ? (
          <button
            type="button"
            onClick={() => setShowReviveActivationModal(true)}
            style={{ padding: "8px 14px", borderRadius: "10px", border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, fontSize: "13px", cursor: "pointer", whiteSpace: "nowrap" }}
          >
            Activate Revive →
          </button>
        ) : isChallengeAllAccepted ? (
          <div style={{ fontSize: "12px", color: "#b45309", background: "#fef3c7", borderRadius: "8px", padding: "6px 10px", whiteSpace: "nowrap" }}>
            Finish today's habits
          </div>
        ) : totalDebtCost <= totalXP ? (
          <button
            type="button"
            onClick={handlePayAll}
            style={{ padding: "8px 14px", borderRadius: "10px", border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, fontSize: "13px", cursor: "pointer", whiteSpace: "nowrap" }}
          >
            Pay All — {totalDebtCost} XP
          </button>
        ) : (
          <button
            type="button"
            onClick={handlePayAll}
            style={{ padding: "8px 14px", borderRadius: "10px", border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, fontSize: "13px", cursor: "pointer", whiteSpace: "nowrap" }}
          >
            Accept Revive Challenge
          </button>
        )}

        {/* Small expand/collapse chevron */}
        <button
          type="button"
          onClick={() => setShowDebtDetails((prev) => !prev)}
          style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", color: "#4b6b8a", flexShrink: 0 }}
          aria-label={showDebtDetails ? "Collapse" : "Expand details"}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d={showDebtDetails ? "M2 9L7 4L12 9" : "M2 5L7 10L12 5"}
              stroke="#4b6b8a"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    )}

    {/* Challenge in-progress banner */}
    {isChallengeAllAccepted && !isChallengeAllComplete && unresolvedDebtItems.length > 0 && (
      <div style={{ fontSize: "12px", color: "#b45309", background: "#fef3c7", borderRadius: "8px", padding: "8px 10px", marginTop: "10px" }}>
        🔥 Complete all 3 habits today to unlock side quests and activate your revive
      </div>
    )}

    {/* Expanded detail list */}
    {showDebtDetails && displayedDebtItems.length > 0 && (
      <div style={{ marginTop: "14px", maxHeight: "45vh", overflowY: "auto" }}>
        {displayedDebtItems.map((item) => {
          if (item.type === "weeklyToken") {
            const catLabel = getCatLabel(item.category);
            const emojiMap = { nutrition: "🥕", movement: "👟", mindset: "🌙" };
            const canAfford = totalXP >= CATEGORY_TOKEN_COST;
            const expandKey = `${item.weekMonday}-${item.category}`;
            const isExpanded = expandedWeeklyDebt.has(expandKey);
            const DAY_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            const today = formatDateKey(realToday);
            return (
              <div key={`wt-${item.weekMonday}-${item.category}`} style={{ ...tokenStyle, marginTop: "10px", display: "block" }}>
                {/* Header row */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ fontSize: "13px", color: "#1e3a5f", fontWeight: 600 }}>
                    {emojiMap[item.category]} {catLabel} — {item.doneCount}/{item.goal} completed
                  </div>
                  <button
                    type="button"
                    onClick={() => setExpandedWeeklyDebt(prev => {
                      const next = new Set(prev);
                      next.has(expandKey) ? next.delete(expandKey) : next.add(expandKey);
                      return next;
                    })}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "#4b6b8a", padding: "2px 6px", fontSize: "12px" }}
                  >
                    {item.weekLabel} {isExpanded ? "▲" : "▼"}
                  </button>
                </div>
                {/* Expandable day breakdown */}
                {isExpanded && (
                  <div style={{ marginTop: "10px", display: "flex", gap: "6px", flexWrap: "wrap" }}>
                    {item.days.map(d => {
                      const dayObj = new Date(`${d}T12:00:00`);
                      const shortName = DAY_SHORT[dayObj.getDay()];
                      const isFuture = d > today;
                      const isVacation = vacationDays[d];
                      const done = item.dayCompletions[d];
                      const isActive = item.activeDays ? item.activeDays.includes(d) : true;
                      return (
                        <div key={d} style={{
                          display: "flex", flexDirection: "column", alignItems: "center", gap: "2px",
                          padding: "6px 8px", borderRadius: "8px", minWidth: "36px",
                          opacity: isActive ? 1 : 0.4,
                          background: !isActive ? "#f8f8f8" : isFuture ? "#f1f5f9" : isVacation ? "#fef3c7" : done ? "#f0fdf4" : "#fef2f2",
                          border: `1px solid ${!isActive ? "#e5e7eb" : isFuture ? "#e2e8f0" : isVacation ? "#fcd34d" : done ? "#86efac" : "#fca5a5"}`,
                        }}>
                          <span style={{ fontSize: "10px", color: "#6b7280", fontWeight: 600 }}>{shortName}</span>
                          <span style={{ fontSize: "13px" }}>
                            {!isActive ? "—" : isFuture ? "·" : isVacation ? "🏖" : done ? "✓" : "✗"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
                {/* Action */}
                <div style={{ marginTop: "10px" }}>
                  {canAfford ? (
                    <button
                      type="button"
                      onClick={() => handleWeeklyToken(item.weekMonday, item.category)}
                      style={{ padding: "8px 14px", borderRadius: "10px", border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}
                    >
                      Use {catLabel} token ({CATEGORY_TOKEN_COST} XP)
                    </button>
                  ) : (
                    <div style={{ fontSize: "12px", color: "#b45309" }}>Need {CATEGORY_TOKEN_COST} XP to use token</div>
                  )}
                </div>
              </div>
            );
          }

          const itemKey = getDebtItemKey(item);
          const challengeCost = challengeCosts[itemKey] || 0;
          const categoryLabel = item.type === "token" ? getCatLabel(item.category) : "";

          if (item.type === "revive") {
            const canAfford = totalXP >= FULL_REVIVE_COST;
            if (item.isApplied) {
              return (
                <button
                  key={`revive-${item.dateKey}`}
                  type="button"
                  onClick={() => handleFullRevive(item.dateKey)}
                  style={{ ...tokenStyle, marginTop: "10px", background: "#e0f2fe", border: "2px solid #2563eb" }}
                >
                  {challengeCost > 0
                    ? `🔥 Revive Challenge Active — ${item.label} (${challengeCost} XP left)`
                    : `🔥 Revive Used — ${item.label}`}
                </button>
              );
            }
            if (canAfford) {
              return (
                <button
                  key={`revive-${item.dateKey}`}
                  type="button"
                  onClick={() => handleFullRevive(item.dateKey)}
                  style={{ ...tokenStyle, marginTop: "10px" }}
                >
                  {`🔥 Revive — ${item.label} (${item.cost} XP)`}
                </button>
              );
            }
            return (
              <div
                key={`revive-${item.dateKey}`}
                style={{ ...tokenStyle, marginTop: "10px", background: "#f8fbff", border: "2px solid #bfdbfe", cursor: "default", opacity: 0.75 }}
              >
                🔥 Revive — {item.label} ({item.cost} XP)
              </div>
            );
          }

          const canAfford = totalXP >= CATEGORY_TOKEN_COST;
          if (item.isApplied) {
            return (
              <button
                key={`${item.category}-${item.dateKey}`}
                type="button"
                onClick={() => handleCategoryToken(item.dateKey, item.category)}
                style={{ ...tokenStyle, marginTop: "10px", background: "#e0f2fe", border: "2px solid #2563eb" }}
              >
                {challengeCost > 0
                  ? `${item.emoji} ${categoryLabel} Token Challenge Active — ${item.label} (${challengeCost} XP left)`
                  : `${item.emoji} ${categoryLabel} Token Used — ${item.label}`}
              </button>
            );
          }
          if (canAfford) {
            return (
              <button
                key={`${item.category}-${item.dateKey}`}
                type="button"
                onClick={() => handleCategoryToken(item.dateKey, item.category)}
                style={{ ...tokenStyle, marginTop: "10px" }}
              >
                {`${item.emoji} ${categoryLabel} Token — ${item.label} (${item.cost} XP)`}
              </button>
            );
          }
          return (
            <div
              key={`${item.category}-${item.dateKey}`}
              style={{ ...tokenStyle, marginTop: "10px", background: "#f8fbff", border: "2px solid #bfdbfe", cursor: "default", opacity: 0.75 }}
            >
              {`${item.emoji} ${categoryLabel} Token — ${item.label} (${item.cost} XP)`}
            </div>
          );
        })}

        {/* Revive challenge card — shown when unaffordable items exist and challenge not yet accepted */}
        {unaffordableUnresolvedItems.length > 0 && !isChallengeAllAccepted && (
          <div style={{ ...tokenStyle, marginTop: "16px", background: "#f0f9ff", border: "2px solid #38bdf8", cursor: "default" }}>
            <div style={{ fontWeight: "bold", color: "#1e3a5f", marginBottom: "6px", fontSize: "15px" }}>
              🔥 Revive Challenge ({unresolvedDebtItems.length} item{unresolvedDebtItems.length !== 1 ? "s" : ""})
            </div>
            <div style={{ fontSize: "13px", color: "#4b6b8a", lineHeight: 1.4, marginBottom: "10px" }}>
              Complete your 3 core habits today to earn a revive. Once done, activate it to reset your XP to zero and save your streak.
            </div>
            <button
              type="button"
              onClick={handleDebtChallengeAll}
              style={{ ...getPrimaryButtonStyle(), marginTop: 0, padding: "12px 14px" }}
            >
              Accept Revive Challenge
            </button>
          </div>
        )}

        {/* Cancel challenge option when challenge accepted but not complete */}
        {isChallengeAllAccepted && !isChallengeAllComplete && (
          <button
            type="button"
            onClick={() => { challengeDeclinedRef.current = true; setActiveChallenges({}); setSaveStatus("Saving..."); }}
            style={{ width: "100%", marginTop: "10px", padding: "10px 14px", borderRadius: "10px", border: "1px solid #f87171", background: "transparent", color: "#ef4444", fontWeight: 600, cursor: "pointer", fontSize: "13px" }}
          >
            Cancel Challenge
          </button>
        )}

        {/* Activate revive when challenge complete */}
        {isChallengeAllAccepted && isChallengeAllComplete && (
          <button
            type="button"
            onClick={() => setShowReviveActivationModal(true)}
            style={{ ...getPrimaryButtonStyle(), marginTop: "16px", padding: "12px 14px" }}
          >
            Activate Revive →
          </button>
        )}
      </div>
    )}

  </div>
)}

      <div
        style={{
          maxWidth: "700px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            background: "#f5faff",
            borderRadius: "26px",
            padding: "16px",
            border: "2px solid #dbeafe",
            boxShadow: "0 10px 28px rgba(30, 58, 138, 0.12)",
            opacity: isLocked ? 0.7 : 1,
          }}
        >
          {/* Mobile top bar: profile pic | greeting | messages + notifications */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", position: "relative" }}>
            {/* Left: profile pic → navigates to settings */}
            <button
              type="button"
              onClick={() => { setActiveScreen("customize"); setShowNotifInbox(false); setShowFABMenu(false); }}
              style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer", flexShrink: 0 }}
            >
              {selectedAvatar ? (
                <img src={selectedAvatar} alt="Profile" title="Settings" style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover", border: "2px solid #bfdbfe", display: "block" }} />
              ) : (
                <div style={{ width: "48px", height: "48px", borderRadius: "50%", background: "#e0f2fe", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", border: "2px solid #bfdbfe" }}>👤</div>
              )}
            </button>

            {/* Center: absolutely centered */}
            <div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", textAlign: "center", pointerEvents: "none", whiteSpace: "nowrap" }}>
              <div style={{ fontSize: "11px", color: "#2563eb", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                {userprogramTag === "momentum" ? "Momentum" : "Quit the Quit"}
              </div>
              <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1e3a5f", lineHeight: 1.2 }}>
                Hi, {profileFirstName || profileName.split(" ")[0]}!
              </div>
            </div>

            {/* Right: messages + notifications */}
            <div style={{ display: "flex", gap: "8px", alignItems: "center", flexShrink: 0 }}>
              <button
                type="button"
                onClick={() => { setActiveScreen("messages"); setShowNotifInbox(false); setShowFABMenu(false); }}
                style={{ position: "relative", width: "40px", height: "40px", borderRadius: "50%", border: activeScreen === "messages" ? "2px solid #2563eb" : "1px solid #dbeafe", background: activeScreen === "messages" ? "#e0f2fe" : "#f8fbff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: activeScreen === "messages" ? "#2563eb" : "#94a3b8" }}
                aria-label="Messages"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
                {dmUnread > 0 && (
                  <span style={{ position: "absolute", top: "2px", right: "2px", background: "#2563eb", color: "#fff", borderRadius: "999px", minWidth: "14px", height: "14px", fontSize: "9px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 3px" }}>
                    {dmUnread}
                  </span>
                )}
              </button>
              <button
                type="button"
                onClick={async () => { setShowNotifInbox((p) => !p); if (!showNotifInbox && user?.uid) { await markAllUserNotificationsRead(user.uid); } }}
                style={{ position: "relative", width: "40px", height: "40px", borderRadius: "50%", border: showNotifInbox ? "2px solid #2563eb" : "1px solid #dbeafe", background: showNotifInbox ? "#e0f2fe" : "#f8fbff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: showNotifInbox ? "#2563eb" : "#94a3b8" }}
                aria-label="Notifications"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
                {userNotifications.filter((n) => !n.read).length > 0 && (
                  <span style={{ position: "absolute", top: "2px", right: "2px", background: "#ef4444", color: "#fff", borderRadius: "999px", minWidth: "14px", height: "14px", fontSize: "9px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 3px" }}>
                    {userNotifications.filter((n) => !n.read).length > 99 ? "99+" : userNotifications.filter((n) => !n.read).length}
                  </span>
                )}
              </button>
            </div>
          </div>

          {renderHeaderLevelCard()}

          <div style={{ fontSize: "10px", color: saveStatus === "Error saving" ? "#b91c1c" : "#9ca3af", fontWeight: "normal", textAlign: "right", marginBottom: "-4px" }}>
            {saveStatus}
          </div>
        </div>

        {/* User notification inbox panel */}
        {showNotifInbox && (
          <div style={{
            background: "#f5faff",
            borderRadius: "20px",
            padding: "18px",
            marginTop: "14px",
            border: "2px solid #dbeafe",
            boxShadow: "0 8px 20px rgba(30,58,138,0.10)",
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px", position: "relative" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>🔔 Notifications</div>
              <button
                type="button"
                onClick={() => setShowNotifInbox(false)}
                style={{ background: "none", border: "none", color: "#6b8cb0", cursor: "pointer", fontSize: "18px", padding: 0 }}
              >✕</button>
            </div>
            {userNotifications.length === 0 ? (
              <div style={{ color: "#6b8cb0", fontSize: "14px", textAlign: "center", padding: "16px 0" }}>
                No notifications yet. You'll see reactions, comments, and mentions here.
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {userNotifications.slice(0, 30).map((notif) => (
                  <div key={notif.id} style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                    padding: "10px 12px",
                    borderRadius: "14px",
                    background: notif.read ? "#f8fbff" : "#eff6ff",
                    border: notif.read ? "1px solid #dbeafe" : "1.5px solid #93c5fd",
                  }}>
                    {notif.fromAvatar ? (
                      <img src={notif.fromAvatar} alt={notif.fromName} style={{ width: "34px", height: "34px", borderRadius: "999px", objectFit: "cover", border: "2px solid #bfdbfe", flexShrink: 0 }} />
                    ) : (
                      <div style={{ width: "34px", height: "34px", borderRadius: "999px", background: "#bfdbfe", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px" }}>
                        {notifEmoji(notif.type)}
                      </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ color: "#1e3a5f", fontSize: "13px", lineHeight: 1.4 }}>
                        {notifEmoji(notif.type)} {notif.message}
                      </div>
                      <div style={{ color: "#9ca3af", fontSize: "11px", marginTop: "3px" }}>
                        {notifTimeAgo(notif.createdAt)}
                      </div>
                      {notif.postId && notif.screen !== "challenges" && (
                        <button
                          type="button"
                          onClick={() => {
                            setHighlightPostId(notif.postId);
                            setActiveScreen("feed");
                            setShowNotifInbox(false);
                          }}
                          style={{ marginTop: "6px", padding: "4px 10px", borderRadius: "8px", border: "1.5px solid #93c5fd", background: "#eff6ff", color: "#2563eb", fontSize: "11px", fontWeight: "bold", cursor: "pointer" }}
                        >
                          View Post →
                        </button>
                      )}
                      {notif.screen === "challenges" && (
                        <button
                          type="button"
                          onClick={() => {
                            setActiveScreen("challenges");
                            setShowNotifInbox(false);
                          }}
                          style={{ marginTop: "6px", padding: "4px 10px", borderRadius: "8px", border: "1.5px solid #93c5fd", background: "#eff6ff", color: "#2563eb", fontSize: "11px", fontWeight: "bold", cursor: "pointer" }}
                        >
                          View Challenge →
                        </button>
                      )}
                      {notif.screen === "admin_broadcasts" && (
                        <button
                          type="button"
                          onClick={() => {
                            setActiveScreen("admin");
                            setAdminTab("broadcasts");
                            setShowNotifInbox(false);
                          }}
                          style={{ marginTop: "6px", padding: "4px 10px", borderRadius: "8px", border: "1.5px solid #93c5fd", background: "#eff6ff", color: "#2563eb", fontSize: "11px", fontWeight: "bold", cursor: "pointer" }}
                        >
                          View Response →
                        </button>
                      )}
                      {notif.screen === "admin_quests" && (
                        <button
                          type="button"
                          onClick={() => {
                            setActiveScreen("admin");
                            setAdminTab("weeklyQuests");
                            setShowNotifInbox(false);
                          }}
                          style={{ marginTop: "6px", padding: "4px 10px", borderRadius: "8px", border: "1.5px solid #93c5fd", background: "#eff6ff", color: "#2563eb", fontSize: "11px", fontWeight: "bold", cursor: "pointer" }}
                        >
                          View Submission →
                        </button>
                      )}
                    </div>
                    {!notif.read && (
                      <div style={{ width: "8px", height: "8px", borderRadius: "999px", background: "#3b82f6", flexShrink: 0, marginTop: "4px" }} />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeScreen === "dashboard" && (
          <>
            {/* Pinned coach notes */}
            {pinnedNotes.filter((n) => {
              const now = new Date();
              const start = new Date(`${n.startDate}T${n.startTime || "00:00"}`);
              const end = new Date(`${n.endDate}T${n.endTime || "23:59"}`);
              if (start > now || end < now) return false;
              const type = n.targetType || "all";
              if (type === "user") return n.targetUserId === user?.uid;
              if (type === "program") return n.targetProgram === userprogramTag;
              return true; // "all"
            }).map((note) => (
              <div key={note.id} style={{ background: "#f0f9ff", borderRadius: "18px", padding: "16px 18px", marginTop: "16px", border: "2px solid #38bdf8", boxShadow: "0 4px 14px rgba(56,189,248,0.15)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "18px" }}>📌</span>
                  <span style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>{note.title}</span>
                </div>
                <div style={{ color: "#4b6b8a", fontSize: "14px", lineHeight: 1.55, marginBottom: note.linkUrl ? "12px" : "0" }}>
                  {note.body}
                </div>
                {note.linkUrl && (
                  <a href={note.linkUrl} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", marginTop: "8px", padding: "10px 18px", borderRadius: "12px", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", textDecoration: "none" }}>
                    {note.linkLabel || "Open Link"} →
                  </a>
                )}
              </div>
            ))}

            {/* Recurring call banner — show on dashboard if RSVP needed or call is today/live */}
            {(() => {
              if (!recurringCallConfig?.active || nextCallOccurrences.length === 0) return null;
              // Audience filter: only show if user is targeted
              const rcTarget = recurringCallConfig.targetType || "program";
              if (rcTarget === "users") {
                if (!(recurringCallConfig.targetUserIds || []).includes(user?.uid)) return null;
              } else {
                if (recurringCallConfig.programTag && recurringCallConfig.programTag !== userprogramTag) return null;
              }
              const nextDate = nextCallOccurrences[0];
              const dateKey = dateKeyFromDate(nextDate);
              const poll = nextCallPolls[dateKey];
              if (poll?.status === "cancelled") return null;
              const scheduledTime = poll?.scheduledTime || nextDate;
              const occStatus = getOccurrenceStatus(scheduledTime);
              const myRSVP = poll?.rsvps?.[user?.uid];
              const isToday = dateKey === new Date().toISOString().slice(0, 10);
              // Show on dashboard only if: live, or today, or RSVP not yet submitted
              if (occStatus !== "live" && !isToday && myRSVP) return null;
              return (
                <RecurringCallCard
                  key={dateKey}
                  compact
                  occurrence={{ dateKey, title: recurringCallConfig.title || "Weekly Group Call", scheduledTime }}
                  pollData={poll}
                  currentUser={{ uid: user?.uid, name: profileName }}
                />
              );
            })()}

            {/* Today's scheduled workouts */}
            {hasFeature("workouts") && user?.uid && dashboardScheduledWorkouts.length > 0 && (() => {
              const today = localDateKey();
              const todaysWorkouts = dashboardScheduledWorkouts.filter((w) => w.dateKey === today);
              if (todaysWorkouts.length === 0) return null;

              async function doDashboardDelete(item, deleteAll) {
                const uid = user.uid;
                const ruleId = item.ruleId || item.id;
                if (item.isRuleOccurrence && deleteAll) {
                  await deleteDoc(doc(db, "users", uid, "workoutSchedule", ruleId));
                } else if (item.isRuleOccurrence && !deleteAll) {
                  const yesterday = new Date(item.dateKey + "T12:00:00");
                  yesterday.setDate(yesterday.getDate() - 1);
                  await updateDoc(doc(db, "users", uid, "workoutSchedule", ruleId), {
                    endDate: localDateKey(yesterday),
                  });
                  const dayAfter = new Date(item.dateKey + "T12:00:00");
                  dayAfter.setDate(dayAfter.getDate() + 1);
                  await addDoc(collection(db, "users", uid, "workoutSchedule"), {
                    workoutName: item.workoutName,
                    workoutType: item.workoutType,
                    workoutId: item.workoutId || null,
                    recurring: true,
                    days: item.days,
                    startDate: localDateKey(dayAfter),
                    endDate: item.endDate || null,
                    createdAt: serverTimestamp(),
                  });
                } else {
                  await deleteDoc(doc(db, "users", uid, "workoutSchedule", item.id));
                }
                setDashboardDeleteConfirm(null);
                loadDashboardSchedule(uid);
              }

              async function doDashboardMove(item, newDate, moveAll) {
                const uid = user.uid;
                const ruleId = item.ruleId || item.id;
                if (item.isRuleOccurrence && moveAll) {
                  const newDow = new Date(newDate + "T12:00:00").getDay();
                  const oldDow = new Date(item.dateKey + "T12:00:00").getDay();
                  const newDays = (item.days || []).map((d) => d === oldDow ? newDow : d);
                  await updateDoc(doc(db, "users", uid, "workoutSchedule", ruleId), {
                    days: [...new Set(newDays)],
                    startDate: newDate,
                  });
                } else if (item.isRuleOccurrence) {
                  const yesterday = new Date(item.dateKey + "T12:00:00");
                  yesterday.setDate(yesterday.getDate() - 1);
                  await updateDoc(doc(db, "users", uid, "workoutSchedule", ruleId), {
                    endDate: yesterday.toISOString().slice(0, 10),
                  });
                  await addDoc(collection(db, "users", uid, "workoutSchedule"), {
                    workoutName: item.workoutName,
                    workoutType: item.workoutType,
                    workoutId: item.workoutId || null,
                    recurring: false,
                    dateKey: newDate,
                    createdAt: serverTimestamp(),
                  });
                } else {
                  await updateDoc(doc(db, "users", uid, "workoutSchedule", item.id), { dateKey: newDate });
                }
                setDashboardMoveItem(null);
                setDashboardMoveDate("");
                loadDashboardSchedule(uid);
              }

              return (
                <div style={{ marginTop: "16px" }}>
                  {todaysWorkouts.map((item) => {
                    const itemKey = item.id || item.workoutName;
                    const isDeleting = dashboardDeleteConfirm?.id === item.id || (dashboardDeleteConfirm?.workoutName === item.workoutName && dashboardDeleteConfirm?.dateKey === item.dateKey);
                    const isMoving = dashboardMoveItem?.id === item.id || (dashboardMoveItem?.workoutName === item.workoutName && dashboardMoveItem?.dateKey === item.dateKey);
                    return (
                      <div key={itemKey} style={{ background: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)", borderRadius: "18px", padding: "16px 18px", marginBottom: "10px", color: "#fff" }}>
                        {/* Header row with label and small icon buttons */}
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                          <div style={{ fontSize: "11px", fontWeight: "bold", letterSpacing: "0.06em", textTransform: "uppercase", opacity: 0.85, flex: 1 }}>
                            📅 Today's Workout{item.recurring ? " · 🔁" : ""}
                          </div>
                          {!isDeleting && !isMoving && (
                            <div style={{ display: "flex", gap: "4px" }}>
                              <button
                                onClick={() => { setDashboardMoveItem(item); setDashboardMoveDate(""); }}
                                title="Move"
                                style={{ width: "26px", height: "26px", borderRadius: "8px", border: "1.5px solid rgba(255,255,255,0.5)", background: "rgba(255,255,255,0.15)", color: "#fff", fontSize: "13px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
                                📅
                              </button>
                              <button
                                onClick={() => setDashboardDeleteConfirm(item)}
                                title="Remove"
                                style={{ width: "26px", height: "26px", borderRadius: "8px", border: "1.5px solid rgba(255,255,255,0.5)", background: "rgba(255,255,255,0.15)", color: "#fff", fontSize: "13px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
                                🗑️
                              </button>
                            </div>
                          )}
                        </div>

                        <div style={{ fontSize: "17px", fontWeight: "bold", marginBottom: "14px" }}>{item.workoutName}</div>

                        {/* Delete confirm */}
                        {isDeleting && (
                          <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "12px", padding: "12px", marginBottom: "10px" }}>
                            <div style={{ fontSize: "13px", marginBottom: "10px", fontWeight: "bold" }}>
                              {item.isRuleOccurrence ? "Remove just today or all future?" : "Remove this workout?"}
                            </div>
                            {item.isRuleOccurrence ? (
                              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                <button onClick={() => doDashboardDelete(item, false)} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "none", background: "#fff", color: "#dc2626", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Just today</button>
                                <button onClick={() => doDashboardDelete(item, true)} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "none", background: "#fff", color: "#dc2626", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>All future</button>
                                <button onClick={() => setDashboardDeleteConfirm(null)} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "1.5px solid rgba(255,255,255,0.5)", background: "transparent", color: "#fff", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Cancel</button>
                              </div>
                            ) : (
                              <div style={{ display: "flex", gap: "6px" }}>
                                <button onClick={() => doDashboardDelete(item, false)} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "none", background: "#fff", color: "#dc2626", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Yes, remove</button>
                                <button onClick={() => setDashboardDeleteConfirm(null)} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "1.5px solid rgba(255,255,255,0.5)", background: "transparent", color: "#fff", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Cancel</button>
                              </div>
                            )}
                            <div style={{ fontSize: "10px", opacity: 0.7, marginTop: "8px" }}>Workout history and strength data won't be affected.</div>
                          </div>
                        )}

                        {/* Move form */}
                        {isMoving && (
                          <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "12px", padding: "12px", marginBottom: "10px" }}>
                            <div style={{ fontSize: "13px", marginBottom: "8px", fontWeight: "bold" }}>Move to a different day</div>
                            <input
                              type="date"
                              value={dashboardMoveDate}
                              onChange={(e) => setDashboardMoveDate(e.target.value)}
                              min={today}
                              style={{ width: "100%", padding: "8px 10px", borderRadius: "8px", border: "none", fontSize: "13px", color: "#1e3a5f", marginBottom: "8px", boxSizing: "border-box" }}
                            />
                            {item.isRuleOccurrence ? (
                              <div style={{ display: "flex", gap: "6px", marginBottom: "6px" }}>
                                <button onClick={() => { if (dashboardMoveDate) doDashboardMove(item, dashboardMoveDate, false); }} disabled={!dashboardMoveDate} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "none", background: dashboardMoveDate ? "#fff" : "rgba(255,255,255,0.3)", color: dashboardMoveDate ? "#1e3a5f" : "#fff", fontWeight: "bold", fontSize: "12px", cursor: dashboardMoveDate ? "pointer" : "default" }}>Just today</button>
                                <button onClick={() => { if (dashboardMoveDate) doDashboardMove(item, dashboardMoveDate, true); }} disabled={!dashboardMoveDate} style={{ flex: 1, padding: "7px", borderRadius: "8px", border: "none", background: dashboardMoveDate ? "#fff" : "rgba(255,255,255,0.3)", color: dashboardMoveDate ? "#1e3a5f" : "#fff", fontWeight: "bold", fontSize: "12px", cursor: dashboardMoveDate ? "pointer" : "default" }}>All future</button>
                              </div>
                            ) : (
                              <button onClick={() => { if (dashboardMoveDate) doDashboardMove(item, dashboardMoveDate, false); }} disabled={!dashboardMoveDate} style={{ width: "100%", padding: "7px", borderRadius: "8px", border: "none", background: dashboardMoveDate ? "#fff" : "rgba(255,255,255,0.3)", color: dashboardMoveDate ? "#1e3a5f" : "#fff", fontWeight: "bold", fontSize: "13px", cursor: dashboardMoveDate ? "pointer" : "default", marginBottom: "6px" }}>Move</button>
                            )}
                            <button onClick={() => { setDashboardMoveItem(null); setDashboardMoveDate(""); }} style={{ width: "100%", padding: "7px", borderRadius: "8px", border: "1.5px solid rgba(255,255,255,0.5)", background: "transparent", color: "#fff", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Cancel</button>
                          </div>
                        )}

                        {/* Start button */}
                        {!isDeleting && !isMoving && (
                          <button
                            onClick={async () => {
                              let template = null;
                              if (item.workoutType === "saved" && item.workoutId) {
                                try {
                                  const snap = await getDoc(doc(db, "users", user.uid, "savedWorkouts", item.workoutId));
                                  if (snap.exists()) template = { id: snap.id, ...snap.data() };
                                } catch (_) {}
                              } else if (item.workoutType === "ondemand" && item.workoutId) {
                                try {
                                  const snap = await getDoc(doc(db, "onDemandWorkouts", item.workoutId));
                                  if (snap.exists()) template = { id: snap.id, ...snap.data() };
                                } catch (_) {}
                              }
                              setScheduleStartWorkout({ workoutType: item.workoutType, template });
                              setActiveScreen("workouts");
                            }}
                            style={{ width: "100%", padding: "12px", borderRadius: "12px", border: "none", background: "#fff", color: "#1e3a5f", fontWeight: "bold", fontSize: "15px", cursor: "pointer" }}>
                            Start Workout
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })()}

            {/* Pinned challenge leaderboards */}
            {hasFeature("challenges") && user?.uid && (
              <DashboardChallengeWidget userId={user.uid} />
            )}

            {/* Pending broadcasts */}
            {pendingBroadcasts.length > 0 && (
              <div style={{ display: "grid", gap: "12px", marginTop: "20px" }}>
                {pendingBroadcasts.map((b) => (
                  <BroadcastCard
                    key={b.id}
                    broadcast={b}
                    currentUser={{ uid: user.uid, name: profileName, avatar: selectedAvatar, programTag: userprogramTag }}
                    onDismiss={(id) => {
                      setPendingBroadcasts((prev) => prev.filter((x) => x.id !== id));
                      dismissBroadcastForUser(id, user.uid).catch(console.error);
                      getSubmittedResponsesWithFeedback(user.uid).then(setBroadcastFeedback).catch(console.error);
                    }}
                    onXpAwarded={(amount) => {
                      setXpAdjustmentTotal((prev) => prev + amount);
                    }}
                  />
                ))}
              </div>
            )}

            {/* Coach feedback on past broadcast responses */}
            {broadcastFeedback.length > 0 && (
              <div style={{ display: "grid", gap: "10px", marginTop: "20px" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>💬 From {coachInfo?.name || "Your Coach"}</div>
                {broadcastFeedback.map((r) => (
                  <BroadcastFeedbackCard
                    key={r.id}
                    response={r}
                    coachName={coachInfo?.name || "Coach"}
                    onDismiss={async () => { await dismissFeedbackForClient(r.id); setBroadcastFeedback((prev) => prev.filter((x) => x.id !== r.id)); }}
                    onClientReply={(text) => setBroadcastFeedback((prev) => prev.map((x) => x.id === r.id ? { ...x, clientReply: text } : x))}
                  />
                ))}
              </div>
            )}

            <div

              style={{
                background: "#f5faff",
                borderRadius: "22px",
                padding: "10px 16px",
                marginTop: "14px",
                marginBottom: "14px",
                border: "2px solid #dbeafe",
                boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
              }}
            >
              {weeklyPromptLoading ? (
  <div
    style={{
      background: "#f8fbff",
      borderRadius: "18px",
      padding: "16px",
      marginBottom: "20px",
      border: "2px solid #bfdbfe",
      color: "#4b6b8a",
    }}
  >
    Loading weekly quest...
  </div>
) : activeWeeklyPrompt ? (
  <WeeklyQuestCard
    prompt={activeWeeklyPrompt}
    currentUser={{
  uid: user.uid,
  name: profileName,
  avatar: selectedAvatar,
  programTag: userprogramTag,
}}
    onSubmitted={() => {
      setWeeklyPromptRefreshKey((prev) => prev + 1);
    }}
    onXpAwarded={(amount) => {
      setXpAdjustmentTotal((prev) => prev + amount);
    }}
  />
) : null}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                }}
              >
                <button
                  onClick={() => changeDay(-1)}
                  style={getArrowButtonStyle()}
                >
                  ←
                </button>

                <div style={{ flex: 1, textAlign: "center" }}>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "13px",
                      color: "#1e3a5f",
                    }}
                  >
                    {formatDisplayDate(currentDate)}
                  </div>
                  {currentDateKey !== formatDateKey(realToday) && (
                    <button
                      onClick={() => setCurrentDate(new Date())}
                      style={{
                        marginTop: "4px",
                        padding: "3px 10px",
                        borderRadius: "999px",
                        border: "1.5px solid #2563eb",
                        background: "#e0f2fe",
                        color: "#2563eb",
                        fontSize: "11px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      Go to Today
                    </button>
                  )}
                </div>

                <button
                  onClick={() => changeDay(1)}
                  style={getArrowButtonStyle()}
                >
                  →
                </button>
              </div>
            </div>

            {/* Scheduled Side Quests for today */}
            {(() => {
              const todayKey = formatDateKey(realToday);
              const scheduled = getScheduledQuestsForDate(todayKey);
              if (scheduled.length === 0) return null;
              return (
                <div style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", marginTop: "16px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30,58,138,0.10)" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "4px", color: "#1e3a5f", fontSize: "18px" }}>📅 Today's Scheduled Quests</h3>
                  <p style={{ marginTop: 0, marginBottom: "14px", color: "#6b8cb0", fontSize: "13px" }}>Tap to complete. Tap ↔ to move to another day.</p>
                  <div style={{ display: "grid", gap: "10px" }}>
                    {scheduled.map((quest) => {
                      const completedToday = isSideQuestCompletedToday(quest.title);
                      return (
                        <div key={quest.id} style={{ background: completedToday ? "#e0f2fe" : "#f8fbff", borderRadius: "18px", padding: "14px 16px", border: completedToday ? "2px solid #2563eb" : "2px solid #bfdbfe", display: "flex", alignItems: "center", gap: "12px" }}>
                          <button type="button" onClick={(e) => handleSideQuestClick(quest.title, e)} style={{ flex: 1, background: "transparent", border: "none", padding: 0, textAlign: "left", cursor: "pointer", display: "flex", alignItems: "center", gap: "10px" }}>
                            <span style={{ fontSize: "24px", flexShrink: 0 }}>{quest.emoji}</span>
                            <div>
                              <div style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "14px" }}>{quest.title}</div>
                              <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "999px", background: completedToday ? "#dbeafe" : "#f5faff", border: "2px solid #bfdbfe", color: "#1e3a5f", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}>
                                {completedToday ? "Done ✓" : `+${quest.xp} XP`}
                              </span>
                            </div>
                          </button>
                          <button type="button" onClick={() => setScheduleMoveQuest({ title: quest.title, fromDateKey: todayKey })} title="Move to another day" style={{ width: "34px", height: "34px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", cursor: "pointer", fontSize: "16px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>↔</button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* Body Metrics Due Today */}
            {(() => {
              const today = new Date();
              const todayStr = today.toISOString().slice(0, 10);
              const dayOfWeek = today.getDay();
              const weekNum = Math.floor(today.getTime() / (7 * 24 * 60 * 60 * 1000));
              const BODY_METRICS = [
                { key: "weight", label: "Weight", emoji: "⚖️" },
                { key: "measurements", label: "Measurements", emoji: "📏" },
                { key: "photos", label: "Progress Photos", emoji: "📸" },
              ];
              const dueMetrics = BODY_METRICS.filter(({ key }) => {
                const cfg = bodyMetricsConfig?.[key];
                if (!cfg?.enabled || !cfg?.scheduleDays?.length) return false;
                if (!cfg.scheduleDays.includes(dayOfWeek)) return false;
                if ((cfg.intervalWeeks || 1) > 1 && weekNum % (cfg.intervalWeeks || 1) !== 0) return false;
                return true;
              });
              if (dueMetrics.length === 0) return null;
              return (
                <div style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", marginTop: "16px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30,58,138,0.10)" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "4px", color: "#1e3a5f", fontSize: "18px" }}>📊 Body Metrics Due Today</h3>
                  <p style={{ marginTop: 0, marginBottom: "14px", color: "#6b8cb0", fontSize: "13px" }}>Log these today to earn XP.</p>
                  <div style={{ display: "grid", gap: "10px" }}>
                    {dueMetrics.map(({ key, label, emoji }) => {
                      const cfg = bodyMetricsConfig[key];
                      const alreadyEarned = !!bodyMetricsXpLog?.[`${key}_${todayStr}`];
                      return (
                        <div key={key} style={{ background: alreadyEarned ? "#e0f2fe" : "#f8fbff", borderRadius: "18px", padding: "14px 16px", border: alreadyEarned ? "2px solid #2563eb" : "2px solid #bfdbfe", display: "flex", alignItems: "center", gap: "12px" }}>
                          <span style={{ fontSize: "24px", flexShrink: 0 }}>{emoji}</span>
                          <div style={{ flex: 1 }}>
                            <div style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "14px" }}>{label}</div>
                            <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "999px", background: alreadyEarned ? "#dbeafe" : "#dcfce7", border: alreadyEarned ? "2px solid #bfdbfe" : "1px solid #bbf7d0", color: alreadyEarned ? "#1e3a5f" : "#166534", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}>
                              {alreadyEarned ? "Logged ✓" : `+${cfg.xp} XP`}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <button
                    type="button"
                    onClick={() => setActiveScreen("you")}
                    style={{ marginTop: "14px", width: "100%", padding: "12px", borderRadius: "14px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                  >
                    Go to Body Metrics →
                  </button>
                </div>
              );
            })()}

            {/* Move Day Modal */}
            {scheduleMoveQuest && (() => {
              const quest = activeSideQuests.find((q) => q.title === scheduleMoveQuest.title);
              if (!quest) return null;
              return (
                <SideQuestMoveDayModal
                  quest={quest}
                  fromDateKey={scheduleMoveQuest.fromDateKey}
                  onMove={(toDateKey) => handleMoveScheduledQuest(scheduleMoveQuest.title, scheduleMoveQuest.fromDateKey, toDateKey)}
                  onClose={() => setScheduleMoveQuest(null)}
                />
              );
            })()}

            {renderWeeklyChallengeCard()}
            {hasFeature("weeklyGoals") && weeklyGoalsEnabled && (
              <WeeklyHabitsWidget
                habits={weeklyHabits}
                completions={weeklyHabitCompletions}
                weekKey={currentWeekKey}
                currentDateKey={currentDateKey}
                onAdd={handleWeeklyHabitAdd}
                onRemove={handleWeeklyHabitRemove}
                onManualUndo={handleWeeklyHabitManualUndo}
                onRemoveSource={handleWeeklyHabitRemoveSource}
                onAddHabit={handleAddWeeklyHabit}
                onUpdateHabit={handleUpdateWeeklyHabit}
                onDeleteHabit={handleDeleteWeeklyHabit}
                disabled={shouldDisableCurrentView}
                activeSideQuests={activeSideQuests}
                isAdmin={false}
              />
            )}
            {isCategoryEnabledForProgram(userprogramTag, "nutrition") && renderCategory("nutrition", getCatLabel("nutrition"), categoryEmojis.nutrition)}
            {isCategoryEnabledForProgram(userprogramTag, "movement") && renderCategory("movement", getCatLabel("movement"), categoryEmojis.movement)}
            {isCategoryEnabledForProgram(userprogramTag, "mindset") && renderCategory("mindset", getCatLabel("mindset"), categoryEmojis.mindset)}
            {userprogramTag === "momentum" && extraCategories.map(({ key, label, emoji }) =>
              renderCategory(key, label, emoji, true)
            )}

            {/* Weekly goal pacing chips */}
            {["nutrition", "movement", "mindset"].some(cat => weeklyGoalFreqs[cat]) && (() => {
              const todayKey = formatDateKey(realToday);
              const monday = getWeekStart(todayKey);
              const weekDays = getWeekDays(monday);
              const pacingItems = ["nutrition", "movement", "mindset"].map(cat => {
                const goal = weeklyGoalFreqs[cat];
                if (!goal) return null;
                const done = weekDays.filter(d => d <= todayKey && !vacationDays[d] && Boolean(dailySelections[d]?.[cat])).length;
                const remaining = weekDays.filter(d => d >= todayKey && !vacationDays[d]).length;
                const needed = goal - done;
                const impossible = needed > 0 && remaining < needed;
                return { cat, done, goal, impossible };
              }).filter(Boolean);
              if (pacingItems.length === 0) return null;
              return (
                <div style={{ maxWidth: "700px", margin: "8px auto 0 auto", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {pacingItems.map(({ cat, done, goal, impossible }) => (
                    <div key={cat} style={{
                      display: "inline-flex", alignItems: "center", gap: "6px",
                      padding: "6px 12px", borderRadius: "20px", fontSize: "13px",
                      background: impossible ? "#fef3c7" : done >= goal ? "#f0fdf4" : "#f8fbff",
                      border: `1px solid ${impossible ? "#fcd34d" : done >= goal ? "#86efac" : "#bfdbfe"}`,
                      color: impossible ? "#92400e" : done >= goal ? "#15803d" : "#4b6b8a",
                    }}>
                      <span style={{ fontWeight: 600 }}>{getCatLabel(cat)}</span>
                      <span>{done}/{goal} this week</span>
                      {done >= goal && <span>✓</span>}
                      {impossible && <span>⚠</span>}
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Add extra category — momentum users with < 2 extras */}
            {userprogramTag === "momentum" && extraCategories.length < 2 && (
              addCategoryOpen ? (
                <div style={{ background: "#f8fbff", borderRadius: "20px", padding: "18px", border: "2px dashed #93c5fd", marginTop: "8px" }}>
                  <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px", marginBottom: "14px" }}>Add Habit Category</div>
                  <div style={{ display: "grid", gridTemplateColumns: "60px 1fr", gap: "10px", marginBottom: "12px" }}>
                    <div>
                      <div style={{ color: "#4b6b8a", fontSize: "11px", marginBottom: "4px" }}>Emoji</div>
                      <input type="text" value={newCatEmoji} onChange={(e) => setNewCatEmoji(e.target.value)} placeholder="💪"
                        style={{ width: "100%", padding: "10px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "20px", textAlign: "center", boxSizing: "border-box" }} />
                    </div>
                    <div>
                      <div style={{ color: "#4b6b8a", fontSize: "11px", marginBottom: "4px" }}>Category Name</div>
                      <input type="text" value={newCatLabel} onChange={(e) => setNewCatLabel(e.target.value)} placeholder="e.g. Sleep"
                        style={{ width: "100%", padding: "10px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "14px", boxSizing: "border-box" }} />
                    </div>
                  </div>
                  <div style={{ marginBottom: "12px", display: "grid", gap: "8px" }}>
                    {[
                      { level: "low", placeholder: "Light version (e.g. 10 min walk)", labelText: "Keep the Streak (light)" },
                      { level: "main", placeholder: "Main habit name", labelText: "Main Quest" },
                      { level: "high", placeholder: "Advanced version (e.g. Full workout)", labelText: "Extra Credit (advanced)" },
                    ].map(({ level, placeholder, labelText }) => (
                      <div key={level}>
                        <div style={{ color: "#4b6b8a", fontSize: "11px", marginBottom: "4px" }}>{labelText}</div>
                        <input type="text" value={newCatHabits[level]} onChange={(e) => setNewCatHabits((prev) => ({ ...prev, [level]: e.target.value }))}
                          placeholder={placeholder}
                          style={{ width: "100%", padding: "10px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "13px", boxSizing: "border-box" }} />
                      </div>
                    ))}
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      disabled={!newCatLabel.trim()}
                      onClick={async () => {
                        const key = `extra${extraCategories.length + 1}`;
                        const base = newCatLabel.trim();
                        const newCat = { key, label: base, emoji: newCatEmoji.trim() || "💪" };
                        const defaultExtraHabits = {
                          low: { label: "Keep the Streak", habitName: newCatHabits.low.trim() || `${base} (light)`, xp: 10 },
                          main: { label: "Main Quest", habitName: newCatHabits.main.trim() || base, xp: 20 },
                          high: { label: "Extra Credit", habitName: newCatHabits.high.trim() || `${base} (advanced)`, xp: 30 },
                        };
                        const updatedExtra = [...extraCategories, newCat];
                        const updatedHabits = { ...customHabits, [key]: defaultExtraHabits };
                        setExtraCategories(updatedExtra);
                        setCustomHabits(updatedHabits);
                        setAddCategoryOpen(false);
                        setNewCatHabits({ low: "", main: "", high: "" });
                        await updateDoc(doc(db, "users", auth.currentUser.uid), { extraCategories: updatedExtra, customHabits: updatedHabits });
                      }}
                      style={{ flex: 1, padding: "11px", borderRadius: "12px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", cursor: "pointer" }}>
                      Save
                    </button>
                    <button onClick={() => { setAddCategoryOpen(false); setNewCatLabel(""); setNewCatEmoji(""); setNewCatHabits({ low: "", main: "", high: "" }); }}
                      style={{ flex: 1, padding: "11px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer" }}>
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <button
                  onClick={() => { setAddCategoryOpen(true); setNewCatLabel(""); setNewCatEmoji(""); setNewCatHabits({ low: "", main: "", high: "" }); }}
                  style={{ width: "100%", marginTop: "8px", padding: "16px", borderRadius: "20px", border: "2px dashed #93c5fd", background: "transparent", color: "#2563eb", fontSize: "28px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  +
                </button>
              )
            )}

            {nutritionTrackingEnabled && (
              <div
                id="fab-nutrition-log"
                style={{
                  background: "#f5faff",
                  borderRadius: "22px",
                  padding: "20px",
                  marginTop: "16px",
                  border: "2px solid #dbeafe",
                  boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: "14px", color: "#1e3a5f", fontSize: "18px" }}>
                  🥗 Nutrition Log
                </h3>
                <NutritionLog
                  uid={user.uid}
                  date={currentDate.toISOString().slice(0, 10)}
                  triggerOpenAdd={nutritionOpenTrigger}
                />
              </div>
            )}

            {portionTrackingEnabled && (
              <div
                id="fab-portion-log"
                style={{
                  background: "#f5faff",
                  borderRadius: "22px",
                  padding: "20px",
                  marginTop: "16px",
                  border: "2px solid #dbeafe",
                  boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: "4px", color: "#1e3a5f", fontSize: "18px" }}>
                  🤚 Hand Portion Tracker
                </h3>
                <p style={{ marginTop: 0, marginBottom: "14px", color: "#6b8cb0", fontSize: "13px" }}>
                  Based on the Precision Nutrition hand-portion system. Tap Edit Targets to set your daily goals.
                </p>
                <HandPortionLog
                  uid={user.uid}
                  date={currentDate.toISOString().slice(0, 10)}
                />
              </div>
            )}

            {waterTrackingEnabled && (
              <div
                style={{
                  background: "#f5faff",
                  borderRadius: "22px",
                  padding: "20px",
                  marginTop: "16px",
                  border: "2px solid #dbeafe",
                  boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
                }}
              >
                <WaterTracker
                  uid={user.uid}
                  date={currentDate.toISOString().slice(0, 10)}
                />
              </div>
            )}

            {macroTrackingEnabled && (
              <div
                id="fab-macro-log"
                style={{
                  background: "#f5faff",
                  borderRadius: "22px",
                  padding: "20px",
                  marginTop: "16px",
                  border: "2px solid #dbeafe",
                  boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
                }}
              >
                <MacroTracker
                  uid={user.uid}
                  date={currentDate.toISOString().slice(0, 10)}
                  triggerOpenSearch={macroOpenTrigger}
                  healthSyncEnabled={healthSyncPrefs.workouts}
                  healthTodayWorkouts={healthTodayWorkouts}
                />
              </div>
            )}

            {/* Cardio panel */}
            {showCardioPanel && (
              <div
                id="fab-cardio-log"
                style={{
                  marginTop: "16px",
                }}
              >
                <CardioLog
                  uid={user.uid}
                  show={showCardioPanel}
                  onClose={() => setShowCardioPanel(false)}
                />
              </div>
            )}

            {/* Completed Side Quests for this day */}
            {(() => {
              const dayQuests = sideQuestCompletions[currentDateKey] || {};
              const completedTitles = Object.entries(dayQuests)
                .filter(([, done]) => done)
                .map(([title]) => title);
              if (completedTitles.length === 0) return null;
              const isPastDay = currentDateKey < formatDateKey(realToday);
              return (
                <div style={{ background: "#f0fdf4", borderRadius: "22px", padding: "20px", marginTop: "16px", border: "2px solid #86efac", boxShadow: "0 8px 20px rgba(30, 58, 138, 0.08)" }}>
                  <h3 style={{ margin: "0 0 4px", color: "#15803d", fontSize: "16px" }}>✅ Side Quests Completed This Day</h3>
                  <p style={{ margin: "0 0 12px", color: "#4b6b8a", fontSize: "12px" }}>
                    {isPastDay ? "Tap a quest to uncheck if it was logged by mistake." : "Side quests you completed today."}
                  </p>
                  <div style={{ display: "grid", gap: "8px" }}>
                    {completedTitles.map((title) => {
                      const quest = activeSideQuests.find((q) => q.title === title);
                      const isConfirming = pastQuestUncheckConfirm?.dateKey === currentDateKey && pastQuestUncheckConfirm?.title === title;
                      return (
                        <div key={title} style={{ background: "#fff", borderRadius: "14px", padding: "10px 14px", border: "1.5px solid #86efac", display: "flex", alignItems: "center", gap: "10px" }}>
                          <span style={{ fontSize: "20px", flexShrink: 0 }}>{quest?.emoji || "⭐"}</span>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: "bold", color: "#166534", fontSize: "13px" }}>{title}</div>
                            {quest?.xp && <div style={{ fontSize: "11px", color: "#4b6b8a" }}>+{quest.xp} XP</div>}
                          </div>
                          {isPastDay && (
                            isConfirming ? (
                              <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
                                <span style={{ fontSize: "11px", color: "#dc2626", fontWeight: "bold" }}>Remove?</span>
                                <button type="button" onClick={() => handlePastSideQuestUncheck(currentDateKey, title)} style={{ padding: "3px 8px", borderRadius: "6px", border: "none", background: "#ef4444", color: "#fff", fontWeight: "bold", fontSize: "11px", cursor: "pointer" }}>Yes</button>
                                <button type="button" onClick={() => setPastQuestUncheckConfirm(null)} style={{ padding: "3px 8px", borderRadius: "6px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "11px", cursor: "pointer" }}>No</button>
                              </div>
                            ) : (
                              <button type="button" onClick={() => setPastQuestUncheckConfirm({ dateKey: currentDateKey, title })} style={{ padding: "4px 10px", borderRadius: "8px", border: "1.5px solid #fca5a5", background: "#fef2f2", color: "#b91c1c", fontWeight: "bold", fontSize: "11px", cursor: "pointer", flexShrink: 0 }}>Uncheck</button>
                            )
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* Habit info toast and uncheck confirm overlays are inline in renderCategory */}

            {/* All caught up — resolved debt, dashboard only */}
            {unresolvedDebtItems.length === 0 && resolvedItemsForViewedDay.length > 0 && (
              <div style={{ maxWidth: "700px", margin: "20px auto 0", background: "#f0fdf4", borderRadius: "18px", padding: "14px 18px", border: "2px solid #86efac" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div style={{ flex: 1, fontWeight: "bold", color: "#166534", fontSize: "14px" }}>✨ All caught up!</div>
                  <button
                    type="button"
                    onClick={() => setShowDebtDetails((prev) => !prev)}
                    style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", color: "#4b6b8a", display: "flex", alignItems: "center", gap: "4px", fontSize: "11px" }}
                  >
                    <span>undo</span>
                    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                      <path d={showDebtDetails ? "M2 9L7 4L12 9" : "M2 5L7 10L12 5"} stroke="#4b6b8a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
                {showDebtDetails && (
                  <div style={{ marginTop: "10px", display: "grid", gap: "8px" }}>
                    {resolvedItemsForViewedDay.map((item) => {
                      if (item.type === "revive") {
                        return (
                          <button key={`undo-revive-${item.dateKey}`} type="button" onClick={() => handleFullRevive(item.dateKey)} style={{ ...tokenStyle, background: "#e0f2fe", border: "2px solid #2563eb" }}>
                            🔥 Revive Used — {item.label} (tap to undo)
                          </button>
                        );
                      }
                      const catLabel = getCatLabel(item.category);
                      return (
                        <button key={`undo-token-${item.category}-${item.dateKey}`} type="button" onClick={() => handleCategoryToken(item.dateKey, item.category)} style={{ ...tokenStyle, background: "#e0f2fe", border: "2px solid #2563eb" }}>
                          {item.emoji} {catLabel} Token Used — {item.label} (tap to undo)
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

          </>
        )}
        {activeScreen === "quests" && (
          <>
            {/* Challenges — Momentum users */}
            {hasFeature("challenges") && (
              <div
                style={{
                  background: "#f5faff",
                  borderRadius: "22px",
                  padding: "20px",
                  marginTop: "20px",
                  border: "2px solid #dbeafe",
                  boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: "14px", color: "#1e3a5f", fontSize: "18px" }}>Challenges</h3>
                <ChallengesScreen
                  currentUser={{ uid: user.uid, name: profileName, avatar: selectedAvatar }}
                />
              </div>
            )}

            {/* Side Quests */}
            {hasFeature("sideQuests") && <div
              id="fab-side-quests"
              style={{
                background: "#f5faff",
                borderRadius: "22px",
                padding: "20px",
                marginTop: "16px",
                border: "2px solid #dbeafe",
                boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                <h3 style={{ margin: 0, color: "#1e3a5f", fontSize: "18px" }}>Side Quests</h3>
                <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <button
                    type="button"
                    onClick={() => setShowScheduleManager(true)}
                    style={{
                      padding: "5px 10px", borderRadius: "8px", fontSize: "12px", fontWeight: "bold", cursor: "pointer",
                      border: "1px solid #bfdbfe",
                      background: "#f8fbff",
                      color: "#4b6b8a",
                      display: "flex", alignItems: "center", gap: "5px",
                    }}
                  >
                    📅 Schedules
                    {activeSideQuests.filter((q) => sideQuestSchedules?.[q.title]).length > 0 && (
                      <span style={{ background: "#2563eb", color: "#fff", borderRadius: "999px", fontSize: "10px", fontWeight: "bold", padding: "1px 6px", lineHeight: "16px" }}>
                        {activeSideQuests.filter((q) => sideQuestSchedules?.[q.title]).length}
                      </span>
                    )}
                  </button>
                  <button type="button" onClick={() => setInfoPopup("sideQuests")} style={{ background: "transparent", border: "1px solid #bfdbfe", borderRadius: "8px", padding: "5px 7px", cursor: "pointer", color: "#6b7280", display: "flex", alignItems: "center" }}><svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg></button>
                </div>
              </div>

              {/* Schedule manager modal */}
              {showScheduleManager && (() => {
                const scheduledList = activeSideQuests.filter((q) => sideQuestSchedules?.[q.title]);
                const unscheduledList = activeSideQuests.filter((q) => !sideQuestSchedules?.[q.title]);
                return (
                  <div
                    style={{ position: "fixed", inset: 0, background: "rgba(30,58,138,0.35)", zIndex: 1000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}
                    onClick={() => setShowScheduleManager(false)}
                  >
                    <div
                      style={{ background: "#f5faff", borderRadius: "24px 24px 0 0", padding: "24px", width: "100%", maxWidth: "480px", boxSizing: "border-box", boxShadow: "0 -8px 32px rgba(30,58,138,0.18)", maxHeight: "82vh", overflowY: "auto" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
                        <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "18px" }}>📅 Quest Schedules</div>
                        <button type="button" onClick={() => setShowScheduleManager(false)} style={{ background: "none", border: "none", color: "#6b8cb0", fontSize: "24px", cursor: "pointer", lineHeight: 1, padding: "4px" }}>×</button>
                      </div>
                      <div style={{ color: "#6b8cb0", fontSize: "13px", marginBottom: "18px" }}>
                        Set recurring or one-time schedules so quests appear automatically on your dashboard.
                      </div>

                      {scheduledList.length > 0 && (
                        <>
                          <div style={{ fontSize: "11px", fontWeight: "bold", color: "#4b6b8a", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Scheduled</div>
                          <div style={{ display: "grid", gap: "8px", marginBottom: "20px" }}>
                            {scheduledList.map((quest) => {
                              const sched = sideQuestSchedules[quest.title];
                              const label = sched?.type === "once"
                                ? `Once · ${sched.oneTimeDate || ""}`
                                : (sched.days || []).map((d) => DAY_NAMES[d]).join(", ");
                              const icon = sched?.type === "once" ? "📅" : "🔁";
                              return (
                                <div key={quest.title} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 14px", borderRadius: "14px", background: "#fff", border: "2px solid #bfdbfe" }}>
                                  <span style={{ fontSize: "22px", flexShrink: 0 }}>{quest.emoji}</span>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{quest.title}</div>
                                    <div style={{ fontSize: "12px", color: "#2563eb", marginTop: "2px", fontWeight: "bold" }}>{icon} {label || "No days set"}</div>
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => { setShowScheduleManager(false); setScheduleEditQuest(quest.title); }}
                                    style={{ padding: "6px 10px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#2563eb", fontSize: "12px", fontWeight: "bold", cursor: "pointer", flexShrink: 0 }}
                                  >Edit</button>
                                  <button
                                    type="button"
                                    onClick={() => handleSaveSchedule(quest.title, null)}
                                    style={{ padding: "6px 10px", borderRadius: "8px", border: "1.5px solid #fecaca", background: "#fff1f2", color: "#dc2626", fontSize: "12px", fontWeight: "bold", cursor: "pointer", flexShrink: 0 }}
                                  >Remove</button>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}

                      {unscheduledList.length > 0 && (
                        <>
                          <div style={{ fontSize: "11px", fontWeight: "bold", color: "#4b6b8a", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Not scheduled</div>
                          <div style={{ display: "grid", gap: "8px" }}>
                            {unscheduledList.map((quest) => (
                              <div key={quest.title} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 14px", borderRadius: "14px", background: "#f8fbff", border: "1.5px solid #e2e8f0" }}>
                                <span style={{ fontSize: "22px", flexShrink: 0, opacity: 0.55 }}>{quest.emoji}</span>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{quest.title}</div>
                                  <div style={{ fontSize: "12px", color: "#9ca3af", marginTop: "2px" }}>No schedule set</div>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => { setShowScheduleManager(false); setScheduleEditQuest(quest.title); }}
                                  style={{ padding: "6px 10px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
                                >+ Schedule</button>
                              </div>
                            ))}
                          </div>
                        </>
                      )}

                      {activeSideQuests.length === 0 && (
                        <div style={{ color: "#4b6b8a", fontSize: "13px", textAlign: "center", padding: "24px 0" }}>No side quests available yet.</div>
                      )}
                    </div>
                  </div>
                );
              })()}

              {/* Date picker — log for today or a past day */}
              {!isChallengeInProgress && (
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ fontSize: "11px", fontWeight: "bold", color: "#4b6b8a", textTransform: "uppercase", marginBottom: "6px" }}>Logging for</div>
                  <div ref={sideQuestDateScrollRef} style={{ display: "flex", gap: "6px", overflowX: "auto", paddingBottom: "4px" }}>
                    {Array.from({ length: 7 }, (_, i) => {
                      const d = new Date(realToday);
                      d.setDate(d.getDate() - (6 - i));
                      const dk = formatDateKey(d);
                      const isToday = dk === formatDateKey(realToday);
                      const isSelected = dk === sideQuestLogDate;
                      return (
                        <button key={dk} type="button" onClick={() => setSideQuestLogDate(dk)} style={{
                          padding: "5px 10px", borderRadius: "10px",
                          border: isSelected ? "2px solid #2563eb" : "1px solid #bfdbfe",
                          background: isSelected ? "#2563eb" : "#f8fbff",
                          color: isSelected ? "#fff" : "#4b6b8a",
                          fontSize: "11px", fontWeight: isSelected ? "bold" : "normal",
                          cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0,
                        }}>
                          {isToday ? "Today" : d.toLocaleDateString("en-US", { weekday: "short", month: "numeric", day: "numeric" })}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              <p style={{ marginTop: 0, marginBottom: "14px", color: "#6b8cb0", fontSize: "13px" }}>
                {isChallengeInProgress
                  ? "Complete all 3 habits today to unlock side quests."
                  : sideQuestLogDate === formatDateKey(realToday)
                    ? "Tap a quest to mark it done today. Tap 📅 to schedule it."
                    : `Logging for ${new Date(`${sideQuestLogDate}T12:00:00`).toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })} — tap to mark completed.`}
              </p>
              <div style={{ display: "grid", gap: "10px" }}>
                {activeSideQuests.map((quest) => {
                  const completedOnDate = isSideQuestCompleted(sideQuestLogDate, quest.title);
                  const sched = sideQuestSchedules[quest.title];
                  const schedLabel = sched
                    ? sched.type === "once"
                      ? `📅 Once · ${sched.oneTimeDate || ""}`
                      : `🔁 ${(sched.days || []).map((d) => DAY_NAMES[d]).join(", ")}`
                    : null;
                  return (
                    <div
                      key={quest.id}
                      style={{
                        background: completedOnDate ? "#e0f2fe" : "#f8fbff",
                        borderRadius: "18px",
                        padding: "14px 16px",
                        border: completedOnDate ? "2px solid #2563eb" : "2px solid #bfdbfe",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      {/* Complete button */}
                      <button
                        type="button"
                        onClick={(event) => handleSideQuestClick(quest.title, event, sideQuestLogDate)}
                        style={{
                          flex: 1,
                          background: "transparent",
                          border: "none",
                          padding: 0,
                          textAlign: "left",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span style={{ fontSize: "24px", flexShrink: 0 }}>{quest.emoji}</span>
                        <div>
                          <div style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "14px" }}>{quest.title}</div>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "4px", flexWrap: "wrap" }}>
                            <span style={{
                              display: "inline-block", padding: "2px 8px", borderRadius: "999px",
                              background: completedOnDate ? "#dbeafe" : "#f5faff",
                              border: "2px solid #bfdbfe", color: "#1e3a5f", fontSize: "11px", fontWeight: "bold",
                            }}>
                              {completedOnDate ? "Done ✓" : `+${quest.xp} XP`}
                            </span>
                            {schedLabel && (
                              <span style={{ fontSize: "11px", color: "#4b6b8a", fontWeight: "bold" }}>{schedLabel}</span>
                            )}
                          </div>
                        </div>
                      </button>
                      {/* Schedule button */}
                      <button
                        type="button"
                        onClick={() => setScheduleEditQuest(quest.title)}
                        title="Schedule this quest"
                        style={{
                          width: "34px", height: "34px", borderRadius: "10px",
                          border: sched ? "2px solid #2563eb" : "2px solid #bfdbfe",
                          background: sched ? "#e0f2fe" : "#f5faff",
                          cursor: "pointer", fontSize: "16px", flexShrink: 0,
                          display: "flex", alignItems: "center", justifyContent: "center",
                        }}
                      >
                        📅
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>}

            {/* Schedule Edit Modal */}
            {scheduleEditQuest && (() => {
              const quest = activeSideQuests.find((q) => q.title === scheduleEditQuest);
              if (!quest) return null;
              return (
                <SideQuestScheduleModal
                  quest={quest}
                  existing={sideQuestSchedules[scheduleEditQuest] || null}
                  todayKey={formatDateKey(realToday)}
                  onSave={(data) => handleSaveSchedule(scheduleEditQuest, data)}
                  onClose={() => setScheduleEditQuest(null)}
                />
              );
            })()}

            {/* Bonus XP */}
            {activeBonusXPOpportunities.length > 0 && (
              <div
                style={{
                  background: "#f5faff",
                  borderRadius: "22px",
                  padding: "20px",
                  marginTop: "16px",
                  border: "2px solid #dbeafe",
                  boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: "14px", color: "#1e3a5f", fontSize: "18px" }}>
                  Bonus XP
                </h3>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "10px" }}>
                  {activeBonusXPOpportunities.map((bonus) => renderQuestCard(bonus, "bonus"))}
                </div>
              </div>
            )}

          </>
        )}
{activeScreen === "admin" && isAdmin && (
  <div
    style={{
      background: "#f5faff",
      borderRadius: "22px",
      padding: "24px",
      marginTop: "20px",
      border: "2px solid #dbeafe",
      boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
      boxSizing: "border-box",
      width: "100%",
      overflow: "hidden",
    }}
  >
    {selectedAdminUser ? (
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px", flexWrap: "wrap" }}>
        {selectedAdminUser.avatar ? (
          <img
            src={selectedAdminUser.avatar}
            alt={selectedAdminUser.name}
            style={{ width: "48px", height: "48px", borderRadius: "999px", objectFit: "cover", border: "2px solid #bfdbfe", flexShrink: 0 }}
          />
        ) : (
          <div style={{ width: "48px", height: "48px", borderRadius: "999px", background: "#e0f2fe", border: "2px solid #bfdbfe", flexShrink: 0 }} />
        )}
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "18px", lineHeight: 1.2, wordBreak: "break-word" }}>{selectedAdminUser.name || "No name"}</div>
          <div style={{ color: "#4b6b8a", fontSize: "13px", marginTop: "2px", wordBreak: "break-all" }}>{selectedAdminUser.email || selectedAdminUser.programTag || ""}</div>
        </div>
        <button
          type="button"
          onClick={() => setSelectedAdminUser(null)}
          style={{ padding: "6px 12px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "13px", cursor: "pointer", flexShrink: 0 }}
        >
          ← Back
        </button>
      </div>
    ) : (
      <>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
          <div>
            <h2 style={{ marginTop: 0, marginBottom: "4px", color: "#1e3a5f", fontSize: "28px" }}>Admin</h2>
            <p style={{ color: "#4b6b8a", margin: 0 }}>Manage your users.</p>
          </div>
        </div>
      </>
    )}

<div
  style={{
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "18px",
  }}
>
  {[
    { key: "users", label: "👥 Users" },
    { key: "weeklyPrompts", label: "Weekly Quest Prompts" },
    { key: "broadcasts", label: "📢 Broadcasts & Notes" },
    { key: "recurringCalls", label: "📅 Recurring Calls" },
    { key: "weeklyChallenges", label: "⭐ Weekly Challenges" },
    { key: "gameContent", label: "🎮 Game Content" },
    { key: "onboarding", label: "🌱 Onboarding" },
    { key: "workoutPrograms", label: "💪 Workout Programs" },
    { key: "avatarOptions", label: "🎨 Avatar Options" },
    { key: "activity", label: "🔔 Activity" },
  ].map((tab) => (
    <button
      key={tab.key}
      onClick={() => {
        setAdminTab(tab.key);
        setSelectedAdminUser(null);
      }}
      style={{
        padding: "10px 14px",
        borderRadius: "14px",
        border: adminTab === tab.key ? "2px solid #2563eb" : "2px solid #bfdbfe",
        background: adminTab === tab.key ? "#e0f2fe" : "#f8fbff",
        color: "#1e3a5f",
        fontWeight: "bold",
        cursor: "pointer",
      }}
    >
      {tab.label}
    </button>
  ))}
</div>
{adminTab === "users" && !selectedAdminUser && (() => {
  const today = new Date().toISOString().slice(0, 10);
  const weekAgo = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
  const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  const activeToday = allUsers.filter((u) => { const s = u.dailySelections?.[today] || {}; return s.nutrition || s.movement || s.mindset || s.weekly; });
  const activeThisWeek = allUsers.filter((u) => Object.keys(u.dailySelections || {}).some((dk) => dk >= weekAgo));
  const atRisk = allUsers.filter((u) => {
    const keys = Object.keys(u.dailySelections || {}).filter((dk) => { const s = u.dailySelections[dk] || {}; return s.nutrition || s.movement || s.mindset; });
    if (keys.length === 0) return false;
    return keys.sort().reverse()[0] < yesterday;
  });
  const hotStreaks = allUsers.filter((u) => calculateFullQuestCurrentStreak(u.dailySelections || {}) >= 7)
    .map((u) => ({ ...u, streak: calculateFullQuestCurrentStreak(u.dailySelections || {}), xpData: getAdminUserXP(u) }))
    .sort((a, b) => b.streak - a.streak);
  const totalHabitsThisWeek = allUsers.reduce((sum, u) => sum + Object.entries(u.dailySelections || {}).reduce((ds, [dk, sel]) => dk < weekAgo ? ds : ds + (sel.nutrition ? 1 : 0) + (sel.movement ? 1 : 0) + (sel.mindset ? 1 : 0), 0), 0);
  const searchTerm = adminUserSearch.toLowerCase().trim();
  const filteredUsers = searchTerm ? allUsers.filter((u) => (u.name || "").toLowerCase().includes(searchTerm) || (u.email || "").toLowerCase().includes(searchTerm)) : allUsers;
  const searchDropdownUsers = searchTerm ? allUsers.filter((u) => (u.name || "").toLowerCase().startsWith(searchTerm) || (u.name || "").toLowerCase().includes(searchTerm) || (u.email || "").toLowerCase().includes(searchTerm)).slice(0, 6) : [];
  const statPill = (value, label, bg, color) => (
    <div style={{ background: bg, borderRadius: "12px", padding: "6px 12px", border: "none", textAlign: "center", flex: 1, minWidth: "70px" }}>
      <div style={{ fontSize: "18px", fontWeight: "bold", color }}>{value}</div>
      <div style={{ color, fontSize: "10px", opacity: 0.8, marginTop: "1px" }}>{label}</div>
    </div>
  );
  return (
    <div style={{ display: "grid", gap: "16px" }}>
      {/* Search bar at top */}
      <div style={{ position: "relative" }}>
        <input
          type="text"
          placeholder="🔍 Search users…"
          value={adminUserSearch}
          onChange={(e) => setAdminUserSearch(e.target.value)}
          style={{ width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontSize: "14px" }}
        />
        {searchDropdownUsers.length > 0 && adminUserSearch.trim() && (
          <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", borderRadius: "12px", border: "2px solid #bfdbfe", boxShadow: "0 8px 20px rgba(30,58,138,0.12)", zIndex: 100, marginTop: "4px", overflow: "hidden" }}>
            {searchDropdownUsers.map((u) => (
              <button key={u.id} type="button" onClick={() => { openAdminUser(u); setAdminUserSearch(""); }} style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", padding: "10px 14px", background: "transparent", border: "none", borderBottom: "1px solid #f0f9ff", cursor: "pointer", textAlign: "left" }}>
                {u.avatar ? <img src={u.avatar} alt={u.name} style={{ width: "28px", height: "28px", borderRadius: "999px", objectFit: "cover" }} /> : <div style={{ width: "28px", height: "28px", borderRadius: "999px", background: "#e0f2fe" }} />}
                <div style={{ flex: 1 }}>
                  <div style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "13px" }}>{u.name || "No name"}</div>
                  <div style={{ color: "#6b8cb0", fontSize: "11px" }}>{u.email}</div>
                </div>
                <div style={{ fontSize: "10px", color: "#6b8cb0", background: "#dbeafe", borderRadius: "6px", padding: "1px 5px" }}>{u.programTag}</div>
              </button>
            ))}
          </div>
        )}
      </div>
      {/* Overview stats — compact pills */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {statPill(allUsers.length, "Total", "#e0f2fe", "#1e3a5f")}
        {statPill(activeToday.length, "Today", "#dcfce7", "#15803d")}
        {statPill(activeThisWeek.length, "This week", "#dbeafe", "#1d4ed8")}
        {statPill(totalHabitsThisWeek, "Habits/wk", "#ede9fe", "#6d28d9")}
      </div>
      {atRisk.length > 0 && (
        <div style={{ background: "#fff7ed", borderRadius: "18px", padding: "16px", border: "2px solid #fed7aa" }}>
          <div style={{ fontWeight: "bold", color: "#9a3412", fontSize: "14px", marginBottom: "10px" }}>⚠️ At-Risk ({atRisk.length}) — no habits in 2+ days</div>
          <div style={{ display: "grid", gap: "6px" }}>
            {atRisk.map((u) => {
              const keys = Object.keys(u.dailySelections || {}).filter((dk) => { const s = u.dailySelections[dk] || {}; return s.nutrition || s.movement || s.mindset; });
              return (
                <button key={u.id} type="button" onClick={() => openAdminUser(u)} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#fff", borderRadius: "10px", padding: "8px 10px", border: "1px solid #fed7aa", cursor: "pointer", textAlign: "left" }}>
                  {u.avatar ? <img src={u.avatar} alt={u.name} style={{ width: "28px", height: "28px", borderRadius: "999px", objectFit: "cover", flexShrink: 0 }} /> : <div style={{ width: "28px", height: "28px", borderRadius: "999px", background: "#fed7aa", flexShrink: 0 }} />}
                  <div style={{ flex: 1 }}><div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>{u.name || "No name"}</div><div style={{ color: "#9a3412", fontSize: "11px" }}>Last: {keys.sort().reverse()[0] || "never"}</div></div>
                </button>
              );
            })}
          </div>
        </div>
      )}
      {hotStreaks.length > 0 && (
        <div style={{ background: "#fefce8", borderRadius: "18px", padding: "16px", border: "2px solid #fde047" }}>
          <div style={{ fontWeight: "bold", color: "#713f12", fontSize: "14px", marginBottom: "10px" }}>🔥 Hot Streaks ({hotStreaks.length}) — 7+ days</div>
          <div style={{ display: "grid", gap: "6px" }}>
            {hotStreaks.map((u) => (
              <button key={u.id} type="button" onClick={() => openAdminUser(u)} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#fff", borderRadius: "10px", padding: "8px 10px", border: "1px solid #fde047", cursor: "pointer", textAlign: "left" }}>
                {u.avatar ? <img src={u.avatar} alt={u.name} style={{ width: "28px", height: "28px", borderRadius: "999px", objectFit: "cover", flexShrink: 0 }} /> : <div style={{ width: "28px", height: "28px", borderRadius: "999px", background: "#fde047", flexShrink: 0 }} />}
                <div style={{ flex: 1 }}><div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>{u.name || "No name"}</div><div style={{ color: "#92400e", fontSize: "11px" }}>🔥 {u.streak} days · Lv {u.xpData.level}</div></div>
              </button>
            ))}
          </div>
        </div>
      )}

    <div style={{ background: "#f8fbff", borderRadius: "18px", border: "2px solid #bfdbfe", overflow: "hidden" }}>
      <button type="button" onClick={() => setLeaderboardVisibilityOpen((p) => !p)} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", background: "transparent", border: "none", cursor: "pointer", textAlign: "left" }}>
        <span style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>👁 Leaderboard Visibility</span>
        <span style={{ color: "#4b6b8a", fontSize: "13px" }}>{leaderboardVisibilityOpen ? "▲ collapse" : "▼ edit"}</span>
      </button>
      {leaderboardVisibilityOpen && (
        <div style={{ padding: "0 18px 16px", display: "grid", gap: "10px" }}>
          {AVAILABLE_PROGRAMS.filter((p) => p.value).map((p) => {
            const visible = isLeaderboardVisibleForProgram(p.value);
            return (
              <div key={p.value} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "14px" }}>{p.label}</span>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ color: "#4b6b8a", fontSize: "13px" }}>{visible ? "Visible" : "Hidden"}</span>
                  <button type="button" onClick={() => handleToggleProgramLeaderboard(p.value)}
                    style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: visible ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative" }}>
                    <div style={{ position: "absolute", top: "3px", left: visible ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

    <div
      style={{
        background: "#f8fbff",
        borderRadius: "18px",
        padding: "18px",
        border: "2px solid #bfdbfe",
      }}
    >
      <h3
  style={{
    marginTop: 0,
    marginBottom: "12px",
    color: "#1e3a5f",
    fontSize: "20px",
  }}
>
  Leaderboard
</h3>

<div style={{ marginBottom: "12px" }}>
  <select
    value={adminLeaderboardProgramFilter}
    onChange={(e) => setAdminLeaderboardProgramFilter(e.target.value)}
    style={{
      width: "100%",
      padding: "12px 14px",
      borderRadius: "14px",
      border: "2px solid #bfdbfe",
      background: "#f5faff",
      color: "#1e3a5f",
      fontSize: "14px",
      boxSizing: "border-box",
    }}
  >
    <option value="all">All Programs</option>
    {AVAILABLE_PROGRAMS.filter((program) => program.value).map((program) => (
      <option key={program.value} value={program.value}>
        {program.label}
      </option>
    ))}
  </select>
</div>

{rankedUsers.length === 0 ? (
  <div style={{ color: "#4b6b8a" }}>No users in this program yet.</div>
) : (
        <div style={{ display: "grid", gap: "10px" }}>
          {rankedUsers.map((client, index) => {
            const xpData = getAdminUserXP(client);

            return (
              <button
                key={client.id}
                onClick={() => openAdminUser(client)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  background: "#f5faff",
                  borderRadius: "16px",
                  padding: "12px 14px",
                  border: "2px solid #bfdbfe",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    width: "28px",
                    flexShrink: 0,
                    color: "#4b6b8a",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  #{index + 1}
                </div>

                {client.avatar ? (
                  <img
                    src={client.avatar}
                    alt={client.name || "avatar"}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "999px",
                      objectFit: "cover",
                      border: "2px solid #bfdbfe",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "999px",
                      background: "#e0f2fe",
                      border: "2px solid #bfdbfe",
                      flexShrink: 0,
                    }}
                  />
                )}

                <div style={{ flex: 1, minWidth: 0 }}>
  <div
    style={{
      fontWeight: "bold",
      color: "#1e3a5f",
      fontSize: "15px",
    }}
  >
    {client.name || "No name"}
  </div>

  <div
    style={{
      color: "#4b6b8a",
      fontSize: "12px",
    }}
  >
    Level {xpData.level} • {xpData.totalXP} XP
  </div>

  {/* 👇 ADD THIS */}
  <div
    style={{
      color: "#2563eb",
      fontSize: "11px",
      marginTop: "4px",
      fontWeight: "bold",
    }}
  >
    {AVAILABLE_PROGRAMS.find(
      (p) => p.value === client.programTag
    )?.label || "No Program"}
  </div>
</div>
              </button>
            );
          })}
        </div>
      )}
    </div>

    <div
      style={{
        background: "#f8fbff",
        borderRadius: "18px",
        padding: "18px",
        border: "2px solid #bfdbfe",
      }}
    >
      <h3 style={{ marginTop: 0, marginBottom: "10px", color: "#1e3a5f", fontSize: "20px" }}>All Users</h3>
      <div style={{ display: "grid", gap: "10px" }}>
        {filteredUsers.map((client) => {
          const activeKeys = Object.keys(client.dailySelections || {}).filter((dk) => {
            const sel = client.dailySelections[dk] || {};
            return sel.nutrition || sel.movement || sel.mindset || sel.weekly;
          });
          const lastActive = activeKeys.length > 0 ? activeKeys.sort().reverse()[0] : null;
          const sevenDaysAgo = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
          const hasFullDayInLast7 = Object.keys(client.dailySelections || {}).some((k) => {
            if (k < sevenDaysAgo) return false;
            const s = client.dailySelections[k] || {};
            return !!(s.nutrition && s.movement && s.mindset);
          });
          const isAtRiskClient = client.status === "active" && !hasFullDayInLast7;
          return (
            <button
              key={`list-${client.id}`}
              onClick={() => openAdminUser(client)}
              style={{ width: "100%", textAlign: "left", background: "#f5faff", borderRadius: "16px", padding: "12px 14px", border: isAtRiskClient ? "2px solid #fca5a5" : "2px solid #bfdbfe", cursor: "pointer" }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", flexWrap: "wrap" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>{client.name || "No name"}</div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  {isAtRiskClient && (
                    <span style={{ fontSize: "11px", background: "#fef2f2", color: "#dc2626", borderRadius: "6px", padding: "2px 7px", fontWeight: "bold", flexShrink: 0 }}>⚠ No full day (7d)</span>
                  )}
                  <div style={{ color: lastActive ? "#4b6b8a" : "#94a3b8", fontSize: "12px", flexShrink: 0 }}>
                    {lastActive ? `Last active: ${lastActive}` : "Never logged"}
                  </div>
                </div>
              </div>
              <div style={{ color: "#4b6b8a", fontSize: "14px", marginTop: "2px" }}>{client.email || "No email"}</div>
              <div style={{ color: "#2563eb", fontSize: "12px", marginTop: "2px", fontWeight: "bold" }}>
                {AVAILABLE_PROGRAMS.find((p) => p.value === client.programTag)?.label || "No Program"}
              </div>
            </button>
          );
        })}
      </div>
    </div>
    </div>
  ); })()}
{adminTab === "weeklyPrompts" && !selectedAdminUser && (
  <AdminWeeklyPrompts
    currentUser={{
      uid: user.uid,
      name: profileName,
      avatar: selectedAvatar,
    }}
    programOptions={AVAILABLE_PROGRAMS.filter((program) => program.value)}
  />
)}
{adminTab === "broadcasts" && !selectedAdminUser && (
  <AdminBroadcasts adminUid={user.uid} allUsers={allUsers} adminName={profileName} adminAvatar={selectedAvatar} programOptions={programs} groupCall={groupCall} initialType={fabInitBroadcastType} initialTypeKey={fabInitBroadcastKey} />
)}

{adminTab === "recurringCalls" && !selectedAdminUser && (() => {
  const cfg = recurringCallConfig || {};
  const occurrences = recurringCallConfig?.active ? computeNextOccurrences(recurringCallConfig, new Date(), 5) : [];

  async function handleSaveConfig(e) {
    e.preventDefault();
    setRcAdminSaving(true);
    setRcAdminError("");
    try {
      const form = e.target;
      const dayOfWeek = Number(form.dayOfWeek.value);
      const [h, m] = form.time.value.split(":").map(Number);
      const targetProgram = rcFormTargetType === "program" ? (form.programTag?.value || userprogramTag || "") : (userprogramTag || "");
      await setRecurringCallConfig({
        active: true,
        title: form.title.value.trim() || "Weekly Group Call",
        dayOfWeek,
        hour: h,
        minute: m,
        timezoneLabel: form.tzLabel.value.trim(),
        programTag: targetProgram,
        targetType: rcFormTargetType,
        targetUserIds: rcFormTargetType === "users" ? rcFormTargetUserIds : [],
        startDate: rcFormStartDate || null,
        endDate: rcFormEndType === "date" ? (rcFormEndDate || null) : null,
        totalCalls: rcFormEndType === "count" ? (Number(rcFormTotalCalls) || null) : null,
        createdBy: user.uid,
      });
    } catch (err) {
      setRcAdminError(err.message || "Save failed");
    }
    setRcAdminSaving(false);
  }

  async function handleDeactivate() {
    if (!window.confirm("Deactivate the recurring call? Clients will stop seeing it.")) return;
    await setRecurringCallConfig({ active: false });
  }

  async function handleCreateRoom(dateKey, scheduledTime) {
    try {
      await createRoomForOccurrence(dateKey, scheduledTime instanceof Date ? scheduledTime.toISOString() : scheduledTime);
      const polls = await getCallPollsForDateKeys(occurrences.map(dateKeyFromDate));
      setNextCallPolls(polls);
    } catch (err) {
      alert("Room creation failed: " + err.message);
    }
  }

  async function handleRemoveRoom(dateKey, roomName) {
    try {
      await removeRoomForOccurrence(dateKey, roomName);
      const polls = await getCallPollsForDateKeys(occurrences.map(dateKeyFromDate));
      setNextCallPolls(polls);
    } catch (err) {
      alert("Error removing room: " + err.message);
    }
  }

  async function handleCancelOccurrence(dateKey) {
    const note = window.prompt("Optional reason for cancellation (shown to clients):", "");
    if (note === null) return;
    await cancelOccurrence(dateKey, note);
    const polls = await getCallPollsForDateKeys(occurrences.map(dateKeyFromDate));
    setNextCallPolls(polls);
    // Post to community feed
    if (userprogramTag) {
      const { createPost } = await import("./communityFeed");
      await createPost({ programTag: userprogramTag, type: "general", text: `📅 The group call on ${dateKey} has been cancelled${note ? `: ${note}` : "."} `, currentUser: { uid: user.uid, name: profileName, avatar: selectedAvatar } });
    }
  }

  async function handleReschedule() {
    if (!rcRescheduleFor || !rcRescheduleDate || !rcRescheduleTime) return;
    setRcRescheduleSaving(true);
    try {
      const newDateTime = new Date(`${rcRescheduleDate}T${rcRescheduleTime}`).toISOString();
      if (rcRescheduleScope === "one") {
        await rescheduleOccurrence(rcRescheduleFor, rcRescheduleDate, newDateTime, rcRescheduleNote);
      } else {
        // Change recurring config from this date forward
        const [h, m] = rcRescheduleTime.split(":").map(Number);
        const newDay = new Date(`${rcRescheduleDate}T12:00:00`).getDay();
        await setRecurringCallConfig({ ...recurringCallConfig, dayOfWeek: newDay, hour: h, minute: m });
      }
      // Post reschedule notice to community feed
      if (userprogramTag) {
        const { createPost } = await import("./communityFeed");
        const origLabel = occurrences.find((o) => dateKeyFromDate(o) === rcRescheduleFor)
          ? formatOccurrenceTime(occurrences.find((o) => dateKeyFromDate(o) === rcRescheduleFor))
          : rcRescheduleFor;
        const newLabel = formatOccurrenceTime(new Date(`${rcRescheduleDate}T${rcRescheduleTime}`));
        await createPost({ programTag: userprogramTag, type: "general", text: `📅 Group call rescheduled${rcRescheduleScope === "all" ? " (all future calls)" : ""}: ${origLabel} → ${newLabel}${rcRescheduleNote ? `\n\n${rcRescheduleNote}` : ""}`, currentUser: { uid: user.uid, name: profileName, avatar: selectedAvatar } });
      }
      const polls = await getCallPollsForDateKeys(computeNextOccurrences(recurringCallConfig, new Date(), 5).map(dateKeyFromDate));
      setNextCallPolls(polls);
      setRcRescheduleFor(null);
    } catch (err) {
      alert("Reschedule failed: " + err.message);
    }
    setRcRescheduleSaving(false);
  }

  const inputStyle = { width: "100%", padding: "9px 12px", borderRadius: "10px", border: "2px solid #bfdbfe", fontSize: "14px", color: "#1e3a5f", outline: "none", boxSizing: "border-box" };
  const labelStyle = { fontSize: "12px", fontWeight: "bold", color: "#4b6b8a", marginBottom: "4px", display: "block" };

  return (
    <div style={{ display: "grid", gap: "18px" }}>
      {/* Config form */}
      <div style={{ background: "#f5faff", borderRadius: "18px", padding: "20px", border: "2px solid #dbeafe" }}>
        <h3 style={{ margin: "0 0 16px", color: "#1e3a5f", fontSize: "17px" }}>📅 Recurring Call Settings</h3>
        <form onSubmit={handleSaveConfig} style={{ display: "grid", gap: "14px" }}>
          <div>
            <label style={labelStyle}>Call title</label>
            <input name="title" defaultValue={cfg.title || "Weekly Group Call"} style={inputStyle} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            <div>
              <label style={labelStyle}>Day of week</label>
              <select name="dayOfWeek" defaultValue={cfg.dayOfWeek ?? 4} style={inputStyle}>
                {DAYS_FULL.map((d, i) => <option key={i} value={i}>{d}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Time</label>
              <input name="time" type="time" defaultValue={`${String(cfg.hour ?? 19).padStart(2,"0")}:${String(cfg.minute ?? 0).padStart(2,"0")}`} style={inputStyle} />
            </div>
          </div>
          <div>
            <label style={labelStyle}>Timezone label (shown to clients, e.g. "7:00 PM ET")</label>
            <input name="tzLabel" defaultValue={cfg.timezoneLabel || ""} placeholder="e.g. 7:00 PM ET" style={inputStyle} />
          </div>

          {/* Audience */}
          <div>
            <label style={labelStyle}>Audience</label>
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              {[{ v: "program", label: "Program" }, { v: "users", label: "Specific people" }].map(({ v, label }) => (
                <button key={v} type="button" onClick={() => setRcFormTargetType(v)}
                  style={{ flex: 1, padding: "8px", borderRadius: "9px", border: rcFormTargetType === v ? "2px solid #2563eb" : "2px solid #bfdbfe", background: rcFormTargetType === v ? "#eff6ff" : "#f8fbff", color: "#1e3a5f", fontWeight: rcFormTargetType === v ? "bold" : "normal", fontSize: "13px", cursor: "pointer" }}>
                  {label}
                </button>
              ))}
            </div>
            {rcFormTargetType === "program" ? (
              <select name="programTag" defaultValue={cfg.programTag || userprogramTag || ""} style={inputStyle}>
                {AVAILABLE_PROGRAMS.filter((p) => p.value).map((p) => (
                  <option key={p.value} value={p.value}>{p.label}</option>
                ))}
              </select>
            ) : (
              <div style={{ border: "2px solid #bfdbfe", borderRadius: "10px", padding: "8px", maxHeight: "160px", overflowY: "auto", display: "grid", gap: "4px" }}>
                {allUsers.filter((u) => u.status === "active").map((u) => (
                  <label key={u.id} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "5px 6px", borderRadius: "7px", cursor: "pointer", background: rcFormTargetUserIds.includes(u.id) ? "#eff6ff" : "transparent" }}>
                    <input type="checkbox" checked={rcFormTargetUserIds.includes(u.id)}
                      onChange={() => setRcFormTargetUserIds((prev) => prev.includes(u.id) ? prev.filter((id) => id !== u.id) : [...prev, u.id])}
                      style={{ width: "15px", height: "15px", accentColor: "#2563eb" }} />
                    <span style={{ fontSize: "13px", color: "#1e3a5f" }}>{u.name || u.email}</span>
                  </label>
                ))}
                {allUsers.filter((u) => u.status === "active").length === 0 && (
                  <div style={{ fontSize: "13px", color: "#4b6b8a", padding: "4px" }}>No active clients found</div>
                )}
              </div>
            )}
          </div>

          {/* Start date */}
          <div>
            <label style={labelStyle}>Start date (optional — leave blank to start immediately)</label>
            <input type="date" value={rcFormStartDate} onChange={(e) => setRcFormStartDate(e.target.value)} style={inputStyle} />
          </div>

          {/* End condition */}
          <div>
            <label style={labelStyle}>End condition</label>
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              {[{ v: "indefinite", label: "Indefinite" }, { v: "date", label: "Until date" }, { v: "count", label: "# of calls" }].map(({ v, label }) => (
                <button key={v} type="button" onClick={() => setRcFormEndType(v)}
                  style={{ flex: 1, padding: "8px", borderRadius: "9px", border: rcFormEndType === v ? "2px solid #2563eb" : "2px solid #bfdbfe", background: rcFormEndType === v ? "#eff6ff" : "#f8fbff", color: "#1e3a5f", fontWeight: rcFormEndType === v ? "bold" : "normal", fontSize: "12px", cursor: "pointer" }}>
                  {label}
                </button>
              ))}
            </div>
            {rcFormEndType === "date" && (
              <input type="date" value={rcFormEndDate} onChange={(e) => setRcFormEndDate(e.target.value)} style={inputStyle} />
            )}
            {rcFormEndType === "count" && (
              <div style={{ display: "grid", gap: "8px" }}>
                <input type="number" min="1" max="104" placeholder="e.g. 12" value={rcFormTotalCalls} onChange={(e) => setRcFormTotalCalls(e.target.value)} style={inputStyle} />
                {rcFormTotalCalls && rcFormStartDate && (() => {
                  const end = computeEffectiveEndDate({ dayOfWeek: cfg.dayOfWeek ?? 4, hour: cfg.hour ?? 19, minute: cfg.minute ?? 0, startDate: rcFormStartDate, totalCalls: Number(rcFormTotalCalls) });
                  return end ? (
                    <div style={{ fontSize: "12px", color: "#4b6b8a", background: "#f0f9ff", borderRadius: "8px", padding: "6px 10px" }}>
                      Last call: {end.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" })}
                    </div>
                  ) : null;
                })()}
              </div>
            )}
          </div>

          {rcAdminError && <div style={{ color: "#dc2626", fontSize: "13px" }}>{rcAdminError}</div>}
          <div style={{ display: "flex", gap: "10px" }}>
            <button type="submit" disabled={rcAdminSaving} style={{ flex: 1, padding: "10px", borderRadius: "10px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}>
              {rcAdminSaving ? "Saving..." : cfg.active ? "Update Settings" : "Activate Recurring Call"}
            </button>
            {cfg.active && (
              <button type="button" onClick={handleDeactivate} style={{ padding: "10px 14px", borderRadius: "10px", border: "2px solid #fca5a5", background: "transparent", color: "#dc2626", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
                Deactivate
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Upcoming occurrences */}
      {cfg.active && occurrences.length > 0 && (
        <div style={{ background: "#f5faff", borderRadius: "18px", padding: "20px", border: "2px solid #dbeafe" }}>
          <h3 style={{ margin: "0 0 14px", color: "#1e3a5f", fontSize: "17px" }}>Upcoming Occurrences</h3>
          {occurrences.map((date) => {
            const dateKey = dateKeyFromDate(date);
            const poll = nextCallPolls[dateKey];
            const isCancelled = poll?.status === "cancelled";
            const rsvps = poll?.rsvps || {};
            const yesCount = Object.values(rsvps).filter((v) => v === "yes").length;
            const noCount = Object.values(rsvps).filter((v) => v === "no").length;
            const targetCount = cfg.targetType === "users"
              ? (cfg.targetUserIds || []).length
              : (allUsers?.filter((u) => u.status === "active" && u.programTag === (cfg.programTag || userprogramTag))?.length || 0);
            const noResp = Math.max(0, targetCount - yesCount - noCount);
            const scheduledTime = poll?.scheduledTime || date;
            const timeLabel = formatOccurrenceTime(scheduledTime);

            return (
              <div key={dateKey} style={{ borderRadius: "14px", padding: "14px 16px", background: isCancelled ? "#fef2f2" : "#fff", border: isCancelled ? "1px solid #fca5a5" : "1px solid #dbeafe", marginBottom: "10px" }}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: "bold", color: isCancelled ? "#dc2626" : "#1e3a5f", fontSize: "14px" }}>
                      {isCancelled ? "🚫 Cancelled — " : "📅 "}{timeLabel}
                    </div>
                    {poll?.note && <div style={{ fontSize: "12px", color: "#4b6b8a", marginTop: "2px" }}>{poll.note}</div>}
                    {!isCancelled && (
                      <div style={{ fontSize: "12px", color: "#4b6b8a", marginTop: "4px" }}>
                        ✓ {yesCount} going · ✗ {noCount} can't · {noResp > 0 ? `${noResp} no response` : "all responded"}
                        {poll?.roomUrl && <span style={{ marginLeft: "8px", color: "#059669", fontWeight: "bold" }}>· Room ready</span>}
                      </div>
                    )}
                  </div>
                  {!isCancelled && (
                    <div style={{ display: "flex", gap: "6px", flexShrink: 0, flexWrap: "wrap", justifyContent: "flex-end" }}>
                      {!poll?.roomUrl ? (
                        <button onClick={() => handleCreateRoom(dateKey, scheduledTime)} style={{ padding: "5px 10px", borderRadius: "8px", border: "none", background: "#059669", color: "#fff", fontWeight: "bold", fontSize: "11px", cursor: "pointer" }}>
                          + Room
                        </button>
                      ) : (
                        <button onClick={() => handleRemoveRoom(dateKey, poll.roomName)} style={{ padding: "5px 10px", borderRadius: "8px", border: "1px solid #d1d5db", background: "transparent", color: "#6b7280", fontSize: "11px", cursor: "pointer" }}>
                          Remove room
                        </button>
                      )}
                      <button
                        onClick={() => { setRcRescheduleFor(dateKey); setRcRescheduleDate(dateKey); setRcRescheduleTime(`${String(cfg.hour ?? 19).padStart(2,"0")}:${String(cfg.minute ?? 0).padStart(2,"0")}`); setRcRescheduleNote(""); setRcRescheduleScope("one"); }}
                        style={{ padding: "5px 10px", borderRadius: "8px", border: "1.5px solid #2563eb", background: "transparent", color: "#2563eb", fontWeight: "bold", fontSize: "11px", cursor: "pointer" }}
                      >
                        Reschedule
                      </button>
                      <button onClick={() => handleCancelOccurrence(dateKey)} style={{ padding: "5px 10px", borderRadius: "8px", border: "1.5px solid #fca5a5", background: "transparent", color: "#dc2626", fontSize: "11px", cursor: "pointer" }}>
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Reschedule modal */}
      {rcRescheduleFor && (
        <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
          <div style={{ background: "#fff", borderRadius: "20px", padding: "24px", width: "100%", maxWidth: "420px", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <h3 style={{ margin: "0 0 16px", color: "#1e3a5f", fontSize: "17px" }}>📅 Reschedule</h3>
            <div style={{ display: "grid", gap: "12px", marginBottom: "16px" }}>
              <div>
                <label style={labelStyle}>New date</label>
                <input type="date" value={rcRescheduleDate} onChange={(e) => setRcRescheduleDate(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>New time</label>
                <input type="time" value={rcRescheduleTime} onChange={(e) => setRcRescheduleTime(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Note for clients (optional)</label>
                <input type="text" placeholder="e.g. Moving due to holiday" value={rcRescheduleNote} onChange={(e) => setRcRescheduleNote(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Scope</label>
                <div style={{ display: "flex", gap: "8px" }}>
                  {[{ v: "one", label: "Just this date" }, { v: "all", label: "All future calls" }].map(({ v, label }) => (
                    <button key={v} type="button" onClick={() => setRcRescheduleScope(v)} style={{ flex: 1, padding: "9px", borderRadius: "10px", border: rcRescheduleScope === v ? "2px solid #2563eb" : "2px solid #bfdbfe", background: rcRescheduleScope === v ? "#eff6ff" : "#f8fbff", color: "#1e3a5f", fontWeight: rcRescheduleScope === v ? "bold" : "normal", fontSize: "13px", cursor: "pointer" }}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button onClick={handleReschedule} disabled={rcRescheduleSaving || !rcRescheduleDate || !rcRescheduleTime} style={{ flex: 1, padding: "11px", borderRadius: "11px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}>
                {rcRescheduleSaving ? "Saving..." : "Confirm Reschedule"}
              </button>
              <button onClick={() => setRcRescheduleFor(null)} style={{ padding: "11px 16px", borderRadius: "11px", border: "2px solid #dbeafe", background: "transparent", color: "#4b6b8a", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
})()}

{adminTab === "weeklyChallenges" && !selectedAdminUser && (
  <AdminGameContent sectionOverride="weeklyChallenges" />
)}
{adminTab === "gameContent" && !selectedAdminUser && (
  <AdminGameContent />
)}

{adminTab === "onboarding" && !selectedAdminUser && (
  <div style={{ display: "grid", gap: "16px" }}>
    {/* Onboarding sub-tabs */}
    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      {[
        { key: "programHabits", label: "Program Habits" },
        { key: "programs", label: "📋 Programs" },
        { key: "infoTexts", label: "📝 Info Texts" },
        { key: "walkthrough", label: "🚶 Walkthrough" },
      ].map((st) => (
        <button key={st.key} type="button" onClick={() => setAdminOnboardingSubTab(st.key)} style={{ padding: "8px 14px", borderRadius: "12px", border: adminOnboardingSubTab === st.key ? "2px solid #2563eb" : "2px solid #bfdbfe", background: adminOnboardingSubTab === st.key ? "#e0f2fe" : "#f8fbff", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
          {st.label}
        </button>
      ))}
    </div>
    {adminOnboardingSubTab === "programHabits" && (
      <div style={{ display: "grid", gap: "10px" }}>
        <p style={{ color: "#4b6b8a", margin: "0 0 4px 0", fontSize: "14px" }}>Click a program to edit its habit categories and default names.</p>
        {AVAILABLE_PROGRAMS.filter((p) => p.value).map((program) => {
          const isOpen = expandedProgramHabit === program.value;
          const cats = [
            { key: "nutrition", label: "Nutrition", emoji: "🍓" },
            { key: "movement", label: "Movement", emoji: "🚶‍♀️" },
            { key: "mindset", label: "Mindset", emoji: "🌙" },
          ];
          const progSettings = programSettings[program.value] || {};
          const enabledCats = cats.filter(({ key }) => isCategoryEnabledForProgram(program.value, key));
          return (
            <div key={program.value} style={{ background: "#f8fbff", borderRadius: "18px", border: "2px solid #bfdbfe", overflow: "hidden" }}>
              <button type="button" onClick={() => setExpandedProgramHabit(isOpen ? null : program.value)} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 18px", background: "none", border: "none", cursor: "pointer", textAlign: "left" }}>
                <div>
                  <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>{program.label}</div>
                  <div style={{ color: "#6b8cb0", fontSize: "12px", marginTop: "2px" }}>{enabledCats.map(c => c.emoji + " " + c.label).join(" · ") || "No categories enabled"}</div>
                </div>
                <div style={{ color: "#6b8cb0", fontSize: "18px", flexShrink: 0 }}>{isOpen ? "▲" : "▼"}</div>
              </button>
              {isOpen && (
                <div style={{ padding: "0 18px 18px", display: "grid", gap: "14px" }}>
                  {cats.map(({ key, label, emoji }) => {
                    const enabled = isCategoryEnabledForProgram(program.value, key);
                    const defaultHabitsForProg = progSettings.defaultHabits?.[key] || {};
                    return (
                      <div key={key} style={{ background: "#f0f9ff", borderRadius: "14px", padding: "14px", border: "1px solid #bfdbfe" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: enabled ? "12px" : 0 }}>
                          <span style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "15px" }}>{emoji} {label}</span>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <span style={{ color: "#4b6b8a", fontSize: "13px" }}>{enabled ? "On" : "Off"}</span>
                            <button type="button" onClick={() => handleToggleProgramCategory(program.value, key)} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: enabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative" }}>
                              <div style={{ position: "absolute", top: "3px", left: enabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                            </button>
                          </div>
                        </div>
                        {enabled && (
                          <div style={{ display: "grid", gap: "8px" }}>
                            <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.3px" }}>Default habit names for new users</div>
                            {[{ level: "low", label: "Keep the Streak" }, { level: "main", label: "Main Quest" }, { level: "high", label: "Extra Credit" }].map(({ level, label: lvLabel }) => {
                              const currentVal = defaultHabitsForProg[level] ?? defaultHabits[key]?.[level]?.habitName ?? "";
                              return (
                                <div key={level}>
                                  <div style={{ color: "#6b8cb0", fontSize: "11px", marginBottom: "3px" }}>{lvLabel}</div>
                                  <input type="text" value={currentVal} placeholder={defaultHabits[key]?.[level]?.habitName || ""} onChange={async (e) => {
                                    const val = e.target.value;
                                    const next = { ...programSettings, [program.value]: { ...progSettings, defaultHabits: { ...(progSettings.defaultHabits || {}), [key]: { ...(defaultHabitsForProg), [level]: val } } } };
                                    setProgramSettings(next);
                                    try { await setDoc(doc(db, "appConfig", "programSettings"), next, { merge: false }); } catch (_) {}
                                  }} style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "10px", border: "1px solid #bfdbfe", background: "#fff", color: "#1e3a5f", fontSize: "13px" }} />
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    )}
    {adminOnboardingSubTab === "programs" && <ProgramsEditor db={db} programs={programs} setPrograms={setPrograms} programSettings={programSettings} setProgramSettings={setProgramSettings} />}
    {adminOnboardingSubTab === "infoTexts" && <InfoTextsEditor infoTexts={infoTexts} setInfoTexts={setInfoTexts} db={db} />}
    {adminOnboardingSubTab === "walkthrough" && (
      <div style={{ display: "grid", gap: "12px" }}>
        <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>🚶 App Walkthrough Preview</div>
        <div style={{ fontSize: "13px", color: "#6b7280" }}>Preview the walkthrough as each program type sees it, or replay from Settings.</div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button type="button" onClick={() => { setShowOnboarding(true); }} style={{ flex: 1, padding: "12px", borderRadius: "14px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}>▶ Preview Walkthrough</button>
        </div>
        <div style={{ fontSize: "13px", color: "#4b6b8a", background: "#f0f9ff", borderRadius: "12px", padding: "12px 14px", border: "1px solid #bfdbfe" }}>
          💡 The walkthrough slides are program-aware — momentum users see extra slides for Workouts and Challenges. Slide text can be edited directly in the codebase at <code>src/OnboardingWalkthrough.jsx</code>.
        </div>
      </div>
    )}
  </div>
)}


{adminTab === "workoutPrograms" && !selectedAdminUser && (() => {
  const card = { background: "#fff", borderRadius: "16px", padding: "16px", border: "1.5px solid #bfdbfe", marginBottom: "12px" };
  const inputStyle = { width: "100%", padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #bfdbfe", fontSize: "14px", color: "#1e3a5f", background: "#f8fbff", boxSizing: "border-box" };
  const btnBlue = { padding: "10px 18px", borderRadius: "12px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: "pointer" };
  const btnGhost = { padding: "8px 14px", borderRadius: "10px", border: "1.5px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" };

  async function wpSave(program) {
    setWpSaving(true);
    try {
      const clean = {
        ...program,
        workouts: (program.workouts || []).map(w => ({
          ...w,
          exercises: (w.exercises || []).map(({ _unmatched, ...ex }) => ex),
        })),
      };
      if (clean.id) {
        await updateWorkoutProgram(clean.id, clean);
      } else {
        const ref = await createWorkoutProgram(clean);
        program = { ...program, id: ref.id };
      }
      const fresh = await getAllWorkoutPrograms();
      setWpList(fresh);
      setWpEditing(program);
    } catch (e) { console.error(e); }
    setWpSaving(false);
  }

  async function wpDelete(id) {
    if (!window.confirm("Delete this program?")) return;
    await deleteWorkoutProgram(id);
    setWpList(prev => prev.filter(p => p.id !== id));
    setWpEditing(null);
    setWpWorkoutIdx(null);
    setWpExEditIdx(null);
  }

  // ── VIEW 3: Exercise editor inside a workout day ──────────────────────────
  if (wpEditing && wpWorkoutIdx !== null) {
    const workout = wpEditing.workouts[wpWorkoutIdx];
    const exercises = workout.exercises || [];

    function setWorkout(updated) {
      const newWorkouts = wpEditing.workouts.map((w, i) => i === wpWorkoutIdx ? updated : w);
      setWpEditing({ ...wpEditing, workouts: newWorkouts });
    }

    function setExercise(idx, updated) {
      const newExs = exercises.map((e, i) => i === idx ? updated : e);
      setWorkout({ ...workout, exercises: newExs });
    }

    function removeExercise(idx) {
      setWorkout({ ...workout, exercises: exercises.filter((_, i) => i !== idx) });
      if (wpExEditIdx === idx) setWpExEditIdx(null);
    }

    function addExercise() {
      const newEx = { id: Date.now().toString(), primaryName: "", sets: 3, reps: "8-12", restSecs: 90, muscleGroup: "", equipment: [], alternatives: [] };
      setWorkout({ ...workout, exercises: [...exercises, newEx] });
      setWpExEditIdx(exercises.length);
    }

    function ExerciseNameInput({ value, onChange }) {
      const [query, setQuery] = useState(value || "");
      const [open, setOpen] = useState(false);
      const filtered = query.length > 0 ? wpExerciseNames.filter(n => n.toLowerCase().includes(query.toLowerCase())).slice(0, 8) : [];
      return (
        <div style={{ position: "relative" }}>
          <input value={query} onChange={e => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
            placeholder="Exercise name..." style={inputStyle} />
          {open && filtered.length > 0 && (
            <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1.5px solid #bfdbfe", borderRadius: "10px", zIndex: 100, maxHeight: "180px", overflowY: "auto", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
              {filtered.map(n => (
                <div key={n} onMouseDown={() => { onChange(n); setQuery(n); setOpen(false); }}
                  style={{ padding: "8px 12px", cursor: "pointer", fontSize: "13px", color: "#1e3a5f" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                >{n}</div>
              ))}
            </div>
          )}
        </div>
      );
    }

    function EquipmentChips({ selected, onChange }) {
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "6px" }}>
          {EQUIPMENT_LIST.map(eq => {
            const on = selected.includes(eq.key);
            return (
              <button key={eq.key} type="button"
                onClick={() => onChange(on ? selected.filter(k => k !== eq.key) : [...selected, eq.key])}
                style={{ padding: "4px 10px", borderRadius: "20px", border: on ? "2px solid #2563eb" : "1.5px solid #bfdbfe", background: on ? "#dbeafe" : "#f5faff", color: on ? "#1d4ed8" : "#4b6b8a", fontSize: "12px", fontWeight: on ? "bold" : "normal", cursor: "pointer" }}
              >{eq.label}</button>
            );
          })}
        </div>
      );
    }

    async function handleWorkoutSave() {
      if (wpEditing._batchIdx !== undefined) { setWpWorkoutIdx(null); setWpExEditIdx(null); return; }
      const wId = workout.workoutId;
      const sharedIn = wId ? wpList.filter(p => p.id !== wpEditing.id && (p.workouts || []).some(w => w.workoutId === wId)) : [];
      if (sharedIn.length > 0) {
        setWpUpdateModal({ workout, sharedIn });
      } else {
        await wpSave(wpEditing);
        setWpWorkoutIdx(null); setWpExEditIdx(null);
      }
    }

    return (
      <div style={{ display: "grid", gap: "12px" }}>
        {wpUpdateModal && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 4000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <div style={{ background: "#fff", borderRadius: "20px", padding: "24px", maxWidth: "420px", width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px", marginBottom: "8px" }}>Update Shared Workout?</div>
              <div style={{ fontSize: "13px", color: "#64748b", marginBottom: "16px" }}>
                This workout day also appears in: <strong>{wpUpdateModal.sharedIn.map(p => p.name).join(", ")}</strong>. Update it there too?
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <button type="button"
                  style={{ flex: 1, padding: "10px", borderRadius: "12px", border: "1.5px solid #e2e8f0", background: "#f8fafc", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}
                  onClick={async () => {
                    setWpUpdateModal(null);
                    await wpSave(wpEditing);
                    setWpWorkoutIdx(null); setWpExEditIdx(null);
                  }}>
                  Just This Program
                </button>
                <button type="button"
                  style={{ flex: 1, padding: "10px", borderRadius: "12px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}
                  onClick={async () => {
                    const modal = wpUpdateModal;
                    const wId2 = modal.workout.workoutId;
                    setWpUpdateModal(null);
                    await wpSave(wpEditing);
                    for (const prog of modal.sharedIn) {
                      const updatedWorkouts = (prog.workouts || []).map(w => w.workoutId === wId2 ? { ...modal.workout, id: w.id, workoutId: w.workoutId } : w);
                      await updateWorkoutProgram(prog.id, { ...prog, workouts: updatedWorkouts });
                    }
                    const fresh = await getAllWorkoutPrograms();
                    setWpList(fresh);
                    setWpWorkoutIdx(null); setWpExEditIdx(null);
                  }}>
                  Update Everywhere
                </button>
              </div>
            </div>
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button style={btnGhost} onClick={handleWorkoutSave}>← Back to Program</button>
          <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>{wpEditing.name} — Workout Day Editor</div>
        </div>

        <div style={card}>
          <div style={{ fontWeight: "bold", color: "#1e3a5f", marginBottom: "8px" }}>Workout Name</div>
          <input value={workout.name} onChange={e => setWorkout({ ...workout, name: e.target.value })} style={inputStyle} placeholder="e.g. Upper Body A" />
        </div>

        <div style={card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
            <div style={{ fontWeight: "bold", color: "#1e3a5f" }}>Exercises ({exercises.length})</div>
            <button style={btnBlue} onClick={addExercise}>＋ Add Exercise</button>
          </div>

          {exercises.length === 0 && (
            <div style={{ color: "#9ca3af", fontSize: "13px", textAlign: "center", padding: "20px" }}>No exercises yet — click ＋ Add Exercise to start.</div>
          )}

          {exercises.map((ex, idx) => (
            <div key={ex.id || idx} style={{ border: "1.5px solid #e0eaff", borderRadius: "12px", padding: "12px", marginBottom: "10px", background: wpExEditIdx === idx ? "#f0f9ff" : "#fafcff" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px" }}>
                  {ex.primaryName || <span style={{ color: "#9ca3af" }}>Unnamed exercise</span>}
                  {ex._unmatched && <span style={{ marginLeft: "6px", fontSize: "11px", background: "#fef3c7", color: "#92400e", borderRadius: "6px", padding: "2px 6px", fontWeight: "600" }}>⚠ fix name</span>}
                  <span style={{ fontWeight: "normal", color: "#6b7280", fontSize: "12px", marginLeft: "8px" }}>{ex.sets}×{ex.reps} · {ex.alternatives?.length || 0} alt{ex.alternatives?.length !== 1 ? "s" : ""}</span>
                </div>
                <div style={{ display: "flex", gap: "6px" }}>
                  <button style={btnGhost} onClick={() => setWpExEditIdx(wpExEditIdx === idx ? null : idx)}>
                    {wpExEditIdx === idx ? "Done" : "Edit"}
                  </button>
                  <button onClick={() => removeExercise(idx)} style={{ ...btnGhost, color: "#dc2626", borderColor: "#fca5a5" }}>Remove</button>
                </div>
              </div>

              {wpExEditIdx === idx && (
                <div style={{ marginTop: "12px", display: "grid", gap: "10px" }}>
                  {ex._unmatched && (
                    <div style={{ background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: "8px", padding: "8px 12px", fontSize: "12px", color: "#92400e" }}>
                      ⚠ Not found in library — video may not work. Fix the name below.
                    </div>
                  )}
                  <div>
                    <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Exercise Name</label>
                    <ExerciseNameInput value={ex.primaryName} onChange={v => { const { _unmatched, ...rest } = ex; setExercise(idx, { ...rest, primaryName: v }); }} />
                    {ex.primaryName && !wpExerciseNames.includes(ex.primaryName) && (
                      <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "4px" }}>
                        Custom exercise — add a video URL below so clients can watch the demo.
                      </div>
                    )}
                  </div>

                  <div>
                    <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Demo Video URL <span style={{ fontWeight: "normal", color: "#94a3b8" }}>(optional — overrides library video)</span></label>
                    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                      <input
                        value={ex.videoUrl || ""}
                        onChange={e => setExercise(idx, { ...ex, videoUrl: e.target.value || undefined })}
                        style={{ ...inputStyle, flex: 1 }}
                        placeholder="https://youtube.com/watch?v=..."
                      />
                      {ex.videoUrl && (
                        <button type="button"
                          onClick={() => window.open(ex.videoUrl, "_blank")}
                          title="Preview video"
                          style={{ padding: "8px 10px", borderRadius: "10px", border: "1.5px solid #bfdbfe", background: "#f0f9ff", cursor: "pointer", fontSize: "15px", flexShrink: 0, lineHeight: 1 }}>
                          🎬
                        </button>
                      )}
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px" }}>
                    <div>
                      <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Sets</label>
                      <input type="number" min="1" max="20" value={ex.sets} onChange={e => setExercise(idx, { ...ex, sets: parseInt(e.target.value) || 1 })} style={inputStyle} />
                    </div>
                    <div>
                      <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Reps</label>
                      <input value={ex.reps} onChange={e => setExercise(idx, { ...ex, reps: e.target.value })} style={inputStyle} placeholder="8-12" />
                    </div>
                    <div>
                      <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Rest (sec)</label>
                      <input type="number" min="0" value={ex.restSecs} onChange={e => setExercise(idx, { ...ex, restSecs: parseInt(e.target.value) || 0 })} style={inputStyle} />
                    </div>
                  </div>

                  <div>
                    <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Muscle Group</label>
                    <input value={ex.muscleGroup} onChange={e => setExercise(idx, { ...ex, muscleGroup: e.target.value })} style={inputStyle} placeholder="e.g. Chest / Shoulders" />
                  </div>

                  <div>
                    <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Equipment Needed for Primary Exercise</label>
                    <EquipmentChips selected={ex.equipment || []} onChange={eq => setExercise(idx, { ...ex, equipment: eq })} />
                  </div>

                  <div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                      <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Alternatives (fallbacks if equipment not available)</label>
                      <button style={{ ...btnGhost, fontSize: "12px", padding: "4px 10px" }}
                        onClick={() => setExercise(idx, { ...ex, alternatives: [...(ex.alternatives || []), { name: "", equipment: [] }] })}>
                        ＋ Add Alternative
                      </button>
                    </div>
                    {(ex.alternatives || []).map((alt, ai) => (
                      <div key={ai} style={{ border: "1px solid #e0eaff", borderRadius: "10px", padding: "10px", marginBottom: "8px", background: "#f8fbff" }}>
                        <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "6px" }}>
                          <div style={{ flex: 1 }}>
                            <ExerciseNameInput value={alt.name}
                              onChange={v => {
                                const newAlts = ex.alternatives.map((a, i) => i === ai ? { ...a, name: v } : a);
                                setExercise(idx, { ...ex, alternatives: newAlts });
                              }} />
                          </div>
                          <button onClick={() => setExercise(idx, { ...ex, alternatives: ex.alternatives.filter((_, i) => i !== ai) })}
                            style={{ ...btnGhost, color: "#dc2626", borderColor: "#fca5a5", padding: "6px 10px" }}>✕</button>
                        </div>
                        <div style={{ fontSize: "11px", color: "#6b7280", marginBottom: "4px" }}>Equipment needed:</div>
                        <EquipmentChips selected={alt.equipment || []}
                          onChange={eq => {
                            const newAlts = ex.alternatives.map((a, i) => i === ai ? { ...a, equipment: eq } : a);
                            setExercise(idx, { ...ex, alternatives: newAlts });
                          }} />
                      </div>
                    ))}
                    <div style={{ fontSize: "11px", color: "#9ca3af" }}>Tip: order from most-equipped to least. Last alternative should be bodyweight (no equipment).</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <button style={{ ...btnBlue, width: "100%" }} disabled={wpSaving}
          onClick={handleWorkoutSave}>
          {wpSaving ? "Saving..." : "Save Workout Day"}
        </button>
      </div>
    );
  }

  // ── VIEW 2: Program builder ───────────────────────────────────────────────
  if (wpEditing) {
    const workouts = wpEditing.workouts || [];

    function addWorkoutDay() {
      const newDay = { id: Date.now().toString(), name: "", exercises: [] };
      setWpEditing({ ...wpEditing, workouts: [...workouts, newDay] });
    }

    function removeWorkoutDay(idx) {
      if (!window.confirm("Remove this workout day?")) return;
      setWpEditing({ ...wpEditing, workouts: workouts.filter((_, i) => i !== idx) });
    }

    return (
      <div style={{ display: "grid", gap: "12px" }}>

        {/* ── Review modal for unmatched exercises after PDF parse ── */}
        {wpReviewExercises && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(30,58,138,0.5)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
            onClick={() => setWpReviewExercises(null)}>
            <div style={{ background: "#fff", borderRadius: "20px", padding: "24px", maxWidth: "520px", width: "100%", maxHeight: "80vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}
              onClick={e => e.stopPropagation()}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px", marginBottom: "4px" }}>
                Review Exercises ({wpReviewExercises.length} not auto-matched)
              </div>
              <div style={{ fontSize: "13px", color: "#64748b", marginBottom: "16px" }}>
                These exercises weren't found in the library. Pick the right name so demo videos work correctly.
              </div>
              {wpReviewExercises.map((item, i) => (
                <div key={i} style={{ marginBottom: "14px", padding: "12px", background: "#f8fafc", borderRadius: "12px", border: "1.5px solid #e2e8f0" }}>
                  <div style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "6px" }}>
                    From PDF: "{item.originalName}"
                  </div>
                  <input
                    list={`wp-review-list-${i}`}
                    value={item.resolvedName}
                    onChange={e => setWpReviewExercises(prev => prev.map((it, j) => j === i ? { ...it, resolvedName: e.target.value } : it))}
                    style={{ width: "100%", fontSize: "13px", padding: "8px 10px", borderRadius: "8px", border: "1.5px solid #bfdbfe", background: "#fff", boxSizing: "border-box" }}
                    placeholder="Search library..."
                  />
                  <datalist id={`wp-review-list-${i}`}>
                    {wpExerciseNames.map(n => <option key={n} value={n} />)}
                  </datalist>
                </div>
              ))}
              <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                <button type="button" onClick={() => setWpReviewExercises(null)}
                  style={{ flex: 1, padding: "10px", borderRadius: "12px", border: "1.5px solid #e2e8f0", background: "#f8fafc", color: "#64748b", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
                  Skip All
                </button>
                <button type="button"
                  onClick={() => {
                    if (wpBatchPending) {
                      setWpBatchPending(prev => {
                        const next = JSON.parse(JSON.stringify(prev));
                        wpReviewExercises.forEach(({ pi, wi, ei, resolvedName }) => {
                          if (pi !== undefined) {
                            const ex = next[pi]?.workouts[wi]?.exercises[ei];
                            if (ex) { ex.primaryName = resolvedName; delete ex._unmatched; }
                          }
                        });
                        return next;
                      });
                    } else {
                      setWpEditing(prev => {
                        const next = JSON.parse(JSON.stringify(prev));
                        wpReviewExercises.forEach(({ wi, ei, resolvedName }) => {
                          const ex = next.workouts[wi]?.exercises[ei];
                          if (ex) { ex.primaryName = resolvedName; delete ex._unmatched; }
                        });
                        return next;
                      });
                    }
                    setWpReviewExercises(null);
                  }}
                  style={{ flex: 2, padding: "10px", borderRadius: "12px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
                  Apply Names
                </button>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button style={btnGhost} onClick={async () => {
            if (wpEditing._batchIdx !== undefined) {
              const bi = wpEditing._batchIdx;
              setWpBatchPending(prev => prev.map((p, i) => i === bi ? { ...wpEditing, _batchIdx: undefined } : p));
            } else {
              await wpSave(wpEditing);
            }
            setWpEditing(null); setWpWorkoutIdx(null); setWpExEditIdx(null);
          }}>← Back to Programs</button>
          <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>{wpEditing.id ? "Edit Program" : "New Program"}</div>
        </div>

        {wpEditing._parsed && (
          <div style={{ background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: "12px", padding: "10px 14px", fontSize: "13px", color: "#166534", display: "flex", alignItems: "center", gap: "8px" }}>
            ✅ Auto-built from your upload! Review the details below, set your audience, then save.
          </div>
        )}

        <div style={card}>
          <div style={{ display: "grid", gap: "10px" }}>
            <div>
              <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Program Name</label>
              <input value={wpEditing.name || ""} onChange={e => setWpEditing({ ...wpEditing, name: e.target.value })} style={inputStyle} placeholder="e.g. Quit the Quit Strength" />
            </div>
            <div>
              <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Description</label>
              <textarea value={wpEditing.description || ""} onChange={e => setWpEditing({ ...wpEditing, description: e.target.value })} style={{ ...inputStyle, minHeight: "70px", resize: "vertical" }} placeholder="Describe this program..." />
            </div>
            <div>
              <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Level</label>
              <select value={wpEditing.level || "Beginner"} onChange={e => setWpEditing({ ...wpEditing, level: e.target.value })} style={inputStyle}>
                <option>Beginner</option>
                <option>Intermediate</option>
                <option>Advanced</option>
              </select>
            </div>

            <div>
              <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold", display: "block", marginBottom: "6px" }}>Visible to — Program Groups</label>
              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>Clients in these programs will see this workout.</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {AVAILABLE_PROGRAMS.filter(p => p.value).map(p => {
                  const on = (wpEditing.programTags || []).includes(p.value);
                  return (
                    <button key={p.value} type="button"
                      onClick={() => {
                        const curr = wpEditing.programTags || [];
                        setWpEditing({ ...wpEditing, programTags: on ? curr.filter(t => t !== p.value) : [...curr, p.value] });
                      }}
                      style={{ padding: "5px 12px", borderRadius: "20px", border: on ? "2px solid #2563eb" : "1.5px solid #bfdbfe", background: on ? "#dbeafe" : "#f5faff", color: on ? "#1d4ed8" : "#4b6b8a", fontSize: "12px", fontWeight: on ? "bold" : "normal", cursor: "pointer" }}>
                      {p.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold", display: "block", marginBottom: "6px" }}>Visible to — Specific Clients</label>
              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>Add individual clients from any group.</div>
              {(() => {
                const [wpUserSearch, setWpUserSearch] = [wpEditing._userSearch || "", (v) => setWpEditing({ ...wpEditing, _userSearch: v })];
                const targetIds = wpEditing.targetUserIds || [];
                const filtered = allUsers.filter(u =>
                  !targetIds.includes(u.id) &&
                  ((u.name || "").toLowerCase().includes(wpUserSearch.toLowerCase()) ||
                   (u.email || "").toLowerCase().includes(wpUserSearch.toLowerCase()))
                ).slice(0, 6);
                return (
                  <div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "8px" }}>
                      {targetIds.map(uid => {
                        const u = allUsers.find(x => x.id === uid);
                        return (
                          <div key={uid} style={{ display: "flex", alignItems: "center", gap: "4px", padding: "4px 10px", borderRadius: "20px", background: "#dbeafe", border: "1.5px solid #93c5fd", fontSize: "12px", color: "#1d4ed8" }}>
                            {u?.name || uid}
                            <button type="button" onClick={() => setWpEditing({ ...wpEditing, targetUserIds: targetIds.filter(i => i !== uid) })}
                              style={{ background: "none", border: "none", color: "#1d4ed8", cursor: "pointer", fontSize: "14px", lineHeight: 1, padding: "0 0 0 4px" }}>×</button>
                          </div>
                        );
                      })}
                    </div>
                    <input value={wpUserSearch} onChange={e => setWpEditing({ ...wpEditing, _userSearch: e.target.value })}
                      placeholder="Search clients by name or email..." style={{ ...inputStyle, marginBottom: "6px" }} />
                    {wpUserSearch && filtered.length > 0 && (
                      <div style={{ border: "1.5px solid #bfdbfe", borderRadius: "10px", overflow: "hidden" }}>
                        {filtered.map(u => (
                          <div key={u.id}
                            onClick={() => setWpEditing({ ...wpEditing, targetUserIds: [...targetIds, u.id], _userSearch: "" })}
                            style={{ padding: "8px 12px", cursor: "pointer", fontSize: "13px", color: "#1e3a5f", borderBottom: "1px solid #e0eaff" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <span style={{ fontWeight: "bold" }}>{u.name}</span>
                            {u.email && <span style={{ color: "#6b7280", marginLeft: "8px", fontSize: "12px" }}>{u.email}</span>}
                          </div>
                        ))}
                      </div>
                    )}
                    {wpUserSearch && filtered.length === 0 && (
                      <div style={{ fontSize: "12px", color: "#9ca3af" }}>No matching clients found.</div>
                    )}
                  </div>
                );
              })()}
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <label style={{ fontSize: "13px", color: "#1e3a5f", fontWeight: "bold" }}>Visible to Clients</label>
              <button type="button"
                onClick={() => setWpEditing({ ...wpEditing, active: !wpEditing.active })}
                style={{ padding: "6px 16px", borderRadius: "20px", border: "none", background: wpEditing.active ? "#22c55e" : "#e5e7eb", color: wpEditing.active ? "#fff" : "#6b7280", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
                {wpEditing.active ? "Active" : "Draft"}
              </button>
            </div>
          </div>
        </div>

        <div style={card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
            <div style={{ fontWeight: "bold", color: "#1e3a5f" }}>Workout Days ({workouts.length})</div>
            <button style={btnBlue} onClick={addWorkoutDay}>＋ Add Day</button>
          </div>
          {workouts.length === 0 && (
            <div style={{ color: "#9ca3af", fontSize: "13px", textAlign: "center", padding: "20px" }}>No workout days yet.</div>
          )}
          {workouts.map((w, idx) => (
            <div key={w.id || idx} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", border: "1.5px solid #e0eaff", borderRadius: "12px", marginBottom: "8px", background: "#fafcff" }}>
              <div>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px" }}>{w.name || <span style={{ color: "#9ca3af" }}>Unnamed day</span>}</div>
                <div style={{ fontSize: "12px", color: "#6b7280" }}>{(w.exercises || []).length} exercises</div>
              </div>
              <div style={{ display: "flex", gap: "6px" }}>
                <button style={btnGhost} onClick={() => { setWpWorkoutIdx(idx); setWpExEditIdx(null); }}>Edit</button>
                <button onClick={() => removeWorkoutDay(idx)} style={{ ...btnGhost, color: "#dc2626", borderColor: "#fca5a5" }}>Remove</button>
              </div>
            </div>
          ))}
        </div>

        <button style={{ ...btnBlue, width: "100%" }} disabled={wpSaving}
          onClick={async () => {
            if (wpEditing._batchIdx !== undefined) {
              const bi = wpEditing._batchIdx;
              setWpBatchPending(prev => prev.map((p, i) => i === bi ? { ...wpEditing, _batchIdx: undefined } : p));
              setWpEditing(null);
            } else {
              await wpSave(wpEditing); setWpEditing(null);
            }
          }}>
          {wpSaving ? "Saving..." : wpEditing._batchIdx !== undefined ? "Save Changes" : "Save Program"}
        </button>
      </div>
    );
  }

  // ── VIEW 1.5: Batch programs pending save ────────────────────────────────
  if (wpBatchPending) {
    return (
      <div style={{ display: "grid", gap: "12px" }}>
        <div style={{ background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: "12px", padding: "10px 14px", fontSize: "13px", color: "#166534", display: "flex", alignItems: "center", gap: "8px" }}>
          ✅ Found {wpBatchPending.length} program{wpBatchPending.length !== 1 ? "s" : ""} in your upload. Review each, then save all at once.
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <button style={btnGhost} onClick={() => setWpBatchPending(null)}>✕ Cancel</button>
          <button style={{ ...btnBlue, flex: 1 }} disabled={wpSaving}
            onClick={async () => {
              setWpSaving(true);
              try {
                for (const prog of wpBatchPending) {
                  const { _parsed, _batchIdx, ...cleanProg } = prog;
                  cleanProg.workouts = (cleanProg.workouts || []).map(w => ({
                    ...w,
                    exercises: (w.exercises || []).map(({ _unmatched, ...ex }) => ex),
                  }));
                  await createWorkoutProgram(cleanProg);
                }
                const fresh = await getAllWorkoutPrograms();
                setWpList(fresh);
                setWpBatchPending(null);
              } catch (e) { console.error(e); }
              setWpSaving(false);
            }}>
            {wpSaving ? "Saving..." : `Save All ${wpBatchPending.length} Programs`}
          </button>
        </div>
        {wpBatchPending.map((prog, pi) => (
          <div key={pi} style={{ ...card }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "10px" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>{prog.name || "Unnamed Program"}</div>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                  {(prog.workouts || []).length} workout days · {prog.level}
                </div>
                {prog.description && <div style={{ fontSize: "13px", color: "#4b6b8a", marginTop: "4px" }}>{prog.description}</div>}
              </div>
              <button style={btnGhost} onClick={() => { setWpEditing({ ...prog, _batchIdx: pi }); setWpWorkoutIdx(null); setWpExEditIdx(null); }}>Edit</button>
            </div>
            {(prog.workouts || []).length > 0 && (
              <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "4px" }}>
                {(prog.workouts || []).map((w, wi) => (
                  <span key={wi} style={{ padding: "3px 8px", borderRadius: "8px", background: "#eff6ff", color: "#2563eb", fontSize: "11px" }}>
                    {w.name || `Day ${wi + 1}`}
                    {(w.exercises || []).some(e => e._unmatched) && <span style={{ color: "#f59e0b" }}> ⚠</span>}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  // ── VIEW 1: Program list ──────────────────────────────────────────────────
  return (
    <div style={{ display: "grid", gap: "12px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
        <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>Workout Programs</div>
        <div style={{ display: "flex", gap: "8px" }}>
          <label style={{ ...btnGhost, display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
            {wpSaving ? "Parsing..." : "📄 Upload & Auto-Build"}
            <input type="file" accept=".pdf,image/*" style={{ display: "none" }} disabled={wpSaving}
              onChange={async (e) => {
                const file = e.target.files?.[0];
                if (!file) return;
                e.target.value = "";
                setWpSaving(true);
                try {
                  const reader = new FileReader();
                  const fileData = await new Promise((res, rej) => {
                    reader.onload = () => res(reader.result.split(",")[1]);
                    reader.onerror = rej;
                    reader.readAsDataURL(file);
                  });
                  const fn = getFunctions();
                  const parse = httpsCallable(fn, "parseWorkoutFile");
                  const result = await parse({ fileData, mimeType: file.type, fileName: file.name });
                  const rawPrograms = result.data.programs || [];
                  const AUTO_THRESHOLD = 0.45;
                  const reviewItems = [];
                  const matchedPrograms = rawPrograms.map((prog, pi) => ({
                    name: prog.name || "",
                    description: prog.description || "",
                    level: prog.level || "Beginner",
                    programTags: [],
                    targetUserIds: [],
                    active: false,
                    coachId: user?.uid || "",
                    _parsed: true,
                    workouts: (prog.workouts || []).map((w, wi) => ({
                      ...w,
                      workoutId: w.workoutId || w.id,
                      exercises: (w.exercises || []).map((ex, ei) => {
                        const { name: matchedName, score } = fuzzyMatchExercise(ex.primaryName);
                        if (score >= AUTO_THRESHOLD) return { ...ex, primaryName: matchedName };
                        reviewItems.push({ pi, wi, ei, originalName: ex.primaryName, resolvedName: matchedName });
                        return { ...ex, _unmatched: true };
                      }),
                    })),
                  }));
                  if (matchedPrograms.length === 1) {
                    setWpEditing(matchedPrograms[0]);
                  } else {
                    setWpBatchPending(matchedPrograms);
                  }
                  if (reviewItems.length > 0) setWpReviewExercises(reviewItems);
                } catch (err) {
                  console.error(err);
                  alert("Failed to parse file: " + (err.message || "Unknown error"));
                } finally {
                  setWpSaving(false);
                }
              }} />
          </label>
          <button style={btnBlue}
            onClick={() => setWpEditing({ name: "", description: "", level: "Beginner", programTags: [], targetUserIds: [], active: false, workouts: [], coachId: user?.uid || "" })}>
            ＋ New Program
          </button>
        </div>
      </div>

      {/* Sub-tabs */}
      <div style={{ display: "flex", gap: "4px", borderBottom: "2px solid #e0eaff" }}>
        {[["programs", "Programs"], ["workouts", "All Workouts"]].map(([tab, label]) => (
          <button key={tab} type="button" onClick={() => setWpSubTab(tab)}
            style={{ padding: "8px 16px", border: "none", background: "none", cursor: "pointer", fontSize: "14px", fontWeight: wpSubTab === tab ? "bold" : "normal", color: wpSubTab === tab ? "#2563eb" : "#6b7280", borderBottom: wpSubTab === tab ? "2px solid #2563eb" : "2px solid transparent", marginBottom: "-2px" }}>
            {label}
          </button>
        ))}
      </div>

      {/* Programs tab */}
      {wpSubTab === "programs" && (
        <>
          {wpList.length === 0 && (
            <div style={{ color: "#9ca3af", fontSize: "14px", textAlign: "center", padding: "40px 20px", background: "#fafcff", borderRadius: "16px", border: "1.5px dashed #bfdbfe" }}>
              No programs yet. Create your first program above.
            </div>
          )}
          {wpList.map(p => {
            const isExpanded = !!wpExpandedPrograms[p.id];
            return (
              <div key={p.id} style={{ ...card }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", flexWrap: "wrap" }}>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>{p.name}</div>
                      <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "bold", background: p.active ? "#dcfce7" : "#f3f4f6", color: p.active ? "#16a34a" : "#6b7280" }}>{p.active ? "Active" : "Draft"}</span>
                      <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "11px", background: "#eff6ff", color: "#2563eb" }}>{p.level}</span>
                    </div>
                    <div style={{ fontSize: "12px", color: "#6b7280" }}>
                      {[...(p.programTags || []), ...(p.targetUserIds || []).map(uid => { const u = allUsers.find(x => x.id === uid); return u ? `@${u.name}` : null; }).filter(Boolean)].join(", ") || "No audience set"}
                      {" · "}{(p.workouts || []).length} workout days
                    </div>
                    {p.description && <div style={{ fontSize: "13px", color: "#4b6b8a", marginTop: "4px" }}>{p.description}</div>}
                  </div>
                  <div style={{ display: "flex", gap: "4px", flexShrink: 0, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <button style={btnGhost} onClick={() => setWpExpandedPrograms(prev => ({ ...prev, [p.id]: !prev[p.id] }))}>{isExpanded ? "▲" : "▼ Days"}</button>
                    <button style={btnGhost} onClick={async () => {
                      await updateWorkoutProgram(p.id, { active: !p.active });
                      setWpList(prev => prev.map(x => x.id === p.id ? { ...x, active: !x.active } : x));
                    }}>{p.active ? "Deactivate" : "Activate"}</button>
                    <button style={btnGhost} onClick={() => { setWpEditing(p); setWpWorkoutIdx(null); setWpExEditIdx(null); }}>Edit</button>
                    <button style={btnGhost} onClick={async () => {
                      const { id: _id, ...copy } = p;
                      await createWorkoutProgram({ ...copy, name: `${p.name} (Copy)`, active: false });
                      const fresh = await getAllWorkoutPrograms();
                      setWpList(fresh);
                    }}>Duplicate</button>
                    <button onClick={() => wpDelete(p.id)} style={{ ...btnGhost, color: "#dc2626", borderColor: "#fca5a5" }}>Delete</button>
                  </div>
                </div>
                {isExpanded && (
                  <div style={{ marginTop: "12px", display: "grid", gap: "6px" }}>
                    {(p.workouts || []).length === 0 && <div style={{ fontSize: "12px", color: "#9ca3af", padding: "8px" }}>No workout days.</div>}
                    {(p.workouts || []).map((w, wi) => (
                      <div key={w.id || wi} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f5faff", borderRadius: "10px", border: "1px solid #dbeafe" }}>
                        <div>
                          <span style={{ fontWeight: "600", color: "#1e3a5f", fontSize: "13px" }}>{w.name || `Day ${wi + 1}`}</span>
                          <span style={{ fontSize: "11px", color: "#6b7280", marginLeft: "8px" }}>{(w.exercises || []).length} exercises</span>
                        </div>
                        <button style={{ ...btnGhost, fontSize: "12px", padding: "4px 10px" }}
                          onClick={() => { setWpEditing(p); setWpWorkoutIdx(wi); setWpExEditIdx(null); }}>
                          Edit Workout
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}

      {/* All Workouts tab */}
      {wpSubTab === "workouts" && (() => {
        const workoutMap = {};
        wpList.forEach(prog => {
          (prog.workouts || []).forEach(w => {
            const key = w.workoutId || w.id;
            if (!workoutMap[key]) workoutMap[key] = { workout: w, programs: [] };
            workoutMap[key].programs.push(prog);
          });
        });
        const allWorkouts = Object.entries(workoutMap).map(([key, val]) => ({ key, ...val }));
        const selectedSet = new Set(wpSelectedWorkouts);
        return (
          <div style={{ display: "grid", gap: "8px" }}>
            {wpSelectedWorkouts.length > 0 && (
              <div style={{ display: "flex", gap: "8px", alignItems: "center", padding: "10px 14px", background: "#eff6ff", borderRadius: "12px", border: "1.5px solid #bfdbfe" }}>
                <span style={{ flex: 1, fontSize: "13px", color: "#1e3a5f", fontWeight: "600" }}>{wpSelectedWorkouts.length} workout{wpSelectedWorkouts.length !== 1 ? "s" : ""} selected</span>
                <button style={btnGhost} onClick={() => setWpSelectedWorkouts([])}>Clear</button>
                <button style={btnBlue} onClick={() => {
                  const selectedWorkouts = allWorkouts.filter(({ key }) => selectedSet.has(key)).map(({ workout }) => ({ ...workout }));
                  setWpEditing({ name: "", description: "", level: "Beginner", programTags: [], targetUserIds: [], active: false, workouts: selectedWorkouts, coachId: user?.uid || "" });
                  setWpSelectedWorkouts([]);
                }}>Create Program from Selected</button>
              </div>
            )}
            {allWorkouts.length === 0 && (
              <div style={{ fontSize: "13px", color: "#9ca3af", textAlign: "center", padding: "30px", background: "#fafcff", borderRadius: "12px", border: "1.5px dashed #bfdbfe" }}>No workouts yet. Create a program first.</div>
            )}
            {allWorkouts.map(({ key, workout: w, programs: progs }) => {
              const isSelected = selectedSet.has(key);
              return (
                <div key={key} style={{ ...card, display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
                  onClick={() => setWpSelectedWorkouts(prev => isSelected ? prev.filter(k => k !== key) : [...prev, key])}>
                  <input type="checkbox" checked={isSelected} onChange={() => {}} style={{ width: 16, height: 16, flexShrink: 0, cursor: "pointer" }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: "600", color: "#1e3a5f", fontSize: "14px" }}>{w.name || "Unnamed Workout"}</div>
                    <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                      {(w.exercises || []).length} exercise{(w.exercises || []).length !== 1 ? "s" : ""}
                      {progs.length > 0 && ` · ${progs.map(p => p.name).join(", ")}`}
                    </div>
                  </div>
                  <button style={{ ...btnGhost, fontSize: "12px", padding: "5px 12px", flexShrink: 0 }}
                    onClick={e => {
                      e.stopPropagation();
                      const prog = progs[0];
                      if (!prog) return;
                      const wi = prog.workouts.findIndex(pw => (pw.workoutId || pw.id) === key);
                      setWpEditing(prog); setWpWorkoutIdx(wi >= 0 ? wi : 0); setWpExEditIdx(null);
                    }}>
                    Edit
                  </button>
                </div>
              );
            })}
          </div>
        );
      })()}
    </div>
  );
})()}

{adminTab === "avatarOptions" && (
  <AvatarBuilderAdmin
    config={avatarBuilderConfig}
    onConfigSaved={(cfg) => setAvatarBuilderConfig(cfg)}
  />
)}

{adminTab === "activity" && !selectedAdminUser && (
  <div style={{ display: "grid", gap: "12px" }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
      <div>
        <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>Client Activity Feed</div>
        <div style={{ color: "#4b6b8a", fontSize: "13px", marginTop: "2px" }}>Real-time updates as clients complete habits, quests, and milestones.</div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
        <select
          value={activityProgramFilter}
          onChange={(e) => setActivityProgramFilter(e.target.value)}
          style={{ padding: "8px 12px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}
        >
          <option value="all">All Programs</option>
          {AVAILABLE_PROGRAMS.filter((p) => p.value).map((p) => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>
        {adminActivityUnread > 0 && (
          <button
            type="button"
            onClick={async () => { await markAllActivityRead(); }}
            style={{ padding: "8px 14px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}
          >
            ✓ Mark all read
          </button>
        )}
      </div>
    </div>

    {(() => {
      const filteredActivityEvents = activityProgramFilter === "all"
        ? adminActivityEvents
        : adminActivityEvents.filter((event) => {
            const client = allUsers.find((u) => u.id === event.userId);
            return (client?.programTag || "") === activityProgramFilter;
          });
      return filteredActivityEvents.length === 0 ? (
      <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "24px", border: "2px solid #bfdbfe", color: "#4b6b8a", textAlign: "center" }}>
        {adminActivityEvents.length === 0 ? "No activity yet. Events will appear here as clients use the app." : "No activity for this program."}
      </div>
    ) : (
      filteredActivityEvents.map((event) => {
        const { emoji } = activityMeta(event.type);
        const client = allUsers.find((u) => u.id === event.userId);
        return (
          <button
            key={event.id}
            type="button"
            onClick={async () => {
              await markActivityRead(event.id);
              if (client) {
                openAdminUser(client);
                // Navigate to the relevant tab based on event type
                const tabMap = {
                  habit_completed: "log",
                  weekly_challenge: "log",
                  side_quest: "log",
                  level_up: "profile",
                  badge_earned: "profile",
                  streak_milestone: "profile",
                };
                setAdminTab(tabMap[event.type] || "profile");
              }
            }}
            style={{
              width: "100%",
              textAlign: "left",
              background: event.readByAdmin ? "#f8fbff" : "#eff6ff",
              borderRadius: "18px",
              padding: "14px 16px",
              border: event.readByAdmin ? "2px solid #bfdbfe" : "2px solid #93c5fd",
              cursor: client ? "pointer" : "default",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            {/* Avatar */}
            {event.userAvatar ? (
              <img src={event.userAvatar} alt={event.userName} style={{ width: "40px", height: "40px", borderRadius: "999px", objectFit: "cover", border: "2px solid #bfdbfe", flexShrink: 0 }} />
            ) : (
              <div style={{ width: "40px", height: "40px", borderRadius: "999px", background: "#e0f2fe", border: "2px solid #bfdbfe", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>{emoji}</div>
            )}

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", marginBottom: "2px" }}>
                {event.userName}
                {!event.readByAdmin && (
                  <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "999px", background: "#3b82f6", marginLeft: "6px", verticalAlign: "middle" }} />
                )}
              </div>
              <div style={{ color: "#4b6b8a", fontSize: "13px", lineHeight: 1.4 }}>{emoji} {event.message}</div>
              <div style={{ color: "#9ca3af", fontSize: "11px", marginTop: "4px" }}>{timeAgo(event.createdAt)}</div>
            </div>

            {/* Arrow if clickable */}
            {client && <div style={{ color: "#bfdbfe", fontSize: "16px", flexShrink: 0 }}>›</div>}
          </button>
        );
      })
    );
    })()}
  </div>
)}

    {selectedAdminUser && (
      <div>
        <div
          style={{
            display: "flex",
            gap: "8px",
            overflowX: "auto",
            marginBottom: "18px",
            paddingBottom: "4px",
          }}
        >
          {[
            { key: "dashboard", label: "👁️ Dashboard" },
            { key: "profile", label: "Profile" },
            { key: "log", label: "Log" },
            { key: "progress", label: "📊 Progress" },
            ...(selectedAdminUser.nutritionTrackingEnabled || selectedAdminUser.portionTrackingEnabled || selectedAdminUser.macroTrackingEnabled
              ? [{ key: "nutrition", label: "Nutrition" }]
              : []),
            { key: "assignments", label: "Assignments" },
            { key: "stats", label: "Stats" },
            { key: "photos", label: "Photos" },
            { key: "settings", label: "Settings" },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => {
                setAdminTab(tab.key);
                if (tab.key === "assignments") loadAdminUserAssignments(selectedAdminUser);
                if (tab.key === "settings") loadAdminXPAdjustLog(selectedAdminUser.id);
                if (tab.key === "dashboard") {
                  setAdminDashboardFeedback([]);
                  setAdminDashboardWeeklyPrompt(null);
                  setAdminDashboardPendingBroadcasts([]);
                  setAdminDashboardViewDate(new Date());
                  refreshAdminDashboard(selectedAdminUser);
                }
              }}
              style={{
                padding: "8px 14px",
                borderRadius: "14px",
                border: adminTab === tab.key ? "2px solid #2563eb" : "2px solid #bfdbfe",
                background: adminTab === tab.key ? "#e0f2fe" : "#f8fbff",
                color: "#1e3a5f",
                fontWeight: "bold",
                cursor: "pointer",
                whiteSpace: "nowrap",
                flexShrink: 0,
                fontSize: "13px",
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {adminTab === "dashboard" && (() => {
          const client = selectedAdminUser;
          const todayDate = new Date();
          const todayKey = todayDate.toISOString().slice(0, 10);

          // The date being viewed (may be in the past via arrows)
          const viewDate = adminDashboardViewDate;
          const viewKey = viewDate.toISOString().slice(0, 10);
          const viewDisplay = viewDate.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
          const isViewingToday = viewKey === todayKey;
          const dayOfWeek = viewDate.getDay();
          const weekNum = Math.floor(viewDate.getTime() / (7 * 24 * 60 * 60 * 1000));

          function shiftViewDate(days) {
            const next = new Date(adminDashboardViewDate);
            next.setDate(next.getDate() + days);
            if (next.toISOString().slice(0, 10) <= todayKey) {
              setAdminDashboardViewDate(next);
            }
          }

          const clientProgram = client.programTag || "";
          const clientHabits = client.customHabits || defaultHabits;
          const clientLabels = client.categoryLabels || {};
          const todaySelections = (client.dailySelections || {})[viewKey] || {};

          const CATS = [
            { key: "nutrition", label: clientLabels.nutrition || "Nutrition", emoji: "🍓" },
            { key: "movement", label: clientLabels.movement || "Movement", emoji: "🚶‍♀️" },
            { key: "mindset", label: clientLabels.mindset || "Mindset", emoji: "🌙" },
          ].filter(({ key }) => isCategoryEnabledForProgram(clientProgram, key));

          const BODY_METRICS = [
            { key: "weight", label: "Weight", emoji: "⚖️" },
            { key: "measurements", label: "Measurements", emoji: "📏" },
            { key: "photos", label: "Progress Photos", emoji: "📸" },
          ];
          const dueBodyMetrics = BODY_METRICS.filter(({ key }) => {
            const cfg = client.bodyMetricsConfig?.[key];
            if (!cfg?.enabled || !cfg?.scheduleDays?.length) return false;
            if (!cfg.scheduleDays.includes(dayOfWeek)) return false;
            if ((cfg.intervalWeeks || 1) > 1 && weekNum % (cfg.intervalWeeks || 1) !== 0) return false;
            return true;
          });

          const clientSchedules = client.sideQuestSchedules || {};
          const clientSQCompletions = client.sideQuestCompletions || {};
          const activeSQ = (gameContent.sideQuests || []).filter((q) => q.active !== false);
          const scheduledSQ = activeSQ.filter((q) => {
            const sched = clientSchedules[q.title];
            if (!sched) return false;
            if (sched.type === "once") {
              const movedTo = sched.movedDates?.[sched.oneTimeDate];
              return (movedTo || sched.oneTimeDate) === viewKey;
            }
            if (sched.type === "recurring") {
              if (Object.keys(sched.movedDates || {}).includes(viewKey)) return false;
              if (Object.values(sched.movedDates || {}).includes(viewKey)) return true;
              return (sched.days || []).includes(dayOfWeek);
            }
            return false;
          });

          // ── Debt / revive calculation ──────────────────────────────────────
          const clientRevivedDays = client.revivedDays || {};
          const clientReviveStartDate = client.reviveStartDate || null;
          const clientShieldActivatedDays = client.shieldActivatedDays || {};

          const clientVacationDays = (client.vacations || []).reduce((acc, v) => {
            if (!v.start || !v.end) return acc;
            const start = new Date(`${v.start}T12:00:00`);
            const end   = new Date(`${v.end}T12:00:00`);
            for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
              acc[d.toISOString().slice(0, 10)] = true;
            }
            return acc;
          }, {});

          const clientDebtItems = [];
          if (clientReviveStartDate) {
            const clientStartDate = new Date(`${clientReviveStartDate}T12:00:00`);
            const dayBefore = new Date(todayDate);
            dayBefore.setDate(todayDate.getDate() - 1);
            if (dayBefore >= clientStartDate) {
              for (let chk = new Date(dayBefore); chk >= clientStartDate; chk.setDate(chk.getDate() - 1)) {
                const dk = chk.toISOString().slice(0, 10);
                if (clientVacationDays[dk]) continue;
                const sel = (client.dailySelections || {})[dk] || {};
                const mn = !sel.nutrition, mm = !sel.movement, mi = !sel.mindset;
                const missed = (mn ? 1 : 0) + (mm ? 1 : 0) + (mi ? 1 : 0);
                if (missed === 0) continue;
                const rev = clientRevivedDays[dk] || { nutrition: false, movement: false, mindset: false };
                const dkLabel = new Date(`${dk}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" });
                if (missed === 3) {
                  clientDebtItems.push({ type: "revive", dateKey: dk, label: dkLabel, cost: 25, isApplied: rev.nutrition && rev.movement && rev.mindset, shielded: !!clientShieldActivatedDays[dk] });
                } else {
                  if (mn) clientDebtItems.push({ type: "token", category: "nutrition", emoji: "🍓", dateKey: dk, label: dkLabel, cost: 10, isApplied: rev.nutrition });
                  if (mm) clientDebtItems.push({ type: "token", category: "movement", emoji: "🚶‍♀️", dateKey: dk, label: dkLabel, cost: 10, isApplied: rev.movement });
                  if (mi) clientDebtItems.push({ type: "token", category: "mindset", emoji: "🌙", dateKey: dk, label: dkLabel, cost: 10, isApplied: rev.mindset });
                }
              }
            }
          }
          const unresolvedDebt = clientDebtItems.filter(i => !i.isApplied && !i.shielded);
          const totalDebt = unresolvedDebt.reduce((s, i) => s + i.cost, 0);
          const { totalXP: clientTotalXP } = getAdminUserXP(client);

          // Pinned notes visible to this client (datetime-aware)
          const nowForPreview = new Date();
          const clientPinnedNotes = pinnedNotes.filter((n) => {
            const start = new Date(`${n.startDate}T${n.startTime || "00:00"}`);
            const end = new Date(`${n.endDate}T${n.endTime || "23:59"}`);
            if (start > nowForPreview || end < nowForPreview) return false;
            const type = n.targetType || "all";
            if (type === "user") return n.targetUserId === client.id;
            if (type === "program") return n.targetProgram === client.programTag;
            return true;
          });


          return (
            <div style={{ display: "grid", gap: "16px" }}>

              {/* Date navigator */}
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <button
                  onClick={() => shiftViewDate(-1)}
                  style={{ width: "36px", height: "36px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", cursor: "pointer", fontSize: "18px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                >←</button>
                <div style={{ flex: 1, textAlign: "center", fontWeight: "bold", color: "#1e3a5f", fontSize: "14px" }}>
                  {viewDisplay}{isViewingToday ? " (Today)" : ""}
                </div>
                <button
                  onClick={() => refreshAdminDashboard(client)}
                  title="Refresh to see latest client data"
                  style={{ width: "36px", height: "36px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", cursor: "pointer", fontSize: "16px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                >↻</button>
                <button
                  onClick={() => shiftViewDate(1)}
                  disabled={isViewingToday}
                  style={{ width: "36px", height: "36px", borderRadius: "10px", border: "2px solid #bfdbfe", background: isViewingToday ? "#f0f0f0" : "#f5faff", cursor: isViewingToday ? "default" : "pointer", fontSize: "18px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, opacity: isViewingToday ? 0.4 : 1 }}
                >→</button>
              </div>

              <div>

                {/* 1. Debt / revive banner — always current, only show when viewing today */}
                {isViewingToday && unresolvedDebt.length > 0 && (
                  <div style={{ background: "#f5faff", borderRadius: "18px", padding: "18px", border: "2px solid #dbeafe", marginBottom: "16px" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "17px", marginBottom: "6px" }}>🔒 Resolve Missed Days</div>
                    <div style={{ color: "#4b6b8a", fontSize: "13px", marginBottom: "12px" }}>
                      Outstanding: <strong>{totalDebt} XP</strong> &nbsp;·&nbsp; Available: <strong>{clientTotalXP} XP</strong>
                      {clientTotalXP < totalDebt && <span style={{ color: "#dc2626", fontWeight: "bold" }}> (not enough XP)</span>}
                    </div>
                    <div style={{ display: "grid", gap: "8px" }}>
                      {unresolvedDebt.map((item, i) => (
                        <button
                          key={i}
                          onClick={() => item.type === "revive" ? handleAdminRevive(client, item.dateKey) : handleAdminToken(client, item.dateKey, item.category)}
                          style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 12px", borderRadius: "12px", background: "#fff", border: "2px solid #fca5a5", cursor: "pointer", width: "100%", textAlign: "left" }}
                        >
                          <span style={{ fontSize: "18px" }}>{item.type === "revive" ? "💀" : item.emoji}</span>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>
                              {item.type === "revive" ? "Full Revive" : `${item.category.charAt(0).toUpperCase() + item.category.slice(1)} Token`}
                            </div>
                            <div style={{ color: "#6b8cb0", fontSize: "11px" }}>{item.label}</div>
                          </div>
                          <span style={{ fontWeight: "bold", color: "#dc2626", fontSize: "13px" }}>–{item.cost} XP</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* 2. Pinned coach notes */}
                {clientPinnedNotes.map((note) => (
                  <div key={note.id} style={{ background: "#f0f9ff", borderRadius: "18px", padding: "16px 18px", marginBottom: "16px", border: "2px solid #38bdf8" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                      <span style={{ fontSize: "18px" }}>📌</span>
                      <span style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>{note.title}</span>
                    </div>
                    <div style={{ color: "#4b6b8a", fontSize: "14px", lineHeight: 1.55 }}>{note.body}</div>
                    {note.linkUrl && (
                      <div style={{ display: "inline-block", marginTop: "8px", padding: "10px 18px", borderRadius: "12px", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px" }}>
                        {note.linkLabel || "Open Link"} →
                      </div>
                    )}
                  </div>
                ))}

                {/* 3. Pending broadcasts — only relevant when viewing today */}
                {isViewingToday && adminDashboardPendingBroadcasts.map((b) => (
                  <AdminBroadcastPreviewCard
                    key={b.id}
                    broadcast={b}
                    clientId={selectedAdminUser.id}
                    onDismissed={(id) => {
                      setAdminDashboardPendingBroadcasts((prev) => prev.filter((x) => x.id !== id));
                      setSelectedAdminUser((prev) => prev ? { ...prev, dismissedBroadcasts: [...(prev.dismissedBroadcasts || []), id] } : prev);
                    }}
                  />
                ))}

                {/* 4. Coach feedback / replies — only relevant when viewing today */}
                {isViewingToday && adminDashboardFeedback.length > 0 && (
                  <div style={{ marginBottom: "16px" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "10px" }}>💬 From {profileName || "Coach"}</div>
                    <div style={{ display: "grid", gap: "10px" }}>
                      {adminDashboardFeedback.map((r) => (
                        <div key={r.id} style={{ background: "#f0f9ff", borderRadius: "18px", border: "2px solid #bfdbfe", padding: "16px", display: "grid", gap: "8px" }}>
                          <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            Re: {r.broadcastTitle || "Broadcast"}
                          </div>
                          {r.comment && (
                            <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe", fontSize: "14px", color: "#243b53" }}>
                              <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>They said:</span><RichTextDisplay html={r.comment} style={{ display: "inline", color: "#243b53" }} />
                            </div>
                          )}
                          {r.adminReaction && <div style={{ fontSize: "22px" }}>{r.adminReaction}</div>}
                          {r.adminReply && (
                            <div style={{ background: "#e0f2fe", borderRadius: "12px", padding: "10px 14px", border: "2px solid #93c5fd", fontSize: "14px", color: "#1e3a5f" }}>
                              <span style={{ fontWeight: "bold", color: "#2563eb", marginRight: "6px" }}>{profileName || "Coach"}:</span>
                              <RichTextDisplay html={r.adminReply} style={{ color: "#1e3a5f", fontSize: "14px" }} />
                            </div>
                          )}
                          {r.clientReply && (
                            <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe", fontSize: "14px", color: "#243b53" }}>
                              <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>They replied:</span>{r.clientReply}
                            </div>
                          )}
                          <div style={{ borderTop: "1px solid #dbeafe", paddingTop: "10px" }}>
                            <button
                              onClick={async () => {
                                await dismissFeedbackForClient(r.id);
                                setAdminDashboardFeedback((prev) => prev.filter((x) => x.id !== r.id));
                              }}
                              style={{ padding: "8px 16px", borderRadius: "10px", border: "2px solid #e2e8f0", background: "#fff", color: "#64748b", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}
                            >
                              Dismiss for client
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* 5. Weekly quest — only show when not yet submitted (matches client dashboard behavior) */}
                {isViewingToday && adminDashboardWeeklyPrompt && !adminDashboardWeeklyPrompt.alreadySubmitted && (
                  <div style={{ border: "1px solid #ddd", borderRadius: 12, padding: 16, marginBottom: "16px", background: "#f8fbff", color: "#1e3a5f" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "4px" }}>Weekly Quest Prompt</div>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "17px", marginBottom: "8px" }}>{adminDashboardWeeklyPrompt.title}</div>
                    <RichTextDisplay html={adminDashboardWeeklyPrompt.prompt} style={{ color: "#4b6b8a", lineHeight: 1.5, marginBottom: "12px" }} />
                    {adminDashboardWeeklyPrompt.xpReward > 0 && (
                      <div style={{ marginBottom: "10px", display: "inline-block", padding: "3px 10px", borderRadius: "999px", background: "#dcfce7", border: "1px solid #bbf7d0", color: "#166534", fontSize: "12px", fontWeight: "bold" }}>
                        +{adminDashboardWeeklyPrompt.xpReward} XP for submitting
                      </div>
                    )}
                    <div style={{ display: "grid", gap: "8px" }}>
                      <div style={{ fontSize: "12px", fontWeight: "bold", color: "#2563eb", textTransform: "uppercase", letterSpacing: "0.3px" }}>Submit on behalf of client</div>
                      <textarea
                        value={coachSubmitText}
                        onChange={(e) => setCoachSubmitText(e.target.value)}
                        placeholder="Type their response here..."
                        rows={3}
                        style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: "12px", border: "1px solid #bfdbfe", background: "#fff", color: "#1e3a5f", fontSize: "14px", resize: "vertical", fontFamily: "inherit" }}
                      />
                      <button
                        onClick={async () => {
                          if (!coachSubmitText.trim()) return;
                          setCoachSubmitting(true);
                          try {
                            await coachSubmitWeeklyQuest({
                              promptId: adminDashboardWeeklyPrompt.id,
                              userId: client.id,
                              userName: client.name || "",
                              userAvatar: client.avatar || "",
                              programTag: client.programTag || "",
                              promptTitle: adminDashboardWeeklyPrompt.title,
                              responseText: coachSubmitText.trim(),
                              xpReward: adminDashboardWeeklyPrompt.xpReward || 0,
                              coachName: profileName,
                            });
                            setAdminDashboardWeeklyPrompt(null);
                            setCoachSubmitText("");
                          } finally {
                            setCoachSubmitting(false);
                          }
                        }}
                        disabled={coachSubmitting || !coachSubmitText.trim()}
                        style={{ padding: "10px 16px", borderRadius: "12px", border: "none", background: coachSubmitText.trim() ? "#2563eb" : "#bfdbfe", color: "#fff", fontWeight: "bold", cursor: coachSubmitText.trim() && !coachSubmitting ? "pointer" : "default", fontSize: "13px" }}
                      >
                        {coachSubmitting ? "Submitting..." : "Submit as Client"}
                      </button>
                      <div style={{ fontSize: "11px", color: "#94a3b8" }}>A note will be added that this was submitted by coach on behalf of client.</div>
                    </div>
                  </div>
                )}

                {/* 6. Weekly challenge card (habit-level selector) — frozen so admin can't accidentally log */}
                {(() => {
                  const wc = getCurrentWeeklyChallenge(viewDate, client.programTag || "");
                  const isSelected = Boolean(todaySelections.weekly);
                  return (
                    <div style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", marginBottom: "16px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30,58,138,0.10)", pointerEvents: "none", userSelect: "none" }}>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "20px", marginBottom: "10px" }}>{wc.emoji} Weekly Challenge</div>
                      <div style={{
                        padding: "14px 16px", borderRadius: "16px",
                        border: isSelected ? "2px solid #5f7fe0" : "2px solid #bfdbfe",
                        background: isSelected ? "#7c9bff" : "#f5faff",
                        color: isSelected ? "#fff" : "#4b3f57",
                        opacity: isSelected ? 1 : 0.85,
                      }}>
                        <div style={{ fontSize: "12px", opacity: 0.85, letterSpacing: "0.3px" }}>Challenge Accepted (+{wc.xp || 0}) {isSelected ? "✓" : ""}</div>
                        <div style={{ fontWeight: "bold", marginTop: "6px", fontSize: "15px" }}>{wc.text}</div>
                      </div>
                      {!isSelected && <div style={{ color: "#94a3b8", fontSize: "13px", marginTop: "8px" }}>Not selected</div>}
                    </div>
                  );
                })()}

                {/* 7. Scheduled side quests today */}
                {scheduledSQ.length > 0 && (
                  <div style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", marginBottom: "16px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30,58,138,0.10)" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "18px", marginBottom: "14px" }}>📅 Today's Scheduled Quests</div>
                    <div style={{ display: "grid", gap: "10px" }}>
                      {scheduledSQ.map((quest) => {
                        const completed = !!(clientSQCompletions[viewKey]?.[quest.title]);
                        return (
                          <div key={quest.title} style={{ background: completed ? "#e0f2fe" : "#f8fbff", borderRadius: "18px", padding: "14px 16px", border: completed ? "2px solid #2563eb" : "2px solid #bfdbfe", display: "flex", alignItems: "center", gap: "12px" }}>
                            <span style={{ fontSize: "24px", flexShrink: 0 }}>{quest.emoji}</span>
                            <div style={{ flex: 1 }}>
                              <div style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "14px" }}>{quest.title}</div>
                              <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "999px", background: completed ? "#dbeafe" : "#f5faff", border: "2px solid #bfdbfe", color: "#1e3a5f", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}>
                                {completed ? "Done ✓" : `+${quest.xp} XP`}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* 8. Habit cards — frozen so admin can't accidentally log for client */}
                {CATS.map(({ key, label, emoji }) => {
                  const habits = clientHabits[key] || defaultHabits[key];
                  const selected = todaySelections[key];
                  return (
                    <div key={key} style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", marginBottom: "16px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30,58,138,0.10)", pointerEvents: "none", userSelect: "none" }}>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "20px", marginBottom: "10px" }}>{emoji} {label}</div>
                      <div style={{ display: "grid", gap: "10px" }}>
                        {["low", "main", "high"].map((level) => {
                          const habit = (habits && habits[level]) || defaultHabits[key][level];
                          const isSelected = selected === level;
                          return (
                            <div key={level} style={{
                              display: "block", width: "100%", padding: "14px 16px", borderRadius: "16px",
                              border: isSelected ? "2px solid #5f7fe0" : "2px solid #bfdbfe",
                              background: isSelected ? "#7c9bff" : "#f5faff",
                              opacity: selected && !isSelected ? 0.5 : 1,
                              boxSizing: "border-box",
                            }}>
                              <div style={{ fontSize: "12px", opacity: 0.85, letterSpacing: "0.3px", color: isSelected ? "#fff" : "#4b3f57" }}>
                                {habit.label} (+{habit.xp}){isSelected ? " ✓" : ""}
                              </div>
                              <div style={{ fontWeight: "bold", marginTop: "4px", fontSize: "15px", color: isSelected ? "#fff" : "#4b3f57" }}>
                                {habit.habitName}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {!selected && <div style={{ color: "#94a3b8", fontSize: "13px", marginTop: "8px" }}>Not logged today</div>}
                    </div>
                  );
                })}

                {/* 9. Body metrics due today */}
                {isViewingToday && dueBodyMetrics.length > 0 && (
                  <div style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", marginBottom: "16px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30,58,138,0.10)" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "18px", marginBottom: "14px" }}>📊 Body Metrics Due Today</div>
                    <div style={{ display: "grid", gap: "10px" }}>
                      {dueBodyMetrics.map(({ key, label, emoji }) => {
                        const cfg = client.bodyMetricsConfig[key];
                        const logged = !!(client.bodyMetricsXpLog || {})[`${key}_${viewKey}`];
                        return (
                          <div key={key} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px 16px", borderRadius: "18px", background: logged ? "#e0f2fe" : "#f8fbff", border: logged ? "2px solid #2563eb" : "2px solid #bfdbfe" }}>
                            <span style={{ fontSize: "24px", flexShrink: 0 }}>{emoji}</span>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px" }}>{label}</div>
                              <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "999px", background: logged ? "#dbeafe" : "#dcfce7", border: logged ? "2px solid #bfdbfe" : "1px solid #bbf7d0", color: logged ? "#1e3a5f" : "#166534", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}>
                                {logged ? "Logged ✓" : `+${cfg.xp} XP`}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

              </div>
            </div>
          );
        })()}

        {adminTab === "profile" && (() => {
          const { totalXP, level } = getAdminUserXP(selectedAdminUser);
          const earnedBadges = getAdminUserBadges(selectedAdminUser);

          const nutritionCurrent = calculateCategoryCurrentStreak(selectedAdminUser.dailySelections || {}, "nutrition");
          const nutritionLongest = calculateCategoryLongestStreak(selectedAdminUser.dailySelections || {}, "nutrition");

          const movementCurrent = calculateCategoryCurrentStreak(selectedAdminUser.dailySelections || {}, "movement");
          const movementLongest = calculateCategoryLongestStreak(selectedAdminUser.dailySelections || {}, "movement");

          const mindsetCurrent = calculateCategoryCurrentStreak(selectedAdminUser.dailySelections || {}, "mindset");
          const mindsetLongest = calculateCategoryLongestStreak(selectedAdminUser.dailySelections || {}, "mindset");

          const fullCurrent = calculateFullQuestCurrentStreak(selectedAdminUser.dailySelections || {});
          const fullLongest = calculateFullQuestLongestStreak(selectedAdminUser.dailySelections || {});

          const loginCurrent = calculateLoginCurrentStreak(selectedAdminUser.dailyCheckIns || {});
          const loginLongest = calculateLoginLongestStreak(selectedAdminUser.dailyCheckIns || {});

          return (
            <div style={{ display: "grid", gap: "16px", width: "100%", boxSizing: "border-box" }}>
              <div
                style={{
                  background: "#f8fbff",
                  borderRadius: "18px",
                  padding: "18px",
                  border: "2px solid #bfdbfe",
                  boxSizing: "border-box",
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
                  {selectedAdminUser.avatar ? (
                    <img
                      src={selectedAdminUser.avatar}
                      alt={selectedAdminUser.name || "avatar"}
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "999px",
                        objectFit: "cover",
                        border: "2px solid #bfdbfe",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "999px",
                        background: "#e0f2fe",
                        border: "2px solid #bfdbfe",
                      }}
                    />
                  )}

                  <div>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "20px" }}>
                      {selectedAdminUser.name || "No name"}
                    </div>
                    <div style={{ color: "#4b6b8a", fontSize: "14px", marginTop: "4px" }}>
                      {selectedAdminUser.email || "No email"}
                    </div>
                    <div style={{ color: "#1e3a5f", fontSize: "14px", marginTop: "8px", fontWeight: "bold" }}>
                      Level {level} • {totalXP} XP
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  background: "#f8fbff",
                  borderRadius: "18px",
                  padding: "18px",
                  border: "2px solid #bfdbfe",
                }}
              >
                <h3 style={{ marginTop: 0, color: "#1e3a5f" }}>Streak Info</h3>
                <div style={{ color: "#4b6b8a", lineHeight: 1.8 }}>
                  <div>🥕 Nutrition: {nutritionCurrent} current / {nutritionLongest} longest</div>
                  <div>👟 Movement: {movementCurrent} current / {movementLongest} longest</div>
                  <div>🌙 Mindset: {mindsetCurrent} current / {mindsetLongest} longest</div>
                  <div>✨ Full Quest: {fullCurrent} current / {fullLongest} longest</div>
                  <div>📆 Check-in: {loginCurrent} current / {loginLongest} longest</div>
                </div>
              </div>


              <div
                style={{
                  background: "#f8fbff",
                  borderRadius: "18px",
                  padding: "18px",
                  border: "2px solid #bfdbfe",
                }}
              >
                <h3 style={{ marginTop: 0, color: "#1e3a5f" }}>Badges</h3>

                {earnedBadges.length === 0 ? (
                  <div style={{ color: "#4b6b8a" }}>No badges yet</div>
                ) : (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    {earnedBadges.map((badge) => (
  <div
    key={badge.id}
    style={{
      padding: "10px 12px",
      borderRadius: "14px",
      border: "2px solid #bfdbfe",
      background: "#f5faff",
      color: "#1e3a5f",
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      minWidth: "160px",
    }}
  >
    <div style={{ fontSize: "18px", flexShrink: 0 }}>
      {badge.emoji || "🏅"}
    </div>

    <div style={{ lineHeight: 1.2 }}>
      <div
        style={{
          fontSize: "13px",
          fontWeight: "bold",
        }}
      >
        {badge.title || badge.name || "Badge"}
      </div>

      {(badge.subtitle || badge.description) && (
        <div
          style={{
            fontSize: "11px",
            color: "#4b6b8a",
            marginTop: "2px",
          }}
        >
          {badge.subtitle || badge.description}
        </div>
      )}
    </div>
  </div>
))}
                  </div>
                )}
              </div>

            </div>
          );
        })()}




        {adminTab === "log" && (
          <div style={{ display: "grid", gap: "14px" }}>
            {/* Weekly Recap navigator */}
            <WeeklyRecap
              mode="navigable"
              dailySelections={selectedAdminUser.dailySelections || {}}
              sideQuestCompletions={selectedAdminUser.sideQuestCompletions || {}}
              revivedDays={selectedAdminUser.revivedDays || {}}
              challengeCosts={selectedAdminUser.challengeCosts || {}}
              customHabits={selectedAdminUser.customHabits}
              gameContent={gameContent}
              isAdmin
              adminUserName={selectedAdminUser.name || ""}
              categoryLabels={selectedAdminUser.categoryLabels || {}}
            />

            {getAdminLogDays(selectedAdminUser).length === 0 ? (
              <div
                style={{
                  background: "#f8fbff",
                  borderRadius: "18px",
                  padding: "18px",
                  border: "2px solid #bfdbfe",
                  color: "#4b6b8a",
                }}
              >
                No log data yet.
              </div>
            ) : (
              getAdminLogDays(selectedAdminUser).map((day) => (
                <div
                  key={day.dateKey}
                  style={{
                    background: "#f8fbff",
                    borderRadius: "18px",
                    padding: "18px",
                    border: "2px solid #bfdbfe",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#1e3a5f",
                      fontSize: "16px",
                      marginBottom: "12px",
                      paddingBottom: "10px",
                      borderBottom: "1px solid #bfdbfe",
                    }}
                  >
                    {day.dateKey}
                  </div>

                  {day.habits.length > 0 && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={{ fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>
                        Habits
                      </div>
                      {day.habits.map((item, index) => (
                        <div key={index} style={{ color: "#1e3a5f", marginBottom: "4px" }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}

                  {day.quests.length > 0 && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={{ fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>
                        Quests
                      </div>
                      {day.quests.map((item, index) => (
                        <div key={index} style={{ color: "#1e3a5f", marginBottom: "4px" }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}

                  {day.challenges.length > 0 && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={{ fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>
                        Challenges
                      </div>
                      {day.challenges.map((item, index) => (
                        <div key={index} style={{ color: "#1e3a5f", marginBottom: "4px" }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}

                  {day.revives.length > 0 && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={{ fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>
                        Revives
                      </div>
                      {day.revives.map((item, index) => (
                        <div key={index} style={{ color: "#1e3a5f", marginBottom: "4px" }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}

                  {day.tokens.length > 0 && (
                    <div>
                      <div style={{ fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>
                        Tokens
                      </div>
                      {day.tokens.map((item, index) => (
                        <div key={index} style={{ color: "#1e3a5f", marginBottom: "4px" }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}

        {adminTab === "progress" && (() => {
          const client = selectedAdminUser;
          const selections = client.dailySelections || {};
          const revivedDays_ = client.revivedDays || {};
          const sqCompletions = client.sideQuestCompletions || {};
          const customHabits_ = client.customHabits || defaultHabits;
          const catLabels = client.categoryLabels || {};

          const today_ = new Date();
          function dk_(d) { return d.toISOString().slice(0, 10); }
          function daysAgoKeys(n) {
            return Array.from({ length: n }, (_, i) => {
              const d = new Date(today_);
              d.setDate(today_.getDate() - (n - 1 - i));
              return dk_(d);
            });
          }
          function isFullDay_(k) {
            const s = selections[k] || {};
            return !!(s.nutrition && s.movement && s.mindset);
          }

          const last7Keys = daysAgoKeys(7);
          const last30Keys = daysAgoKeys(30);
          const pct7 = Math.round((last7Keys.filter(isFullDay_).length / 7) * 100);
          const pct30 = Math.round((last30Keys.filter(isFullDay_).length / 30) * 100);

          // Simple streak from dailySelections
          const todayKey_ = dk_(today_);
          let streak_ = 0;
          const startI = isFullDay_(todayKey_) ? 0 : 1;
          for (let i = startI; i < 365; i++) {
            const d = new Date(today_); d.setDate(today_.getDate() - i);
            if (isFullDay_(dk_(d))) streak_++;
            else break;
          }

          const reviveCount_ = last30Keys.filter((k) => {
            const r = revivedDays_[k]; return r && (r.nutrition || r.movement || r.mindset);
          }).length;

          // Category completion pcts (last 30)
          const CATS = ["nutrition", "movement", "mindset"];
          const CAT_COLORS = { nutrition: "#38bdf8", movement: "#4ade80", mindset: "#a78bfa" };
          const catPcts = {};
          for (const cat of CATS) {
            catPcts[cat] = Math.round((last30Keys.filter((k) => !!(selections[k] || {})[cat]).length / 30) * 100);
          }

          // Weekly XP chart
          const sqXP = Object.fromEntries((gameContent.sideQuests || []).filter((q) => q.active).map((q) => [q.title, q.xp]));
          function getDayXP_(k) {
            const s = selections[k]; if (!s) return 0;
            return (
              (s.nutrition ? customHabits_.nutrition?.[s.nutrition]?.xp || 0 : 0) +
              (s.movement ? customHabits_.movement?.[s.movement]?.xp || 0 : 0) +
              (s.mindset ? customHabits_.mindset?.[s.mindset]?.xp || 0 : 0) +
              Object.entries(sqCompletions[k] || {}).reduce((sum, [t, done]) => sum + (done ? sqXP[t] || 0 : 0), 0)
            );
          }
          const NUM_WEEKS = 12;
          const sundayBase = new Date(today_);
          sundayBase.setDate(today_.getDate() - today_.getDay());
          sundayBase.setHours(0, 0, 0, 0);
          const weeklyBars = Array.from({ length: NUM_WEEKS }, (_, wi) => {
            const ws = new Date(sundayBase);
            ws.setDate(sundayBase.getDate() - (NUM_WEEKS - 1 - wi) * 7);
            let xp = 0;
            for (let d = 0; d < 7; d++) {
              const day = new Date(ws); day.setDate(ws.getDate() + d);
              xp += getDayXP_(dk_(day));
            }
            return { week: `${ws.getMonth() + 1}/${ws.getDate()}`, xp, isCurrent: wi === NUM_WEEKS - 1 };
          });

          // Coach insight
          const sortedCats = [...CATS].sort((a, b) => catPcts[b] - catPcts[a]);
          const best = sortedCats[0], worst = sortedCats[sortedCats.length - 1];
          const recent4 = weeklyBars.slice(-4).reduce((s, w) => s + w.xp, 0);
          const prior4 = weeklyBars.slice(-8, -4).reduce((s, w) => s + w.xp, 0);
          const trend = recent4 > prior4 * 1.1 ? "up 📈" : recent4 < prior4 * 0.9 ? "down 📉" : "steady ➡️";
          const bestLabel = catLabels[best] || best.charAt(0).toUpperCase() + best.slice(1);
          const worstLabel = catLabels[worst] || worst.charAt(0).toUpperCase() + worst.slice(1);
          const insight = `Strongest in ${bestLabel} (${catPcts[best]}%), weakest in ${worstLabel} (${catPcts[worst]}%). ${reviveCount_} revive${reviveCount_ !== 1 ? "s" : ""} used in the last 30 days. XP trending ${trend}.`;

          const chip = (val, label, color) => (
            <div style={{ flex: 1, minWidth: "70px", background: "#f0f9ff", borderRadius: "14px", padding: "12px 8px", textAlign: "center", border: "2px solid #bfdbfe" }}>
              <div style={{ fontWeight: "bold", fontSize: "22px", color }}>{val}</div>
              <div style={{ fontSize: "11px", color: "#4b6b8a", marginTop: "3px" }}>{label}</div>
            </div>
          );

          return (
            <div style={{ display: "grid", gap: "16px" }}>
              {/* Summary chips */}
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {chip(`${pct7}%`, "Last 7 days", "#1e3a5f")}
                {chip(`${pct30}%`, "Last 30 days", "#1e3a5f")}
                {chip(streak_, "Day streak", streak_ >= 7 ? "#059669" : "#1e3a5f")}
                {chip(reviveCount_, "Revives (30d)", reviveCount_ >= 3 ? "#dc2626" : "#1e3a5f")}
              </div>

              {/* Weekly XP bar chart */}
              <div style={{ background: "#f5faff", borderRadius: "18px", padding: "18px", border: "2px solid #dbeafe" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", marginBottom: "14px" }}>Weekly XP — last 12 weeks</div>
                <ResponsiveContainer width="100%" height={160}>
                  <BarChart data={weeklyBars} margin={{ top: 4, right: 4, left: -28, bottom: 0 }}>
                    <XAxis dataKey="week" tick={{ fontSize: 10, fill: "#4b6b8a" }} interval={1} />
                    <YAxis tick={{ fontSize: 10, fill: "#4b6b8a" }} />
                    <Tooltip formatter={(v) => [`${v} XP`, "XP"]} labelStyle={{ color: "#1e3a5f" }} contentStyle={{ borderRadius: "10px", border: "1px solid #bfdbfe", fontSize: "12px" }} />
                    <Bar dataKey="xp" radius={[4, 4, 0, 0]}>
                      {weeklyBars.map((entry, index) => (
                        <Cell key={index} fill={entry.isCurrent ? "#2563eb" : "#93c5fd"} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {/* Category completion bars */}
              <div style={{ background: "#f5faff", borderRadius: "18px", padding: "18px", border: "2px solid #dbeafe" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", marginBottom: "14px" }}>Category completion — last 30 days</div>
                <div style={{ display: "grid", gap: "12px" }}>
                  {CATS.map((cat) => {
                    const label = catLabels[cat] || cat.charAt(0).toUpperCase() + cat.slice(1);
                    const pct = catPcts[cat];
                    return (
                      <div key={cat}>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#1e3a5f", marginBottom: "5px" }}>
                          <span style={{ fontWeight: "bold" }}>{label}</span>
                          <span>{pct}%</span>
                        </div>
                        <div style={{ height: "10px", borderRadius: "5px", background: "#e2e8f0", overflow: "hidden" }}>
                          <div style={{ width: `${pct}%`, height: "100%", borderRadius: "5px", background: CAT_COLORS[cat], transition: "width 0.4s" }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Coach insight */}
              <div style={{ background: "#fffbeb", borderRadius: "16px", padding: "14px 16px", border: "2px solid #fde68a", fontSize: "13px", color: "#78350f", lineHeight: 1.5 }}>
                💡 {insight}
              </div>
            </div>
          );
        })()}

        {adminTab === "nutrition" && (
          <div>
            {(() => {
              const arrowBtnStyle = { padding: "8px 14px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f8fbff", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer", fontSize: "16px" };
              function shiftNutritionDate(days) {
                const d = new Date(adminNutritionDate + "T12:00:00");
                d.setDate(d.getDate() + days);
                setAdminNutritionDate(d.toISOString().slice(0, 10));
              }
              return (
                <div style={{ marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <button onClick={() => shiftNutritionDate(-1)} style={arrowBtnStyle}>←</button>
                  <input
                    type="date"
                    value={adminNutritionDate}
                    onChange={(e) => setAdminNutritionDate(e.target.value)}
                    style={{ padding: "8px 12px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontSize: "14px", flex: 1 }}
                  />
                  <button onClick={() => shiftNutritionDate(1)} style={arrowBtnStyle}>→</button>
                </div>
              );
            })()}
            <NutritionLog uid={selectedAdminUser.id} date={adminNutritionDate} />
          </div>
        )}

        {adminTab === "assignments" && (
          <div style={{ display: "grid", gap: "14px" }}>
            {adminAssignmentsLoading ? (
              <div style={{ color: "#4b6b8a", padding: "16px" }}>Loading...</div>
            ) : adminUserAssignments.length === 0 ? (
              <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", color: "#4b6b8a" }}>
                No submitted assignments yet.
              </div>
            ) : adminUserAssignments.map(({ prompt, response }) => (
              <div key={response.id} style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px", marginBottom: "4px" }}>{prompt.title}</div>
                <div style={{ color: "#6b8cb0", fontSize: "12px", marginBottom: "10px" }}>
                  Submitted {response.submittedAt?.toDate?.()?.toLocaleDateString?.() || ""}
                  {response.isEdited ? " · edited" : ""}
                  {response.isPrivate ? " · 🔒 private" : ""}
                </div>
                <div style={{ color: "#243b53", whiteSpace: "pre-wrap", lineHeight: "1.6", fontSize: "14px" }}>
                  {response.responseText || <span style={{ color: "#6b8cb0", fontStyle: "italic" }}>No response text</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {adminTab === "stats" && (
          <YouScreen
            currentUser={{ uid: selectedAdminUser.id, name: selectedAdminUser.name, avatar: selectedAdminUser.avatar }}
            defaultSubTab="stats"
            hideNav
            showRecap
            categoryLabels={selectedAdminUser.categoryLabels || {}}
          />
        )}

        {adminTab === "photos" && (
          <YouScreen
            currentUser={{ uid: selectedAdminUser.id, name: selectedAdminUser.name, avatar: selectedAdminUser.avatar }}
            defaultSubTab="photos"
            hideNav
            categoryLabels={selectedAdminUser.categoryLabels || {}}
          />
        )}

        {adminTab === "settings" && (
          <div
            style={{
              background: "#f8fbff",
              borderRadius: "18px",
              padding: "18px",
              border: "2px solid #bfdbfe",
            }}
          >
            {/* Edit mode header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
              <div>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "16px" }}>User Settings</div>
                <div style={{ color: "#4b6b8a", fontSize: "12px", marginTop: "2px" }}>
                  {adminSettingsEditMode ? "Editing — make changes and save" : "Read-only — tap Edit to make changes"}
                </div>
              </div>
              <button
                type="button"
                onClick={() => {
                  setAdminSettingsEditMode((prev) => !prev);
                  setAdminXPAdjustAmount(0);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "12px",
                  border: "none",
                  background: adminSettingsEditMode ? "#fca5a5" : "#38bdf8",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                {adminSettingsEditMode ? "Cancel" : "✏️ Edit"}
              </button>
            </div>

            {/* XP Adjustment — always visible */}
            <div style={{ marginBottom: "18px", padding: "14px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", marginBottom: "4px" }}>
                XP Adjustment
              </div>
              <div style={{ color: "#4b6b8a", fontSize: "12px", marginBottom: "10px" }}>
                Calculated total: <strong>{getAdminUserXP(selectedAdminUser).totalXP} XP</strong>
              </div>
              <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "8px" }}>
                <input
                  type="number"
                  min="0"
                  value={adminXPAdjustAmount}
                  onChange={(e) => setAdminXPAdjustAmount(Math.max(0, Number(e.target.value)))}
                  placeholder="Amount"
                  style={{ ...getAuthInputStyle(), marginTop: 0, flex: 1 }}
                />
                <button
                  type="button"
                  onClick={async () => {
                    const amt = parseInt(adminXPAdjustAmount, 10) || 0;
                    if (amt <= 0 || !selectedAdminUser) return;
                    const currentAdjTotal = parseInt(selectedAdminUser.xpAdjustmentTotal, 10) || 0;
                    const newAdjTotal = currentAdjTotal + amt;
                    try {
                      await addDoc(collection(db, "users", selectedAdminUser.id, "xpAdjustments"), {
                        amount: amt,
                        type: "add",
                        note: adminXPAdjustNote.trim() || "",
                        adminUid: user.uid,
                        adminName: profileName,
                        createdAt: serverTimestamp(),
                      });
                      await setDoc(doc(db, "users", selectedAdminUser.id), { xpAdjustmentTotal: newAdjTotal }, { merge: true });
                      setSelectedAdminUser((prev) => prev ? { ...prev, xpAdjustmentTotal: newAdjTotal } : prev);
                      setAdminXPAdjustAmount(0);
                      setAdminXPAdjustNote("");
                      await loadAllUsers();
                      await loadAdminXPAdjustLog(selectedAdminUser.id);
                    } catch (err) {
                      console.error("XP save error:", err);
                    }
                  }}
                  style={{ padding: "10px 14px", borderRadius: "12px", border: "none", background: "#22c55e", color: "#fff", fontWeight: "bold", cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  + Add
                </button>
                <button
                  type="button"
                  onClick={async () => {
                    const amt = parseInt(adminXPAdjustAmount, 10) || 0;
                    if (amt <= 0 || !selectedAdminUser) return;
                    const currentAdjTotal = parseInt(selectedAdminUser.xpAdjustmentTotal, 10) || 0;
                    const newAdjTotal = currentAdjTotal - amt;
                    try {
                      await addDoc(collection(db, "users", selectedAdminUser.id, "xpAdjustments"), {
                        amount: amt,
                        type: "remove",
                        note: adminXPAdjustNote.trim() || "",
                        adminUid: user.uid,
                        adminName: profileName,
                        createdAt: serverTimestamp(),
                      });
                      await setDoc(doc(db, "users", selectedAdminUser.id), { xpAdjustmentTotal: newAdjTotal }, { merge: true });
                      setSelectedAdminUser((prev) => prev ? { ...prev, xpAdjustmentTotal: newAdjTotal } : prev);
                      setAdminXPAdjustAmount(0);
                      setAdminXPAdjustNote("");
                      await loadAllUsers();
                      await loadAdminXPAdjustLog(selectedAdminUser.id);
                    } catch (err) {
                      console.error("XP save error:", err);
                    }
                  }}
                  style={{ padding: "10px 14px", borderRadius: "12px", border: "none", background: "#f87171", color: "#fff", fontWeight: "bold", cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  − Remove
                </button>
              </div>
              <input
                type="text"
                value={adminXPAdjustNote}
                onChange={(e) => setAdminXPAdjustNote(e.target.value)}
                placeholder="Note (optional)"
                style={{ ...getAuthInputStyle(), marginTop: 0, width: "100%", boxSizing: "border-box" }}
              />
              {/* XP Adjustment Log */}
              <div style={{ marginTop: "14px" }}>
                <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px", marginBottom: "6px" }}>
                  Adjustment Log
                  <button
                    type="button"
                    onClick={() => loadAdminXPAdjustLog(selectedAdminUser.id)}
                    style={{ marginLeft: "8px", padding: "2px 8px", borderRadius: "8px", border: "1px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontSize: "11px", cursor: "pointer" }}
                  >
                    Refresh
                  </button>
                </div>
                {adminXPAdjustLogLoading ? (
                  <div style={{ color: "#4b6b8a", fontSize: "12px" }}>Loading...</div>
                ) : adminXPAdjustLog.length === 0 ? (
                  <div style={{ color: "#4b6b8a", fontSize: "12px" }}>No adjustments yet.</div>
                ) : (
                  <div style={{ display: "grid", gap: "6px", maxHeight: "200px", overflowY: "auto" }}>
                    {adminXPAdjustLog.map((entry) => {
                      const isPositive = entry.type === "earn" || entry.type === "add";
                      const bg = isPositive ? "#f0fdf4" : "#fff1f2";
                      const border = isPositive ? "1px solid #bbf7d0" : "1px solid #fecaca";
                      const color = isPositive ? "#16a34a" : "#dc2626";
                      const prefix = isPositive ? `+${entry.amount}` : `-${entry.amount}`;
                      const byAdmin = entry.type === "add" || entry.type === "remove";
                      return (
                        <div key={entry.id} style={{ padding: "8px 10px", borderRadius: "10px", background: bg, border, fontSize: "12px" }}>
                          <span style={{ fontWeight: "bold", color }}>{prefix} XP</span>
                          {entry.note ? <span style={{ color: "#4b6b8a", marginLeft: "6px" }}>— {entry.note}</span> : null}
                          <div style={{ color: "#9ca3af", marginTop: "2px" }}>
                            {byAdmin ? `${entry.adminName || "Admin"} · ` : ""}{entry.createdAt?.toDate?.()?.toLocaleString?.() || ""}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            {/* Vacation Log */}
            {(() => {
              const userVacations = selectedAdminUser?.vacations || [];
              if (userVacations.length === 0) return null;
              return (
                <div style={{ marginBottom: "18px", padding: "14px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
                  <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px", marginBottom: "10px" }}>🏖️ Vacation Log</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    {[...userVacations].sort((a, b) => b.start.localeCompare(a.start)).map((v) => {
                      const startFmt = new Date(`${v.start}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
                      const endFmt = new Date(`${v.end}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
                      const today = new Date().toISOString().slice(0, 10);
                      const status = v.end < today ? "past" : v.start <= today ? "active" : "upcoming";
                      return (
                        <div key={v.id} style={{ padding: "8px 12px", borderRadius: "10px", background: status === "active" ? "#eff6ff" : "#f8fbff", border: `1px solid ${status === "active" ? "#93c5fd" : "#dbeafe"}`, fontSize: "12px", color: "#1e3a5f" }}>
                          <span style={{ fontWeight: "bold" }}>{startFmt} → {endFmt}</span>
                          <span style={{ marginLeft: "8px", color: status === "active" ? "#2563eb" : status === "upcoming" ? "#7c3aed" : "#6b8cb0", fontWeight: "bold", fontSize: "11px" }}>
                            {status === "active" ? "ACTIVE" : status === "upcoming" ? "UPCOMING" : "PAST"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* All other fields — locked unless in edit mode */}
            <div style={{ opacity: adminSettingsEditMode ? 1 : 0.5, pointerEvents: adminSettingsEditMode ? "auto" : "none" }}>
              <div style={{ marginBottom: "14px" }}>
                <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", textTransform: "uppercase" }}>
                  Status
                </div>
                <select
                  value={adminUserStatus}
                  onChange={(e) => setAdminUserStatus(e.target.value)}
                  style={{ width: "100%", padding: "12px 14px", borderRadius: "14px", border: "2px solid #bfdbfe", background: "#f5faff", fontSize: "15px", boxSizing: "border-box", outline: "none", color: "#1e3a5f" }}
                >
                  <option value="active">Active</option>
                  <option value="paused">Paused</option>
                  <option value="ended">Ended</option>
                </select>
              </div>

              <div style={{ marginBottom: "14px" }}>
                <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", textTransform: "uppercase" }}>
                  Start Date
                </div>
                <input type="date" value={adminUserStartDate} onChange={(e) => setAdminUserStartDate(e.target.value)} style={getAuthInputStyle()} />
              </div>

              <div style={{ marginBottom: "14px" }}>
                <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", textTransform: "uppercase" }}>
                  End Date
                </div>
                <input type="date" value={adminUserEndDate} onChange={(e) => setAdminUserEndDate(e.target.value)} style={getAuthInputStyle()} />
              </div>

              <div style={{ marginBottom: "14px" }}>
                <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", textTransform: "uppercase" }}>
                  Revives Start Date
                </div>
                <input type="date" value={adminReviveStartDate} onChange={(e) => setAdminReviveStartDate(e.target.value)} style={getAuthInputStyle()} />
              </div>

              <div style={{ marginBottom: "18px" }}>
                <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", textTransform: "uppercase" }}>
                  Starting XP (direct set)
                </div>
                <input type="number" value={adminUserStartingXP} onChange={(e) => setAdminUserStartingXP(e.target.value)} style={getAuthInputStyle()} />
              </div>

              <div style={{ marginTop: "12px" }}>
                <div style={{ fontSize: "13px", fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>Program</div>
                <select
                  value={adminUserprogramTag}
                  onChange={(e) => setAdminUserprogramTag(e.target.value)}
                  style={{ width: "100%", padding: "12px 14px", borderRadius: "14px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontSize: "15px", boxSizing: "border-box" }}
                >
                  {AVAILABLE_PROGRAMS.map((program) => (
                    <option key={program.value} value={program.value}>{program.label}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginTop: "12px" }}>
                <div style={{ fontSize: "13px", fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>Hidden Category Tags</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {AVAILABLE_CATEGORY_TAGS.map((tag) => {
                    const isSelected = adminUserCategoryTags.includes(tag.value);
                    return (
                      <button
                        key={tag.value}
                        type="button"
                        onClick={() => {
                          setAdminUserCategoryTags((prev) =>
                            prev.includes(tag.value) ? prev.filter((item) => item !== tag.value) : [...prev, tag.value]
                          );
                        }}
                        style={{ padding: "8px 12px", borderRadius: "999px", border: isSelected ? "2px solid #2563eb" : "2px solid #bfdbfe", background: isSelected ? "#3b82f6" : "#f5faff", color: isSelected ? "#fff" : "#1e3a5f", cursor: "pointer", fontWeight: "bold", fontSize: "13px" }}
                      >
                        {tag.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              <button
                onClick={async () => {
                  await handleSaveAdminUserSettings();
                  setAdminSettingsEditMode(false);
                }}
                style={{ marginTop: "18px", padding: "12px 16px", borderRadius: "14px", border: "none", background: "#38bdf8", color: "#fff", fontWeight: "bold", cursor: "pointer", boxShadow: "0 6px 16px rgba(159, 122, 234, 0.4)" }}
              >
                Save User Settings
              </button>
            </div>

            {/* Admin Habit Override */}
            <div style={{ marginTop: "20px", padding: "16px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "4px" }}>🎯 Habit Name Override</div>
              <div style={{ color: "#4b6b8a", fontSize: "12px", marginBottom: "14px" }}>
                Set this user's habit names directly. They can still edit their own habits — this just sets the starting values.
              </div>
              <AdminHabitOverride
                selectedAdminUser={selectedAdminUser}
                defaultHabits={defaultHabits}
                onSaved={(merged, newLabels) => {
                  setSelectedAdminUser((prev) => prev ? { ...prev, customHabits: merged, categoryLabels: newLabels } : prev);
                  loadAllUsers();
                }}
              />
            </div>

            {/* Body Metrics XP + Schedule Config */}
            <div style={{ marginTop: "20px", padding: "16px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "4px" }}>📊 Body Metrics XP</div>
              <div style={{ color: "#4b6b8a", fontSize: "12px", marginBottom: "14px" }}>
                Set XP rewards and due-day schedules for logging weight, measurements, and progress photos.
              </div>
              <AdminBodyMetricsConfig
                selectedAdminUser={selectedAdminUser}
                onSaved={(cfg) => {
                  setSelectedAdminUser((prev) => prev ? { ...prev, bodyMetricsConfig: cfg } : prev);
                }}
              />
            </div>

            {/* Weekly Goals */}
            <div style={{ marginTop: "20px", padding: "16px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "4px" }}>🎯 Weekly Goals</div>
              <div style={{ color: "#4b6b8a", fontSize: "12px", marginBottom: "14px" }}>
                Set recurring weekly goals for this client. They earn XP when they hit the target for the week. Completing linked side quests auto-counts toward the goal.
              </div>
              <WeeklyHabitsWidget
                habits={selectedAdminUser.weeklyHabits || []}
                completions={selectedAdminUser.weeklyHabitCompletions || {}}
                weekKey={getWeekKey(new Date())}
                onAdd={() => {}}
                onRemove={() => {}}
                onAddHabit={async (habitData) => {
                  const newHabit = { ...habitData, id: Date.now().toString(), createdBy: "admin" };
                  const updated = [...(selectedAdminUser.weeklyHabits || []), newHabit];
                  await updateDoc(doc(db, "users", selectedAdminUser.id), { weeklyHabits: updated });
                  setSelectedAdminUser((prev) => prev ? { ...prev, weeklyHabits: updated } : prev);
                }}
                onDeleteHabit={async (habitId) => {
                  const updated = (selectedAdminUser.weeklyHabits || []).filter((h) => h.id !== habitId);
                  await updateDoc(doc(db, "users", selectedAdminUser.id), { weeklyHabits: updated });
                  setSelectedAdminUser((prev) => prev ? { ...prev, weeklyHabits: updated } : prev);
                }}
                disabled={true}
                activeSideQuests={gameContent.sideQuests?.filter((q) => q.active) || []}
                isAdmin={true}
              />
            </div>

            {/* Weekly Frequency Goals — admin view/edit */}
            <div style={{ marginTop: "20px", padding: "16px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
              <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "4px" }}>📅 Weekly Frequency Goals</div>
              <div style={{ color: "#4b6b8a", fontSize: "12px", marginBottom: "14px" }}>
                View and edit how many times per week this client wants to complete each core habit. Tokens only trigger when the goal is mathematically impossible to reach.
              </div>
              {/* Week start day */}
              <div style={{ marginBottom: "14px" }}>
                <div style={{ fontSize: "12px", fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>Week starts on</div>
                <div style={{ display: "flex", gap: "8px" }}>
                  {[{ val: "sunday", label: "Sunday" }, { val: "monday", label: "Monday" }].map(({ val, label }) => (
                    <button
                      key={val}
                      type="button"
                      onClick={async () => {
                        setAdminUserWeekStartDay(val);
                        await updateDoc(doc(db, "users", selectedAdminUser.id), { weekStartDay: val });
                        setSelectedAdminUser(prev => prev ? { ...prev, weekStartDay: val } : prev);
                      }}
                      style={{
                        padding: "6px 14px", borderRadius: "10px",
                        border: adminUserWeekStartDay === val ? "2px solid #2563eb" : "2px solid #bfdbfe",
                        background: adminUserWeekStartDay === val ? "#dbeafe" : "#f8fbff",
                        color: adminUserWeekStartDay === val ? "#1e3a5f" : "#4b6b8a",
                        fontWeight: adminUserWeekStartDay === val ? 700 : 400,
                        fontSize: "13px", cursor: "pointer",
                      }}
                    >{label}</button>
                  ))}
                </div>
              </div>
              {/* Per-category frequency */}
              {[
                { cat: "nutrition", label: "Nutrition", emoji: "🥗" },
                { cat: "movement", label: "Movement", emoji: "🏃" },
                { cat: "mindset", label: "Mindset", emoji: "🧠" },
              ].map(({ cat, label, emoji }) => (
                <div key={cat} style={{ marginBottom: "14px" }}>
                  <div style={{ fontSize: "13px", fontWeight: "bold", color: "#4b6b8a", marginBottom: "6px" }}>{emoji} {label}</div>
                  <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                    {[null, 1, 2, 3, 4, 5, 6, 7].map((val) => {
                      const isSelected = (adminUserWeeklyGoalFreqs[cat] ?? null) === val;
                      return (
                        <button
                          key={val ?? "off"}
                          type="button"
                          onClick={async () => {
                            const newGoals = { ...adminUserWeeklyGoalFreqs, [cat]: val };
                            setAdminUserWeeklyGoalFreqs(newGoals);
                            const today = new Date().toISOString().slice(0, 10);
                            const existingLog = selectedAdminUser.weeklyGoalFreqsLog || [];
                            const existingIdx = existingLog.findIndex(e => e.date === today);
                            const newLog = existingIdx >= 0
                              ? existingLog.map((e, i) => i === existingIdx ? { ...e, freqs: newGoals } : e)
                              : [...existingLog, { date: today, freqs: newGoals }];
                            await updateDoc(doc(db, "users", selectedAdminUser.id), { weeklyGoalFreqs: newGoals, weeklyGoalFreqsLog: newLog });
                            setSelectedAdminUser(prev => prev ? { ...prev, weeklyGoalFreqs: newGoals, weeklyGoalFreqsLog: newLog } : prev);
                          }}
                          style={{
                            padding: "6px 12px", borderRadius: "8px",
                            border: isSelected ? "2px solid #2563eb" : "2px solid #bfdbfe",
                            background: isSelected ? "#dbeafe" : "#f8fbff",
                            color: isSelected ? "#1e3a5f" : "#4b6b8a",
                            fontWeight: isSelected ? 700 : 400,
                            fontSize: "13px", cursor: "pointer",
                          }}
                        >{val === null ? "Off" : `${val}x`}</button>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>

            {/* Extra Habit Categories — Momentum users only */}
            {(selectedAdminUser.programTag === "momentum") && (
              <div style={{ marginTop: "20px", padding: "16px", borderRadius: "14px", border: "2px solid #dbeafe", background: "#f0f9ff" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
                  <div>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>💪 Extra Habit Categories</div>
                    <div style={{ color: "#4b6b8a", fontSize: "12px", marginTop: "2px" }}>Add up to 2 extra habit categories for this user (Momentum only)</div>
                  </div>
                  {(selectedAdminUser.extraCategories || []).length < 2 && !adminExtraCatOpen && (
                    <button
                      onClick={() => { setAdminExtraCatOpen(true); setAdminExtraCatLabel(""); setAdminExtraCatEmoji(""); }}
                      style={{ padding: "6px 14px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#e0f2fe", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}
                    >+ Add</button>
                  )}
                </div>

                {adminExtraCatOpen && (
                  <div style={{ marginBottom: "14px", padding: "12px", borderRadius: "12px", background: "#f8fbff", border: "1px solid #bfdbfe" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "60px 1fr", gap: "10px", marginBottom: "10px" }}>
                      <div>
                        <div style={{ color: "#4b6b8a", fontSize: "11px", marginBottom: "4px" }}>Emoji</div>
                        <input type="text" value={adminExtraCatEmoji} onChange={(e) => setAdminExtraCatEmoji(e.target.value)} placeholder="💪"
                          style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #bfdbfe", fontSize: "20px", textAlign: "center", boxSizing: "border-box" }} />
                      </div>
                      <div>
                        <div style={{ color: "#4b6b8a", fontSize: "11px", marginBottom: "4px" }}>Category Name</div>
                        <input type="text" value={adminExtraCatLabel} onChange={(e) => setAdminExtraCatLabel(e.target.value)} placeholder="e.g. Sleep"
                          style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #bfdbfe", fontSize: "14px", boxSizing: "border-box" }} />
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        disabled={!adminExtraCatLabel.trim()}
                        onClick={async () => {
                          const existing = selectedAdminUser.extraCategories || [];
                          const key = `extra${existing.length + 1}`;
                          const newCat = { key, label: adminExtraCatLabel.trim(), emoji: adminExtraCatEmoji.trim() || "💪" };
                          const defaultHabitsForCat = {
                            low: { label: "Keep the Streak", habitName: `${adminExtraCatLabel.trim()} (light)`, xp: 10 },
                            main: { label: "Main Quest", habitName: adminExtraCatLabel.trim(), xp: 20 },
                            high: { label: "Extra Credit", habitName: `${adminExtraCatLabel.trim()} (advanced)`, xp: 30 },
                          };
                          const updatedExtra = [...existing, newCat];
                          const updatedHabits = { ...(selectedAdminUser.customHabits || {}), [key]: defaultHabitsForCat };
                          await setDoc(doc(db, "users", selectedAdminUser.id), { extraCategories: updatedExtra, customHabits: updatedHabits }, { merge: true });
                          setSelectedAdminUser((prev) => prev ? { ...prev, extraCategories: updatedExtra, customHabits: updatedHabits } : prev);
                          setAdminExtraCatOpen(false);
                          setAdminExtraCatLabel("");
                          setAdminExtraCatEmoji("");
                        }}
                        style={{ flex: 1, padding: "8px", borderRadius: "10px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "13px", cursor: "pointer", opacity: adminExtraCatLabel.trim() ? 1 : 0.5 }}
                      >Save</button>
                      <button onClick={() => setAdminExtraCatOpen(false)}
                        style={{ flex: 1, padding: "8px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>Cancel</button>
                    </div>
                  </div>
                )}

                {(selectedAdminUser.extraCategories || []).length === 0 && !adminExtraCatOpen && (
                  <div style={{ color: "#6b8cb0", fontSize: "13px" }}>No extra categories yet.</div>
                )}

                {(selectedAdminUser.extraCategories || []).map((cat) => (
                  <div key={cat.key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", borderRadius: "10px", background: "#f8fbff", border: "1px solid #bfdbfe", marginBottom: "8px" }}>
                    <span style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px" }}>{cat.emoji} {cat.label}</span>
                    {adminExtraCatDeleteConfirm === cat.key ? (
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ fontSize: "12px", color: "#991b1b", fontWeight: "bold" }}>Remove?</span>
                        <button onClick={async () => {
                          const updated = (selectedAdminUser.extraCategories || []).filter((c) => c.key !== cat.key);
                          await setDoc(doc(db, "users", selectedAdminUser.id), { extraCategories: updated }, { merge: true });
                          setSelectedAdminUser((prev) => prev ? { ...prev, extraCategories: updated } : prev);
                          setAdminExtraCatDeleteConfirm(null);
                        }} style={{ padding: "4px 10px", borderRadius: "6px", border: "none", background: "#ef4444", color: "#fff", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Yes</button>
                        <button onClick={() => setAdminExtraCatDeleteConfirm(null)}
                          style={{ padding: "4px 10px", borderRadius: "6px", border: "1px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>No</button>
                      </div>
                    ) : (
                      <button onClick={() => setAdminExtraCatDeleteConfirm(cat.key)}
                        style={{ padding: "4px 10px", borderRadius: "6px", border: "1px solid #fecaca", background: "#fff5f5", color: "#991b1b", fontWeight: "bold", fontSize: "12px", cursor: "pointer" }}>Remove</button>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Danger Zone */}
            <div style={{ marginTop: "20px", padding: "18px", borderRadius: "14px", border: "2px solid #fecaca", background: "#fff5f5" }}>
              <div style={{ fontWeight: "bold", color: "#991b1b", fontSize: "15px", marginBottom: "14px" }}>⚠️ Danger Zone</div>

              {resetConfirmStep === 0 && (
                <button
                  onClick={() => { setResetConfirmStep(1); setResetConfirmInput(""); }}
                  style={{ padding: "10px 20px", borderRadius: "10px", border: "2px solid #f87171", background: "#fee2e2", color: "#991b1b", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                >
                  Reset All Progress
                </button>
              )}

              {resetConfirmStep === 1 && (
                <div style={{ display: "grid", gap: "12px" }}>
                  <div style={{ color: "#991b1b", fontWeight: "bold", fontSize: "14px" }}>
                    This will permanently erase ALL progress for {selectedAdminUser.name || "this user"} — XP, streaks, badges, habits, side quests, shields, revives, and check-ins. This cannot be undone.
                  </div>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      onClick={() => setResetConfirmStep(2)}
                      style={{ padding: "10px 20px", borderRadius: "10px", border: "2px solid #f87171", background: "#fee2e2", color: "#991b1b", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                    >
                      Yes, I understand — continue
                    </button>
                    <button
                      onClick={() => setResetConfirmStep(0)}
                      style={{ padding: "10px 20px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {/* Separator between Reset and Delete */}
              <div style={{ margin: "18px 0", borderTop: "1px solid #fecaca" }} />

              {/* Delete Account */}
              {deleteAccountStep === 0 && (
                <button
                  onClick={() => { setDeleteAccountStep(1); setDeleteAccountError(""); }}
                  style={{ padding: "10px 20px", borderRadius: "10px", border: "2px solid #dc2626", background: "#dc2626", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                >
                  🗑 Delete Account
                </button>
              )}

              {deleteAccountStep === 1 && (
                <div style={{ display: "grid", gap: "12px" }}>
                  <div style={{ color: "#991b1b", fontWeight: "bold", fontSize: "14px" }}>
                    Permanently delete <strong>{selectedAdminUser.name || "this user"}</strong>'s account? Their Firebase Auth login and all Firestore data will be erased. They can re-register with the same email. This cannot be undone.
                  </div>
                  <div>
                    <div style={{ color: "#991b1b", fontSize: "13px", marginBottom: "6px" }}>Type <strong>DELETE</strong> to confirm:</div>
                    <input
                      type="text"
                      value={deleteAccountConfirmText}
                      onChange={(e) => setDeleteAccountConfirmText(e.target.value)}
                      placeholder="DELETE"
                      style={{ padding: "10px 14px", borderRadius: "10px", border: "2px solid #f87171", fontSize: "14px", outline: "none", background: "#fff", width: "100%", boxSizing: "border-box" }}
                    />
                  </div>
                  {deleteAccountError && (
                    <div style={{ color: "#dc2626", fontSize: "13px", fontWeight: "bold" }}>{deleteAccountError}</div>
                  )}
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      disabled={deleteAccountConfirmText !== "DELETE"}
                      onClick={async () => {
                        setDeleteAccountStep(2);
                        setDeleteAccountError("");
                        try {
                          const fn = httpsCallable(getFunctions(), "deleteUserAccount");
                          await fn({ uid: selectedAdminUser.id });
                          setSelectedAdminUser(null);
                          loadAllUsers();
                        } catch (err) {
                          setDeleteAccountError(err.message || "Failed to delete account.");
                          setDeleteAccountStep(1);
                        }
                      }}
                      style={{
                        padding: "10px 20px", borderRadius: "10px", border: "2px solid #dc2626",
                        background: deleteAccountConfirmText === "DELETE" ? "#dc2626" : "#fca5a5",
                        color: "#fff", fontWeight: "bold", fontSize: "14px",
                        cursor: deleteAccountConfirmText === "DELETE" ? "pointer" : "not-allowed",
                      }}
                    >
                      Yes, Delete Permanently
                    </button>
                    <button
                      onClick={() => { setDeleteAccountStep(0); setDeleteAccountError(""); setDeleteAccountConfirmText(""); }}
                      style={{ padding: "10px 20px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {deleteAccountStep === 2 && (
                <div style={{ color: "#991b1b", fontWeight: "bold", fontSize: "14px" }}>Deleting account...</div>
              )}

              {resetConfirmStep === 2 && (
                <div style={{ display: "grid", gap: "12px" }}>
                  <div style={{ color: "#991b1b", fontWeight: "bold", fontSize: "14px" }}>
                    Final confirmation: type <strong>{selectedAdminUser.name || "their name"}</strong> exactly to unlock the reset.
                  </div>
                  <input
                    type="text"
                    value={resetConfirmInput}
                    onChange={(e) => setResetConfirmInput(e.target.value)}
                    placeholder={`Type "${selectedAdminUser.name || "their name"}" to confirm`}
                    style={{ padding: "10px 14px", borderRadius: "10px", border: "2px solid #f87171", fontSize: "14px", outline: "none", background: "#fff" }}
                  />
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      onClick={handleResetUserData}
                      disabled={resetConfirmInput.trim() !== (selectedAdminUser.name || "").trim() || resetInProgress}
                      style={{
                        padding: "10px 20px", borderRadius: "10px", border: "2px solid #dc2626",
                        background: resetConfirmInput.trim() === (selectedAdminUser.name || "").trim() ? "#dc2626" : "#fca5a5",
                        color: "#fff", fontWeight: "bold", fontSize: "14px",
                        cursor: resetConfirmInput.trim() === (selectedAdminUser.name || "").trim() ? "pointer" : "not-allowed",
                        opacity: resetInProgress ? 0.6 : 1,
                      }}
                    >
                      {resetInProgress ? "Resetting..." : "Reset Everything"}
                    </button>
                    <button
                      onClick={() => { setResetConfirmStep(0); setResetConfirmInput(""); }}
                      style={{ padding: "10px 20px", borderRadius: "10px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )}
  </div>
)}
        {activeScreen === "workouts" && hasFeature("workouts") && (
          <div style={{ background: "#f5faff", borderRadius: "22px", padding: "24px", marginTop: "20px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)" }}>
            <WorkoutsScreen
              userId={user.uid}
              programTag={userprogramTag}
              videoGender={videoGender}
              onVideoGenderChange={(g) => setVideoGender(g)}
              onWorkoutComplete={handleWorkoutAutoSideQuest}
              onWorkoutDeleted={handleWorkoutDeleted}
              workoutAutoSideQuest={workoutAutoSideQuest}
              onWorkoutAutoSideQuestChange={async (val) => {
                setWorkoutAutoSideQuest(val);
                await updateDoc(doc(db, "users", user.uid), { workoutAutoSideQuest: val });
              }}
              activeSideQuests={activeSideQuests}
              scheduleStartWorkout={scheduleStartWorkout}
              onScheduleStartConsumed={() => setScheduleStartWorkout(null)}
            />
          </div>
        )}

        {activeScreen === "you" && (
          <YouScreen
            currentUser={{ uid: user.uid, name: profileName, avatar: selectedAvatar }}
            dailySelections={dailySelections}
            revivedDays={revivedDays}
            customHabits={customHabits}
            gameContent={gameContent}
            onVideoGenderChange={(g) => setVideoGender(g)}
            isMomentum={userprogramTag === "momentum"}
            sideQuestCompletions={sideQuestCompletions}
            activeSideQuests={activeSideQuests}
            categoryLabels={categoryLabels}
            bodyMetricsConfig={bodyMetricsConfig}
            bodyMetricsXpLog={bodyMetricsXpLog}
            onNavigateToSettings={() => setActiveScreen("customize")}
            onBodyMetricXpAwarded={(metricKey, dateStr, xpAmount) => {
              setXpAdjustmentTotal((prev) => prev + xpAmount);
              setBodyMetricsXpLog((prev) => ({ ...prev, [`${metricKey}_${dateStr}`]: xpAmount }));
            }}
            initAction={youInitAction}
            onInitActionConsumed={() => setYouInitAction(null)}
            profileData={{
              level,
              totalXP,
              leaderboardVisible: isLeaderboardVisibleForProgram(userprogramTag),
              leaderboardEntries: getLeaderboardEntriesForProgram(),
              streakShield,
              shieldEarnProgressStart,
              shieldActivatedDays,
              streaks: [
                { title: categoryLabels.nutrition || "Nutrition", emoji: categoryEmojis.nutrition, current: nutritionCurrentStreak, longest: nutritionLongestStreak },
                { title: categoryLabels.movement || "Movement", emoji: categoryEmojis.movement, current: movementCurrentStreak, longest: movementLongestStreak },
                { title: categoryLabels.mindset || "Mindset", emoji: categoryEmojis.mindset, current: mindsetCurrentStreak, longest: mindsetLongestStreak },
                { title: "Full Quest", emoji: "🔥", current: fullQuestCurrentStreak, longest: fullQuestLongestStreak },
                { title: "Challenge", emoji: "⭐", current: challengeCurrentStreak, longest: challengeLongestStreak },
                { title: "Login", emoji: "📱", current: loginCurrentStreak, longest: loginLongestStreak },
              ],
              badges: earnedBadges,
            }}
          />
        )}

        {activeScreen === "feed" && (
          <div style={{ marginTop: "8px" }}>
            {/* Community sub-tabs */}
            <div style={{ display: "flex", gap: "8px", marginBottom: "18px", flexWrap: "wrap" }}>
              {[
                { key: "feed", label: "Feed" },
                { key: "assignments", label: "Assignments" },
                { key: "calls", label: "Calls" },
              ].map(({ key, label }) => (
                <button
                  key={key}
                  onClick={() => setCommunitySubTab(key)}
                  style={{ padding: "8px 16px", borderRadius: "20px", border: communitySubTab === key ? "2px solid #2563eb" : "2px solid #bfdbfe", background: communitySubTab === key ? "#2563eb" : "#f5faff", color: communitySubTab === key ? "#fff" : "#1e3a5f", fontWeight: "bold", fontSize: "13px", cursor: "pointer" }}>
                  {label}
                </button>
              ))}
            </div>

            {communitySubTab === "feed" && (
              <CommunityFeed
                currentUser={{ uid: user.uid, name: profileName, avatar: selectedAvatar, programTag: userprogramTag }}
                isAdmin={isAdmin}
                notifPrefs={communityNotifPrefs}
                onUpdateNotifPrefs={handleUpdateCommunityNotifPrefs}
                highlightPostId={highlightPostId}
                onClearHighlight={() => setHighlightPostId(null)}
              />
            )}

            {communitySubTab === "assignments" && (
              <div style={{ background: "#f5faff", borderRadius: "22px", padding: "20px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
                  <h3 style={{ margin: 0, color: "#1e3a5f", fontSize: "18px" }}>Weekly Quest Assignments</h3>
                  <button type="button" onClick={() => setInfoPopup("questAssignments")} style={{ background: "transparent", border: "1px solid #bfdbfe", borderRadius: "8px", padding: "5px 7px", cursor: "pointer", color: "#6b7280", display: "flex", alignItems: "center" }}><svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg></button>
                </div>
                <AssignmentsScreen
                  currentUser={{ uid: user.uid, name: profileName, avatar: selectedAvatar, programTag: userprogramTag }}
                  isAdmin={isAdmin}
                  onXpAwarded={(amount) => setXpAdjustmentTotal((prev) => prev + amount)}
                />
              </div>
            )}

            {communitySubTab === "calls" && (
              <>
                {/* Recurring weekly call */}
                {recurringCallConfig?.active && nextCallOccurrences.length > 0 && (() => {
                  // Audience filter
                  const rcTarget = recurringCallConfig.targetType || "program";
                  if (rcTarget === "users") {
                    if (!(recurringCallConfig.targetUserIds || []).includes(user?.uid)) return null;
                  } else {
                    if (recurringCallConfig.programTag && recurringCallConfig.programTag !== userprogramTag) return null;
                  }
                  const nextDate = nextCallOccurrences[0];
                  const dateKey = dateKeyFromDate(nextDate);
                  const poll = nextCallPolls[dateKey];
                  if (poll?.status === "cancelled") return null;
                  const scheduledTime = poll?.scheduledTime || nextDate;
                  return (
                    <RecurringCallCard
                      key={dateKey}
                      occurrence={{ dateKey, title: recurringCallConfig.title || "Weekly Group Call", scheduledTime }}
                      pollData={poll}
                      currentUser={{ uid: user?.uid, name: profileName }}
                    />
                  );
                })()}
                <CallsScreen
                currentUser={{ uid: user?.uid, name: profileName, avatar: selectedAvatar, programTag: userprogramTag }}
                groupCall={groupCall}
                pollBroadcast={callPollBroadcast}
                isAdmin={isAdmin}
                onInCallChange={(v) => setInActiveCall(v)}
                onCallVoted={async (opt) => {
                  if (!groupCall?.pollBroadcastId || !user?.uid) return;
                  await submitBroadcastResponse({
                    broadcastId: groupCall.pollBroadcastId,
                    broadcastTitle: callPollBroadcast?.title || "",
                    userId: user.uid,
                    userName: profileName,
                    userAvatar: selectedAvatar,
                    type: "call_poll",
                    comment: "",
                    selections: [opt],
                    programTag: userprogramTag,
                    callId: groupCall.id,
                    options: callPollBroadcast?.options || [],
                  });
                  setCallPollBroadcast((prev) => prev ? {
                    ...prev,
                    responses: [...(prev.responses || []).filter((r) => r.userId !== user.uid), { userId: user.uid, selections: [opt] }],
                  } : prev);
                }}
              />
              </>
            )}
          </div>
        )}

        {activeScreen === "messages" && (
          <div style={{ background: "#f5faff", borderRadius: "22px", padding: "24px", marginTop: "20px", border: "2px solid #dbeafe", boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)" }}>
            <h2 style={{ marginTop: 0, marginBottom: "16px", color: "#1e3a5f", fontSize: "22px" }}>
              {isAdmin ? "Messages" : "Coach Messages"}
            </h2>

            {/* Tab bar — only show for non-admin clients */}
            {!isAdmin && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
                <button
                  onClick={() => setMessagesTab("direct")}
                  style={{ padding: "8px 16px", borderRadius: "12px", border: messagesTab === "direct" ? "2px solid #2563eb" : "2px solid #bfdbfe", background: messagesTab === "direct" ? "#e0f2fe" : "#f8fbff", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}
                >
                  💬 Direct Messages
                </button>
                <button
                  onClick={() => {
                    setMessagesTab("broadcasts");
                    setBroadcastConvosLoading(true);
                    getAllBroadcastResponsesForUser(user.uid)
                      .then(setBroadcastConvos)
                      .catch(console.error)
                      .finally(() => setBroadcastConvosLoading(false));
                  }}
                  style={{ padding: "8px 16px", borderRadius: "12px", border: messagesTab === "broadcasts" ? "2px solid #2563eb" : "2px solid #bfdbfe", background: messagesTab === "broadcasts" ? "#e0f2fe" : "#f8fbff", color: "#1e3a5f", fontWeight: "bold", cursor: "pointer", fontSize: "13px" }}
                >
                  📢 Broadcast Convos
                </button>
              </div>
            )}

            {/* Direct messages tab (always shown for admin, or when tab = direct) */}
            {(isAdmin || messagesTab === "direct") && (
              <DirectMessages
                currentUser={{ uid: user.uid, name: profileName, avatar: selectedAvatar }}
                isCoach={isAdmin}
                coachInfo={isAdmin ? null : coachInfo}
                allUsers={allUsers}
              />
            )}

            {/* Broadcast conversations tab */}
            {!isAdmin && messagesTab === "broadcasts" && (
              <div>
                {broadcastConvosLoading ? (
                  <div style={{ color: "#4b6b8a", fontSize: "14px" }}>Loading...</div>
                ) : broadcastConvos.length === 0 ? (
                  <div style={{ color: "#4b6b8a", fontSize: "14px" }}>No broadcast conversations yet.</div>
                ) : (
                  <div style={{ display: "grid", gap: "12px" }}>
                    {broadcastConvos.map((r) => {
                      const hasConvo = r.comment || r.adminReaction || r.adminReply || r.clientReply;
                      return (
                        <div key={r.id} style={{ background: "#fff", borderRadius: "16px", border: "2px solid #bfdbfe", padding: "16px", display: "grid", gap: "10px" }}>
                          <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "14px" }}>
                            📢 {r.broadcastTitle || "Broadcast"}
                          </div>
                          {r.submittedByCoach && (
                            <div style={{ fontSize: "11px", color: "#94a3b8", fontStyle: "italic" }}>{r.coachNote}</div>
                          )}
                          {r.comment && (
                            <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe", fontSize: "14px", color: "#243b53" }}>
                              <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>You:</span>
                              <RichTextDisplay html={r.comment} style={{ display: "inline", color: "#243b53" }} />
                            </div>
                          )}
                          {r.selections?.length > 0 && (
                            <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe", fontSize: "14px", color: "#243b53" }}>
                              <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>You selected:</span>{r.selections.join(", ")}
                            </div>
                          )}
                          {r.adminReaction && <div style={{ fontSize: "22px" }}>{r.adminReaction}</div>}
                          {r.adminReply && (
                            <div style={{ background: "#e0f2fe", borderRadius: "12px", padding: "10px 14px", border: "2px solid #93c5fd", fontSize: "14px", color: "#1e3a5f" }}>
                              <span style={{ fontWeight: "bold", color: "#2563eb", marginRight: "6px" }}>{coachInfo?.name || "Coach"}:</span>
                              <RichTextDisplay html={r.adminReply} style={{ display: "inline", color: "#1e3a5f" }} />
                            </div>
                          )}
                          {r.clientReply && (
                            <div style={{ background: "#f8fbff", borderRadius: "12px", padding: "10px 14px", border: "1.5px solid #dbeafe", fontSize: "14px", color: "#243b53" }}>
                              <span style={{ fontWeight: "bold", color: "#4b6b8a", marginRight: "6px" }}>You replied:</span>
                              <RichTextDisplay html={r.clientReply} style={{ display: "inline", color: "#243b53" }} />
                            </div>
                          )}
                          {/* Reply input if coach has replied and client hasn't yet */}
                          {r.adminReply && !r.clientReply && (
                            <BroadcastConvoReply
                              responseId={r.id}
                              onSent={(text) => setBroadcastConvos((prev) => prev.map((x) => x.id === r.id ? { ...x, clientReply: text } : x))}
                            />
                          )}
                          {!hasConvo && <div style={{ color: "#94a3b8", fontSize: "12px" }}>No conversation yet.</div>}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {activeScreen === "customize" && (
          <div
            style={{
              background: "#f5faff",
              borderRadius: "22px",
              padding: "24px",
              marginTop: "20px",
              border: "2px solid #dbeafe",
              boxShadow: "0 8px 20px rgba(30, 58, 138, 0.10)",
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: "16px", color: "#1e3a5f", fontSize: "28px" }}>
              ⚙️ Settings
            </h2>

            {/* Profile picture + name */}
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <button
                  type="button"
                  onClick={() => setIsEditingAvatar(true)}
                  style={{ background: "transparent", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}
                >
                  {selectedAvatar ? (
                    <img src={selectedAvatar} alt="Profile" style={{ width: "80px", height: "80px", borderRadius: "50%", objectFit: "cover", border: "3px solid #bfdbfe" }} />
                  ) : (
                    <div style={{ width: "80px", height: "80px", borderRadius: "50%", background: "#e0f2fe", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "36px", border: "3px solid #bfdbfe" }}>👤</div>
                  )}
                  <span style={{ fontSize: "12px", color: "#4b6b8a", fontWeight: "bold" }}>Tap to change photo</span>
                </button>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "17px" }}>{[profileFirstName, profileLastName].filter(Boolean).join(" ") || profileName}</span>
                  <button type="button" onClick={() => setShowNameEditModal(true)} style={{ background: "transparent", border: "none", cursor: "pointer", padding: "2px", display: "flex", alignItems: "center", color: "#94a3b8" }} title="Edit name">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                </div>
              </div>
            </div>

            {/* Name edit modal */}
            {showNameEditModal && (
              <div style={{ position: "fixed", inset: 0, background: "rgba(30,58,138,0.18)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }} onClick={(e) => { if (e.target === e.currentTarget) setShowNameEditModal(false); }}>
                <div style={{ background: "#f5faff", borderRadius: "22px", padding: "24px", width: "100%", maxWidth: "380px", border: "2px solid #dbeafe", boxShadow: "0 12px 32px rgba(30,58,138,0.18)" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "16px", color: "#1e3a5f", fontSize: "20px" }}>Edit Your Name</h3>
                  <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
                    <input type="text" placeholder="First name" value={profileFirstName} onChange={(e) => setProfileFirstName(e.target.value)} style={{ flex: 1, padding: "10px 14px", borderRadius: "12px", border: "2px solid #bfdbfe", fontSize: "15px", color: "#1e3a5f", background: "#fff", outline: "none" }} />
                    <input type="text" placeholder="Last name" value={profileLastName} onChange={(e) => setProfileLastName(e.target.value)} style={{ flex: 1, padding: "10px 14px", borderRadius: "12px", border: "2px solid #bfdbfe", fontSize: "15px", color: "#1e3a5f", background: "#fff", outline: "none" }} />
                  </div>
                  <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", marginBottom: "18px" }}>
                    <input type="checkbox" checked={showLastNameInitial} onChange={(e) => setShowLastNameInitial(e.target.checked)} style={{ width: "18px", height: "18px", accentColor: "#2563eb", flexShrink: 0 }} />
                    <span style={{ fontSize: "13px", color: "#4b6b8a", lineHeight: 1.4 }}>Show only last initial in community (e.g. <strong>{profileFirstName || "Ashley"} {profileLastName ? profileLastName[0] + "." : "C."}</strong>)</span>
                  </label>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button type="button" onClick={() => setShowNameEditModal(false)} style={{ flex: 1, padding: "12px", borderRadius: "12px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#4b6b8a", fontWeight: "bold", fontSize: "15px", cursor: "pointer" }}>Cancel</button>
                    <button type="button" onClick={handleSaveName} style={{ flex: 1, padding: "12px", borderRadius: "12px", background: "#2563eb", color: "#fff", border: "none", fontWeight: "bold", fontSize: "15px", cursor: "pointer" }}>Save</button>
                  </div>
                </div>
              </div>
            )}

            {/* Subtab navigation */}
            <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap" }}>
              {[
                { key: "tracking", label: "📊 Tracking" },
                { key: "reminders", label: "🔔 Reminders" },
                { key: "vacation", label: "🏖️ Vacation" },
                { key: "goals", label: "🎯 Goals" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setCustomizeTab(tab.key)}
                  style={{
                    padding: "10px 16px",
                    borderRadius: "14px",
                    border: customizeTab === tab.key ? "2px solid #2563eb" : "2px solid #bfdbfe",
                    background: customizeTab === tab.key ? "#e0f2fe" : "#f8fbff",
                    color: "#1e3a5f",
                    fontWeight: "bold",
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* ── TAB: Tracking ── */}
            {customizeTab === "tracking" && (
              <>
                <p style={{ color: "#4b6b8a", marginTop: 0, marginBottom: "16px", fontSize: "14px", lineHeight: 1.5 }}>
                  Choose which tracking tools appear on your dashboard.
                </p>

                {/* Nutrition Tracking section */}
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "6px", color: "#1e3a5f", fontSize: "20px" }}>🥗 Nutrition Tracking</h3>
                  <p style={{ marginTop: 0, marginBottom: "14px", color: "#4b6b8a", fontSize: "13px", lineHeight: 1.5 }}>
                    Choose one option to show on your dashboard, or turn both off.
                  </p>

                  {/* Meal Photo Log */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #dbeafe" }}>
                    <div>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>📷 Meal photo log</div>
                      <div style={{ color: "#6b8cb0", fontSize: "13px", marginTop: "2px" }}>Log meals with photos each day</div>
                    </div>
                    <button type="button" onClick={handleToggleNutritionTracking} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: nutritionTrackingEnabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
                      <div style={{ position: "absolute", top: "3px", left: nutritionTrackingEnabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                    </button>
                  </div>

                  {/* Hand Portion Log */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: hasFeature("macroTracking") ? "1px solid #dbeafe" : "none" }}>
                    <div>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>🤚 Hand portion tracker</div>
                      <div style={{ color: "#6b8cb0", fontSize: "13px", marginTop: "2px" }}>Precision Nutrition hand-portion system</div>
                    </div>
                    <button type="button" onClick={handleTogglePortionTracking} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: portionTrackingEnabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
                      <div style={{ position: "absolute", top: "3px", left: portionTrackingEnabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                    </button>
                  </div>

                  {/* Macro Tracker */}
                  {hasFeature("macroTracking") && (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0" }}>
                      <div>
                        <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>📊 Macro tracker</div>
                        <div style={{ color: "#6b8cb0", fontSize: "13px", marginTop: "2px" }}>Track protein, carbs, fat & calories</div>
                      </div>
                      <button type="button" onClick={handleToggleMacroTracking} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: macroTrackingEnabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
                        <div style={{ position: "absolute", top: "3px", left: macroTrackingEnabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                      </button>
                    </div>
                  )}
                </div>

                {/* Weekly Goals */}
                {hasFeature("weeklyGoals") && (
                  <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div>
                        <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>🎯 Weekly Goals</div>
                        <div style={{ color: "#6b8cb0", fontSize: "13px", marginTop: "2px" }}>Track recurring weekly goals on your dashboard</div>
                      </div>
                      <button type="button" onClick={handleToggleWeeklyGoals} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: weeklyGoalsEnabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
                        <div style={{ position: "absolute", top: "3px", left: weeklyGoalsEnabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                      </button>
                    </div>
                  </div>
                )}

                {/* Water Tracker */}
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px" }}>💧 Water tracker</div>
                      <div style={{ color: "#6b8cb0", fontSize: "13px", marginTop: "2px" }}>Set a glass goal and log daily intake</div>
                    </div>
                    <button type="button" onClick={handleToggleWaterTracking} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: waterTrackingEnabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
                      <div style={{ position: "absolute", top: "3px", left: waterTrackingEnabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                    </button>
                  </div>
                </div>

                {/* Log Out */}
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginTop: "4px" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a5f", fontSize: "20px" }}>Account</h3>
                  <button type="button" onClick={handleLogout} style={{ width: "100%", padding: "14px", borderRadius: "16px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "16px", cursor: "pointer" }}>Log Out</button>
                </div>
              </>
            )}

            {/* ── TAB 3: Reminders ── */}
            {customizeTab === "reminders" && (
              <>
                {/* Notifications */}
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "8px", color: "#1e3a5f", fontSize: "20px" }}>Notifications</h3>
                  <p style={{ marginTop: 0, marginBottom: "14px", color: "#4b6b8a", fontSize: "13px" }}>Set your reminder times and toggles for daily check-ins.</p>

                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                    <span style={{ color: "#1e3a5f", fontWeight: "bold", fontSize: "14px" }}>Push notifications</span>
                    <button type="button" onClick={handleTogglePushNotifications} style={{ width: "52px", height: "28px", borderRadius: "999px", border: "none", background: notificationsEnabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative" }}>
                      <div style={{ position: "absolute", top: "3px", left: notificationsEnabled ? "27px" : "3px", width: "22px", height: "22px", borderRadius: "999px", background: "#fff", transition: "left 0.2s" }} />
                    </button>
                  </div>

                  <div style={{ display: "grid", gap: "10px", marginBottom: "12px" }}>
                    <div style={{ display: "grid", gap: "6px", border: "1px solid #dbeafe", borderRadius: "12px", padding: "10px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ color: "#1e3a5f", fontSize: "14px", fontWeight: "bold" }}>Daily habit reminder</span>
                        <button type="button" onClick={() => handleReminderToggle("dailyHabitReminder", !(notificationSettings.dailyHabitReminder?.enabled === true))} style={{ width: "44px", height: "24px", borderRadius: "999px", border: "none", background: notificationSettings.dailyHabitReminder?.enabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative" }}>
                          <div style={{ position: "absolute", top: "2px", left: notificationSettings.dailyHabitReminder?.enabled ? "22px" : "2px", width: "20px", height: "20px", borderRadius: "999px", background: "#fff" }} />
                        </button>
                      </div>
                      <input type="time" step="300" value={notificationSettings.dailyHabitReminder?.time || "09:00"} onChange={(e) => handleReminderTime("dailyHabitReminder", e.target.value)} style={{ ...getAuthInputStyle(), marginTop: 0 }} />
                    </div>
                    <div style={{ display: "grid", gap: "6px", border: "1px solid #dbeafe", borderRadius: "12px", padding: "10px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ color: "#1e3a5f", fontSize: "14px", fontWeight: "bold" }}>Streak risk reminder</span>
                        <button type="button" onClick={() => handleReminderToggle("streakRiskReminder", !(notificationSettings.streakRiskReminder?.enabled === true))} style={{ width: "44px", height: "24px", borderRadius: "999px", border: "none", background: notificationSettings.streakRiskReminder?.enabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative" }}>
                          <div style={{ position: "absolute", top: "2px", left: notificationSettings.streakRiskReminder?.enabled ? "22px" : "2px", width: "20px", height: "20px", borderRadius: "999px", background: "#fff" }} />
                        </button>
                      </div>
                      <input type="time" step="300" value={notificationSettings.streakRiskReminder?.time || "09:00"} onChange={(e) => handleReminderTime("streakRiskReminder", e.target.value)} style={{ ...getAuthInputStyle(), marginTop: 0 }} />
                    </div>
                    <div style={{ display: "grid", gap: "6px", border: "1px solid #dbeafe", borderRadius: "12px", padding: "10px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ color: "#1e3a5f", fontSize: "14px", fontWeight: "bold" }}>Due today reminder</span>
                        <button type="button" onClick={() => handleDueReminderToggle(!(notificationSettings.dueReminder?.enabled === true))} style={{ width: "44px", height: "24px", borderRadius: "999px", border: "none", background: notificationSettings.dueReminder?.enabled ? "#2563eb" : "#d1c4e9", cursor: "pointer", position: "relative" }}>
                          <div style={{ position: "absolute", top: "2px", left: notificationSettings.dueReminder?.enabled ? "22px" : "2px", width: "20px", height: "20px", borderRadius: "999px", background: "#fff" }} />
                        </button>
                      </div>
                      <input type="time" step="300" value={notificationSettings.dueReminder?.time || "09:00"} onChange={(e) => handleDueReminderTime(e.target.value)} style={{ ...getAuthInputStyle(), marginTop: 0 }} />
                    </div>
                  </div>

                  <div>
                    <div style={{ color: "#4b6b8a", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", textTransform: "uppercase" }}>Time zone</div>
                    <select value={userTimezone} onChange={(e) => handleTimezoneChange(e.target.value)} style={{ ...getAuthInputStyle(), marginTop: 0 }}>
                      <option value="America/New_York">Eastern (America/New_York)</option>
                      <option value="America/Chicago">Central (America/Chicago)</option>
                      <option value="America/Denver">Mountain (America/Denver)</option>
                      <option value="America/Los_Angeles">Pacific (America/Los_Angeles)</option>
                    </select>
                  </div>
                </div>

                {/* Onboarding re-watch */}
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "8px", color: "#1e3a5f", fontSize: "20px" }}>📖 App Walkthrough</h3>
                  <p style={{ marginTop: 0, marginBottom: "14px", color: "#4b6b8a", fontSize: "13px" }}>Replay the onboarding walkthrough to review how the app works.</p>
                  <button
                    type="button"
                    onClick={() => setShowOnboarding(true)}
                    style={{ width: "100%", padding: "12px", borderRadius: "14px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "15px", cursor: "pointer" }}
                  >
                    ▶ Replay Walkthrough
                  </button>
                </div>

{/* Log Out button for Tab 3 */}
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a5f", fontSize: "20px" }}>Account</h3>
                  <button type="button" onClick={handleLogout} style={{ width: "100%", padding: "14px", borderRadius: "16px", border: "2px solid #bfdbfe", background: "#f5faff", color: "#1e3a5f", fontWeight: "bold", fontSize: "16px", cursor: "pointer" }}>Log Out</button>
                </div>
              </>
            )}

            {/* ── TAB 4: Vacation ── */}
            {customizeTab === "vacation" && (
              <VacationTab
                vacations={vacations}
                onAdd={handleAddVacation}
                onRemove={handleRemoveVacation}
                vacationModeActive={vacationModeActive}
                onToggleVacationMode={handleToggleVacationMode}
              />
            )}

            {/* ── TAB 5: Goals ── */}
            {customizeTab === "goals" && (
              <>
                <div style={{ background: "#f8fbff", borderRadius: "18px", padding: "18px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                  <h3 style={{ marginTop: 0, marginBottom: "6px", color: "#1e3a5f", fontSize: "20px" }}>🎯 Weekly Frequency Goals</h3>
                  <p style={{ marginTop: 0, marginBottom: "16px", color: "#4b6b8a", fontSize: "13px", lineHeight: 1.5 }}>
                    Set how many times per week you want to complete each habit. A token is only required when hitting your goal becomes mathematically impossible — not on individual missed days.
                  </p>
                  {/* Week start day */}
                  <div style={{ marginBottom: "20px" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "8px" }}>📅 Week starts on</div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      {[{ val: "sunday", label: "Sunday" }, { val: "monday", label: "Monday" }].map(({ val, label }) => (
                        <button
                          key={val}
                          type="button"
                          onClick={() => handleSetWeekStartDay(val)}
                          style={{
                            padding: "8px 18px", borderRadius: "10px",
                            border: weekStartDay === val ? "2px solid #2563eb" : "2px solid #bfdbfe",
                            background: weekStartDay === val ? "#dbeafe" : "#f8fbff",
                            color: weekStartDay === val ? "#1e3a5f" : "#4b6b8a",
                            fontWeight: weekStartDay === val ? 700 : 400,
                            fontSize: "14px", cursor: "pointer",
                          }}
                        >{label}</button>
                      ))}
                    </div>
                  </div>
                  {[
                    { cat: "nutrition", label: getCatLabel("nutrition"), emoji: categoryEmojis.nutrition || "🍓" },
                    { cat: "movement", label: getCatLabel("movement"), emoji: categoryEmojis.movement || "🚶‍♀️" },
                    { cat: "mindset", label: getCatLabel("mindset"), emoji: categoryEmojis.mindset || "🌙" },
                  ].map(({ cat, label, emoji }) => (
                    <div key={cat} style={{ marginBottom: "20px" }}>
                      <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "15px", marginBottom: "8px" }}>
                        {emoji} {label}
                      </div>
                      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                        {[null, 1, 2, 3, 4, 5, 6, 7].map((val) => {
                          const isSelected = weeklyGoalFreqs[cat] === val;
                          return (
                            <button
                              key={val ?? "off"}
                              type="button"
                              onClick={() => handleSetWeeklyGoalFreq(cat, val)}
                              style={{
                                padding: "8px 14px",
                                borderRadius: "10px",
                                border: isSelected ? "2px solid #2563eb" : "2px solid #bfdbfe",
                                background: isSelected ? "#dbeafe" : "#f8fbff",
                                color: isSelected ? "#1e3a5f" : "#4b6b8a",
                                fontWeight: isSelected ? 700 : 400,
                                fontSize: "14px",
                                cursor: "pointer",
                              }}
                            >
                              {val === null ? "Off" : `${val}x`}
                            </button>
                          );
                        })}
                      </div>
                      {weeklyGoalFreqs[cat] !== null && (
                        <div style={{ fontSize: "12px", color: "#6b8cb0", marginTop: "6px" }}>
                          Goal: {weeklyGoalFreqs[cat]}×/week — token required when goal becomes impossible
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}


          </div>
        )}
      </div>

      {/* Level-up celebration banner */}
      {levelUpBanner && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 10000, pointerEvents: "none",
        }}>
          <div style={{
            background: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 50%, #38bdf8 100%)",
            borderRadius: "28px", padding: "32px 40px", textAlign: "center",
            boxShadow: "0 20px 60px rgba(30,58,138,0.5)",
            animation: "sparkle-burst 0.4s ease-out",
            border: "3px solid #93c5fd",
            maxWidth: "320px", width: "90%",
          }}>
            <div style={{ fontSize: "56px", marginBottom: "8px" }}>🎉</div>
            <div style={{ color: "#fff", fontWeight: "bold", fontSize: "28px", marginBottom: "4px" }}>
              Level {levelUpBanner.level}!
            </div>
            <div style={{ color: "#bfdbfe", fontSize: "16px" }}>
              You reached Level {levelUpBanner.level} · {levelUpBanner.xp} XP total
            </div>
          </div>
        </div>
      )}

      {/* Onboarding walkthrough — shown to new users after profile setup */}
      {showOnboarding && (
        <OnboardingWalkthrough
          onComplete={() => setShowOnboarding(false)}
          onSkip={() => setShowOnboarding(false)}
          programTag={userprogramTag || pendingProgramTag}
        />
      )}

      {/* Info popups */}
      {infoPopup && (
        <div
          onClick={() => setInfoPopup(null)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: "20px", padding: "24px", maxWidth: "340px", width: "100%", boxShadow: "0 12px 40px rgba(30,58,138,0.18)", border: "2px solid #bfdbfe" }}>
            {infoPopup === "weekly" && (
              <>
                <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1e3a5f", marginBottom: "10px" }}>📅 Weekly Challenge</div>
                <p style={{ margin: 0, color: "#4b6b8a", fontSize: "14px", lineHeight: 1.6 }}>{infoTexts.weekly}</p>
              </>
            )}
            {infoPopup === "habits" && (
              <>
                <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1e3a5f", marginBottom: "10px" }}>💡 How Habits Work</div>
                <p style={{ margin: 0, color: "#4b6b8a", fontSize: "14px", lineHeight: 1.6, marginBottom: "12px" }}>{infoTexts.habitsIntro}</p>
                <div style={{ display: "grid", gap: "8px", marginBottom: "14px" }}>
                  <div style={{ background: "#f0f9ff", borderRadius: "10px", padding: "10px 12px" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>Keep the Streak (light)</div>
                    <div style={{ color: "#4b6b8a", fontSize: "12px", marginTop: "2px" }}>{infoTexts.habitsKeepStreak}</div>
                  </div>
                  <div style={{ background: "#f0f9ff", borderRadius: "10px", padding: "10px 12px" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>Main Quest</div>
                    <div style={{ color: "#4b6b8a", fontSize: "12px", marginTop: "2px" }}>{infoTexts.habitsMainQuest}</div>
                  </div>
                  <div style={{ background: "#f0f9ff", borderRadius: "10px", padding: "10px 12px" }}>
                    <div style={{ fontWeight: "bold", color: "#1e3a5f", fontSize: "13px" }}>Extra Credit</div>
                    <div style={{ color: "#4b6b8a", fontSize: "12px", marginTop: "2px" }}>{infoTexts.habitsExtraCredit}</div>
                  </div>
                </div>
                <p style={{ margin: 0, color: "#4b6b8a", fontSize: "13px", lineHeight: 1.5 }}>{infoTexts.habitsWarning}</p>
              </>
            )}
            {infoPopup === "habits_extra" && (
              <>
                <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1e3a5f", marginBottom: "10px" }}>✨ Bonus Category</div>
                <p style={{ margin: 0, color: "#4b6b8a", fontSize: "14px", lineHeight: 1.6 }}>{infoTexts.habitsExtra}</p>
              </>
            )}
            {infoPopup === "questAssignments" && (
              <>
                <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1e3a5f", marginBottom: "10px" }}>📋 Weekly Quest Assignments</div>
                <p style={{ margin: 0, color: "#4b6b8a", fontSize: "14px", lineHeight: 1.6 }}>{infoTexts.questAssignments}</p>
              </>
            )}
            {infoPopup === "sideQuests" && (
              <>
                <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1e3a5f", marginBottom: "10px" }}>✨ Side Quests</div>
                <p style={{ margin: 0, color: "#4b6b8a", fontSize: "14px", lineHeight: 1.6 }}>{infoTexts.sideQuests}</p>
              </>
            )}
            <button
              onClick={() => setInfoPopup(null)}
              style={{ marginTop: "18px", width: "100%", padding: "11px", borderRadius: "12px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}>
              Got it
            </button>
          </div>
        </div>
      )}

      {/* FAB quick-action menu */}
      {!inActiveCall && showFABMenu && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1000 }} onClick={() => { setShowFABMenu(false); setShowNotifInbox(false); }} />
      )}
      {!inActiveCall && showFABMenu && (isAdmin ? (
        /* Admin: two-tab panel */
        <div
          onTouchStart={(e) => { fabSwipeStartX.current = e.touches[0].clientX; }}
          onTouchEnd={(e) => {
            const dx = e.changedTouches[0].clientX - fabSwipeStartX.current;
            if (dx < -50) setFabTab(1);
            if (dx > 50) setFabTab(0);
          }}
          style={{
            position: "fixed", bottom: "140px", right: "16px", width: "224px",
            background: "#fff", borderRadius: "20px", border: "2px solid #dbeafe",
            boxShadow: "0 8px 28px rgba(30,58,138,0.2)", zIndex: 1001, overflow: "hidden",
          }}
        >
          {/* Tab bar */}
          <div style={{ display: "flex", borderBottom: "2px solid #dbeafe", background: "#f8fbff" }}>
            {["My Log", "Clients"].map((tab, i) => (
              <button
                key={tab}
                type="button"
                onClick={(e) => { e.stopPropagation(); setFabTab(i); }}
                style={{
                  flex: 1, padding: "10px 0", border: "none",
                  background: fabTab === i ? "#fff" : "transparent",
                  color: fabTab === i ? "#2563eb" : "#94a3b8",
                  fontWeight: fabTab === i ? "bold" : "normal",
                  fontSize: "13px", cursor: "pointer",
                  borderBottom: fabTab === i ? "3px solid #2563eb" : "3px solid transparent",
                  marginBottom: "-2px",
                }}
              >{tab}</button>
            ))}
          </div>
          {/* Shortcut buttons */}
          <div style={{ padding: "10px 12px", display: "flex", flexDirection: "column", gap: "8px" }}>
            {(fabTab === 0 ? [
              nutritionTrackingEnabled
                ? { label: "📷 Log Food", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setNutritionOpenTrigger(k => k + 1); setTimeout(() => document.getElementById("fab-nutrition-log")?.scrollIntoView({ behavior: "smooth", block: "start" }), 250); } }
                : portionTrackingEnabled
                  ? { label: "🤚 Log Food", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setTimeout(() => document.getElementById("fab-portion-log")?.scrollIntoView({ behavior: "smooth", block: "start" }), 200); } }
                  : macroTrackingEnabled
                    ? { label: "📊 Log Food", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setMacroOpenTrigger(k => k + 1); setTimeout(() => (document.getElementById("macro-add-panel") || document.getElementById("fab-macro-log"))?.scrollIntoView({ behavior: "smooth", block: "start" }), 350); } }
                    : null,
              { label: "⚔️ Log Side Quest", action: () => { setActiveScreen("quests"); setShowFABMenu(false); setTimeout(() => document.getElementById("fab-side-quests")?.scrollIntoView({ behavior: "smooth", block: "start" }), 200); } },
              { label: "🏃 Log Cardio", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setShowCardioPanel(true); setTimeout(() => document.getElementById("fab-cardio-log")?.scrollIntoView({ behavior: "smooth", block: "start" }), 300); } },
              { label: "⚖️ Weight", action: () => { setYouInitAction("weight"); setActiveScreen("you"); setShowFABMenu(false); } },
              { label: "📏 Measurements", action: () => { setYouInitAction("measurements"); setActiveScreen("you"); setShowFABMenu(false); } },
              { label: "📷 Progress Photos", action: () => { setYouInitAction("photos"); setActiveScreen("you"); setShowFABMenu(false); } },
            ].filter(Boolean) : [
              { label: "📢 Announcement", action: () => { setFabInitBroadcastType("announcement"); setFabInitBroadcastKey((k) => k + 1); setActiveScreen("admin"); setAdminTab("broadcasts"); setShowFABMenu(false); } },
              { label: "💬 Question", action: () => { setFabInitBroadcastType("question"); setFabInitBroadcastKey((k) => k + 1); setActiveScreen("admin"); setAdminTab("broadcasts"); setShowFABMenu(false); } },
              { label: "📊 Poll", action: () => { setFabInitBroadcastType("poll"); setFabInitBroadcastKey((k) => k + 1); setActiveScreen("admin"); setAdminTab("broadcasts"); setShowFABMenu(false); } },
              { label: "📌 Pin Note", action: () => { setFabInitBroadcastType("note"); setFabInitBroadcastKey((k) => k + 1); setActiveScreen("admin"); setAdminTab("broadcasts"); setShowFABMenu(false); } },
              { label: "📹 Schedule Call", action: () => { setFabInitBroadcastType("call_poll"); setFabInitBroadcastKey((k) => k + 1); setActiveScreen("admin"); setAdminTab("broadcasts"); setShowFABMenu(false); } },
              { label: "📝 Weekly Quest", action: () => { setActiveScreen("admin"); setAdminTab("weeklyPrompts"); setShowFABMenu(false); } },
            ]).map(({ label, action }) => (
              <button
                key={label}
                type="button"
                onClick={action}
                style={{ display: "flex", alignItems: "center", gap: "10px", background: "#f5faff", border: "2px solid #dbeafe", borderRadius: "12px", padding: "10px 14px", cursor: "pointer", fontSize: "13px", fontWeight: "bold", color: "#1e3a5f", whiteSpace: "nowrap", textAlign: "left", width: "100%", boxSizing: "border-box" }}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        /* Non-admin: simple floating list */
        <div style={{ position: "fixed", bottom: "96px", right: "20px", display: "flex", flexDirection: "column", gap: "10px", zIndex: 1001 }}>
          {[
            nutritionTrackingEnabled
              ? { label: "📷 Log Food", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setShowNotifInbox(false); setNutritionOpenTrigger(k => k + 1); setTimeout(() => document.getElementById("fab-nutrition-log")?.scrollIntoView({ behavior: "smooth", block: "start" }), 250); } }
              : portionTrackingEnabled
                ? { label: "🤚 Log Food", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setShowNotifInbox(false); setTimeout(() => document.getElementById("fab-portion-log")?.scrollIntoView({ behavior: "smooth", block: "start" }), 200); } }
                : macroTrackingEnabled
                  ? { label: "📊 Log Food", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setShowNotifInbox(false); setMacroOpenTrigger(k => k + 1); setTimeout(() => (document.getElementById("macro-add-panel") || document.getElementById("fab-macro-log"))?.scrollIntoView({ behavior: "smooth", block: "start" }), 350); } }
                  : null,
            { label: "⚔️ Log Side Quest", action: () => { setActiveScreen("quests"); setShowFABMenu(false); setShowNotifInbox(false); setTimeout(() => document.getElementById("fab-side-quests")?.scrollIntoView({ behavior: "smooth", block: "start" }), 200); } },
            { label: "🏃 Log Cardio", action: () => { setActiveScreen("dashboard"); setShowFABMenu(false); setShowNotifInbox(false); setShowCardioPanel(true); setTimeout(() => document.getElementById("fab-cardio-log")?.scrollIntoView({ behavior: "smooth", block: "start" }), 300); } },
            { label: "⚖️ Weight", action: () => { setYouInitAction("weight"); setActiveScreen("you"); setShowFABMenu(false); setShowNotifInbox(false); } },
            { label: "📏 Measurements", action: () => { setYouInitAction("measurements"); setActiveScreen("you"); setShowFABMenu(false); setShowNotifInbox(false); } },
            { label: "📷 Progress Photos", action: () => { setYouInitAction("photos"); setActiveScreen("you"); setShowFABMenu(false); setShowNotifInbox(false); } },
          ].filter(Boolean).map(({ label, action }) => (
            <button
              key={label}
              type="button"
              onClick={action}
              style={{ display: "flex", alignItems: "center", gap: "10px", background: "#fff", border: "2px solid #dbeafe", borderRadius: "14px", padding: "10px 16px", cursor: "pointer", fontSize: "14px", fontWeight: "bold", color: "#1e3a5f", whiteSpace: "nowrap", boxShadow: "0 4px 14px rgba(30,58,138,0.12)", textAlign: "left" }}
            >
              {label}
            </button>
          ))}
        </div>
      ))}
      {!inActiveCall && (
        <button
          type="button"
          onClick={() => setShowFABMenu((p) => !p)}
          style={{
            position: "fixed", bottom: "76px", right: "20px",
            width: "56px", height: "56px", borderRadius: "50%",
            background: showFABMenu ? "#1d4ed8" : "#2563eb",
            color: "#fff", border: "none", fontSize: "28px", lineHeight: 1,
            cursor: "pointer", zIndex: 1002,
            boxShadow: "0 4px 18px rgba(37,99,235,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            transform: showFABMenu ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
          aria-label="Quick actions"
        >
          +
        </button>
      )}

      {/* Revive activation modal */}
      {showReviveActivationModal && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 1200,
          background: "rgba(0,0,0,0.55)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "24px",
        }}>
          <div style={{
            background: "#fff", borderRadius: "22px", padding: "32px 24px",
            maxWidth: "360px", width: "100%", textAlign: "center",
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          }}>
            <div style={{ fontSize: "52px", marginBottom: "12px" }}>🔥</div>
            <h2 style={{ margin: "0 0 10px", color: "#1e3a5f", fontSize: "22px", fontWeight: "bold" }}>
              Revive Earned!
            </h2>
            <p style={{ color: "#4b6b8a", fontSize: "14px", lineHeight: 1.6, margin: "0 0 24px" }}>
              You completed all 3 core habits today. Activate your revive to save your streak — your XP resets to zero and you continue earning from here.
            </p>
            <button
              type="button"
              onClick={handleActivateRevive}
              style={{ ...getPrimaryButtonStyle(), width: "100%", marginBottom: "12px", padding: "16px" }}
            >
              Activate Revive
            </button>
            <button
              type="button"
              onClick={() => setShowReviveActivationModal(false)}
              style={{ background: "transparent", border: "none", color: "#9ca3af", fontSize: "13px", cursor: "pointer", padding: "8px" }}
            >
              Not now
            </button>
          </div>
        </div>
      )}

      {/* Fixed bottom navigation */}
      {!inActiveCall && <nav style={{
        position: "fixed", bottom: 0, left: 0, right: 0,
        background: "#fff", borderTop: "1px solid #e2e8f0",
        display: "flex", justifyContent: "space-around", alignItems: "center",
        paddingTop: "8px", paddingBottom: "env(safe-area-inset-bottom, 12px)",
        zIndex: 999, boxShadow: "0 -2px 12px rgba(30,58,138,0.08)", minHeight: "60px",
      }}>
        {[
          { screen: "dashboard", label: "Dashboard", d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" },
          { screen: "quests", label: "Quests", d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" },
          ...(hasFeature("workouts") ? [{ screen: "workouts", label: "Workouts", d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 5.57 2 7.71 3.43 9.14 2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22 14.86 20.57 16.29 22 18.43 19.86 19.86 18.43 22 16.29 20.57 14.86z" }] : []),
          { screen: "feed", label: "Community", d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" },
          { screen: "you", label: "You", d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" },
        ].map(({ screen, d, label }) => (
          <button
            key={screen}
            type="button"
            onClick={() => { setActiveScreen(screen); setShowNotifInbox(false); setShowFABMenu(false); }}
            style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "3px", background: "transparent", border: "none", cursor: "pointer", padding: "4px 8px", color: activeScreen === screen ? "#2563eb" : "#94a3b8", minWidth: "44px" }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d={d} /></svg>
            <span style={{ fontSize: "10px", fontWeight: activeScreen === screen ? "bold" : "normal" }}>{label}</span>
          </button>
        ))}
        {isAdmin && (
          <button
            type="button"
            onClick={() => { setActiveScreen("admin"); setAdminTab(adminActivityUnread > 0 ? "activity" : "users"); setShowNotifInbox(false); setShowFABMenu(false); }}
            style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "3px", background: "transparent", border: "none", cursor: "pointer", padding: "4px 12px", color: activeScreen === "admin" ? "#2563eb" : "#94a3b8", position: "relative", minWidth: "56px" }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" /></svg>
            <span style={{ fontSize: "10px", fontWeight: activeScreen === "admin" ? "bold" : "normal" }}>Admin</span>
            {adminActivityUnread > 0 && (
              <span style={{ position: "absolute", top: 0, right: "8px", background: "#ef4444", color: "#fff", borderRadius: "999px", minWidth: "14px", height: "14px", fontSize: "9px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 3px" }}>
                {adminActivityUnread > 99 ? "99+" : adminActivityUnread}
              </span>
            )}
          </button>
        )}
      </nav>}

      {isEditingAvatar && (
        <AvatarBuilder
          initialUrl={selectedAvatar}
          seedHint={profileName || profileFirstName.trim()}
          onSave={(url) => handleAvatarChange(url)}
          onCancel={() => setIsEditingAvatar(false)}
          config={avatarBuilderConfig}
        />
      )}
    </div>
  );
}